(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2844"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2844"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1tTUb", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $1143dd7f04075183$export$ffb0004e005737fa; }, function (v) { return $1143dd7f04075183$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $1143dd7f04075183$export$34b9dba7ce09269b; }, function (v) { return $1143dd7f04075183$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $1143dd7f04075183$export$25062201e9e25d76; }, function (v) { return $1143dd7f04075183$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1143dd7f04075183$export$ffb0004e005737fa;
var $1143dd7f04075183$export$34b9dba7ce09269b;
var $1143dd7f04075183$export$25062201e9e25d76;
"use strict";
var $1143dd7f04075183$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $1143dd7f04075183$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $1143dd7f04075183$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $1143dd7f04075183$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$1143dd7f04075183$export$ffb0004e005737fa = $1143dd7f04075183$var$REACT_FRAGMENT_TYPE;
$1143dd7f04075183$export$34b9dba7ce09269b = $1143dd7f04075183$var$jsxProd;
$1143dd7f04075183$export$25062201e9e25d76 = $1143dd7f04075183$var$jsxProd;

});

parcelRegister("gfHYB", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $bd5028e33dce7343$export$dca3b0875bd9a954; }, function (v) { return $bd5028e33dce7343$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $bd5028e33dce7343$export$16fa2f45be04daa8; }, function (v) { return $bd5028e33dce7343$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $bd5028e33dce7343$export$ffb0004e005737fa; }, function (v) { return $bd5028e33dce7343$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $bd5028e33dce7343$export$e2c29f18771995cb; }, function (v) { return $bd5028e33dce7343$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $bd5028e33dce7343$export$221d75b3f55bb0bd; }, function (v) { return $bd5028e33dce7343$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $bd5028e33dce7343$export$5f8d39834fd61797; }, function (v) { return $bd5028e33dce7343$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $bd5028e33dce7343$export$74bf444e3cd11ea5; }, function (v) { return $bd5028e33dce7343$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $bd5028e33dce7343$export$1ced07cd6b1985ce; }, function (v) { return $bd5028e33dce7343$export$1ced07cd6b1985ce = v; });
$parcel$export(module.exports, "act", function () { return $bd5028e33dce7343$export$3ba232387fd5d6dd; }, function (v) { return $bd5028e33dce7343$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cache", function () { return $bd5028e33dce7343$export$69a3209f1a06c04d; }, function (v) { return $bd5028e33dce7343$export$69a3209f1a06c04d = v; });
$parcel$export(module.exports, "cloneElement", function () { return $bd5028e33dce7343$export$e530037191fcd5d7; }, function (v) { return $bd5028e33dce7343$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $bd5028e33dce7343$export$fd42f52fd3ae1109; }, function (v) { return $bd5028e33dce7343$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $bd5028e33dce7343$export$c8a8987d4410bf2d; }, function (v) { return $bd5028e33dce7343$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createRef", function () { return $bd5028e33dce7343$export$7d1e3a5e95ceca43; }, function (v) { return $bd5028e33dce7343$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $bd5028e33dce7343$export$257a8862b851cb5b; }, function (v) { return $bd5028e33dce7343$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $bd5028e33dce7343$export$a8257692ac88316c; }, function (v) { return $bd5028e33dce7343$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $bd5028e33dce7343$export$488013bae63b21da; }, function (v) { return $bd5028e33dce7343$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $bd5028e33dce7343$export$7c73462e0d25e514; }, function (v) { return $bd5028e33dce7343$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $bd5028e33dce7343$export$7568632d0d33d16d; }, function (v) { return $bd5028e33dce7343$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_useCacheRefresh", function () { return $bd5028e33dce7343$export$f93f40ac0ca7e3a8; }, function (v) { return $bd5028e33dce7343$export$f93f40ac0ca7e3a8 = v; });
$parcel$export(module.exports, "use", function () { return $bd5028e33dce7343$export$1f96ae73734a86cc; }, function (v) { return $bd5028e33dce7343$export$1f96ae73734a86cc = v; });
$parcel$export(module.exports, "useActionState", function () { return $bd5028e33dce7343$export$9a47ced3238df325; }, function (v) { return $bd5028e33dce7343$export$9a47ced3238df325 = v; });
$parcel$export(module.exports, "useCallback", function () { return $bd5028e33dce7343$export$35808ee640e87ca7; }, function (v) { return $bd5028e33dce7343$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $bd5028e33dce7343$export$fae74005e78b1a27; }, function (v) { return $bd5028e33dce7343$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $bd5028e33dce7343$export$dc8fbce3eb94dc1e; }, function (v) { return $bd5028e33dce7343$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $bd5028e33dce7343$export$6a7bc4e911dc01cf; }, function (v) { return $bd5028e33dce7343$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $bd5028e33dce7343$export$6d9c69b0de29b591; }, function (v) { return $bd5028e33dce7343$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $bd5028e33dce7343$export$f680877a34711e37; }, function (v) { return $bd5028e33dce7343$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $bd5028e33dce7343$export$d5a552a76deda3c2; }, function (v) { return $bd5028e33dce7343$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $bd5028e33dce7343$export$aaabe4eda9ed9969; }, function (v) { return $bd5028e33dce7343$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $bd5028e33dce7343$export$e5c5a5f917a5871c; }, function (v) { return $bd5028e33dce7343$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $bd5028e33dce7343$export$1538c33de8887b59; }, function (v) { return $bd5028e33dce7343$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useOptimistic", function () { return $bd5028e33dce7343$export$fca7f784ae7a249a; }, function (v) { return $bd5028e33dce7343$export$fca7f784ae7a249a = v; });
$parcel$export(module.exports, "useReducer", function () { return $bd5028e33dce7343$export$13e3392192263954; }, function (v) { return $bd5028e33dce7343$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $bd5028e33dce7343$export$b8f5890fc79d6aca; }, function (v) { return $bd5028e33dce7343$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $bd5028e33dce7343$export$60241385465d0a34; }, function (v) { return $bd5028e33dce7343$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $bd5028e33dce7343$export$306c0aa65ff9ec16; }, function (v) { return $bd5028e33dce7343$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $bd5028e33dce7343$export$7b286972b8d8ccbf; }, function (v) { return $bd5028e33dce7343$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $bd5028e33dce7343$export$83d89fbfd8236492; }, function (v) { return $bd5028e33dce7343$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bd5028e33dce7343$export$dca3b0875bd9a954;
var $bd5028e33dce7343$export$16fa2f45be04daa8;
var $bd5028e33dce7343$export$ffb0004e005737fa;
var $bd5028e33dce7343$export$e2c29f18771995cb;
var $bd5028e33dce7343$export$221d75b3f55bb0bd;
var $bd5028e33dce7343$export$5f8d39834fd61797;
var $bd5028e33dce7343$export$74bf444e3cd11ea5;
var $bd5028e33dce7343$export$1ced07cd6b1985ce;
var $bd5028e33dce7343$export$3ba232387fd5d6dd;
var $bd5028e33dce7343$export$69a3209f1a06c04d;
var $bd5028e33dce7343$export$e530037191fcd5d7;
var $bd5028e33dce7343$export$fd42f52fd3ae1109;
var $bd5028e33dce7343$export$c8a8987d4410bf2d;
var $bd5028e33dce7343$export$7d1e3a5e95ceca43;
var $bd5028e33dce7343$export$257a8862b851cb5b;
var $bd5028e33dce7343$export$a8257692ac88316c;
var $bd5028e33dce7343$export$488013bae63b21da;
var $bd5028e33dce7343$export$7c73462e0d25e514;
var $bd5028e33dce7343$export$7568632d0d33d16d;
var $bd5028e33dce7343$export$f93f40ac0ca7e3a8;
var $bd5028e33dce7343$export$1f96ae73734a86cc;
var $bd5028e33dce7343$export$9a47ced3238df325;
var $bd5028e33dce7343$export$35808ee640e87ca7;
var $bd5028e33dce7343$export$fae74005e78b1a27;
var $bd5028e33dce7343$export$dc8fbce3eb94dc1e;
var $bd5028e33dce7343$export$6a7bc4e911dc01cf;
var $bd5028e33dce7343$export$6d9c69b0de29b591;
var $bd5028e33dce7343$export$f680877a34711e37;
var $bd5028e33dce7343$export$d5a552a76deda3c2;
var $bd5028e33dce7343$export$aaabe4eda9ed9969;
var $bd5028e33dce7343$export$e5c5a5f917a5871c;
var $bd5028e33dce7343$export$1538c33de8887b59;
var $bd5028e33dce7343$export$fca7f784ae7a249a;
var $bd5028e33dce7343$export$13e3392192263954;
var $bd5028e33dce7343$export$b8f5890fc79d6aca;
var $bd5028e33dce7343$export$60241385465d0a34;
var $bd5028e33dce7343$export$306c0aa65ff9ec16;
var $bd5028e33dce7343$export$7b286972b8d8ccbf;
var $bd5028e33dce7343$export$83d89fbfd8236492;

var $6qd2L = parcelRequire("6qd2L");
"use strict";
var $bd5028e33dce7343$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $bd5028e33dce7343$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $bd5028e33dce7343$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $bd5028e33dce7343$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $bd5028e33dce7343$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $bd5028e33dce7343$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $bd5028e33dce7343$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $bd5028e33dce7343$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $bd5028e33dce7343$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $bd5028e33dce7343$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $bd5028e33dce7343$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $bd5028e33dce7343$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $bd5028e33dce7343$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $bd5028e33dce7343$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$bd5028e33dce7343$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $bd5028e33dce7343$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $bd5028e33dce7343$var$assign = Object.assign, $bd5028e33dce7343$var$emptyObject = {};
function $bd5028e33dce7343$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $bd5028e33dce7343$var$emptyObject;
    this.updater = updater || $bd5028e33dce7343$var$ReactNoopUpdateQueue;
}
$bd5028e33dce7343$var$Component.prototype.isReactComponent = {};
$bd5028e33dce7343$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$bd5028e33dce7343$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $bd5028e33dce7343$var$ComponentDummy() {}
$bd5028e33dce7343$var$ComponentDummy.prototype = $bd5028e33dce7343$var$Component.prototype;
function $bd5028e33dce7343$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $bd5028e33dce7343$var$emptyObject;
    this.updater = updater || $bd5028e33dce7343$var$ReactNoopUpdateQueue;
}
var $bd5028e33dce7343$var$pureComponentPrototype = $bd5028e33dce7343$var$PureComponent.prototype = new $bd5028e33dce7343$var$ComponentDummy();
$bd5028e33dce7343$var$pureComponentPrototype.constructor = $bd5028e33dce7343$var$PureComponent;
$bd5028e33dce7343$var$assign($bd5028e33dce7343$var$pureComponentPrototype, $bd5028e33dce7343$var$Component.prototype);
$bd5028e33dce7343$var$pureComponentPrototype.isPureReactComponent = !0;
var $bd5028e33dce7343$var$isArrayImpl = Array.isArray, $bd5028e33dce7343$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $bd5028e33dce7343$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $bd5028e33dce7343$var$ReactElement(type, key, self, source, owner, props) {
    self = props.ref;
    return {
        $$typeof: $bd5028e33dce7343$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== self ? self : null,
        props: props
    };
}
function $bd5028e33dce7343$var$cloneAndReplaceKey(oldElement, newKey) {
    return $bd5028e33dce7343$var$ReactElement(oldElement.type, newKey, void 0, void 0, void 0, oldElement.props);
}
function $bd5028e33dce7343$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $bd5028e33dce7343$var$REACT_ELEMENT_TYPE;
}
function $bd5028e33dce7343$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $bd5028e33dce7343$var$userProvidedKeyEscapeRegex = /\/+/g;
function $bd5028e33dce7343$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $bd5028e33dce7343$var$escape("" + element.key) : index.toString(36);
}
function $bd5028e33dce7343$var$noop$1() {}
function $bd5028e33dce7343$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($bd5028e33dce7343$var$noop$1, $bd5028e33dce7343$var$noop$1) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $bd5028e33dce7343$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $bd5028e33dce7343$var$REACT_ELEMENT_TYPE:
                case $bd5028e33dce7343$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $bd5028e33dce7343$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $bd5028e33dce7343$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $bd5028e33dce7343$var$getElementKey(children, 0) : nameSoFar, $bd5028e33dce7343$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($bd5028e33dce7343$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $bd5028e33dce7343$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($bd5028e33dce7343$var$isValidElement(callback) && (callback = $bd5028e33dce7343$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($bd5028e33dce7343$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($bd5028e33dce7343$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $bd5028e33dce7343$var$getElementKey(nameSoFar, i), invokeCallback += $bd5028e33dce7343$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $bd5028e33dce7343$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $bd5028e33dce7343$var$getElementKey(nameSoFar, i++), invokeCallback += $bd5028e33dce7343$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $bd5028e33dce7343$var$mapIntoArray($bd5028e33dce7343$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $bd5028e33dce7343$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $bd5028e33dce7343$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $bd5028e33dce7343$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $bd5028e33dce7343$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    } else if ("object" === typeof $6qd2L && "function" === typeof $6qd2L.emit) {
        $6qd2L.emit("uncaughtException", error);
        return;
    }
    console.error(error);
};
function $bd5028e33dce7343$var$noop() {}
$bd5028e33dce7343$export$dca3b0875bd9a954 = {
    map: $bd5028e33dce7343$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $bd5028e33dce7343$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $bd5028e33dce7343$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $bd5028e33dce7343$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$bd5028e33dce7343$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$bd5028e33dce7343$export$16fa2f45be04daa8 = $bd5028e33dce7343$var$Component;
$bd5028e33dce7343$export$ffb0004e005737fa = $bd5028e33dce7343$var$REACT_FRAGMENT_TYPE;
$bd5028e33dce7343$export$e2c29f18771995cb = $bd5028e33dce7343$var$REACT_PROFILER_TYPE;
$bd5028e33dce7343$export$221d75b3f55bb0bd = $bd5028e33dce7343$var$PureComponent;
$bd5028e33dce7343$export$5f8d39834fd61797 = $bd5028e33dce7343$var$REACT_STRICT_MODE_TYPE;
$bd5028e33dce7343$export$74bf444e3cd11ea5 = $bd5028e33dce7343$var$REACT_SUSPENSE_TYPE;
$bd5028e33dce7343$export$1ced07cd6b1985ce = $bd5028e33dce7343$var$ReactSharedInternals;
$bd5028e33dce7343$export$3ba232387fd5d6dd = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$bd5028e33dce7343$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$bd5028e33dce7343$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $bd5028e33dce7343$var$assign({}, element.props), key = element.key, owner = void 0;
    if (null != config) for(propName in void 0 !== config.ref && (owner = void 0), void 0 !== config.key && (key = "" + config.key), config)!$bd5028e33dce7343$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $bd5028e33dce7343$var$ReactElement(element.type, key, void 0, void 0, owner, props);
};
$bd5028e33dce7343$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $bd5028e33dce7343$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $bd5028e33dce7343$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$bd5028e33dce7343$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$bd5028e33dce7343$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $bd5028e33dce7343$var$ReactElement(type, key, void 0, void 0, null, props);
};
$bd5028e33dce7343$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$bd5028e33dce7343$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $bd5028e33dce7343$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$bd5028e33dce7343$export$a8257692ac88316c = $bd5028e33dce7343$var$isValidElement;
$bd5028e33dce7343$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $bd5028e33dce7343$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $bd5028e33dce7343$var$lazyInitializer
    };
};
$bd5028e33dce7343$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $bd5028e33dce7343$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$bd5028e33dce7343$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $bd5028e33dce7343$var$ReactSharedInternals.T, currentTransition = {};
    $bd5028e33dce7343$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $bd5028e33dce7343$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($bd5028e33dce7343$var$noop, $bd5028e33dce7343$var$reportGlobalError);
    } catch (error) {
        $bd5028e33dce7343$var$reportGlobalError(error);
    } finally{
        $bd5028e33dce7343$var$ReactSharedInternals.T = prevTransition;
    }
};
$bd5028e33dce7343$export$f93f40ac0ca7e3a8 = function() {
    return $bd5028e33dce7343$var$ReactSharedInternals.H.useCacheRefresh();
};
$bd5028e33dce7343$export$1f96ae73734a86cc = function(usable) {
    return $bd5028e33dce7343$var$ReactSharedInternals.H.use(usable);
};
$bd5028e33dce7343$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $bd5028e33dce7343$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$bd5028e33dce7343$export$35808ee640e87ca7 = function(callback, deps) {
    return $bd5028e33dce7343$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$bd5028e33dce7343$export$fae74005e78b1a27 = function(Context) {
    return $bd5028e33dce7343$var$ReactSharedInternals.H.useContext(Context);
};
$bd5028e33dce7343$export$dc8fbce3eb94dc1e = function() {};
$bd5028e33dce7343$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $bd5028e33dce7343$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$bd5028e33dce7343$export$6d9c69b0de29b591 = function(create, deps) {
    return $bd5028e33dce7343$var$ReactSharedInternals.H.useEffect(create, deps);
};
$bd5028e33dce7343$export$f680877a34711e37 = function() {
    return $bd5028e33dce7343$var$ReactSharedInternals.H.useId();
};
$bd5028e33dce7343$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $bd5028e33dce7343$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$bd5028e33dce7343$export$aaabe4eda9ed9969 = function(create, deps) {
    return $bd5028e33dce7343$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$bd5028e33dce7343$export$e5c5a5f917a5871c = function(create, deps) {
    return $bd5028e33dce7343$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$bd5028e33dce7343$export$1538c33de8887b59 = function(create, deps) {
    return $bd5028e33dce7343$var$ReactSharedInternals.H.useMemo(create, deps);
};
$bd5028e33dce7343$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $bd5028e33dce7343$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$bd5028e33dce7343$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $bd5028e33dce7343$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$bd5028e33dce7343$export$b8f5890fc79d6aca = function(initialValue) {
    return $bd5028e33dce7343$var$ReactSharedInternals.H.useRef(initialValue);
};
$bd5028e33dce7343$export$60241385465d0a34 = function(initialState) {
    return $bd5028e33dce7343$var$ReactSharedInternals.H.useState(initialState);
};
$bd5028e33dce7343$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $bd5028e33dce7343$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$bd5028e33dce7343$export$7b286972b8d8ccbf = function() {
    return $bd5028e33dce7343$var$ReactSharedInternals.H.useTransition();
};
$bd5028e33dce7343$export$83d89fbfd8236492 = "19.0.0";

});
parcelRegister("6qd2L", function(module, exports) {
// shim for using process in browser
var $4acf49f6c3e67aec$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $4acf49f6c3e67aec$var$cachedSetTimeout;
var $4acf49f6c3e67aec$var$cachedClearTimeout;
function $4acf49f6c3e67aec$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $4acf49f6c3e67aec$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $4acf49f6c3e67aec$var$cachedSetTimeout = setTimeout;
        else $4acf49f6c3e67aec$var$cachedSetTimeout = $4acf49f6c3e67aec$var$defaultSetTimout;
    } catch (e) {
        $4acf49f6c3e67aec$var$cachedSetTimeout = $4acf49f6c3e67aec$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $4acf49f6c3e67aec$var$cachedClearTimeout = clearTimeout;
        else $4acf49f6c3e67aec$var$cachedClearTimeout = $4acf49f6c3e67aec$var$defaultClearTimeout;
    } catch (e) {
        $4acf49f6c3e67aec$var$cachedClearTimeout = $4acf49f6c3e67aec$var$defaultClearTimeout;
    }
})();
function $4acf49f6c3e67aec$var$runTimeout(fun) {
    if ($4acf49f6c3e67aec$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($4acf49f6c3e67aec$var$cachedSetTimeout === $4acf49f6c3e67aec$var$defaultSetTimout || !$4acf49f6c3e67aec$var$cachedSetTimeout) && setTimeout) {
        $4acf49f6c3e67aec$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $4acf49f6c3e67aec$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $4acf49f6c3e67aec$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $4acf49f6c3e67aec$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $4acf49f6c3e67aec$var$runClearTimeout(marker) {
    if ($4acf49f6c3e67aec$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($4acf49f6c3e67aec$var$cachedClearTimeout === $4acf49f6c3e67aec$var$defaultClearTimeout || !$4acf49f6c3e67aec$var$cachedClearTimeout) && clearTimeout) {
        $4acf49f6c3e67aec$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $4acf49f6c3e67aec$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $4acf49f6c3e67aec$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $4acf49f6c3e67aec$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $4acf49f6c3e67aec$var$queue = [];
var $4acf49f6c3e67aec$var$draining = false;
var $4acf49f6c3e67aec$var$currentQueue;
var $4acf49f6c3e67aec$var$queueIndex = -1;
function $4acf49f6c3e67aec$var$cleanUpNextTick() {
    if (!$4acf49f6c3e67aec$var$draining || !$4acf49f6c3e67aec$var$currentQueue) return;
    $4acf49f6c3e67aec$var$draining = false;
    if ($4acf49f6c3e67aec$var$currentQueue.length) $4acf49f6c3e67aec$var$queue = $4acf49f6c3e67aec$var$currentQueue.concat($4acf49f6c3e67aec$var$queue);
    else $4acf49f6c3e67aec$var$queueIndex = -1;
    if ($4acf49f6c3e67aec$var$queue.length) $4acf49f6c3e67aec$var$drainQueue();
}
function $4acf49f6c3e67aec$var$drainQueue() {
    if ($4acf49f6c3e67aec$var$draining) return;
    var timeout = $4acf49f6c3e67aec$var$runTimeout($4acf49f6c3e67aec$var$cleanUpNextTick);
    $4acf49f6c3e67aec$var$draining = true;
    var len = $4acf49f6c3e67aec$var$queue.length;
    while(len){
        $4acf49f6c3e67aec$var$currentQueue = $4acf49f6c3e67aec$var$queue;
        $4acf49f6c3e67aec$var$queue = [];
        while(++$4acf49f6c3e67aec$var$queueIndex < len)if ($4acf49f6c3e67aec$var$currentQueue) $4acf49f6c3e67aec$var$currentQueue[$4acf49f6c3e67aec$var$queueIndex].run();
        $4acf49f6c3e67aec$var$queueIndex = -1;
        len = $4acf49f6c3e67aec$var$queue.length;
    }
    $4acf49f6c3e67aec$var$currentQueue = null;
    $4acf49f6c3e67aec$var$draining = false;
    $4acf49f6c3e67aec$var$runClearTimeout(timeout);
}
$4acf49f6c3e67aec$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $4acf49f6c3e67aec$var$queue.push(new $4acf49f6c3e67aec$var$Item(fun, args));
    if ($4acf49f6c3e67aec$var$queue.length === 1 && !$4acf49f6c3e67aec$var$draining) $4acf49f6c3e67aec$var$runTimeout($4acf49f6c3e67aec$var$drainQueue);
};
// v8 likes predictible objects
function $4acf49f6c3e67aec$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$4acf49f6c3e67aec$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$4acf49f6c3e67aec$var$process.title = "browser";
$4acf49f6c3e67aec$var$process.browser = true;
$4acf49f6c3e67aec$var$process.env = {};
$4acf49f6c3e67aec$var$process.argv = [];
$4acf49f6c3e67aec$var$process.version = ""; // empty string to avoid regexp issues
$4acf49f6c3e67aec$var$process.versions = {};
function $4acf49f6c3e67aec$var$noop() {}
$4acf49f6c3e67aec$var$process.on = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.addListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.once = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.off = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.removeListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.removeAllListeners = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.emit = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.prependListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.prependOnceListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.listeners = function(name) {
    return [];
};
$4acf49f6c3e67aec$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$4acf49f6c3e67aec$var$process.cwd = function() {
    return "/";
};
$4acf49f6c3e67aec$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$4acf49f6c3e67aec$var$process.umask = function() {
    return 0;
};

});


parcelRegister("8LThT", function(module, exports) {

$parcel$export(module.exports, "createRoot", function () { return $662d9978aa5168bc$export$882461b6382ed46c; }, function (v) { return $662d9978aa5168bc$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $662d9978aa5168bc$export$757ceba2d55c277e; }, function (v) { return $662d9978aa5168bc$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "version", function () { return $662d9978aa5168bc$export$83d89fbfd8236492; }, function (v) { return $662d9978aa5168bc$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $662d9978aa5168bc$export$882461b6382ed46c;
var $662d9978aa5168bc$export$757ceba2d55c277e;
var $662d9978aa5168bc$export$83d89fbfd8236492;

var $6qd2L = parcelRequire("6qd2L");
"use strict";

var $ibqfJ = parcelRequire("ibqfJ");

var $exYeM = parcelRequire("exYeM");

var $d2lNW = parcelRequire("d2lNW");
function $662d9978aa5168bc$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $662d9978aa5168bc$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
var $662d9978aa5168bc$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $662d9978aa5168bc$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $662d9978aa5168bc$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $662d9978aa5168bc$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $662d9978aa5168bc$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $662d9978aa5168bc$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $662d9978aa5168bc$var$REACT_PROVIDER_TYPE = Symbol.for("react.provider"), $662d9978aa5168bc$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $662d9978aa5168bc$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $662d9978aa5168bc$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $662d9978aa5168bc$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $662d9978aa5168bc$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $662d9978aa5168bc$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $662d9978aa5168bc$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $662d9978aa5168bc$var$REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $662d9978aa5168bc$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel"), $662d9978aa5168bc$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $662d9978aa5168bc$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $662d9978aa5168bc$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$662d9978aa5168bc$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $662d9978aa5168bc$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $662d9978aa5168bc$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $662d9978aa5168bc$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $662d9978aa5168bc$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $662d9978aa5168bc$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $662d9978aa5168bc$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $662d9978aa5168bc$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $662d9978aa5168bc$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $662d9978aa5168bc$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $662d9978aa5168bc$var$REACT_CONTEXT_TYPE:
            return (type.displayName || "Context") + ".Provider";
        case $662d9978aa5168bc$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $662d9978aa5168bc$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $662d9978aa5168bc$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $662d9978aa5168bc$var$getComponentNameFromType(type.type) || "Memo";
        case $662d9978aa5168bc$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $662d9978aa5168bc$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $662d9978aa5168bc$var$ReactSharedInternals = $exYeM.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $662d9978aa5168bc$var$assign = Object.assign, $662d9978aa5168bc$var$prefix, $662d9978aa5168bc$var$suffix;
function $662d9978aa5168bc$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $662d9978aa5168bc$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $662d9978aa5168bc$var$prefix = match && match[1] || "";
        $662d9978aa5168bc$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $662d9978aa5168bc$var$prefix + name + $662d9978aa5168bc$var$suffix;
}
var $662d9978aa5168bc$var$reentry = !1;
function $662d9978aa5168bc$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $662d9978aa5168bc$var$reentry) return "";
    $662d9978aa5168bc$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$0) {
                                control = x$0;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$1) {
                            control = x$1;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $662d9978aa5168bc$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $662d9978aa5168bc$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $662d9978aa5168bc$var$describeFiber(fiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $662d9978aa5168bc$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $662d9978aa5168bc$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return $662d9978aa5168bc$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $662d9978aa5168bc$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return fiber = $662d9978aa5168bc$var$describeNativeComponentFrame(fiber.type, !1), fiber;
        case 11:
            return fiber = $662d9978aa5168bc$var$describeNativeComponentFrame(fiber.type.render, !1), fiber;
        case 1:
            return fiber = $662d9978aa5168bc$var$describeNativeComponentFrame(fiber.type, !0), fiber;
        default:
            return "";
    }
}
function $662d9978aa5168bc$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "";
        do info += $662d9978aa5168bc$var$describeFiber(workInProgress), workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
function $662d9978aa5168bc$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $662d9978aa5168bc$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $662d9978aa5168bc$var$assertIsMounted(fiber) {
    if ($662d9978aa5168bc$var$getNearestMountedFiber(fiber) !== fiber) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(188));
}
function $662d9978aa5168bc$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $662d9978aa5168bc$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $662d9978aa5168bc$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $662d9978aa5168bc$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($662d9978aa5168bc$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$2 = parentA.child; child$2;){
                if (child$2 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$2 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$2 = child$2.sibling;
            }
            if (!didFindChild) {
                for(child$2 = parentB.child; child$2;){
                    if (child$2 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$2 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$2 = child$2.sibling;
                }
                if (!didFindChild) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $662d9978aa5168bc$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $662d9978aa5168bc$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $662d9978aa5168bc$var$isArrayImpl = Array.isArray, $662d9978aa5168bc$var$ReactDOMSharedInternals = $d2lNW.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $662d9978aa5168bc$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $662d9978aa5168bc$var$valueStack = [], $662d9978aa5168bc$var$index = -1;
function $662d9978aa5168bc$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $662d9978aa5168bc$var$pop(cursor) {
    0 > $662d9978aa5168bc$var$index || (cursor.current = $662d9978aa5168bc$var$valueStack[$662d9978aa5168bc$var$index], $662d9978aa5168bc$var$valueStack[$662d9978aa5168bc$var$index] = null, $662d9978aa5168bc$var$index--);
}
function $662d9978aa5168bc$var$push(cursor, value) {
    $662d9978aa5168bc$var$index++;
    $662d9978aa5168bc$var$valueStack[$662d9978aa5168bc$var$index] = cursor.current;
    cursor.current = value;
}
var $662d9978aa5168bc$var$contextStackCursor = $662d9978aa5168bc$var$createCursor(null), $662d9978aa5168bc$var$contextFiberStackCursor = $662d9978aa5168bc$var$createCursor(null), $662d9978aa5168bc$var$rootInstanceStackCursor = $662d9978aa5168bc$var$createCursor(null), $662d9978aa5168bc$var$hostTransitionProviderCursor = $662d9978aa5168bc$var$createCursor(null);
function $662d9978aa5168bc$var$pushHostContainer(fiber, nextRootInstance) {
    $662d9978aa5168bc$var$push($662d9978aa5168bc$var$rootInstanceStackCursor, nextRootInstance);
    $662d9978aa5168bc$var$push($662d9978aa5168bc$var$contextFiberStackCursor, fiber);
    $662d9978aa5168bc$var$push($662d9978aa5168bc$var$contextStackCursor, null);
    fiber = nextRootInstance.nodeType;
    switch(fiber){
        case 9:
        case 11:
            nextRootInstance = (nextRootInstance = nextRootInstance.documentElement) ? (nextRootInstance = nextRootInstance.namespaceURI) ? $662d9978aa5168bc$var$getOwnHostContext(nextRootInstance) : 0 : 0;
            break;
        default:
            if (fiber = 8 === fiber ? nextRootInstance.parentNode : nextRootInstance, nextRootInstance = fiber.tagName, fiber = fiber.namespaceURI) fiber = $662d9978aa5168bc$var$getOwnHostContext(fiber), nextRootInstance = $662d9978aa5168bc$var$getChildHostContextProd(fiber, nextRootInstance);
            else switch(nextRootInstance){
                case "svg":
                    nextRootInstance = 1;
                    break;
                case "math":
                    nextRootInstance = 2;
                    break;
                default:
                    nextRootInstance = 0;
            }
    }
    $662d9978aa5168bc$var$pop($662d9978aa5168bc$var$contextStackCursor);
    $662d9978aa5168bc$var$push($662d9978aa5168bc$var$contextStackCursor, nextRootInstance);
}
function $662d9978aa5168bc$var$popHostContainer() {
    $662d9978aa5168bc$var$pop($662d9978aa5168bc$var$contextStackCursor);
    $662d9978aa5168bc$var$pop($662d9978aa5168bc$var$contextFiberStackCursor);
    $662d9978aa5168bc$var$pop($662d9978aa5168bc$var$rootInstanceStackCursor);
}
function $662d9978aa5168bc$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $662d9978aa5168bc$var$push($662d9978aa5168bc$var$hostTransitionProviderCursor, fiber);
    var context = $662d9978aa5168bc$var$contextStackCursor.current;
    var JSCompiler_inline_result = $662d9978aa5168bc$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($662d9978aa5168bc$var$push($662d9978aa5168bc$var$contextFiberStackCursor, fiber), $662d9978aa5168bc$var$push($662d9978aa5168bc$var$contextStackCursor, JSCompiler_inline_result));
}
function $662d9978aa5168bc$var$popHostContext(fiber) {
    $662d9978aa5168bc$var$contextFiberStackCursor.current === fiber && ($662d9978aa5168bc$var$pop($662d9978aa5168bc$var$contextStackCursor), $662d9978aa5168bc$var$pop($662d9978aa5168bc$var$contextFiberStackCursor));
    $662d9978aa5168bc$var$hostTransitionProviderCursor.current === fiber && ($662d9978aa5168bc$var$pop($662d9978aa5168bc$var$hostTransitionProviderCursor), $662d9978aa5168bc$var$HostTransitionContext._currentValue = $662d9978aa5168bc$var$sharedNotPendingObject);
}
var $662d9978aa5168bc$var$hasOwnProperty = Object.prototype.hasOwnProperty, $662d9978aa5168bc$var$scheduleCallback$3 = $ibqfJ.unstable_scheduleCallback, $662d9978aa5168bc$var$cancelCallback$1 = $ibqfJ.unstable_cancelCallback, $662d9978aa5168bc$var$shouldYield = $ibqfJ.unstable_shouldYield, $662d9978aa5168bc$var$requestPaint = $ibqfJ.unstable_requestPaint, $662d9978aa5168bc$var$now = $ibqfJ.unstable_now, $662d9978aa5168bc$var$getCurrentPriorityLevel = $ibqfJ.unstable_getCurrentPriorityLevel, $662d9978aa5168bc$var$ImmediatePriority = $ibqfJ.unstable_ImmediatePriority, $662d9978aa5168bc$var$UserBlockingPriority = $ibqfJ.unstable_UserBlockingPriority, $662d9978aa5168bc$var$NormalPriority$1 = $ibqfJ.unstable_NormalPriority, $662d9978aa5168bc$var$LowPriority = $ibqfJ.unstable_LowPriority, $662d9978aa5168bc$var$IdlePriority = $ibqfJ.unstable_IdlePriority, $662d9978aa5168bc$var$log$1 = $ibqfJ.log, $662d9978aa5168bc$var$unstable_setDisableYieldValue = $ibqfJ.unstable_setDisableYieldValue, $662d9978aa5168bc$var$rendererID = null, $662d9978aa5168bc$var$injectedHook = null;
function $662d9978aa5168bc$var$onCommitRoot(root) {
    if ($662d9978aa5168bc$var$injectedHook && "function" === typeof $662d9978aa5168bc$var$injectedHook.onCommitFiberRoot) try {
        $662d9978aa5168bc$var$injectedHook.onCommitFiberRoot($662d9978aa5168bc$var$rendererID, root, void 0, 128 === (root.current.flags & 128));
    } catch (err) {}
}
function $662d9978aa5168bc$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $662d9978aa5168bc$var$log$1 && $662d9978aa5168bc$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($662d9978aa5168bc$var$injectedHook && "function" === typeof $662d9978aa5168bc$var$injectedHook.setStrictMode) try {
        $662d9978aa5168bc$var$injectedHook.setStrictMode($662d9978aa5168bc$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $662d9978aa5168bc$var$clz32 = Math.clz32 ? Math.clz32 : $662d9978aa5168bc$var$clz32Fallback, $662d9978aa5168bc$var$log = Math.log, $662d9978aa5168bc$var$LN2 = Math.LN2;
function $662d9978aa5168bc$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($662d9978aa5168bc$var$log(x) / $662d9978aa5168bc$var$LN2 | 0) | 0;
}
var $662d9978aa5168bc$var$nextTransitionLane = 128, $662d9978aa5168bc$var$nextRetryLane = 4194304;
function $662d9978aa5168bc$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 4194176;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $662d9978aa5168bc$var$getNextLanes(root, wipLanes) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, warmLanes = root.warmLanes;
    root = 0 !== root.finishedLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $662d9978aa5168bc$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $662d9978aa5168bc$var$getHighestPriorityLanes(pingedLanes) : root || (warmLanes = nonIdlePendingLanes & ~warmLanes, 0 !== warmLanes && (nextLanes = $662d9978aa5168bc$var$getHighestPriorityLanes(warmLanes))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $662d9978aa5168bc$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $662d9978aa5168bc$var$getHighestPriorityLanes(pingedLanes) : root || (warmLanes = pendingLanes & ~warmLanes, 0 !== warmLanes && (nextLanes = $662d9978aa5168bc$var$getHighestPriorityLanes(warmLanes))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, warmLanes = wipLanes & -wipLanes, suspendedLanes >= warmLanes || 32 === suspendedLanes && 0 !== (warmLanes & 4194176)) ? wipLanes : nextLanes;
}
function $662d9978aa5168bc$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $662d9978aa5168bc$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
            return currentTime + 250;
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $662d9978aa5168bc$var$claimNextTransitionLane() {
    var lane = $662d9978aa5168bc$var$nextTransitionLane;
    $662d9978aa5168bc$var$nextTransitionLane <<= 1;
    0 === ($662d9978aa5168bc$var$nextTransitionLane & 4194176) && ($662d9978aa5168bc$var$nextTransitionLane = 128);
    return lane;
}
function $662d9978aa5168bc$var$claimNextRetryLane() {
    var lane = $662d9978aa5168bc$var$nextRetryLane;
    $662d9978aa5168bc$var$nextRetryLane <<= 1;
    0 === ($662d9978aa5168bc$var$nextRetryLane & 62914560) && ($662d9978aa5168bc$var$nextRetryLane = 4194304);
    return lane;
}
function $662d9978aa5168bc$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $662d9978aa5168bc$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $662d9978aa5168bc$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $662d9978aa5168bc$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $662d9978aa5168bc$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $662d9978aa5168bc$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $662d9978aa5168bc$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 4194218;
}
function $662d9978aa5168bc$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $662d9978aa5168bc$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $662d9978aa5168bc$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $662d9978aa5168bc$var$resolveUpdatePriority() {
    var updatePriority = $662d9978aa5168bc$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $662d9978aa5168bc$var$getEventPriority(updatePriority.type);
}
function $662d9978aa5168bc$var$runWithPriority(priority, fn) {
    var previousPriority = $662d9978aa5168bc$var$ReactDOMSharedInternals.p;
    try {
        return $662d9978aa5168bc$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $662d9978aa5168bc$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $662d9978aa5168bc$var$randomKey = Math.random().toString(36).slice(2), $662d9978aa5168bc$var$internalInstanceKey = "__reactFiber$" + $662d9978aa5168bc$var$randomKey, $662d9978aa5168bc$var$internalPropsKey = "__reactProps$" + $662d9978aa5168bc$var$randomKey, $662d9978aa5168bc$var$internalContainerInstanceKey = "__reactContainer$" + $662d9978aa5168bc$var$randomKey, $662d9978aa5168bc$var$internalEventHandlersKey = "__reactEvents$" + $662d9978aa5168bc$var$randomKey, $662d9978aa5168bc$var$internalEventHandlerListenersKey = "__reactListeners$" + $662d9978aa5168bc$var$randomKey, $662d9978aa5168bc$var$internalEventHandlesSetKey = "__reactHandles$" + $662d9978aa5168bc$var$randomKey, $662d9978aa5168bc$var$internalRootNodeResourcesKey = "__reactResources$" + $662d9978aa5168bc$var$randomKey, $662d9978aa5168bc$var$internalHoistableMarker = "__reactMarker$" + $662d9978aa5168bc$var$randomKey;
function $662d9978aa5168bc$var$detachDeletedInstance(node) {
    delete node[$662d9978aa5168bc$var$internalInstanceKey];
    delete node[$662d9978aa5168bc$var$internalPropsKey];
    delete node[$662d9978aa5168bc$var$internalEventHandlersKey];
    delete node[$662d9978aa5168bc$var$internalEventHandlerListenersKey];
    delete node[$662d9978aa5168bc$var$internalEventHandlesSetKey];
}
function $662d9978aa5168bc$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$662d9978aa5168bc$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$662d9978aa5168bc$var$internalContainerInstanceKey] || parentNode[$662d9978aa5168bc$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $662d9978aa5168bc$var$getParentSuspenseInstance(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$662d9978aa5168bc$var$internalInstanceKey]) return parentNode;
                targetNode = $662d9978aa5168bc$var$getParentSuspenseInstance(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $662d9978aa5168bc$var$getInstanceFromNode(node) {
    if (node = node[$662d9978aa5168bc$var$internalInstanceKey] || node[$662d9978aa5168bc$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $662d9978aa5168bc$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($662d9978aa5168bc$var$formatProdErrorMessage(33));
}
function $662d9978aa5168bc$var$getResourcesFromRoot(root) {
    var resources = root[$662d9978aa5168bc$var$internalRootNodeResourcesKey];
    resources || (resources = root[$662d9978aa5168bc$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $662d9978aa5168bc$var$markNodeAsHoistable(node) {
    node[$662d9978aa5168bc$var$internalHoistableMarker] = !0;
}
var $662d9978aa5168bc$var$allNativeEvents = new Set(), $662d9978aa5168bc$var$registrationNameDependencies = {};
function $662d9978aa5168bc$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $662d9978aa5168bc$var$registerDirectEvent(registrationName, dependencies);
    $662d9978aa5168bc$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $662d9978aa5168bc$var$registerDirectEvent(registrationName, dependencies) {
    $662d9978aa5168bc$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$662d9978aa5168bc$var$allNativeEvents.add(dependencies[registrationName]);
}
var $662d9978aa5168bc$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $662d9978aa5168bc$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $662d9978aa5168bc$var$illegalAttributeNameCache = {}, $662d9978aa5168bc$var$validatedAttributeNameCache = {};
function $662d9978aa5168bc$var$isAttributeNameSafe(attributeName) {
    if ($662d9978aa5168bc$var$hasOwnProperty.call($662d9978aa5168bc$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($662d9978aa5168bc$var$hasOwnProperty.call($662d9978aa5168bc$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($662d9978aa5168bc$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $662d9978aa5168bc$var$validatedAttributeNameCache[attributeName] = !0;
    $662d9978aa5168bc$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $662d9978aa5168bc$var$setValueForAttribute(node, name, value) {
    if ($662d9978aa5168bc$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $662d9978aa5168bc$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $662d9978aa5168bc$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $662d9978aa5168bc$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $662d9978aa5168bc$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $662d9978aa5168bc$var$trackValueOnNode(node) {
    var valueField = $662d9978aa5168bc$var$isCheckable(node) ? "checked" : "value", descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField), currentValue = "" + node[valueField];
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $662d9978aa5168bc$var$track(node) {
    node._valueTracker || (node._valueTracker = $662d9978aa5168bc$var$trackValueOnNode(node));
}
function $662d9978aa5168bc$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $662d9978aa5168bc$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $662d9978aa5168bc$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $662d9978aa5168bc$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $662d9978aa5168bc$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($662d9978aa5168bc$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $662d9978aa5168bc$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $662d9978aa5168bc$var$getToStringValue(value);
        } else element.value !== "" + $662d9978aa5168bc$var$getToStringValue(value) && (element.value = "" + $662d9978aa5168bc$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $662d9978aa5168bc$var$setDefaultValue(element, type, $662d9978aa5168bc$var$getToStringValue(value)) : null != defaultValue ? $662d9978aa5168bc$var$setDefaultValue(element, type, $662d9978aa5168bc$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $662d9978aa5168bc$var$getToStringValue(name) : element.removeAttribute("name");
}
function $662d9978aa5168bc$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) return;
        defaultValue = null != defaultValue ? "" + $662d9978aa5168bc$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $662d9978aa5168bc$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
}
function $662d9978aa5168bc$var$setDefaultValue(node, type, value) {
    "number" === type && $662d9978aa5168bc$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $662d9978aa5168bc$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $662d9978aa5168bc$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $662d9978aa5168bc$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $662d9978aa5168bc$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $662d9978aa5168bc$var$getToStringValue(defaultValue) : "";
}
function $662d9978aa5168bc$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(92));
            if ($662d9978aa5168bc$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $662d9978aa5168bc$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
}
function $662d9978aa5168bc$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $662d9978aa5168bc$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $662d9978aa5168bc$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $662d9978aa5168bc$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $662d9978aa5168bc$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $662d9978aa5168bc$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $662d9978aa5168bc$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $662d9978aa5168bc$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $662d9978aa5168bc$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $662d9978aa5168bc$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $662d9978aa5168bc$var$sanitizeURL(url) {
    return $662d9978aa5168bc$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
var $662d9978aa5168bc$var$currentReplayingEvent = null;
function $662d9978aa5168bc$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $662d9978aa5168bc$var$restoreTarget = null, $662d9978aa5168bc$var$restoreQueue = null;
function $662d9978aa5168bc$var$restoreStateOfTarget(target) {
    var internalInstance = $662d9978aa5168bc$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$662d9978aa5168bc$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $662d9978aa5168bc$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $662d9978aa5168bc$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$662d9978aa5168bc$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(90));
                            $662d9978aa5168bc$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $662d9978aa5168bc$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $662d9978aa5168bc$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $662d9978aa5168bc$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $662d9978aa5168bc$var$isInsideEventHandler = !1;
function $662d9978aa5168bc$var$batchedUpdates$1(fn, a, b) {
    if ($662d9978aa5168bc$var$isInsideEventHandler) return fn(a, b);
    $662d9978aa5168bc$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($662d9978aa5168bc$var$isInsideEventHandler = !1, null !== $662d9978aa5168bc$var$restoreTarget || null !== $662d9978aa5168bc$var$restoreQueue) {
            if ($662d9978aa5168bc$var$flushSyncWork$1(), $662d9978aa5168bc$var$restoreTarget && (a = $662d9978aa5168bc$var$restoreTarget, fn = $662d9978aa5168bc$var$restoreQueue, $662d9978aa5168bc$var$restoreQueue = $662d9978aa5168bc$var$restoreTarget = null, $662d9978aa5168bc$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$662d9978aa5168bc$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $662d9978aa5168bc$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$662d9978aa5168bc$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $662d9978aa5168bc$var$passiveBrowserEventsSupported = !1;
if ($662d9978aa5168bc$var$canUseDOM) try {
    var $662d9978aa5168bc$var$options = {};
    Object.defineProperty($662d9978aa5168bc$var$options, "passive", {
        get: function() {
            $662d9978aa5168bc$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $662d9978aa5168bc$var$options, $662d9978aa5168bc$var$options);
    window.removeEventListener("test", $662d9978aa5168bc$var$options, $662d9978aa5168bc$var$options);
} catch (e) {
    $662d9978aa5168bc$var$passiveBrowserEventsSupported = !1;
}
var $662d9978aa5168bc$var$root = null, $662d9978aa5168bc$var$startText = null, $662d9978aa5168bc$var$fallbackText = null;
function $662d9978aa5168bc$var$getData() {
    if ($662d9978aa5168bc$var$fallbackText) return $662d9978aa5168bc$var$fallbackText;
    var start, startValue = $662d9978aa5168bc$var$startText, startLength = startValue.length, end, endValue = "value" in $662d9978aa5168bc$var$root ? $662d9978aa5168bc$var$root.value : $662d9978aa5168bc$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $662d9978aa5168bc$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $662d9978aa5168bc$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $662d9978aa5168bc$var$functionThatReturnsTrue() {
    return !0;
}
function $662d9978aa5168bc$var$functionThatReturnsFalse() {
    return !1;
}
function $662d9978aa5168bc$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $662d9978aa5168bc$var$functionThatReturnsTrue : $662d9978aa5168bc$var$functionThatReturnsFalse;
        this.isPropagationStopped = $662d9978aa5168bc$var$functionThatReturnsFalse;
        return this;
    }
    $662d9978aa5168bc$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $662d9978aa5168bc$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $662d9978aa5168bc$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $662d9978aa5168bc$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $662d9978aa5168bc$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $662d9978aa5168bc$var$SyntheticEvent = $662d9978aa5168bc$var$createSyntheticEvent($662d9978aa5168bc$var$EventInterface), $662d9978aa5168bc$var$UIEventInterface = $662d9978aa5168bc$var$assign({}, $662d9978aa5168bc$var$EventInterface, {
    view: 0,
    detail: 0
}), $662d9978aa5168bc$var$SyntheticUIEvent = $662d9978aa5168bc$var$createSyntheticEvent($662d9978aa5168bc$var$UIEventInterface), $662d9978aa5168bc$var$lastMovementX, $662d9978aa5168bc$var$lastMovementY, $662d9978aa5168bc$var$lastMouseEvent, $662d9978aa5168bc$var$MouseEventInterface = $662d9978aa5168bc$var$assign({}, $662d9978aa5168bc$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $662d9978aa5168bc$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $662d9978aa5168bc$var$lastMouseEvent && ($662d9978aa5168bc$var$lastMouseEvent && "mousemove" === event.type ? ($662d9978aa5168bc$var$lastMovementX = event.screenX - $662d9978aa5168bc$var$lastMouseEvent.screenX, $662d9978aa5168bc$var$lastMovementY = event.screenY - $662d9978aa5168bc$var$lastMouseEvent.screenY) : $662d9978aa5168bc$var$lastMovementY = $662d9978aa5168bc$var$lastMovementX = 0, $662d9978aa5168bc$var$lastMouseEvent = event);
        return $662d9978aa5168bc$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $662d9978aa5168bc$var$lastMovementY;
    }
}), $662d9978aa5168bc$var$SyntheticMouseEvent = $662d9978aa5168bc$var$createSyntheticEvent($662d9978aa5168bc$var$MouseEventInterface), $662d9978aa5168bc$var$DragEventInterface = $662d9978aa5168bc$var$assign({}, $662d9978aa5168bc$var$MouseEventInterface, {
    dataTransfer: 0
}), $662d9978aa5168bc$var$SyntheticDragEvent = $662d9978aa5168bc$var$createSyntheticEvent($662d9978aa5168bc$var$DragEventInterface), $662d9978aa5168bc$var$FocusEventInterface = $662d9978aa5168bc$var$assign({}, $662d9978aa5168bc$var$UIEventInterface, {
    relatedTarget: 0
}), $662d9978aa5168bc$var$SyntheticFocusEvent = $662d9978aa5168bc$var$createSyntheticEvent($662d9978aa5168bc$var$FocusEventInterface), $662d9978aa5168bc$var$AnimationEventInterface = $662d9978aa5168bc$var$assign({}, $662d9978aa5168bc$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $662d9978aa5168bc$var$SyntheticAnimationEvent = $662d9978aa5168bc$var$createSyntheticEvent($662d9978aa5168bc$var$AnimationEventInterface), $662d9978aa5168bc$var$ClipboardEventInterface = $662d9978aa5168bc$var$assign({}, $662d9978aa5168bc$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $662d9978aa5168bc$var$SyntheticClipboardEvent = $662d9978aa5168bc$var$createSyntheticEvent($662d9978aa5168bc$var$ClipboardEventInterface), $662d9978aa5168bc$var$CompositionEventInterface = $662d9978aa5168bc$var$assign({}, $662d9978aa5168bc$var$EventInterface, {
    data: 0
}), $662d9978aa5168bc$var$SyntheticCompositionEvent = $662d9978aa5168bc$var$createSyntheticEvent($662d9978aa5168bc$var$CompositionEventInterface), $662d9978aa5168bc$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $662d9978aa5168bc$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $662d9978aa5168bc$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $662d9978aa5168bc$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $662d9978aa5168bc$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $662d9978aa5168bc$var$getEventModifierState() {
    return $662d9978aa5168bc$var$modifierStateGetter;
}
var $662d9978aa5168bc$var$KeyboardEventInterface = $662d9978aa5168bc$var$assign({}, $662d9978aa5168bc$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $662d9978aa5168bc$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $662d9978aa5168bc$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $662d9978aa5168bc$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $662d9978aa5168bc$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $662d9978aa5168bc$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $662d9978aa5168bc$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $662d9978aa5168bc$var$SyntheticKeyboardEvent = $662d9978aa5168bc$var$createSyntheticEvent($662d9978aa5168bc$var$KeyboardEventInterface), $662d9978aa5168bc$var$PointerEventInterface = $662d9978aa5168bc$var$assign({}, $662d9978aa5168bc$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $662d9978aa5168bc$var$SyntheticPointerEvent = $662d9978aa5168bc$var$createSyntheticEvent($662d9978aa5168bc$var$PointerEventInterface), $662d9978aa5168bc$var$TouchEventInterface = $662d9978aa5168bc$var$assign({}, $662d9978aa5168bc$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $662d9978aa5168bc$var$getEventModifierState
}), $662d9978aa5168bc$var$SyntheticTouchEvent = $662d9978aa5168bc$var$createSyntheticEvent($662d9978aa5168bc$var$TouchEventInterface), $662d9978aa5168bc$var$TransitionEventInterface = $662d9978aa5168bc$var$assign({}, $662d9978aa5168bc$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $662d9978aa5168bc$var$SyntheticTransitionEvent = $662d9978aa5168bc$var$createSyntheticEvent($662d9978aa5168bc$var$TransitionEventInterface), $662d9978aa5168bc$var$WheelEventInterface = $662d9978aa5168bc$var$assign({}, $662d9978aa5168bc$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $662d9978aa5168bc$var$SyntheticWheelEvent = $662d9978aa5168bc$var$createSyntheticEvent($662d9978aa5168bc$var$WheelEventInterface), $662d9978aa5168bc$var$ToggleEventInterface = $662d9978aa5168bc$var$assign({}, $662d9978aa5168bc$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $662d9978aa5168bc$var$SyntheticToggleEvent = $662d9978aa5168bc$var$createSyntheticEvent($662d9978aa5168bc$var$ToggleEventInterface), $662d9978aa5168bc$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $662d9978aa5168bc$var$canUseCompositionEvent = $662d9978aa5168bc$var$canUseDOM && "CompositionEvent" in window, $662d9978aa5168bc$var$documentMode = null;
$662d9978aa5168bc$var$canUseDOM && "documentMode" in document && ($662d9978aa5168bc$var$documentMode = document.documentMode);
var $662d9978aa5168bc$var$canUseTextInputEvent = $662d9978aa5168bc$var$canUseDOM && "TextEvent" in window && !$662d9978aa5168bc$var$documentMode, $662d9978aa5168bc$var$useFallbackCompositionData = $662d9978aa5168bc$var$canUseDOM && (!$662d9978aa5168bc$var$canUseCompositionEvent || $662d9978aa5168bc$var$documentMode && 8 < $662d9978aa5168bc$var$documentMode && 11 >= $662d9978aa5168bc$var$documentMode), $662d9978aa5168bc$var$SPACEBAR_CHAR = String.fromCharCode(32), $662d9978aa5168bc$var$hasSpaceKeypress = !1;
function $662d9978aa5168bc$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $662d9978aa5168bc$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $662d9978aa5168bc$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $662d9978aa5168bc$var$isComposing = !1;
function $662d9978aa5168bc$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $662d9978aa5168bc$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $662d9978aa5168bc$var$hasSpaceKeypress = !0;
            return $662d9978aa5168bc$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $662d9978aa5168bc$var$SPACEBAR_CHAR && $662d9978aa5168bc$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $662d9978aa5168bc$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($662d9978aa5168bc$var$isComposing) return "compositionend" === domEventName || !$662d9978aa5168bc$var$canUseCompositionEvent && $662d9978aa5168bc$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $662d9978aa5168bc$var$getData(), $662d9978aa5168bc$var$fallbackText = $662d9978aa5168bc$var$startText = $662d9978aa5168bc$var$root = null, $662d9978aa5168bc$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $662d9978aa5168bc$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $662d9978aa5168bc$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $662d9978aa5168bc$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$662d9978aa5168bc$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $662d9978aa5168bc$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $662d9978aa5168bc$var$restoreTarget ? $662d9978aa5168bc$var$restoreQueue ? $662d9978aa5168bc$var$restoreQueue.push(target) : $662d9978aa5168bc$var$restoreQueue = [
        target
    ] : $662d9978aa5168bc$var$restoreTarget = target;
    inst = $662d9978aa5168bc$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $662d9978aa5168bc$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $662d9978aa5168bc$var$activeElement$1 = null, $662d9978aa5168bc$var$activeElementInst$1 = null;
function $662d9978aa5168bc$var$runEventInBatch(dispatchQueue) {
    $662d9978aa5168bc$var$processDispatchQueue(dispatchQueue, 0);
}
function $662d9978aa5168bc$var$getInstIfValueChanged(targetInst) {
    var targetNode = $662d9978aa5168bc$var$getNodeFromInstance(targetInst);
    if ($662d9978aa5168bc$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $662d9978aa5168bc$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $662d9978aa5168bc$var$isInputEventSupported = !1;
if ($662d9978aa5168bc$var$canUseDOM) {
    var $662d9978aa5168bc$var$JSCompiler_inline_result$jscomp$283;
    if ($662d9978aa5168bc$var$canUseDOM) {
        var $662d9978aa5168bc$var$isSupported$jscomp$inline_418 = "oninput" in document;
        if (!$662d9978aa5168bc$var$isSupported$jscomp$inline_418) {
            var $662d9978aa5168bc$var$element$jscomp$inline_419 = document.createElement("div");
            $662d9978aa5168bc$var$element$jscomp$inline_419.setAttribute("oninput", "return;");
            $662d9978aa5168bc$var$isSupported$jscomp$inline_418 = "function" === typeof $662d9978aa5168bc$var$element$jscomp$inline_419.oninput;
        }
        $662d9978aa5168bc$var$JSCompiler_inline_result$jscomp$283 = $662d9978aa5168bc$var$isSupported$jscomp$inline_418;
    } else $662d9978aa5168bc$var$JSCompiler_inline_result$jscomp$283 = !1;
    $662d9978aa5168bc$var$isInputEventSupported = $662d9978aa5168bc$var$JSCompiler_inline_result$jscomp$283 && (!document.documentMode || 9 < document.documentMode);
}
function $662d9978aa5168bc$var$stopWatchingForValueChange() {
    $662d9978aa5168bc$var$activeElement$1 && ($662d9978aa5168bc$var$activeElement$1.detachEvent("onpropertychange", $662d9978aa5168bc$var$handlePropertyChange), $662d9978aa5168bc$var$activeElementInst$1 = $662d9978aa5168bc$var$activeElement$1 = null);
}
function $662d9978aa5168bc$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $662d9978aa5168bc$var$getInstIfValueChanged($662d9978aa5168bc$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $662d9978aa5168bc$var$createAndAccumulateChangeEvent(dispatchQueue, $662d9978aa5168bc$var$activeElementInst$1, nativeEvent, $662d9978aa5168bc$var$getEventTarget(nativeEvent));
        $662d9978aa5168bc$var$batchedUpdates$1($662d9978aa5168bc$var$runEventInBatch, dispatchQueue);
    }
}
function $662d9978aa5168bc$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($662d9978aa5168bc$var$stopWatchingForValueChange(), $662d9978aa5168bc$var$activeElement$1 = target, $662d9978aa5168bc$var$activeElementInst$1 = targetInst, $662d9978aa5168bc$var$activeElement$1.attachEvent("onpropertychange", $662d9978aa5168bc$var$handlePropertyChange)) : "focusout" === domEventName && $662d9978aa5168bc$var$stopWatchingForValueChange();
}
function $662d9978aa5168bc$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $662d9978aa5168bc$var$getInstIfValueChanged($662d9978aa5168bc$var$activeElementInst$1);
}
function $662d9978aa5168bc$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $662d9978aa5168bc$var$getInstIfValueChanged(targetInst);
}
function $662d9978aa5168bc$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $662d9978aa5168bc$var$getInstIfValueChanged(targetInst);
}
function $662d9978aa5168bc$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $662d9978aa5168bc$var$objectIs = "function" === typeof Object.is ? Object.is : $662d9978aa5168bc$var$is;
function $662d9978aa5168bc$var$shallowEqual(objA, objB) {
    if ($662d9978aa5168bc$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$662d9978aa5168bc$var$hasOwnProperty.call(objB, currentKey) || !$662d9978aa5168bc$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $662d9978aa5168bc$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $662d9978aa5168bc$var$getNodeForCharacterOffset(root, offset) {
    var node = $662d9978aa5168bc$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $662d9978aa5168bc$var$getLeafNode(node);
    }
}
function $662d9978aa5168bc$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $662d9978aa5168bc$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $662d9978aa5168bc$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $662d9978aa5168bc$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $662d9978aa5168bc$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $662d9978aa5168bc$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
function $662d9978aa5168bc$var$restoreSelection(priorSelectionInformation, containerInfo) {
    var curFocusedElem = $662d9978aa5168bc$var$getActiveElementDeep(containerInfo);
    containerInfo = priorSelectionInformation.focusedElem;
    var priorSelectionRange = priorSelectionInformation.selectionRange;
    if (curFocusedElem !== containerInfo && containerInfo && containerInfo.ownerDocument && $662d9978aa5168bc$var$containsNode(containerInfo.ownerDocument.documentElement, containerInfo)) {
        if (null !== priorSelectionRange && $662d9978aa5168bc$var$hasSelectionCapabilities(containerInfo)) {
            if (priorSelectionInformation = priorSelectionRange.start, curFocusedElem = priorSelectionRange.end, void 0 === curFocusedElem && (curFocusedElem = priorSelectionInformation), "selectionStart" in containerInfo) containerInfo.selectionStart = priorSelectionInformation, containerInfo.selectionEnd = Math.min(curFocusedElem, containerInfo.value.length);
            else if (curFocusedElem = (priorSelectionInformation = containerInfo.ownerDocument || document) && priorSelectionInformation.defaultView || window, curFocusedElem.getSelection) {
                curFocusedElem = curFocusedElem.getSelection();
                var length = containerInfo.textContent.length, start = Math.min(priorSelectionRange.start, length);
                priorSelectionRange = void 0 === priorSelectionRange.end ? start : Math.min(priorSelectionRange.end, length);
                !curFocusedElem.extend && start > priorSelectionRange && (length = priorSelectionRange, priorSelectionRange = start, start = length);
                length = $662d9978aa5168bc$var$getNodeForCharacterOffset(containerInfo, start);
                var endMarker = $662d9978aa5168bc$var$getNodeForCharacterOffset(containerInfo, priorSelectionRange);
                length && endMarker && (1 !== curFocusedElem.rangeCount || curFocusedElem.anchorNode !== length.node || curFocusedElem.anchorOffset !== length.offset || curFocusedElem.focusNode !== endMarker.node || curFocusedElem.focusOffset !== endMarker.offset) && (priorSelectionInformation = priorSelectionInformation.createRange(), priorSelectionInformation.setStart(length.node, length.offset), curFocusedElem.removeAllRanges(), start > priorSelectionRange ? (curFocusedElem.addRange(priorSelectionInformation), curFocusedElem.extend(endMarker.node, endMarker.offset)) : (priorSelectionInformation.setEnd(endMarker.node, endMarker.offset), curFocusedElem.addRange(priorSelectionInformation)));
            }
        }
        priorSelectionInformation = [];
        for(curFocusedElem = containerInfo; curFocusedElem = curFocusedElem.parentNode;)1 === curFocusedElem.nodeType && priorSelectionInformation.push({
            element: curFocusedElem,
            left: curFocusedElem.scrollLeft,
            top: curFocusedElem.scrollTop
        });
        "function" === typeof containerInfo.focus && containerInfo.focus();
        for(containerInfo = 0; containerInfo < priorSelectionInformation.length; containerInfo++)curFocusedElem = priorSelectionInformation[containerInfo], curFocusedElem.element.scrollLeft = curFocusedElem.left, curFocusedElem.element.scrollTop = curFocusedElem.top;
    }
}
var $662d9978aa5168bc$var$skipSelectionChangeEvent = $662d9978aa5168bc$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $662d9978aa5168bc$var$activeElement = null, $662d9978aa5168bc$var$activeElementInst = null, $662d9978aa5168bc$var$lastSelection = null, $662d9978aa5168bc$var$mouseDown = !1;
function $662d9978aa5168bc$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $662d9978aa5168bc$var$mouseDown || null == $662d9978aa5168bc$var$activeElement || $662d9978aa5168bc$var$activeElement !== $662d9978aa5168bc$var$getActiveElement(doc) || (doc = $662d9978aa5168bc$var$activeElement, "selectionStart" in doc && $662d9978aa5168bc$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $662d9978aa5168bc$var$lastSelection && $662d9978aa5168bc$var$shallowEqual($662d9978aa5168bc$var$lastSelection, doc) || ($662d9978aa5168bc$var$lastSelection = doc, doc = $662d9978aa5168bc$var$accumulateTwoPhaseListeners($662d9978aa5168bc$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $662d9978aa5168bc$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $662d9978aa5168bc$var$activeElement)));
}
function $662d9978aa5168bc$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $662d9978aa5168bc$var$vendorPrefixes = {
    animationend: $662d9978aa5168bc$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $662d9978aa5168bc$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $662d9978aa5168bc$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $662d9978aa5168bc$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $662d9978aa5168bc$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $662d9978aa5168bc$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $662d9978aa5168bc$var$makePrefixMap("Transition", "TransitionEnd")
}, $662d9978aa5168bc$var$prefixedEventNames = {}, $662d9978aa5168bc$var$style = {};
$662d9978aa5168bc$var$canUseDOM && ($662d9978aa5168bc$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $662d9978aa5168bc$var$vendorPrefixes.animationend.animation, delete $662d9978aa5168bc$var$vendorPrefixes.animationiteration.animation, delete $662d9978aa5168bc$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $662d9978aa5168bc$var$vendorPrefixes.transitionend.transition);
function $662d9978aa5168bc$var$getVendorPrefixedEventName(eventName) {
    if ($662d9978aa5168bc$var$prefixedEventNames[eventName]) return $662d9978aa5168bc$var$prefixedEventNames[eventName];
    if (!$662d9978aa5168bc$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $662d9978aa5168bc$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $662d9978aa5168bc$var$style) return $662d9978aa5168bc$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $662d9978aa5168bc$var$ANIMATION_END = $662d9978aa5168bc$var$getVendorPrefixedEventName("animationend"), $662d9978aa5168bc$var$ANIMATION_ITERATION = $662d9978aa5168bc$var$getVendorPrefixedEventName("animationiteration"), $662d9978aa5168bc$var$ANIMATION_START = $662d9978aa5168bc$var$getVendorPrefixedEventName("animationstart"), $662d9978aa5168bc$var$TRANSITION_RUN = $662d9978aa5168bc$var$getVendorPrefixedEventName("transitionrun"), $662d9978aa5168bc$var$TRANSITION_START = $662d9978aa5168bc$var$getVendorPrefixedEventName("transitionstart"), $662d9978aa5168bc$var$TRANSITION_CANCEL = $662d9978aa5168bc$var$getVendorPrefixedEventName("transitioncancel"), $662d9978aa5168bc$var$TRANSITION_END = $662d9978aa5168bc$var$getVendorPrefixedEventName("transitionend"), $662d9978aa5168bc$var$topLevelEventsToReactNames = new Map(), $662d9978aa5168bc$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll scrollEnd toggle touchMove waiting wheel".split(" ");
function $662d9978aa5168bc$var$registerSimpleEvent(domEventName, reactName) {
    $662d9978aa5168bc$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $662d9978aa5168bc$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $662d9978aa5168bc$var$concurrentQueues = [], $662d9978aa5168bc$var$concurrentQueuesIndex = 0, $662d9978aa5168bc$var$concurrentlyUpdatedLanes = 0;
function $662d9978aa5168bc$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $662d9978aa5168bc$var$concurrentQueuesIndex, i = $662d9978aa5168bc$var$concurrentlyUpdatedLanes = $662d9978aa5168bc$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $662d9978aa5168bc$var$concurrentQueues[i];
        $662d9978aa5168bc$var$concurrentQueues[i++] = null;
        var queue = $662d9978aa5168bc$var$concurrentQueues[i];
        $662d9978aa5168bc$var$concurrentQueues[i++] = null;
        var update = $662d9978aa5168bc$var$concurrentQueues[i];
        $662d9978aa5168bc$var$concurrentQueues[i++] = null;
        var lane = $662d9978aa5168bc$var$concurrentQueues[i];
        $662d9978aa5168bc$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $662d9978aa5168bc$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $662d9978aa5168bc$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $662d9978aa5168bc$var$concurrentQueues[$662d9978aa5168bc$var$concurrentQueuesIndex++] = fiber;
    $662d9978aa5168bc$var$concurrentQueues[$662d9978aa5168bc$var$concurrentQueuesIndex++] = queue;
    $662d9978aa5168bc$var$concurrentQueues[$662d9978aa5168bc$var$concurrentQueuesIndex++] = update;
    $662d9978aa5168bc$var$concurrentQueues[$662d9978aa5168bc$var$concurrentQueuesIndex++] = lane;
    $662d9978aa5168bc$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $662d9978aa5168bc$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $662d9978aa5168bc$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $662d9978aa5168bc$var$getRootForUpdatedFiber(fiber);
}
function $662d9978aa5168bc$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $662d9978aa5168bc$var$enqueueUpdate$1(fiber, null, null, lane);
    return $662d9978aa5168bc$var$getRootForUpdatedFiber(fiber);
}
function $662d9978aa5168bc$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    isHidden && null !== update && 3 === sourceFiber.tag && (parent = sourceFiber.stateNode, isHidden = 31 - $662d9978aa5168bc$var$clz32(lane), parent = parent.hiddenUpdates, sourceFiber = parent[isHidden], null === sourceFiber ? parent[isHidden] = [
        update
    ] : sourceFiber.push(update), update.lane = lane | 536870912);
}
function $662d9978aa5168bc$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $662d9978aa5168bc$var$nestedUpdateCount) throw $662d9978aa5168bc$var$nestedUpdateCount = 0, $662d9978aa5168bc$var$rootWithNestedUpdates = null, Error($662d9978aa5168bc$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $662d9978aa5168bc$var$emptyContextObject = {}, $662d9978aa5168bc$var$CapturedStacks = new WeakMap();
function $662d9978aa5168bc$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $662d9978aa5168bc$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $662d9978aa5168bc$var$getStackByFiberInDevAndProd(source)
        };
        $662d9978aa5168bc$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $662d9978aa5168bc$var$getStackByFiberInDevAndProd(source)
    };
}
var $662d9978aa5168bc$var$forkStack = [], $662d9978aa5168bc$var$forkStackIndex = 0, $662d9978aa5168bc$var$treeForkProvider = null, $662d9978aa5168bc$var$treeForkCount = 0, $662d9978aa5168bc$var$idStack = [], $662d9978aa5168bc$var$idStackIndex = 0, $662d9978aa5168bc$var$treeContextProvider = null, $662d9978aa5168bc$var$treeContextId = 1, $662d9978aa5168bc$var$treeContextOverflow = "";
function $662d9978aa5168bc$var$pushTreeFork(workInProgress, totalChildren) {
    $662d9978aa5168bc$var$forkStack[$662d9978aa5168bc$var$forkStackIndex++] = $662d9978aa5168bc$var$treeForkCount;
    $662d9978aa5168bc$var$forkStack[$662d9978aa5168bc$var$forkStackIndex++] = $662d9978aa5168bc$var$treeForkProvider;
    $662d9978aa5168bc$var$treeForkProvider = workInProgress;
    $662d9978aa5168bc$var$treeForkCount = totalChildren;
}
function $662d9978aa5168bc$var$pushTreeId(workInProgress, totalChildren, index) {
    $662d9978aa5168bc$var$idStack[$662d9978aa5168bc$var$idStackIndex++] = $662d9978aa5168bc$var$treeContextId;
    $662d9978aa5168bc$var$idStack[$662d9978aa5168bc$var$idStackIndex++] = $662d9978aa5168bc$var$treeContextOverflow;
    $662d9978aa5168bc$var$idStack[$662d9978aa5168bc$var$idStackIndex++] = $662d9978aa5168bc$var$treeContextProvider;
    $662d9978aa5168bc$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $662d9978aa5168bc$var$treeContextId;
    workInProgress = $662d9978aa5168bc$var$treeContextOverflow;
    var baseLength = 32 - $662d9978aa5168bc$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $662d9978aa5168bc$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $662d9978aa5168bc$var$treeContextId = 1 << 32 - $662d9978aa5168bc$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $662d9978aa5168bc$var$treeContextOverflow = length + workInProgress;
    } else $662d9978aa5168bc$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $662d9978aa5168bc$var$treeContextOverflow = workInProgress;
}
function $662d9978aa5168bc$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($662d9978aa5168bc$var$pushTreeFork(workInProgress, 1), $662d9978aa5168bc$var$pushTreeId(workInProgress, 1, 0));
}
function $662d9978aa5168bc$var$popTreeContext(workInProgress) {
    for(; workInProgress === $662d9978aa5168bc$var$treeForkProvider;)$662d9978aa5168bc$var$treeForkProvider = $662d9978aa5168bc$var$forkStack[--$662d9978aa5168bc$var$forkStackIndex], $662d9978aa5168bc$var$forkStack[$662d9978aa5168bc$var$forkStackIndex] = null, $662d9978aa5168bc$var$treeForkCount = $662d9978aa5168bc$var$forkStack[--$662d9978aa5168bc$var$forkStackIndex], $662d9978aa5168bc$var$forkStack[$662d9978aa5168bc$var$forkStackIndex] = null;
    for(; workInProgress === $662d9978aa5168bc$var$treeContextProvider;)$662d9978aa5168bc$var$treeContextProvider = $662d9978aa5168bc$var$idStack[--$662d9978aa5168bc$var$idStackIndex], $662d9978aa5168bc$var$idStack[$662d9978aa5168bc$var$idStackIndex] = null, $662d9978aa5168bc$var$treeContextOverflow = $662d9978aa5168bc$var$idStack[--$662d9978aa5168bc$var$idStackIndex], $662d9978aa5168bc$var$idStack[$662d9978aa5168bc$var$idStackIndex] = null, $662d9978aa5168bc$var$treeContextId = $662d9978aa5168bc$var$idStack[--$662d9978aa5168bc$var$idStackIndex], $662d9978aa5168bc$var$idStack[$662d9978aa5168bc$var$idStackIndex] = null;
}
var $662d9978aa5168bc$var$hydrationParentFiber = null, $662d9978aa5168bc$var$nextHydratableInstance = null, $662d9978aa5168bc$var$isHydrating = !1, $662d9978aa5168bc$var$hydrationErrors = null, $662d9978aa5168bc$var$rootOrSingletonContext = !1, $662d9978aa5168bc$var$HydrationMismatchException = Error($662d9978aa5168bc$var$formatProdErrorMessage(519));
function $662d9978aa5168bc$var$throwOnHydrationMismatch(fiber) {
    var error = Error($662d9978aa5168bc$var$formatProdErrorMessage(418, ""));
    $662d9978aa5168bc$var$queueHydrationError($662d9978aa5168bc$var$createCapturedValueAtFiber(error, fiber));
    throw $662d9978aa5168bc$var$HydrationMismatchException;
}
function $662d9978aa5168bc$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$662d9978aa5168bc$var$internalInstanceKey] = fiber;
    instance[$662d9978aa5168bc$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $662d9978aa5168bc$var$listenToNonDelegatedEvent("cancel", instance);
            $662d9978aa5168bc$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $662d9978aa5168bc$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $662d9978aa5168bc$var$mediaEventTypes.length; type++)$662d9978aa5168bc$var$listenToNonDelegatedEvent($662d9978aa5168bc$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $662d9978aa5168bc$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $662d9978aa5168bc$var$listenToNonDelegatedEvent("error", instance);
            $662d9978aa5168bc$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $662d9978aa5168bc$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $662d9978aa5168bc$var$listenToNonDelegatedEvent("invalid", instance);
            $662d9978aa5168bc$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            $662d9978aa5168bc$var$track(instance);
            break;
        case "select":
            $662d9978aa5168bc$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $662d9978aa5168bc$var$listenToNonDelegatedEvent("invalid", instance), $662d9978aa5168bc$var$initTextarea(instance, props.value, props.defaultValue, props.children), $662d9978aa5168bc$var$track(instance);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $662d9978aa5168bc$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($662d9978aa5168bc$var$listenToNonDelegatedEvent("beforetoggle", instance), $662d9978aa5168bc$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $662d9978aa5168bc$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $662d9978aa5168bc$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $662d9978aa5168bc$var$noop$1), instance = !0) : instance = !1;
    instance || $662d9978aa5168bc$var$throwOnHydrationMismatch(fiber);
}
function $662d9978aa5168bc$var$popToNextHostParent(fiber) {
    for($662d9978aa5168bc$var$hydrationParentFiber = fiber.return; $662d9978aa5168bc$var$hydrationParentFiber;)switch($662d9978aa5168bc$var$hydrationParentFiber.tag){
        case 3:
        case 27:
            $662d9978aa5168bc$var$rootOrSingletonContext = !0;
            return;
        case 5:
        case 13:
            $662d9978aa5168bc$var$rootOrSingletonContext = !1;
            return;
        default:
            $662d9978aa5168bc$var$hydrationParentFiber = $662d9978aa5168bc$var$hydrationParentFiber.return;
    }
}
function $662d9978aa5168bc$var$popHydrationState(fiber) {
    if (fiber !== $662d9978aa5168bc$var$hydrationParentFiber) return !1;
    if (!$662d9978aa5168bc$var$isHydrating) return $662d9978aa5168bc$var$popToNextHostParent(fiber), $662d9978aa5168bc$var$isHydrating = !0, !1;
    var shouldClear = !1, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== fiber.tag && 27 !== fiber.tag) {
        if (JSCompiler_temp = 5 === fiber.tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $662d9978aa5168bc$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && (shouldClear = !0);
    shouldClear && $662d9978aa5168bc$var$nextHydratableInstance && $662d9978aa5168bc$var$throwOnHydrationMismatch(fiber);
    $662d9978aa5168bc$var$popToNextHostParent(fiber);
    if (13 === fiber.tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(317));
        a: {
            fiber = fiber.nextSibling;
            for(shouldClear = 0; fiber;){
                if (8 === fiber.nodeType) {
                    if (JSCompiler_temp = fiber.data, "/$" === JSCompiler_temp) {
                        if (0 === shouldClear) {
                            $662d9978aa5168bc$var$nextHydratableInstance = $662d9978aa5168bc$var$getNextHydratable(fiber.nextSibling);
                            break a;
                        }
                        shouldClear--;
                    } else "$" !== JSCompiler_temp && "$!" !== JSCompiler_temp && "$?" !== JSCompiler_temp || shouldClear++;
                }
                fiber = fiber.nextSibling;
            }
            $662d9978aa5168bc$var$nextHydratableInstance = null;
        }
    } else $662d9978aa5168bc$var$nextHydratableInstance = $662d9978aa5168bc$var$hydrationParentFiber ? $662d9978aa5168bc$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $662d9978aa5168bc$var$resetHydrationState() {
    $662d9978aa5168bc$var$nextHydratableInstance = $662d9978aa5168bc$var$hydrationParentFiber = null;
    $662d9978aa5168bc$var$isHydrating = !1;
}
function $662d9978aa5168bc$var$queueHydrationError(error) {
    null === $662d9978aa5168bc$var$hydrationErrors ? $662d9978aa5168bc$var$hydrationErrors = [
        error
    ] : $662d9978aa5168bc$var$hydrationErrors.push(error);
}
var $662d9978aa5168bc$var$SuspenseException = Error($662d9978aa5168bc$var$formatProdErrorMessage(460)), $662d9978aa5168bc$var$SuspenseyCommitException = Error($662d9978aa5168bc$var$formatProdErrorMessage(474)), $662d9978aa5168bc$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $662d9978aa5168bc$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $662d9978aa5168bc$var$noop$3() {}
function $662d9978aa5168bc$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($662d9978aa5168bc$var$noop$3, $662d9978aa5168bc$var$noop$3), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            thenableState = thenable.reason;
            if (thenableState === $662d9978aa5168bc$var$SuspenseException) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(483));
            throw thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($662d9978aa5168bc$var$noop$3, $662d9978aa5168bc$var$noop$3);
            else {
                thenableState = $662d9978aa5168bc$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    thenableState = thenable.reason;
                    if (thenableState === $662d9978aa5168bc$var$SuspenseException) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(483));
                    throw thenableState;
            }
            $662d9978aa5168bc$var$suspendedThenable = thenable;
            throw $662d9978aa5168bc$var$SuspenseException;
    }
}
var $662d9978aa5168bc$var$suspendedThenable = null;
function $662d9978aa5168bc$var$getSuspendedThenable() {
    if (null === $662d9978aa5168bc$var$suspendedThenable) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(459));
    var thenable = $662d9978aa5168bc$var$suspendedThenable;
    $662d9978aa5168bc$var$suspendedThenable = null;
    return thenable;
}
var $662d9978aa5168bc$var$thenableState$1 = null, $662d9978aa5168bc$var$thenableIndexCounter$1 = 0;
function $662d9978aa5168bc$var$unwrapThenable(thenable) {
    var index = $662d9978aa5168bc$var$thenableIndexCounter$1;
    $662d9978aa5168bc$var$thenableIndexCounter$1 += 1;
    null === $662d9978aa5168bc$var$thenableState$1 && ($662d9978aa5168bc$var$thenableState$1 = []);
    return $662d9978aa5168bc$var$trackUsedThenable($662d9978aa5168bc$var$thenableState$1, thenable, index);
}
function $662d9978aa5168bc$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $662d9978aa5168bc$var$throwOnInvalidObjectType(returnFiber, newChild) {
    if (newChild.$$typeof === $662d9978aa5168bc$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($662d9978aa5168bc$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $662d9978aa5168bc$var$resolveLazy(lazyType) {
    var init = lazyType._init;
    return init(lazyType._payload);
}
function $662d9978aa5168bc$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $662d9978aa5168bc$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 33554434, lastPlacedIndex) : newIndex;
        newFiber.flags |= 33554434;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 33554434);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $662d9978aa5168bc$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $662d9978aa5168bc$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $662d9978aa5168bc$var$REACT_LAZY_TYPE && $662d9978aa5168bc$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $662d9978aa5168bc$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $662d9978aa5168bc$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $662d9978aa5168bc$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $662d9978aa5168bc$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $662d9978aa5168bc$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $662d9978aa5168bc$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $662d9978aa5168bc$var$REACT_ELEMENT_TYPE:
                    return lanes = $662d9978aa5168bc$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $662d9978aa5168bc$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $662d9978aa5168bc$var$REACT_PORTAL_TYPE:
                    return newChild = $662d9978aa5168bc$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $662d9978aa5168bc$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return createChild(returnFiber, newChild, lanes);
            }
            if ($662d9978aa5168bc$var$isArrayImpl(newChild) || $662d9978aa5168bc$var$getIteratorFn(newChild)) return newChild = $662d9978aa5168bc$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $662d9978aa5168bc$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $662d9978aa5168bc$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $662d9978aa5168bc$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $662d9978aa5168bc$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $662d9978aa5168bc$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $662d9978aa5168bc$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $662d9978aa5168bc$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($662d9978aa5168bc$var$isArrayImpl(newChild) || $662d9978aa5168bc$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $662d9978aa5168bc$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $662d9978aa5168bc$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $662d9978aa5168bc$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $662d9978aa5168bc$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $662d9978aa5168bc$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $662d9978aa5168bc$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $662d9978aa5168bc$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($662d9978aa5168bc$var$isArrayImpl(newChild) || $662d9978aa5168bc$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $662d9978aa5168bc$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $662d9978aa5168bc$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $662d9978aa5168bc$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $662d9978aa5168bc$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $662d9978aa5168bc$var$isHydrating && $662d9978aa5168bc$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $662d9978aa5168bc$var$isHydrating && $662d9978aa5168bc$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $662d9978aa5168bc$var$isHydrating && $662d9978aa5168bc$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $662d9978aa5168bc$var$isHydrating && $662d9978aa5168bc$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $662d9978aa5168bc$var$isHydrating && $662d9978aa5168bc$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $662d9978aa5168bc$var$isHydrating && $662d9978aa5168bc$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $662d9978aa5168bc$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $662d9978aa5168bc$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $662d9978aa5168bc$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $662d9978aa5168bc$var$REACT_LAZY_TYPE && $662d9978aa5168bc$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $662d9978aa5168bc$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $662d9978aa5168bc$var$REACT_FRAGMENT_TYPE ? (lanes = $662d9978aa5168bc$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $662d9978aa5168bc$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $662d9978aa5168bc$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $662d9978aa5168bc$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $662d9978aa5168bc$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $662d9978aa5168bc$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($662d9978aa5168bc$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($662d9978aa5168bc$var$getIteratorFn(newChild)) {
                key = $662d9978aa5168bc$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $662d9978aa5168bc$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $662d9978aa5168bc$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $662d9978aa5168bc$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $662d9978aa5168bc$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $662d9978aa5168bc$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $662d9978aa5168bc$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $662d9978aa5168bc$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $662d9978aa5168bc$var$SuspenseException) throw x;
            var fiber = $662d9978aa5168bc$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $662d9978aa5168bc$var$reconcileChildFibers = $662d9978aa5168bc$var$createChildReconciler(!0), $662d9978aa5168bc$var$mountChildFibers = $662d9978aa5168bc$var$createChildReconciler(!1), $662d9978aa5168bc$var$currentTreeHiddenStackCursor = $662d9978aa5168bc$var$createCursor(null), $662d9978aa5168bc$var$prevEntangledRenderLanesCursor = $662d9978aa5168bc$var$createCursor(0);
function $662d9978aa5168bc$var$pushHiddenContext(fiber, context) {
    fiber = $662d9978aa5168bc$var$entangledRenderLanes;
    $662d9978aa5168bc$var$push($662d9978aa5168bc$var$prevEntangledRenderLanesCursor, fiber);
    $662d9978aa5168bc$var$push($662d9978aa5168bc$var$currentTreeHiddenStackCursor, context);
    $662d9978aa5168bc$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $662d9978aa5168bc$var$reuseHiddenContextOnStack() {
    $662d9978aa5168bc$var$push($662d9978aa5168bc$var$prevEntangledRenderLanesCursor, $662d9978aa5168bc$var$entangledRenderLanes);
    $662d9978aa5168bc$var$push($662d9978aa5168bc$var$currentTreeHiddenStackCursor, $662d9978aa5168bc$var$currentTreeHiddenStackCursor.current);
}
function $662d9978aa5168bc$var$popHiddenContext() {
    $662d9978aa5168bc$var$entangledRenderLanes = $662d9978aa5168bc$var$prevEntangledRenderLanesCursor.current;
    $662d9978aa5168bc$var$pop($662d9978aa5168bc$var$currentTreeHiddenStackCursor);
    $662d9978aa5168bc$var$pop($662d9978aa5168bc$var$prevEntangledRenderLanesCursor);
}
var $662d9978aa5168bc$var$suspenseHandlerStackCursor = $662d9978aa5168bc$var$createCursor(null), $662d9978aa5168bc$var$shellBoundary = null;
function $662d9978aa5168bc$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $662d9978aa5168bc$var$push($662d9978aa5168bc$var$suspenseStackCursor, $662d9978aa5168bc$var$suspenseStackCursor.current & 1);
    $662d9978aa5168bc$var$push($662d9978aa5168bc$var$suspenseHandlerStackCursor, handler);
    null === $662d9978aa5168bc$var$shellBoundary && (null === current || null !== $662d9978aa5168bc$var$currentTreeHiddenStackCursor.current ? $662d9978aa5168bc$var$shellBoundary = handler : null !== current.memoizedState && ($662d9978aa5168bc$var$shellBoundary = handler));
}
function $662d9978aa5168bc$var$pushOffscreenSuspenseHandler(fiber) {
    if (22 === fiber.tag) {
        if ($662d9978aa5168bc$var$push($662d9978aa5168bc$var$suspenseStackCursor, $662d9978aa5168bc$var$suspenseStackCursor.current), $662d9978aa5168bc$var$push($662d9978aa5168bc$var$suspenseHandlerStackCursor, fiber), null === $662d9978aa5168bc$var$shellBoundary) {
            var current = fiber.alternate;
            null !== current && null !== current.memoizedState && ($662d9978aa5168bc$var$shellBoundary = fiber);
        }
    } else $662d9978aa5168bc$var$reuseSuspenseHandlerOnStack(fiber);
}
function $662d9978aa5168bc$var$reuseSuspenseHandlerOnStack() {
    $662d9978aa5168bc$var$push($662d9978aa5168bc$var$suspenseStackCursor, $662d9978aa5168bc$var$suspenseStackCursor.current);
    $662d9978aa5168bc$var$push($662d9978aa5168bc$var$suspenseHandlerStackCursor, $662d9978aa5168bc$var$suspenseHandlerStackCursor.current);
}
function $662d9978aa5168bc$var$popSuspenseHandler(fiber) {
    $662d9978aa5168bc$var$pop($662d9978aa5168bc$var$suspenseHandlerStackCursor);
    $662d9978aa5168bc$var$shellBoundary === fiber && ($662d9978aa5168bc$var$shellBoundary = null);
    $662d9978aa5168bc$var$pop($662d9978aa5168bc$var$suspenseStackCursor);
}
var $662d9978aa5168bc$var$suspenseStackCursor = $662d9978aa5168bc$var$createCursor(0);
function $662d9978aa5168bc$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || "$?" === state.data || "$!" === state.data)) return node;
        } else if (19 === node.tag && void 0 !== node.memoizedProps.revealOrder) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $662d9978aa5168bc$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $662d9978aa5168bc$var$scheduleCallback$2 = $ibqfJ.unstable_scheduleCallback, $662d9978aa5168bc$var$NormalPriority = $ibqfJ.unstable_NormalPriority, $662d9978aa5168bc$var$CacheContext = {
    $$typeof: $662d9978aa5168bc$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $662d9978aa5168bc$var$createCache() {
    return {
        controller: new $662d9978aa5168bc$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $662d9978aa5168bc$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $662d9978aa5168bc$var$scheduleCallback$2($662d9978aa5168bc$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $662d9978aa5168bc$var$currentEntangledListeners = null, $662d9978aa5168bc$var$currentEntangledPendingCount = 0, $662d9978aa5168bc$var$currentEntangledLane = 0, $662d9978aa5168bc$var$currentEntangledActionThenable = null;
function $662d9978aa5168bc$var$entangleAsyncAction(transition, thenable) {
    if (null === $662d9978aa5168bc$var$currentEntangledListeners) {
        var entangledListeners = $662d9978aa5168bc$var$currentEntangledListeners = [];
        $662d9978aa5168bc$var$currentEntangledPendingCount = 0;
        $662d9978aa5168bc$var$currentEntangledLane = $662d9978aa5168bc$var$requestTransitionLane();
        $662d9978aa5168bc$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $662d9978aa5168bc$var$currentEntangledPendingCount++;
    thenable.then($662d9978aa5168bc$var$pingEngtangledActionScope, $662d9978aa5168bc$var$pingEngtangledActionScope);
    return thenable;
}
function $662d9978aa5168bc$var$pingEngtangledActionScope() {
    if (0 === --$662d9978aa5168bc$var$currentEntangledPendingCount && null !== $662d9978aa5168bc$var$currentEntangledListeners) {
        null !== $662d9978aa5168bc$var$currentEntangledActionThenable && ($662d9978aa5168bc$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $662d9978aa5168bc$var$currentEntangledListeners;
        $662d9978aa5168bc$var$currentEntangledListeners = null;
        $662d9978aa5168bc$var$currentEntangledLane = 0;
        $662d9978aa5168bc$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $662d9978aa5168bc$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $662d9978aa5168bc$var$prevOnStartTransitionFinish = $662d9978aa5168bc$var$ReactSharedInternals.S;
$662d9978aa5168bc$var$ReactSharedInternals.S = function(transition, returnValue) {
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $662d9978aa5168bc$var$entangleAsyncAction(transition, returnValue);
    null !== $662d9978aa5168bc$var$prevOnStartTransitionFinish && $662d9978aa5168bc$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $662d9978aa5168bc$var$resumedCache = $662d9978aa5168bc$var$createCursor(null);
function $662d9978aa5168bc$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $662d9978aa5168bc$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $662d9978aa5168bc$var$workInProgressRoot.pooledCache;
}
function $662d9978aa5168bc$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $662d9978aa5168bc$var$push($662d9978aa5168bc$var$resumedCache, $662d9978aa5168bc$var$resumedCache.current) : $662d9978aa5168bc$var$push($662d9978aa5168bc$var$resumedCache, prevCachePool.pool);
}
function $662d9978aa5168bc$var$getSuspendedCache() {
    var cacheFromPool = $662d9978aa5168bc$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $662d9978aa5168bc$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $662d9978aa5168bc$var$renderLanes = 0, $662d9978aa5168bc$var$currentlyRenderingFiber$1 = null, $662d9978aa5168bc$var$currentHook = null, $662d9978aa5168bc$var$workInProgressHook = null, $662d9978aa5168bc$var$didScheduleRenderPhaseUpdate = !1, $662d9978aa5168bc$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $662d9978aa5168bc$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $662d9978aa5168bc$var$localIdCounter = 0, $662d9978aa5168bc$var$thenableIndexCounter = 0, $662d9978aa5168bc$var$thenableState = null, $662d9978aa5168bc$var$globalClientIdCounter = 0;
function $662d9978aa5168bc$var$throwInvalidHookError() {
    throw Error($662d9978aa5168bc$var$formatProdErrorMessage(321));
}
function $662d9978aa5168bc$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$662d9978aa5168bc$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $662d9978aa5168bc$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $662d9978aa5168bc$var$renderLanes = nextRenderLanes;
    $662d9978aa5168bc$var$currentlyRenderingFiber$1 = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $662d9978aa5168bc$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $662d9978aa5168bc$var$HooksDispatcherOnMount : $662d9978aa5168bc$var$HooksDispatcherOnUpdate;
    $662d9978aa5168bc$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $662d9978aa5168bc$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $662d9978aa5168bc$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $662d9978aa5168bc$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $662d9978aa5168bc$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $662d9978aa5168bc$var$finishRenderingHooks(current) {
    $662d9978aa5168bc$var$ReactSharedInternals.H = $662d9978aa5168bc$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $662d9978aa5168bc$var$currentHook && null !== $662d9978aa5168bc$var$currentHook.next;
    $662d9978aa5168bc$var$renderLanes = 0;
    $662d9978aa5168bc$var$workInProgressHook = $662d9978aa5168bc$var$currentHook = $662d9978aa5168bc$var$currentlyRenderingFiber$1 = null;
    $662d9978aa5168bc$var$didScheduleRenderPhaseUpdate = !1;
    $662d9978aa5168bc$var$thenableIndexCounter = 0;
    $662d9978aa5168bc$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(300));
    null === current || $662d9978aa5168bc$var$didReceiveUpdate || (current = current.dependencies, null !== current && $662d9978aa5168bc$var$checkIfContextChanged(current) && ($662d9978aa5168bc$var$didReceiveUpdate = !0));
}
function $662d9978aa5168bc$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $662d9978aa5168bc$var$currentlyRenderingFiber$1 = workInProgress;
    var numberOfReRenders = 0;
    do {
        $662d9978aa5168bc$var$didScheduleRenderPhaseUpdateDuringThisPass && ($662d9978aa5168bc$var$thenableState = null);
        $662d9978aa5168bc$var$thenableIndexCounter = 0;
        $662d9978aa5168bc$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $662d9978aa5168bc$var$workInProgressHook = $662d9978aa5168bc$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $662d9978aa5168bc$var$ReactSharedInternals.H = $662d9978aa5168bc$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($662d9978aa5168bc$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $662d9978aa5168bc$var$TransitionAwareHostComponent() {
    var dispatcher = $662d9978aa5168bc$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $662d9978aa5168bc$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $662d9978aa5168bc$var$currentHook ? $662d9978aa5168bc$var$currentHook.memoizedState : null) !== dispatcher && ($662d9978aa5168bc$var$currentlyRenderingFiber$1.flags |= 1024);
    return maybeThenable;
}
function $662d9978aa5168bc$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $662d9978aa5168bc$var$localIdCounter;
    $662d9978aa5168bc$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $662d9978aa5168bc$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $662d9978aa5168bc$var$resetHooksOnUnwind(workInProgress) {
    if ($662d9978aa5168bc$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $662d9978aa5168bc$var$didScheduleRenderPhaseUpdate = !1;
    }
    $662d9978aa5168bc$var$renderLanes = 0;
    $662d9978aa5168bc$var$workInProgressHook = $662d9978aa5168bc$var$currentHook = $662d9978aa5168bc$var$currentlyRenderingFiber$1 = null;
    $662d9978aa5168bc$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $662d9978aa5168bc$var$thenableIndexCounter = $662d9978aa5168bc$var$localIdCounter = 0;
    $662d9978aa5168bc$var$thenableState = null;
}
function $662d9978aa5168bc$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $662d9978aa5168bc$var$workInProgressHook ? $662d9978aa5168bc$var$currentlyRenderingFiber$1.memoizedState = $662d9978aa5168bc$var$workInProgressHook = hook : $662d9978aa5168bc$var$workInProgressHook = $662d9978aa5168bc$var$workInProgressHook.next = hook;
    return $662d9978aa5168bc$var$workInProgressHook;
}
function $662d9978aa5168bc$var$updateWorkInProgressHook() {
    if (null === $662d9978aa5168bc$var$currentHook) {
        var nextCurrentHook = $662d9978aa5168bc$var$currentlyRenderingFiber$1.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $662d9978aa5168bc$var$currentHook.next;
    var nextWorkInProgressHook = null === $662d9978aa5168bc$var$workInProgressHook ? $662d9978aa5168bc$var$currentlyRenderingFiber$1.memoizedState : $662d9978aa5168bc$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $662d9978aa5168bc$var$workInProgressHook = nextWorkInProgressHook, $662d9978aa5168bc$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $662d9978aa5168bc$var$currentlyRenderingFiber$1.alternate) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(467));
            throw Error($662d9978aa5168bc$var$formatProdErrorMessage(310));
        }
        $662d9978aa5168bc$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $662d9978aa5168bc$var$currentHook.memoizedState,
            baseState: $662d9978aa5168bc$var$currentHook.baseState,
            baseQueue: $662d9978aa5168bc$var$currentHook.baseQueue,
            queue: $662d9978aa5168bc$var$currentHook.queue,
            next: null
        };
        null === $662d9978aa5168bc$var$workInProgressHook ? $662d9978aa5168bc$var$currentlyRenderingFiber$1.memoizedState = $662d9978aa5168bc$var$workInProgressHook = nextCurrentHook : $662d9978aa5168bc$var$workInProgressHook = $662d9978aa5168bc$var$workInProgressHook.next = nextCurrentHook;
    }
    return $662d9978aa5168bc$var$workInProgressHook;
}
var $662d9978aa5168bc$var$createFunctionComponentUpdateQueue;
$662d9978aa5168bc$var$createFunctionComponentUpdateQueue = function() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
};
function $662d9978aa5168bc$var$useThenable(thenable) {
    var index = $662d9978aa5168bc$var$thenableIndexCounter;
    $662d9978aa5168bc$var$thenableIndexCounter += 1;
    null === $662d9978aa5168bc$var$thenableState && ($662d9978aa5168bc$var$thenableState = []);
    thenable = $662d9978aa5168bc$var$trackUsedThenable($662d9978aa5168bc$var$thenableState, thenable, index);
    index = $662d9978aa5168bc$var$currentlyRenderingFiber$1;
    null === (null === $662d9978aa5168bc$var$workInProgressHook ? index.memoizedState : $662d9978aa5168bc$var$workInProgressHook.next) && (index = index.alternate, $662d9978aa5168bc$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $662d9978aa5168bc$var$HooksDispatcherOnMount : $662d9978aa5168bc$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $662d9978aa5168bc$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $662d9978aa5168bc$var$useThenable(usable);
        if (usable.$$typeof === $662d9978aa5168bc$var$REACT_CONTEXT_TYPE) return $662d9978aa5168bc$var$readContext(usable);
    }
    throw Error($662d9978aa5168bc$var$formatProdErrorMessage(438, String(usable)));
}
function $662d9978aa5168bc$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $662d9978aa5168bc$var$currentlyRenderingFiber$1.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $662d9978aa5168bc$var$currentlyRenderingFiber$1.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $662d9978aa5168bc$var$createFunctionComponentUpdateQueue(), $662d9978aa5168bc$var$currentlyRenderingFiber$1.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $662d9978aa5168bc$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $662d9978aa5168bc$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $662d9978aa5168bc$var$updateReducer(reducer) {
    var hook = $662d9978aa5168bc$var$updateWorkInProgressHook();
    return $662d9978aa5168bc$var$updateReducerImpl(hook, $662d9978aa5168bc$var$currentHook, reducer);
}
function $662d9978aa5168bc$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$54 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($662d9978aa5168bc$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($662d9978aa5168bc$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $662d9978aa5168bc$var$currentEntangledLane && (didReadFromEntangledAsyncAction$54 = !0);
                else if (($662d9978aa5168bc$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $662d9978aa5168bc$var$currentEntangledLane && (didReadFromEntangledAsyncAction$54 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $662d9978aa5168bc$var$currentlyRenderingFiber$1.lanes |= revertLane, $662d9978aa5168bc$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $662d9978aa5168bc$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $662d9978aa5168bc$var$currentlyRenderingFiber$1.lanes |= updateLane, $662d9978aa5168bc$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$662d9978aa5168bc$var$objectIs(pendingQueue, hook.memoizedState) && ($662d9978aa5168bc$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$54 && (reducer = $662d9978aa5168bc$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $662d9978aa5168bc$var$rerenderReducer(reducer) {
    var hook = $662d9978aa5168bc$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $662d9978aa5168bc$var$objectIs(newState, hook.memoizedState) || ($662d9978aa5168bc$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $662d9978aa5168bc$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $662d9978aa5168bc$var$currentlyRenderingFiber$1, hook = $662d9978aa5168bc$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $662d9978aa5168bc$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$662d9978aa5168bc$var$objectIs(($662d9978aa5168bc$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $662d9978aa5168bc$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $662d9978aa5168bc$var$updateEffect($662d9978aa5168bc$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $662d9978aa5168bc$var$workInProgressHook && $662d9978aa5168bc$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $662d9978aa5168bc$var$pushEffect(9, $662d9978aa5168bc$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), {
            destroy: void 0
        }, null);
        if (null === $662d9978aa5168bc$var$workInProgressRoot) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($662d9978aa5168bc$var$renderLanes & 60) || $662d9978aa5168bc$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $662d9978aa5168bc$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $662d9978aa5168bc$var$currentlyRenderingFiber$1.updateQueue;
    null === getSnapshot ? (getSnapshot = $662d9978aa5168bc$var$createFunctionComponentUpdateQueue(), $662d9978aa5168bc$var$currentlyRenderingFiber$1.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $662d9978aa5168bc$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $662d9978aa5168bc$var$checkIfSnapshotChanged(inst) && $662d9978aa5168bc$var$forceStoreRerender(fiber);
}
function $662d9978aa5168bc$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $662d9978aa5168bc$var$checkIfSnapshotChanged(inst) && $662d9978aa5168bc$var$forceStoreRerender(fiber);
    });
}
function $662d9978aa5168bc$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$662d9978aa5168bc$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $662d9978aa5168bc$var$forceStoreRerender(fiber) {
    var root = $662d9978aa5168bc$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $662d9978aa5168bc$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $662d9978aa5168bc$var$mountStateImpl(initialState) {
    var hook = $662d9978aa5168bc$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($662d9978aa5168bc$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $662d9978aa5168bc$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $662d9978aa5168bc$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $662d9978aa5168bc$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $662d9978aa5168bc$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $662d9978aa5168bc$var$updateReducerImpl(hook, $662d9978aa5168bc$var$currentHook, "function" === typeof reducer ? reducer : $662d9978aa5168bc$var$basicStateReducer);
}
function $662d9978aa5168bc$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($662d9978aa5168bc$var$isRenderPhaseUpdate(fiber)) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $662d9978aa5168bc$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $662d9978aa5168bc$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $662d9978aa5168bc$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $662d9978aa5168bc$var$ReactSharedInternals.T, currentTransition = {};
        $662d9978aa5168bc$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $662d9978aa5168bc$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $662d9978aa5168bc$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $662d9978aa5168bc$var$onActionError(actionQueue, node, error);
        } finally{
            $662d9978aa5168bc$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $662d9978aa5168bc$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$60) {
        $662d9978aa5168bc$var$onActionError(actionQueue, node, error$60);
    }
}
function $662d9978aa5168bc$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $662d9978aa5168bc$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $662d9978aa5168bc$var$onActionError(actionQueue, node, error);
    }) : $662d9978aa5168bc$var$onActionSuccess(actionQueue, node, returnValue);
}
function $662d9978aa5168bc$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $662d9978aa5168bc$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $662d9978aa5168bc$var$runActionStateAction(actionQueue, nextState)));
}
function $662d9978aa5168bc$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $662d9978aa5168bc$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $662d9978aa5168bc$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $662d9978aa5168bc$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $662d9978aa5168bc$var$mountActionState(action, initialStateProp) {
    if ($662d9978aa5168bc$var$isHydrating) {
        var ssrFormState = $662d9978aa5168bc$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $662d9978aa5168bc$var$currentlyRenderingFiber$1;
                if ($662d9978aa5168bc$var$isHydrating) {
                    if ($662d9978aa5168bc$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $662d9978aa5168bc$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $662d9978aa5168bc$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $662d9978aa5168bc$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $662d9978aa5168bc$var$nextHydratableInstance = $662d9978aa5168bc$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $662d9978aa5168bc$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $662d9978aa5168bc$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $662d9978aa5168bc$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $662d9978aa5168bc$var$dispatchSetState.bind(null, $662d9978aa5168bc$var$currentlyRenderingFiber$1, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $662d9978aa5168bc$var$mountStateImpl(!1);
    inRootOrSingleton = $662d9978aa5168bc$var$dispatchOptimisticSetState.bind(null, $662d9978aa5168bc$var$currentlyRenderingFiber$1, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $662d9978aa5168bc$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $662d9978aa5168bc$var$dispatchActionState.bind(null, $662d9978aa5168bc$var$currentlyRenderingFiber$1, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $662d9978aa5168bc$var$updateActionState(action) {
    var stateHook = $662d9978aa5168bc$var$updateWorkInProgressHook();
    return $662d9978aa5168bc$var$updateActionStateImpl(stateHook, $662d9978aa5168bc$var$currentHook, action);
}
function $662d9978aa5168bc$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $662d9978aa5168bc$var$updateReducerImpl(stateHook, currentStateHook, $662d9978aa5168bc$var$actionStateReducer)[0];
    stateHook = $662d9978aa5168bc$var$updateReducer($662d9978aa5168bc$var$basicStateReducer)[0];
    currentStateHook = "object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then ? $662d9978aa5168bc$var$useThenable(currentStateHook) : currentStateHook;
    var actionQueueHook = $662d9978aa5168bc$var$updateWorkInProgressHook(), actionQueue = actionQueueHook.queue, dispatch = actionQueue.dispatch;
    action !== actionQueueHook.memoizedState && ($662d9978aa5168bc$var$currentlyRenderingFiber$1.flags |= 2048, $662d9978aa5168bc$var$pushEffect(9, $662d9978aa5168bc$var$actionStateActionEffect.bind(null, actionQueue, action), {
        destroy: void 0
    }, null));
    return [
        currentStateHook,
        dispatch,
        stateHook
    ];
}
function $662d9978aa5168bc$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $662d9978aa5168bc$var$rerenderActionState(action) {
    var stateHook = $662d9978aa5168bc$var$updateWorkInProgressHook(), currentStateHook = $662d9978aa5168bc$var$currentHook;
    if (null !== currentStateHook) return $662d9978aa5168bc$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $662d9978aa5168bc$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $662d9978aa5168bc$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $662d9978aa5168bc$var$pushEffect(tag, create, inst, deps) {
    tag = {
        tag: tag,
        create: create,
        inst: inst,
        deps: deps,
        next: null
    };
    create = $662d9978aa5168bc$var$currentlyRenderingFiber$1.updateQueue;
    null === create && (create = $662d9978aa5168bc$var$createFunctionComponentUpdateQueue(), $662d9978aa5168bc$var$currentlyRenderingFiber$1.updateQueue = create);
    inst = create.lastEffect;
    null === inst ? create.lastEffect = tag.next = tag : (deps = inst.next, inst.next = tag, tag.next = deps, create.lastEffect = tag);
    return tag;
}
function $662d9978aa5168bc$var$updateRef() {
    return $662d9978aa5168bc$var$updateWorkInProgressHook().memoizedState;
}
function $662d9978aa5168bc$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $662d9978aa5168bc$var$mountWorkInProgressHook();
    $662d9978aa5168bc$var$currentlyRenderingFiber$1.flags |= fiberFlags;
    hook.memoizedState = $662d9978aa5168bc$var$pushEffect(1 | hookFlags, create, {
        destroy: void 0
    }, void 0 === deps ? null : deps);
}
function $662d9978aa5168bc$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $662d9978aa5168bc$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $662d9978aa5168bc$var$currentHook && null !== deps && $662d9978aa5168bc$var$areHookInputsEqual(deps, $662d9978aa5168bc$var$currentHook.memoizedState.deps) ? hook.memoizedState = $662d9978aa5168bc$var$pushEffect(hookFlags, create, inst, deps) : ($662d9978aa5168bc$var$currentlyRenderingFiber$1.flags |= fiberFlags, hook.memoizedState = $662d9978aa5168bc$var$pushEffect(1 | hookFlags, create, inst, deps));
}
function $662d9978aa5168bc$var$mountEffect(create, deps) {
    $662d9978aa5168bc$var$mountEffectImpl(8390656, 8, create, deps);
}
function $662d9978aa5168bc$var$updateEffect(create, deps) {
    $662d9978aa5168bc$var$updateEffectImpl(2048, 8, create, deps);
}
function $662d9978aa5168bc$var$updateInsertionEffect(create, deps) {
    return $662d9978aa5168bc$var$updateEffectImpl(4, 2, create, deps);
}
function $662d9978aa5168bc$var$updateLayoutEffect(create, deps) {
    return $662d9978aa5168bc$var$updateEffectImpl(4, 4, create, deps);
}
function $662d9978aa5168bc$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $662d9978aa5168bc$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $662d9978aa5168bc$var$updateEffectImpl(4, 4, $662d9978aa5168bc$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $662d9978aa5168bc$var$mountDebugValue() {}
function $662d9978aa5168bc$var$updateCallback(callback, deps) {
    var hook = $662d9978aa5168bc$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $662d9978aa5168bc$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $662d9978aa5168bc$var$updateMemo(nextCreate, deps) {
    var hook = $662d9978aa5168bc$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $662d9978aa5168bc$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($662d9978aa5168bc$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $662d9978aa5168bc$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $662d9978aa5168bc$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $662d9978aa5168bc$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($662d9978aa5168bc$var$renderLanes & 1073741824)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $662d9978aa5168bc$var$requestDeferredLane();
    $662d9978aa5168bc$var$currentlyRenderingFiber$1.lanes |= hook;
    $662d9978aa5168bc$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $662d9978aa5168bc$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($662d9978aa5168bc$var$objectIs(value, prevValue)) return value;
    if (null !== $662d9978aa5168bc$var$currentTreeHiddenStackCursor.current) return hook = $662d9978aa5168bc$var$mountDeferredValueImpl(hook, value, initialValue), $662d9978aa5168bc$var$objectIs(hook, prevValue) || ($662d9978aa5168bc$var$didReceiveUpdate = !0), hook;
    if (0 === ($662d9978aa5168bc$var$renderLanes & 42)) return $662d9978aa5168bc$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $662d9978aa5168bc$var$requestDeferredLane();
    $662d9978aa5168bc$var$currentlyRenderingFiber$1.lanes |= hook;
    $662d9978aa5168bc$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $662d9978aa5168bc$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $662d9978aa5168bc$var$ReactDOMSharedInternals.p;
    $662d9978aa5168bc$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $662d9978aa5168bc$var$ReactSharedInternals.T, currentTransition = {};
    $662d9978aa5168bc$var$ReactSharedInternals.T = currentTransition;
    $662d9978aa5168bc$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $662d9978aa5168bc$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $662d9978aa5168bc$var$chainThenableValue(returnValue, finishedState);
            $662d9978aa5168bc$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $662d9978aa5168bc$var$requestUpdateLane(fiber));
        } else $662d9978aa5168bc$var$dispatchSetStateInternal(fiber, queue, finishedState, $662d9978aa5168bc$var$requestUpdateLane(fiber));
    } catch (error) {
        $662d9978aa5168bc$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $662d9978aa5168bc$var$requestUpdateLane());
    } finally{
        $662d9978aa5168bc$var$ReactDOMSharedInternals.p = previousPriority, $662d9978aa5168bc$var$ReactSharedInternals.T = prevTransition;
    }
}
function $662d9978aa5168bc$var$noop$2() {}
function $662d9978aa5168bc$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(476));
    var queue = $662d9978aa5168bc$var$ensureFormComponentIsStateful(formFiber).queue;
    $662d9978aa5168bc$var$startTransition(formFiber, queue, pendingState, $662d9978aa5168bc$var$sharedNotPendingObject, null === action ? $662d9978aa5168bc$var$noop$2 : function() {
        $662d9978aa5168bc$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $662d9978aa5168bc$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $662d9978aa5168bc$var$sharedNotPendingObject,
        baseState: $662d9978aa5168bc$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $662d9978aa5168bc$var$basicStateReducer,
            lastRenderedState: $662d9978aa5168bc$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $662d9978aa5168bc$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $662d9978aa5168bc$var$requestFormReset$1(formFiber) {
    var resetStateQueue = $662d9978aa5168bc$var$ensureFormComponentIsStateful(formFiber).next.queue;
    $662d9978aa5168bc$var$dispatchSetStateInternal(formFiber, resetStateQueue, {}, $662d9978aa5168bc$var$requestUpdateLane());
}
function $662d9978aa5168bc$var$useHostTransitionStatus() {
    return $662d9978aa5168bc$var$readContext($662d9978aa5168bc$var$HostTransitionContext);
}
function $662d9978aa5168bc$var$updateId() {
    return $662d9978aa5168bc$var$updateWorkInProgressHook().memoizedState;
}
function $662d9978aa5168bc$var$updateRefresh() {
    return $662d9978aa5168bc$var$updateWorkInProgressHook().memoizedState;
}
function $662d9978aa5168bc$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $662d9978aa5168bc$var$requestUpdateLane();
                fiber = $662d9978aa5168bc$var$createUpdate(lane);
                var root$63 = $662d9978aa5168bc$var$enqueueUpdate(provider, fiber, lane);
                null !== root$63 && ($662d9978aa5168bc$var$scheduleUpdateOnFiber(root$63, provider, lane), $662d9978aa5168bc$var$entangleTransitions(root$63, provider, lane));
                provider = {
                    cache: $662d9978aa5168bc$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $662d9978aa5168bc$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $662d9978aa5168bc$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $662d9978aa5168bc$var$isRenderPhaseUpdate(fiber) ? $662d9978aa5168bc$var$enqueueRenderPhaseUpdate(queue, action) : (action = $662d9978aa5168bc$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($662d9978aa5168bc$var$scheduleUpdateOnFiber(action, fiber, lane), $662d9978aa5168bc$var$entangleTransitionUpdate(action, queue, lane)));
}
function $662d9978aa5168bc$var$dispatchSetState(fiber, queue, action) {
    var lane = $662d9978aa5168bc$var$requestUpdateLane();
    $662d9978aa5168bc$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $662d9978aa5168bc$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($662d9978aa5168bc$var$isRenderPhaseUpdate(fiber)) $662d9978aa5168bc$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($662d9978aa5168bc$var$objectIs(eagerState, currentState)) return $662d9978aa5168bc$var$enqueueUpdate$1(fiber, queue, update, 0), null === $662d9978aa5168bc$var$workInProgressRoot && $662d9978aa5168bc$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $662d9978aa5168bc$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $662d9978aa5168bc$var$scheduleUpdateOnFiber(action, fiber, lane), $662d9978aa5168bc$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $662d9978aa5168bc$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $662d9978aa5168bc$var$requestTransitionLane(),
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($662d9978aa5168bc$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $662d9978aa5168bc$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $662d9978aa5168bc$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $662d9978aa5168bc$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $662d9978aa5168bc$var$currentlyRenderingFiber$1 || null !== alternate && alternate === $662d9978aa5168bc$var$currentlyRenderingFiber$1;
}
function $662d9978aa5168bc$var$enqueueRenderPhaseUpdate(queue, update) {
    $662d9978aa5168bc$var$didScheduleRenderPhaseUpdateDuringThisPass = $662d9978aa5168bc$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $662d9978aa5168bc$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194176)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $662d9978aa5168bc$var$markRootEntangled(root, lane);
    }
}
var $662d9978aa5168bc$var$ContextOnlyDispatcher = {
    readContext: $662d9978aa5168bc$var$readContext,
    use: $662d9978aa5168bc$var$use,
    useCallback: $662d9978aa5168bc$var$throwInvalidHookError,
    useContext: $662d9978aa5168bc$var$throwInvalidHookError,
    useEffect: $662d9978aa5168bc$var$throwInvalidHookError,
    useImperativeHandle: $662d9978aa5168bc$var$throwInvalidHookError,
    useLayoutEffect: $662d9978aa5168bc$var$throwInvalidHookError,
    useInsertionEffect: $662d9978aa5168bc$var$throwInvalidHookError,
    useMemo: $662d9978aa5168bc$var$throwInvalidHookError,
    useReducer: $662d9978aa5168bc$var$throwInvalidHookError,
    useRef: $662d9978aa5168bc$var$throwInvalidHookError,
    useState: $662d9978aa5168bc$var$throwInvalidHookError,
    useDebugValue: $662d9978aa5168bc$var$throwInvalidHookError,
    useDeferredValue: $662d9978aa5168bc$var$throwInvalidHookError,
    useTransition: $662d9978aa5168bc$var$throwInvalidHookError,
    useSyncExternalStore: $662d9978aa5168bc$var$throwInvalidHookError,
    useId: $662d9978aa5168bc$var$throwInvalidHookError
};
$662d9978aa5168bc$var$ContextOnlyDispatcher.useCacheRefresh = $662d9978aa5168bc$var$throwInvalidHookError;
$662d9978aa5168bc$var$ContextOnlyDispatcher.useMemoCache = $662d9978aa5168bc$var$throwInvalidHookError;
$662d9978aa5168bc$var$ContextOnlyDispatcher.useHostTransitionStatus = $662d9978aa5168bc$var$throwInvalidHookError;
$662d9978aa5168bc$var$ContextOnlyDispatcher.useFormState = $662d9978aa5168bc$var$throwInvalidHookError;
$662d9978aa5168bc$var$ContextOnlyDispatcher.useActionState = $662d9978aa5168bc$var$throwInvalidHookError;
$662d9978aa5168bc$var$ContextOnlyDispatcher.useOptimistic = $662d9978aa5168bc$var$throwInvalidHookError;
var $662d9978aa5168bc$var$HooksDispatcherOnMount = {
    readContext: $662d9978aa5168bc$var$readContext,
    use: $662d9978aa5168bc$var$use,
    useCallback: function(callback, deps) {
        $662d9978aa5168bc$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $662d9978aa5168bc$var$readContext,
    useEffect: $662d9978aa5168bc$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $662d9978aa5168bc$var$mountEffectImpl(4194308, 4, $662d9978aa5168bc$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $662d9978aa5168bc$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $662d9978aa5168bc$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $662d9978aa5168bc$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($662d9978aa5168bc$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $662d9978aa5168bc$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $662d9978aa5168bc$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $662d9978aa5168bc$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($662d9978aa5168bc$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $662d9978aa5168bc$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $662d9978aa5168bc$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $662d9978aa5168bc$var$dispatchReducerAction.bind(null, $662d9978aa5168bc$var$currentlyRenderingFiber$1, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $662d9978aa5168bc$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $662d9978aa5168bc$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $662d9978aa5168bc$var$dispatchSetState.bind(null, $662d9978aa5168bc$var$currentlyRenderingFiber$1, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $662d9978aa5168bc$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $662d9978aa5168bc$var$mountWorkInProgressHook();
        return $662d9978aa5168bc$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $662d9978aa5168bc$var$mountStateImpl(!1);
        stateHook = $662d9978aa5168bc$var$startTransition.bind(null, $662d9978aa5168bc$var$currentlyRenderingFiber$1, stateHook.queue, !0, !1);
        $662d9978aa5168bc$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $662d9978aa5168bc$var$currentlyRenderingFiber$1, hook = $662d9978aa5168bc$var$mountWorkInProgressHook();
        if ($662d9978aa5168bc$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $662d9978aa5168bc$var$workInProgressRoot) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(349));
            0 !== ($662d9978aa5168bc$var$workInProgressRootRenderLanes & 60) || $662d9978aa5168bc$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $662d9978aa5168bc$var$mountEffect($662d9978aa5168bc$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $662d9978aa5168bc$var$pushEffect(9, $662d9978aa5168bc$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), {
            destroy: void 0
        }, null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $662d9978aa5168bc$var$mountWorkInProgressHook(), identifierPrefix = $662d9978aa5168bc$var$workInProgressRoot.identifierPrefix;
        if ($662d9978aa5168bc$var$isHydrating) {
            var JSCompiler_inline_result = $662d9978aa5168bc$var$treeContextOverflow;
            var idWithLeadingBit = $662d9978aa5168bc$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $662d9978aa5168bc$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = ":" + identifierPrefix + "R" + JSCompiler_inline_result;
            JSCompiler_inline_result = $662d9978aa5168bc$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += ":";
        } else JSCompiler_inline_result = $662d9978aa5168bc$var$globalClientIdCounter++, identifierPrefix = ":" + identifierPrefix + "r" + JSCompiler_inline_result.toString(32) + ":";
        return hook.memoizedState = identifierPrefix;
    },
    useCacheRefresh: function() {
        return $662d9978aa5168bc$var$mountWorkInProgressHook().memoizedState = $662d9978aa5168bc$var$refreshCache.bind(null, $662d9978aa5168bc$var$currentlyRenderingFiber$1);
    }
};
$662d9978aa5168bc$var$HooksDispatcherOnMount.useMemoCache = $662d9978aa5168bc$var$useMemoCache;
$662d9978aa5168bc$var$HooksDispatcherOnMount.useHostTransitionStatus = $662d9978aa5168bc$var$useHostTransitionStatus;
$662d9978aa5168bc$var$HooksDispatcherOnMount.useFormState = $662d9978aa5168bc$var$mountActionState;
$662d9978aa5168bc$var$HooksDispatcherOnMount.useActionState = $662d9978aa5168bc$var$mountActionState;
$662d9978aa5168bc$var$HooksDispatcherOnMount.useOptimistic = function(passthrough) {
    var hook = $662d9978aa5168bc$var$mountWorkInProgressHook();
    hook.memoizedState = hook.baseState = passthrough;
    var queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: null,
        lastRenderedState: null
    };
    hook.queue = queue;
    hook = $662d9978aa5168bc$var$dispatchOptimisticSetState.bind(null, $662d9978aa5168bc$var$currentlyRenderingFiber$1, !0, queue);
    queue.dispatch = hook;
    return [
        passthrough,
        hook
    ];
};
var $662d9978aa5168bc$var$HooksDispatcherOnUpdate = {
    readContext: $662d9978aa5168bc$var$readContext,
    use: $662d9978aa5168bc$var$use,
    useCallback: $662d9978aa5168bc$var$updateCallback,
    useContext: $662d9978aa5168bc$var$readContext,
    useEffect: $662d9978aa5168bc$var$updateEffect,
    useImperativeHandle: $662d9978aa5168bc$var$updateImperativeHandle,
    useInsertionEffect: $662d9978aa5168bc$var$updateInsertionEffect,
    useLayoutEffect: $662d9978aa5168bc$var$updateLayoutEffect,
    useMemo: $662d9978aa5168bc$var$updateMemo,
    useReducer: $662d9978aa5168bc$var$updateReducer,
    useRef: $662d9978aa5168bc$var$updateRef,
    useState: function() {
        return $662d9978aa5168bc$var$updateReducer($662d9978aa5168bc$var$basicStateReducer);
    },
    useDebugValue: $662d9978aa5168bc$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $662d9978aa5168bc$var$updateWorkInProgressHook();
        return $662d9978aa5168bc$var$updateDeferredValueImpl(hook, $662d9978aa5168bc$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $662d9978aa5168bc$var$updateReducer($662d9978aa5168bc$var$basicStateReducer)[0], start = $662d9978aa5168bc$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $662d9978aa5168bc$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $662d9978aa5168bc$var$updateSyncExternalStore,
    useId: $662d9978aa5168bc$var$updateId
};
$662d9978aa5168bc$var$HooksDispatcherOnUpdate.useCacheRefresh = $662d9978aa5168bc$var$updateRefresh;
$662d9978aa5168bc$var$HooksDispatcherOnUpdate.useMemoCache = $662d9978aa5168bc$var$useMemoCache;
$662d9978aa5168bc$var$HooksDispatcherOnUpdate.useHostTransitionStatus = $662d9978aa5168bc$var$useHostTransitionStatus;
$662d9978aa5168bc$var$HooksDispatcherOnUpdate.useFormState = $662d9978aa5168bc$var$updateActionState;
$662d9978aa5168bc$var$HooksDispatcherOnUpdate.useActionState = $662d9978aa5168bc$var$updateActionState;
$662d9978aa5168bc$var$HooksDispatcherOnUpdate.useOptimistic = function(passthrough, reducer) {
    var hook = $662d9978aa5168bc$var$updateWorkInProgressHook();
    return $662d9978aa5168bc$var$updateOptimisticImpl(hook, $662d9978aa5168bc$var$currentHook, passthrough, reducer);
};
var $662d9978aa5168bc$var$HooksDispatcherOnRerender = {
    readContext: $662d9978aa5168bc$var$readContext,
    use: $662d9978aa5168bc$var$use,
    useCallback: $662d9978aa5168bc$var$updateCallback,
    useContext: $662d9978aa5168bc$var$readContext,
    useEffect: $662d9978aa5168bc$var$updateEffect,
    useImperativeHandle: $662d9978aa5168bc$var$updateImperativeHandle,
    useInsertionEffect: $662d9978aa5168bc$var$updateInsertionEffect,
    useLayoutEffect: $662d9978aa5168bc$var$updateLayoutEffect,
    useMemo: $662d9978aa5168bc$var$updateMemo,
    useReducer: $662d9978aa5168bc$var$rerenderReducer,
    useRef: $662d9978aa5168bc$var$updateRef,
    useState: function() {
        return $662d9978aa5168bc$var$rerenderReducer($662d9978aa5168bc$var$basicStateReducer);
    },
    useDebugValue: $662d9978aa5168bc$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $662d9978aa5168bc$var$updateWorkInProgressHook();
        return null === $662d9978aa5168bc$var$currentHook ? $662d9978aa5168bc$var$mountDeferredValueImpl(hook, value, initialValue) : $662d9978aa5168bc$var$updateDeferredValueImpl(hook, $662d9978aa5168bc$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $662d9978aa5168bc$var$rerenderReducer($662d9978aa5168bc$var$basicStateReducer)[0], start = $662d9978aa5168bc$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $662d9978aa5168bc$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $662d9978aa5168bc$var$updateSyncExternalStore,
    useId: $662d9978aa5168bc$var$updateId
};
$662d9978aa5168bc$var$HooksDispatcherOnRerender.useCacheRefresh = $662d9978aa5168bc$var$updateRefresh;
$662d9978aa5168bc$var$HooksDispatcherOnRerender.useMemoCache = $662d9978aa5168bc$var$useMemoCache;
$662d9978aa5168bc$var$HooksDispatcherOnRerender.useHostTransitionStatus = $662d9978aa5168bc$var$useHostTransitionStatus;
$662d9978aa5168bc$var$HooksDispatcherOnRerender.useFormState = $662d9978aa5168bc$var$rerenderActionState;
$662d9978aa5168bc$var$HooksDispatcherOnRerender.useActionState = $662d9978aa5168bc$var$rerenderActionState;
$662d9978aa5168bc$var$HooksDispatcherOnRerender.useOptimistic = function(passthrough, reducer) {
    var hook = $662d9978aa5168bc$var$updateWorkInProgressHook();
    if (null !== $662d9978aa5168bc$var$currentHook) return $662d9978aa5168bc$var$updateOptimisticImpl(hook, $662d9978aa5168bc$var$currentHook, passthrough, reducer);
    hook.baseState = passthrough;
    return [
        passthrough,
        hook.queue.dispatch
    ];
};
function $662d9978aa5168bc$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $662d9978aa5168bc$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $662d9978aa5168bc$var$classComponentUpdater = {
    isMounted: function(component) {
        return (component = component._reactInternals) ? $662d9978aa5168bc$var$getNearestMountedFiber(component) === component : !1;
    },
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $662d9978aa5168bc$var$requestUpdateLane(), update = $662d9978aa5168bc$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $662d9978aa5168bc$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($662d9978aa5168bc$var$scheduleUpdateOnFiber(payload, inst, lane), $662d9978aa5168bc$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $662d9978aa5168bc$var$requestUpdateLane(), update = $662d9978aa5168bc$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $662d9978aa5168bc$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($662d9978aa5168bc$var$scheduleUpdateOnFiber(payload, inst, lane), $662d9978aa5168bc$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $662d9978aa5168bc$var$requestUpdateLane(), update = $662d9978aa5168bc$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $662d9978aa5168bc$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($662d9978aa5168bc$var$scheduleUpdateOnFiber(callback, inst, lane), $662d9978aa5168bc$var$entangleTransitions(callback, inst, lane));
    }
};
function $662d9978aa5168bc$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$662d9978aa5168bc$var$shallowEqual(oldProps, newProps) || !$662d9978aa5168bc$var$shallowEqual(oldState, newState) : !0;
}
function $662d9978aa5168bc$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $662d9978aa5168bc$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $662d9978aa5168bc$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $662d9978aa5168bc$var$assign({}, newProps));
        for(var propName$67 in Component)void 0 === newProps[propName$67] && (newProps[propName$67] = Component[propName$67]);
    }
    return newProps;
}
var $662d9978aa5168bc$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    } else if ("object" === typeof $6qd2L && "function" === typeof $6qd2L.emit) {
        $6qd2L.emit("uncaughtException", error);
        return;
    }
    console.error(error);
};
function $662d9978aa5168bc$var$defaultOnUncaughtError(error) {
    $662d9978aa5168bc$var$reportGlobalError(error);
}
function $662d9978aa5168bc$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $662d9978aa5168bc$var$defaultOnRecoverableError(error) {
    $662d9978aa5168bc$var$reportGlobalError(error);
}
function $662d9978aa5168bc$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$68) {
        setTimeout(function() {
            throw e$68;
        });
    }
}
function $662d9978aa5168bc$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$69) {
        setTimeout(function() {
            throw e$69;
        });
    }
}
function $662d9978aa5168bc$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $662d9978aa5168bc$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $662d9978aa5168bc$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $662d9978aa5168bc$var$createClassErrorUpdate(lane) {
    lane = $662d9978aa5168bc$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $662d9978aa5168bc$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $662d9978aa5168bc$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $662d9978aa5168bc$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $662d9978aa5168bc$var$legacyErrorBoundariesThatAlreadyFailed ? $662d9978aa5168bc$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $662d9978aa5168bc$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $662d9978aa5168bc$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $662d9978aa5168bc$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $662d9978aa5168bc$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 13:
                    return null === $662d9978aa5168bc$var$shellBoundary ? $662d9978aa5168bc$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $662d9978aa5168bc$var$workInProgressRootExitStatus && ($662d9978aa5168bc$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $662d9978aa5168bc$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $662d9978aa5168bc$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $662d9978aa5168bc$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $662d9978aa5168bc$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($662d9978aa5168bc$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $662d9978aa5168bc$var$attachPingListener(root, value, rootRenderLanes);
        $662d9978aa5168bc$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($662d9978aa5168bc$var$isHydrating) return returnFiber = $662d9978aa5168bc$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $662d9978aa5168bc$var$HydrationMismatchException && (root = Error($662d9978aa5168bc$var$formatProdErrorMessage(422), {
        cause: value
    }), $662d9978aa5168bc$var$queueHydrationError($662d9978aa5168bc$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $662d9978aa5168bc$var$HydrationMismatchException && (returnFiber = Error($662d9978aa5168bc$var$formatProdErrorMessage(423), {
        cause: value
    }), $662d9978aa5168bc$var$queueHydrationError($662d9978aa5168bc$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $662d9978aa5168bc$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $662d9978aa5168bc$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $662d9978aa5168bc$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $662d9978aa5168bc$var$workInProgressRootExitStatus && ($662d9978aa5168bc$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($662d9978aa5168bc$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $662d9978aa5168bc$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $662d9978aa5168bc$var$workInProgressRootConcurrentErrors ? $662d9978aa5168bc$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $662d9978aa5168bc$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $662d9978aa5168bc$var$workInProgressRootExitStatus && ($662d9978aa5168bc$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $662d9978aa5168bc$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $662d9978aa5168bc$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $662d9978aa5168bc$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $662d9978aa5168bc$var$legacyErrorBoundariesThatAlreadyFailed || !$662d9978aa5168bc$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $662d9978aa5168bc$var$createClassErrorUpdate(rootRenderLanes), $662d9978aa5168bc$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $662d9978aa5168bc$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $662d9978aa5168bc$var$SelectiveHydrationException = Error($662d9978aa5168bc$var$formatProdErrorMessage(461)), $662d9978aa5168bc$var$didReceiveUpdate = !1;
function $662d9978aa5168bc$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $662d9978aa5168bc$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $662d9978aa5168bc$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $662d9978aa5168bc$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $662d9978aa5168bc$var$prepareToReadContext(workInProgress);
    nextProps = $662d9978aa5168bc$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $662d9978aa5168bc$var$checkDidRenderIdHook();
    if (null !== current && !$662d9978aa5168bc$var$didReceiveUpdate) return $662d9978aa5168bc$var$bailoutHooks(current, workInProgress, renderLanes), $662d9978aa5168bc$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $662d9978aa5168bc$var$isHydrating && key && $662d9978aa5168bc$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $662d9978aa5168bc$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $662d9978aa5168bc$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$662d9978aa5168bc$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $662d9978aa5168bc$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $662d9978aa5168bc$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$662d9978aa5168bc$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $662d9978aa5168bc$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $662d9978aa5168bc$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $662d9978aa5168bc$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $662d9978aa5168bc$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($662d9978aa5168bc$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($662d9978aa5168bc$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $662d9978aa5168bc$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($662d9978aa5168bc$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $662d9978aa5168bc$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $662d9978aa5168bc$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $662d9978aa5168bc$var$updateOffscreenComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, nextChildren = nextProps.children, nextIsDetached = 0 !== (workInProgress.stateNode._pendingVisibility & 2), prevState = null !== current ? current.memoizedState : null;
    $662d9978aa5168bc$var$markRef(current, workInProgress);
    if ("hidden" === nextProps.mode || nextIsDetached) {
        if (0 !== (workInProgress.flags & 128)) {
            nextProps = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextChildren = workInProgress.child = current.child;
                for(nextIsDetached = 0; null !== nextChildren;)nextIsDetached = nextIsDetached | nextChildren.lanes | nextChildren.childLanes, nextChildren = nextChildren.sibling;
                workInProgress.childLanes = nextIsDetached & ~nextProps;
            } else workInProgress.childLanes = 0, workInProgress.child = null;
            return $662d9978aa5168bc$var$deferHiddenOffscreenComponent(current, workInProgress, nextProps, renderLanes);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $662d9978aa5168bc$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $662d9978aa5168bc$var$pushHiddenContext(workInProgress, prevState) : $662d9978aa5168bc$var$reuseHiddenContextOnStack(), $662d9978aa5168bc$var$pushOffscreenSuspenseHandler(workInProgress);
        else return workInProgress.lanes = workInProgress.childLanes = 536870912, $662d9978aa5168bc$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes);
    } else null !== prevState ? ($662d9978aa5168bc$var$pushTransition(workInProgress, prevState.cachePool), $662d9978aa5168bc$var$pushHiddenContext(workInProgress, prevState), $662d9978aa5168bc$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $662d9978aa5168bc$var$pushTransition(workInProgress, null), $662d9978aa5168bc$var$reuseHiddenContextOnStack(), $662d9978aa5168bc$var$reuseSuspenseHandlerOnStack(workInProgress));
    $662d9978aa5168bc$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $662d9978aa5168bc$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes) {
    var JSCompiler_inline_result = $662d9978aa5168bc$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $662d9978aa5168bc$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $662d9978aa5168bc$var$pushTransition(workInProgress, null);
    $662d9978aa5168bc$var$reuseHiddenContextOnStack();
    $662d9978aa5168bc$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $662d9978aa5168bc$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    return null;
}
function $662d9978aa5168bc$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 2097664);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 2097664;
    }
}
function $662d9978aa5168bc$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $662d9978aa5168bc$var$prepareToReadContext(workInProgress);
    Component = $662d9978aa5168bc$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $662d9978aa5168bc$var$checkDidRenderIdHook();
    if (null !== current && !$662d9978aa5168bc$var$didReceiveUpdate) return $662d9978aa5168bc$var$bailoutHooks(current, workInProgress, renderLanes), $662d9978aa5168bc$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $662d9978aa5168bc$var$isHydrating && nextProps && $662d9978aa5168bc$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $662d9978aa5168bc$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $662d9978aa5168bc$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $662d9978aa5168bc$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $662d9978aa5168bc$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $662d9978aa5168bc$var$finishRenderingHooks(current);
    Component = $662d9978aa5168bc$var$checkDidRenderIdHook();
    if (null !== current && !$662d9978aa5168bc$var$didReceiveUpdate) return $662d9978aa5168bc$var$bailoutHooks(current, workInProgress, renderLanes), $662d9978aa5168bc$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $662d9978aa5168bc$var$isHydrating && Component && $662d9978aa5168bc$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $662d9978aa5168bc$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $662d9978aa5168bc$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $662d9978aa5168bc$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $662d9978aa5168bc$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $662d9978aa5168bc$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $662d9978aa5168bc$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $662d9978aa5168bc$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $662d9978aa5168bc$var$readContext(contextType) : $662d9978aa5168bc$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($662d9978aa5168bc$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $662d9978aa5168bc$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $662d9978aa5168bc$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $662d9978aa5168bc$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $662d9978aa5168bc$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $662d9978aa5168bc$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $662d9978aa5168bc$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $662d9978aa5168bc$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $662d9978aa5168bc$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $662d9978aa5168bc$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $662d9978aa5168bc$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $662d9978aa5168bc$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($662d9978aa5168bc$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $662d9978aa5168bc$var$hasForceUpdate || $662d9978aa5168bc$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $662d9978aa5168bc$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $662d9978aa5168bc$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $662d9978aa5168bc$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $662d9978aa5168bc$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $662d9978aa5168bc$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $662d9978aa5168bc$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $662d9978aa5168bc$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $662d9978aa5168bc$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $662d9978aa5168bc$var$hasForceUpdate || null !== current && null !== current.dependencies && $662d9978aa5168bc$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($662d9978aa5168bc$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $662d9978aa5168bc$var$hasForceUpdate || $662d9978aa5168bc$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $662d9978aa5168bc$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $662d9978aa5168bc$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $662d9978aa5168bc$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $662d9978aa5168bc$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $662d9978aa5168bc$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $662d9978aa5168bc$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $662d9978aa5168bc$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $662d9978aa5168bc$var$resetHydrationState();
    workInProgress.flags |= 256;
    $662d9978aa5168bc$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $662d9978aa5168bc$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $662d9978aa5168bc$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $662d9978aa5168bc$var$getSuspendedCache()
    };
}
function $662d9978aa5168bc$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $662d9978aa5168bc$var$workInProgressDeferredLane);
    return current;
}
function $662d9978aa5168bc$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($662d9978aa5168bc$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($662d9978aa5168bc$var$isHydrating) {
            showFallback ? $662d9978aa5168bc$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $662d9978aa5168bc$var$reuseSuspenseHandlerOnStack(workInProgress);
            if ($662d9978aa5168bc$var$isHydrating) {
                var nextInstance = $662d9978aa5168bc$var$nextHydratableInstance, JSCompiler_temp$jscomp$0;
                if (JSCompiler_temp$jscomp$0 = nextInstance) {
                    c: {
                        JSCompiler_temp$jscomp$0 = nextInstance;
                        for(nextInstance = $662d9978aa5168bc$var$rootOrSingletonContext; 8 !== JSCompiler_temp$jscomp$0.nodeType;){
                            if (!nextInstance) {
                                nextInstance = null;
                                break c;
                            }
                            JSCompiler_temp$jscomp$0 = $662d9978aa5168bc$var$getNextHydratable(JSCompiler_temp$jscomp$0.nextSibling);
                            if (null === JSCompiler_temp$jscomp$0) {
                                nextInstance = null;
                                break c;
                            }
                        }
                        nextInstance = JSCompiler_temp$jscomp$0;
                    }
                    null !== nextInstance ? (workInProgress.memoizedState = {
                        dehydrated: nextInstance,
                        treeContext: null !== $662d9978aa5168bc$var$treeContextProvider ? {
                            id: $662d9978aa5168bc$var$treeContextId,
                            overflow: $662d9978aa5168bc$var$treeContextOverflow
                        } : null,
                        retryLane: 536870912
                    }, JSCompiler_temp$jscomp$0 = $662d9978aa5168bc$var$createFiberImplClass(18, null, null, 0), JSCompiler_temp$jscomp$0.stateNode = nextInstance, JSCompiler_temp$jscomp$0.return = workInProgress, workInProgress.child = JSCompiler_temp$jscomp$0, $662d9978aa5168bc$var$hydrationParentFiber = workInProgress, $662d9978aa5168bc$var$nextHydratableInstance = null, JSCompiler_temp$jscomp$0 = !0) : JSCompiler_temp$jscomp$0 = !1;
                }
                JSCompiler_temp$jscomp$0 || $662d9978aa5168bc$var$throwOnHydrationMismatch(workInProgress);
            }
            nextInstance = workInProgress.memoizedState;
            if (null !== nextInstance && (nextInstance = nextInstance.dehydrated, null !== nextInstance)) return "$!" === nextInstance.data ? workInProgress.lanes = 16 : workInProgress.lanes = 536870912, null;
            $662d9978aa5168bc$var$popSuspenseHandler(workInProgress);
        }
        nextInstance = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $662d9978aa5168bc$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextInstance = $662d9978aa5168bc$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextInstance
        }, showFallback), nextProps = $662d9978aa5168bc$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextInstance.return = workInProgress, nextProps.return = workInProgress, nextInstance.sibling = nextProps, workInProgress.child = nextInstance, showFallback = workInProgress.child, showFallback.memoizedState = $662d9978aa5168bc$var$mountSuspenseOffscreenState(renderLanes), showFallback.childLanes = $662d9978aa5168bc$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $662d9978aa5168bc$var$SUSPENDED_MARKER, nextProps;
        $662d9978aa5168bc$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $662d9978aa5168bc$var$mountSuspensePrimaryChildren(workInProgress, nextInstance);
    }
    JSCompiler_temp$jscomp$0 = current.memoizedState;
    if (null !== JSCompiler_temp$jscomp$0 && (nextInstance = JSCompiler_temp$jscomp$0.dehydrated, null !== nextInstance)) {
        if (didSuspend) workInProgress.flags & 256 ? ($662d9978aa5168bc$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $662d9978aa5168bc$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($662d9978aa5168bc$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($662d9978aa5168bc$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, nextProps = $662d9978aa5168bc$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, nextInstance), showFallback = $662d9978aa5168bc$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2, nextProps.return = workInProgress, showFallback.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, $662d9978aa5168bc$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $662d9978aa5168bc$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $662d9978aa5168bc$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $662d9978aa5168bc$var$SUSPENDED_MARKER, workInProgress = showFallback);
        else if ($662d9978aa5168bc$var$pushPrimaryTreeSuspenseHandler(workInProgress), "$!" === nextInstance.data) {
            JSCompiler_temp = nextInstance.nextSibling && nextInstance.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($662d9978aa5168bc$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $662d9978aa5168bc$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $662d9978aa5168bc$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($662d9978aa5168bc$var$didReceiveUpdate || $662d9978aa5168bc$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $662d9978aa5168bc$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $662d9978aa5168bc$var$workInProgressRoot;
            if (null !== JSCompiler_temp) {
                nextProps = renderLanes & -renderLanes;
                if (0 !== (nextProps & 42)) nextProps = 1;
                else switch(nextProps){
                    case 2:
                        nextProps = 1;
                        break;
                    case 8:
                        nextProps = 4;
                        break;
                    case 32:
                        nextProps = 16;
                        break;
                    case 128:
                    case 256:
                    case 512:
                    case 1024:
                    case 2048:
                    case 4096:
                    case 8192:
                    case 16384:
                    case 32768:
                    case 65536:
                    case 131072:
                    case 262144:
                    case 524288:
                    case 1048576:
                    case 2097152:
                    case 4194304:
                    case 8388608:
                    case 16777216:
                    case 33554432:
                        nextProps = 64;
                        break;
                    case 268435456:
                        nextProps = 134217728;
                        break;
                    default:
                        nextProps = 0;
                }
                nextProps = 0 !== (nextProps & (JSCompiler_temp.suspendedLanes | renderLanes)) ? 0 : nextProps;
                if (0 !== nextProps && nextProps !== JSCompiler_temp$jscomp$0.retryLane) throw JSCompiler_temp$jscomp$0.retryLane = nextProps, $662d9978aa5168bc$var$enqueueConcurrentRenderForLane(current, nextProps), $662d9978aa5168bc$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $662d9978aa5168bc$var$SelectiveHydrationException;
            }
            "$?" === nextInstance.data || $662d9978aa5168bc$var$renderDidSuspendDelayIfPossible();
            workInProgress = $662d9978aa5168bc$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else "$?" === nextInstance.data ? (workInProgress.flags |= 128, workInProgress.child = current.child, workInProgress = $662d9978aa5168bc$var$retryDehydratedSuspenseBoundary.bind(null, current), nextInstance._reactRetry = workInProgress, workInProgress = null) : (current = JSCompiler_temp$jscomp$0.treeContext, $662d9978aa5168bc$var$nextHydratableInstance = $662d9978aa5168bc$var$getNextHydratable(nextInstance.nextSibling), $662d9978aa5168bc$var$hydrationParentFiber = workInProgress, $662d9978aa5168bc$var$isHydrating = !0, $662d9978aa5168bc$var$hydrationErrors = null, $662d9978aa5168bc$var$rootOrSingletonContext = !1, null !== current && ($662d9978aa5168bc$var$idStack[$662d9978aa5168bc$var$idStackIndex++] = $662d9978aa5168bc$var$treeContextId, $662d9978aa5168bc$var$idStack[$662d9978aa5168bc$var$idStackIndex++] = $662d9978aa5168bc$var$treeContextOverflow, $662d9978aa5168bc$var$idStack[$662d9978aa5168bc$var$idStackIndex++] = $662d9978aa5168bc$var$treeContextProvider, $662d9978aa5168bc$var$treeContextId = current.id, $662d9978aa5168bc$var$treeContextOverflow = current.overflow, $662d9978aa5168bc$var$treeContextProvider = workInProgress), workInProgress = $662d9978aa5168bc$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $662d9978aa5168bc$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, JSCompiler_temp$jscomp$0 = current.child, digest = JSCompiler_temp$jscomp$0.sibling, nextProps = $662d9978aa5168bc$var$createWorkInProgress(JSCompiler_temp$jscomp$0, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = JSCompiler_temp$jscomp$0.subtreeFlags & 31457280, null !== digest ? showFallback = $662d9978aa5168bc$var$createWorkInProgress(digest, showFallback) : (showFallback = $662d9978aa5168bc$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2), showFallback.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, nextProps = showFallback, showFallback = workInProgress.child, nextInstance = current.child.memoizedState, null === nextInstance ? nextInstance = $662d9978aa5168bc$var$mountSuspenseOffscreenState(renderLanes) : (JSCompiler_temp$jscomp$0 = nextInstance.cachePool, null !== JSCompiler_temp$jscomp$0 ? (digest = $662d9978aa5168bc$var$CacheContext._currentValue, JSCompiler_temp$jscomp$0 = JSCompiler_temp$jscomp$0.parent !== digest ? {
        parent: digest,
        pool: digest
    } : JSCompiler_temp$jscomp$0) : JSCompiler_temp$jscomp$0 = $662d9978aa5168bc$var$getSuspendedCache(), nextInstance = {
        baseLanes: nextInstance.baseLanes | renderLanes,
        cachePool: JSCompiler_temp$jscomp$0
    }), showFallback.memoizedState = nextInstance, showFallback.childLanes = $662d9978aa5168bc$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $662d9978aa5168bc$var$SUSPENDED_MARKER, nextProps;
    $662d9978aa5168bc$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $662d9978aa5168bc$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $662d9978aa5168bc$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $662d9978aa5168bc$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $662d9978aa5168bc$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    return $662d9978aa5168bc$var$createFiberFromOffscreen(offscreenProps, mode, 0, null);
}
function $662d9978aa5168bc$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $662d9978aa5168bc$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $662d9978aa5168bc$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $662d9978aa5168bc$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $662d9978aa5168bc$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $662d9978aa5168bc$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode);
}
function $662d9978aa5168bc$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    $662d9978aa5168bc$var$reconcileChildren(current, workInProgress, nextProps.children, renderLanes);
    nextProps = $662d9978aa5168bc$var$suspenseStackCursor.current;
    if (0 !== (nextProps & 2)) nextProps = nextProps & 1 | 2, workInProgress.flags |= 128;
    else {
        if (null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
            if (13 === current.tag) null !== current.memoizedState && $662d9978aa5168bc$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (19 === current.tag) $662d9978aa5168bc$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (null !== current.child) {
                current.child.return = current;
                current = current.child;
                continue;
            }
            if (current === workInProgress) break a;
            for(; null === current.sibling;){
                if (null === current.return || current.return === workInProgress) break a;
                current = current.return;
            }
            current.sibling.return = current.return;
            current = current.sibling;
        }
        nextProps &= 1;
    }
    $662d9978aa5168bc$var$push($662d9978aa5168bc$var$suspenseStackCursor, nextProps);
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $662d9978aa5168bc$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $662d9978aa5168bc$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode);
            break;
        case "backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $662d9978aa5168bc$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $662d9978aa5168bc$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode);
            break;
        case "together":
            $662d9978aa5168bc$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $662d9978aa5168bc$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $662d9978aa5168bc$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($662d9978aa5168bc$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $662d9978aa5168bc$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $662d9978aa5168bc$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $662d9978aa5168bc$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $662d9978aa5168bc$var$checkIfContextChanged(current) ? !0 : !1;
}
function $662d9978aa5168bc$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $662d9978aa5168bc$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $662d9978aa5168bc$var$pushProvider(workInProgress, $662d9978aa5168bc$var$CacheContext, current.memoizedState.cache);
            $662d9978aa5168bc$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $662d9978aa5168bc$var$pushHostContext(workInProgress);
            break;
        case 4:
            $662d9978aa5168bc$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $662d9978aa5168bc$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 13:
            var state = workInProgress.memoizedState;
            if (null !== state) {
                if (null !== state.dehydrated) return $662d9978aa5168bc$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $662d9978aa5168bc$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $662d9978aa5168bc$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $662d9978aa5168bc$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $662d9978aa5168bc$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state = 0 !== (renderLanes & workInProgress.childLanes);
            state || ($662d9978aa5168bc$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state) return $662d9978aa5168bc$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $662d9978aa5168bc$var$push($662d9978aa5168bc$var$suspenseStackCursor, $662d9978aa5168bc$var$suspenseStackCursor.current);
            if (state) break;
            else return null;
        case 22:
        case 23:
            return workInProgress.lanes = 0, $662d9978aa5168bc$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            $662d9978aa5168bc$var$pushProvider(workInProgress, $662d9978aa5168bc$var$CacheContext, current.memoizedState.cache);
    }
    return $662d9978aa5168bc$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $662d9978aa5168bc$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $662d9978aa5168bc$var$didReceiveUpdate = !0;
        else {
            if (!$662d9978aa5168bc$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $662d9978aa5168bc$var$didReceiveUpdate = !1, $662d9978aa5168bc$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $662d9978aa5168bc$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $662d9978aa5168bc$var$didReceiveUpdate = !1, $662d9978aa5168bc$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $662d9978aa5168bc$var$pushTreeId(workInProgress, $662d9978aa5168bc$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                current = workInProgress.pendingProps;
                var lazyComponent = workInProgress.elementType, init = lazyComponent._init;
                lazyComponent = init(lazyComponent._payload);
                workInProgress.type = lazyComponent;
                if ("function" === typeof lazyComponent) $662d9978aa5168bc$var$shouldConstruct(lazyComponent) ? (current = $662d9978aa5168bc$var$resolveClassComponentProps(lazyComponent, current), workInProgress.tag = 1, workInProgress = $662d9978aa5168bc$var$updateClassComponent(null, workInProgress, lazyComponent, current, renderLanes)) : (workInProgress.tag = 0, workInProgress = $662d9978aa5168bc$var$updateFunctionComponent(null, workInProgress, lazyComponent, current, renderLanes));
                else {
                    if (void 0 !== lazyComponent && null !== lazyComponent) {
                        if (init = lazyComponent.$$typeof, init === $662d9978aa5168bc$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $662d9978aa5168bc$var$updateForwardRef(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        } else if (init === $662d9978aa5168bc$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $662d9978aa5168bc$var$updateMemoComponent(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $662d9978aa5168bc$var$getComponentNameFromType(lazyComponent) || lazyComponent;
                    throw Error($662d9978aa5168bc$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $662d9978aa5168bc$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return lazyComponent = workInProgress.type, init = $662d9978aa5168bc$var$resolveClassComponentProps(lazyComponent, workInProgress.pendingProps), $662d9978aa5168bc$var$updateClassComponent(current, workInProgress, lazyComponent, init, renderLanes);
        case 3:
            a: {
                $662d9978aa5168bc$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(387));
                var nextProps = workInProgress.pendingProps;
                init = workInProgress.memoizedState;
                lazyComponent = init.element;
                $662d9978aa5168bc$var$cloneUpdateQueue(current, workInProgress);
                $662d9978aa5168bc$var$processUpdateQueue(workInProgress, nextProps, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                nextProps = nextState.cache;
                $662d9978aa5168bc$var$pushProvider(workInProgress, $662d9978aa5168bc$var$CacheContext, nextProps);
                nextProps !== init.cache && $662d9978aa5168bc$var$propagateContextChanges(workInProgress, [
                    $662d9978aa5168bc$var$CacheContext
                ], renderLanes, !0);
                $662d9978aa5168bc$var$suspendIfUpdateReadFromEntangledAsyncAction();
                nextProps = nextState.element;
                if (init.isDehydrated) {
                    if (init = {
                        element: nextProps,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = init, workInProgress.memoizedState = init, workInProgress.flags & 256) {
                        workInProgress = $662d9978aa5168bc$var$mountHostRootWithoutHydrating(current, workInProgress, nextProps, renderLanes);
                        break a;
                    } else if (nextProps !== lazyComponent) {
                        lazyComponent = $662d9978aa5168bc$var$createCapturedValueAtFiber(Error($662d9978aa5168bc$var$formatProdErrorMessage(424)), workInProgress);
                        $662d9978aa5168bc$var$queueHydrationError(lazyComponent);
                        workInProgress = $662d9978aa5168bc$var$mountHostRootWithoutHydrating(current, workInProgress, nextProps, renderLanes);
                        break a;
                    } else for($662d9978aa5168bc$var$nextHydratableInstance = $662d9978aa5168bc$var$getNextHydratable(workInProgress.stateNode.containerInfo.firstChild), $662d9978aa5168bc$var$hydrationParentFiber = workInProgress, $662d9978aa5168bc$var$isHydrating = !0, $662d9978aa5168bc$var$hydrationErrors = null, $662d9978aa5168bc$var$rootOrSingletonContext = !0, renderLanes = $662d9978aa5168bc$var$mountChildFibers(workInProgress, null, nextProps, renderLanes), workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                } else {
                    $662d9978aa5168bc$var$resetHydrationState();
                    if (nextProps === lazyComponent) {
                        workInProgress = $662d9978aa5168bc$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $662d9978aa5168bc$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $662d9978aa5168bc$var$markRef(current, workInProgress), null === current ? (renderLanes = $662d9978aa5168bc$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $662d9978aa5168bc$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, lazyComponent = $662d9978aa5168bc$var$getOwnerDocumentFromRootContainer($662d9978aa5168bc$var$rootInstanceStackCursor.current).createElement(renderLanes), lazyComponent[$662d9978aa5168bc$var$internalInstanceKey] = workInProgress, lazyComponent[$662d9978aa5168bc$var$internalPropsKey] = current, $662d9978aa5168bc$var$setInitialProperties(lazyComponent, renderLanes, current), $662d9978aa5168bc$var$markNodeAsHoistable(lazyComponent), workInProgress.stateNode = lazyComponent) : workInProgress.memoizedState = $662d9978aa5168bc$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $662d9978aa5168bc$var$pushHostContext(workInProgress), null === current && $662d9978aa5168bc$var$isHydrating && (lazyComponent = workInProgress.stateNode = $662d9978aa5168bc$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $662d9978aa5168bc$var$rootInstanceStackCursor.current), $662d9978aa5168bc$var$hydrationParentFiber = workInProgress, $662d9978aa5168bc$var$rootOrSingletonContext = !0, $662d9978aa5168bc$var$nextHydratableInstance = $662d9978aa5168bc$var$getNextHydratable(lazyComponent.firstChild)), lazyComponent = workInProgress.pendingProps.children, null !== current || $662d9978aa5168bc$var$isHydrating ? $662d9978aa5168bc$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes) : workInProgress.child = $662d9978aa5168bc$var$reconcileChildFibers(workInProgress, null, lazyComponent, renderLanes), $662d9978aa5168bc$var$markRef(current, workInProgress), workInProgress.child;
        case 5:
            if (null === current && $662d9978aa5168bc$var$isHydrating) {
                if (init = lazyComponent = $662d9978aa5168bc$var$nextHydratableInstance) lazyComponent = $662d9978aa5168bc$var$canHydrateInstance(lazyComponent, workInProgress.type, workInProgress.pendingProps, $662d9978aa5168bc$var$rootOrSingletonContext), null !== lazyComponent ? (workInProgress.stateNode = lazyComponent, $662d9978aa5168bc$var$hydrationParentFiber = workInProgress, $662d9978aa5168bc$var$nextHydratableInstance = $662d9978aa5168bc$var$getNextHydratable(lazyComponent.firstChild), $662d9978aa5168bc$var$rootOrSingletonContext = !1, init = !0) : init = !1;
                init || $662d9978aa5168bc$var$throwOnHydrationMismatch(workInProgress);
            }
            $662d9978aa5168bc$var$pushHostContext(workInProgress);
            init = workInProgress.type;
            nextProps = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            lazyComponent = nextProps.children;
            $662d9978aa5168bc$var$shouldSetTextContent(init, nextProps) ? lazyComponent = null : null !== nextState && $662d9978aa5168bc$var$shouldSetTextContent(init, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && (init = $662d9978aa5168bc$var$renderWithHooks(current, workInProgress, $662d9978aa5168bc$var$TransitionAwareHostComponent, null, null, renderLanes), $662d9978aa5168bc$var$HostTransitionContext._currentValue = init);
            $662d9978aa5168bc$var$markRef(current, workInProgress);
            $662d9978aa5168bc$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $662d9978aa5168bc$var$isHydrating) {
                if (current = renderLanes = $662d9978aa5168bc$var$nextHydratableInstance) renderLanes = $662d9978aa5168bc$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $662d9978aa5168bc$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $662d9978aa5168bc$var$hydrationParentFiber = workInProgress, $662d9978aa5168bc$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $662d9978aa5168bc$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $662d9978aa5168bc$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $662d9978aa5168bc$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), lazyComponent = workInProgress.pendingProps, null === current ? workInProgress.child = $662d9978aa5168bc$var$reconcileChildFibers(workInProgress, null, lazyComponent, renderLanes) : $662d9978aa5168bc$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 11:
            return $662d9978aa5168bc$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $662d9978aa5168bc$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $662d9978aa5168bc$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $662d9978aa5168bc$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return lazyComponent = workInProgress.pendingProps, $662d9978aa5168bc$var$pushProvider(workInProgress, workInProgress.type, lazyComponent.value), $662d9978aa5168bc$var$reconcileChildren(current, workInProgress, lazyComponent.children, renderLanes), workInProgress.child;
        case 9:
            return init = workInProgress.type._context, lazyComponent = workInProgress.pendingProps.children, $662d9978aa5168bc$var$prepareToReadContext(workInProgress), init = $662d9978aa5168bc$var$readContext(init), lazyComponent = lazyComponent(init), workInProgress.flags |= 1, $662d9978aa5168bc$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 14:
            return $662d9978aa5168bc$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $662d9978aa5168bc$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $662d9978aa5168bc$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 22:
            return $662d9978aa5168bc$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            return $662d9978aa5168bc$var$prepareToReadContext(workInProgress), lazyComponent = $662d9978aa5168bc$var$readContext($662d9978aa5168bc$var$CacheContext), null === current ? (init = $662d9978aa5168bc$var$peekCacheFromPool(), null === init && (init = $662d9978aa5168bc$var$workInProgressRoot, nextProps = $662d9978aa5168bc$var$createCache(), init.pooledCache = nextProps, nextProps.refCount++, null !== nextProps && (init.pooledCacheLanes |= renderLanes), init = nextProps), workInProgress.memoizedState = {
                parent: lazyComponent,
                cache: init
            }, $662d9978aa5168bc$var$initializeUpdateQueue(workInProgress), $662d9978aa5168bc$var$pushProvider(workInProgress, $662d9978aa5168bc$var$CacheContext, init)) : (0 !== (current.lanes & renderLanes) && ($662d9978aa5168bc$var$cloneUpdateQueue(current, workInProgress), $662d9978aa5168bc$var$processUpdateQueue(workInProgress, null, null, renderLanes), $662d9978aa5168bc$var$suspendIfUpdateReadFromEntangledAsyncAction()), init = current.memoizedState, nextProps = workInProgress.memoizedState, init.parent !== lazyComponent ? (init = {
                parent: lazyComponent,
                cache: lazyComponent
            }, workInProgress.memoizedState = init, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = init), $662d9978aa5168bc$var$pushProvider(workInProgress, $662d9978aa5168bc$var$CacheContext, lazyComponent)) : (lazyComponent = nextProps.cache, $662d9978aa5168bc$var$pushProvider(workInProgress, $662d9978aa5168bc$var$CacheContext, lazyComponent), lazyComponent !== init.cache && $662d9978aa5168bc$var$propagateContextChanges(workInProgress, [
                $662d9978aa5168bc$var$CacheContext
            ], renderLanes, !0))), $662d9978aa5168bc$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($662d9978aa5168bc$var$formatProdErrorMessage(156, workInProgress.tag));
}
var $662d9978aa5168bc$var$valueCursor = $662d9978aa5168bc$var$createCursor(null), $662d9978aa5168bc$var$currentlyRenderingFiber = null, $662d9978aa5168bc$var$lastContextDependency = null;
function $662d9978aa5168bc$var$pushProvider(providerFiber, context, nextValue) {
    $662d9978aa5168bc$var$push($662d9978aa5168bc$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $662d9978aa5168bc$var$popProvider(context) {
    context._currentValue = $662d9978aa5168bc$var$valueCursor.current;
    $662d9978aa5168bc$var$pop($662d9978aa5168bc$var$valueCursor);
}
function $662d9978aa5168bc$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $662d9978aa5168bc$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $662d9978aa5168bc$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $662d9978aa5168bc$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $662d9978aa5168bc$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $662d9978aa5168bc$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $662d9978aa5168bc$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($662d9978aa5168bc$var$HostTransitionContext) : current = [
                $662d9978aa5168bc$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $662d9978aa5168bc$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $662d9978aa5168bc$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$662d9978aa5168bc$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $662d9978aa5168bc$var$prepareToReadContext(workInProgress) {
    $662d9978aa5168bc$var$currentlyRenderingFiber = workInProgress;
    $662d9978aa5168bc$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $662d9978aa5168bc$var$readContext(context) {
    return $662d9978aa5168bc$var$readContextForConsumer($662d9978aa5168bc$var$currentlyRenderingFiber, context);
}
function $662d9978aa5168bc$var$readContextDuringReconciliation(consumer, context) {
    null === $662d9978aa5168bc$var$currentlyRenderingFiber && $662d9978aa5168bc$var$prepareToReadContext(consumer);
    return $662d9978aa5168bc$var$readContextForConsumer(consumer, context);
}
function $662d9978aa5168bc$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $662d9978aa5168bc$var$lastContextDependency) {
        if (null === consumer) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(308));
        $662d9978aa5168bc$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $662d9978aa5168bc$var$lastContextDependency = $662d9978aa5168bc$var$lastContextDependency.next = context;
    return value;
}
var $662d9978aa5168bc$var$hasForceUpdate = !1;
function $662d9978aa5168bc$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $662d9978aa5168bc$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $662d9978aa5168bc$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $662d9978aa5168bc$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($662d9978aa5168bc$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $662d9978aa5168bc$var$getRootForUpdatedFiber(fiber);
        $662d9978aa5168bc$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $662d9978aa5168bc$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $662d9978aa5168bc$var$getRootForUpdatedFiber(fiber);
}
function $662d9978aa5168bc$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194176))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $662d9978aa5168bc$var$markRootEntangled(root, lane);
    }
}
function $662d9978aa5168bc$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $662d9978aa5168bc$var$didReadFromEntangledAsyncAction = !1;
function $662d9978aa5168bc$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($662d9978aa5168bc$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $662d9978aa5168bc$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $662d9978aa5168bc$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $662d9978aa5168bc$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $662d9978aa5168bc$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($662d9978aa5168bc$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $662d9978aa5168bc$var$currentEntangledLane && ($662d9978aa5168bc$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $662d9978aa5168bc$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $662d9978aa5168bc$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $662d9978aa5168bc$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $662d9978aa5168bc$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $662d9978aa5168bc$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$662d9978aa5168bc$var$callCallback(callbacks[updateQueue], context);
}
function $662d9978aa5168bc$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $662d9978aa5168bc$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $662d9978aa5168bc$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0;
                        try {
                            destroy();
                        } catch (error) {
                            $662d9978aa5168bc$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $662d9978aa5168bc$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $662d9978aa5168bc$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $662d9978aa5168bc$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $662d9978aa5168bc$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $662d9978aa5168bc$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $662d9978aa5168bc$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $662d9978aa5168bc$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $662d9978aa5168bc$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            var instance = current.stateNode;
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = instance;
                    break;
                default:
                    instanceToUse = instance;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $662d9978aa5168bc$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $662d9978aa5168bc$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $662d9978aa5168bc$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$112) {
            $662d9978aa5168bc$var$captureCommitPhaseError(current, nearestMountedAncestor, error$112);
        }
        else ref.current = null;
    }
}
function $662d9978aa5168bc$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $662d9978aa5168bc$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $662d9978aa5168bc$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $662d9978aa5168bc$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$662d9978aa5168bc$var$internalPropsKey] = newProps;
    } catch (error) {
        $662d9978aa5168bc$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $662d9978aa5168bc$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag || 4 === fiber.tag;
}
function $662d9978aa5168bc$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $662d9978aa5168bc$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 27 !== fiber.tag && 18 !== fiber.tag;){
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $662d9978aa5168bc$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? 8 === parent.nodeType ? parent.parentNode.insertBefore(node, before) : parent.insertBefore(node, before) : (8 === parent.nodeType ? (before = parent.parentNode, before.insertBefore(node, parent)) : (before = parent, before.appendChild(node)), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $662d9978aa5168bc$var$noop$1));
    else if (4 !== tag && 27 !== tag && (node = node.child, null !== node)) for($662d9978aa5168bc$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$662d9978aa5168bc$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $662d9978aa5168bc$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && 27 !== tag && (node = node.child, null !== node)) for($662d9978aa5168bc$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$662d9978aa5168bc$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
var $662d9978aa5168bc$var$offscreenSubtreeIsHidden = !1, $662d9978aa5168bc$var$offscreenSubtreeWasHidden = !1, $662d9978aa5168bc$var$needsFormReset = !1, $662d9978aa5168bc$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $662d9978aa5168bc$var$nextEffect = null, $662d9978aa5168bc$var$shouldFireAfterActiveInstanceBlur = !1;
function $662d9978aa5168bc$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $662d9978aa5168bc$var$eventsEnabled = $662d9978aa5168bc$var$_enabled;
    root = $662d9978aa5168bc$var$getActiveElementDeep(root);
    if ($662d9978aa5168bc$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $662d9978aa5168bc$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $662d9978aa5168bc$var$_enabled = !1;
    for($662d9978aa5168bc$var$nextEffect = firstChild; null !== $662d9978aa5168bc$var$nextEffect;)if (firstChild = $662d9978aa5168bc$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $662d9978aa5168bc$var$nextEffect = root;
    else for(; null !== $662d9978aa5168bc$var$nextEffect;){
        firstChild = $662d9978aa5168bc$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $662d9978aa5168bc$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset, JSCompiler_temp.elementType === JSCompiler_temp.type);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $662d9978aa5168bc$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $662d9978aa5168bc$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $662d9978aa5168bc$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $662d9978aa5168bc$var$nextEffect = root;
            break;
        }
        $662d9978aa5168bc$var$nextEffect = firstChild.return;
    }
    resolvedPrevProps = $662d9978aa5168bc$var$shouldFireAfterActiveInstanceBlur;
    $662d9978aa5168bc$var$shouldFireAfterActiveInstanceBlur = !1;
    return resolvedPrevProps;
}
function $662d9978aa5168bc$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $662d9978aa5168bc$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $662d9978aa5168bc$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $662d9978aa5168bc$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $662d9978aa5168bc$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $662d9978aa5168bc$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$111) {
                        $662d9978aa5168bc$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$111);
                    }
                }
            }
            flags & 64 && $662d9978aa5168bc$var$commitClassCallbacks(finishedWork);
            flags & 512 && $662d9978aa5168bc$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $662d9978aa5168bc$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (flags = finishedWork.updateQueue, null !== flags)) {
                finishedRoot = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        finishedRoot = finishedWork.child.stateNode;
                        break;
                    case 1:
                        finishedRoot = finishedWork.child.stateNode;
                }
                try {
                    $662d9978aa5168bc$var$commitCallbacks(flags, finishedRoot);
                } catch (error) {
                    $662d9978aa5168bc$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 26:
            $662d9978aa5168bc$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 512 && $662d9978aa5168bc$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 27:
        case 5:
            $662d9978aa5168bc$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $662d9978aa5168bc$var$commitHostMount(finishedWork);
            flags & 512 && $662d9978aa5168bc$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $662d9978aa5168bc$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 13:
            $662d9978aa5168bc$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $662d9978aa5168bc$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 22:
            prevProps = null !== finishedWork.memoizedState || $662d9978aa5168bc$var$offscreenSubtreeIsHidden;
            if (!prevProps) {
                current = null !== current && null !== current.memoizedState || $662d9978aa5168bc$var$offscreenSubtreeWasHidden;
                var prevOffscreenSubtreeIsHidden = $662d9978aa5168bc$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $662d9978aa5168bc$var$offscreenSubtreeWasHidden;
                $662d9978aa5168bc$var$offscreenSubtreeIsHidden = prevProps;
                ($662d9978aa5168bc$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $662d9978aa5168bc$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $662d9978aa5168bc$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $662d9978aa5168bc$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
                $662d9978aa5168bc$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            flags & 512 && ("manual" === finishedWork.memoizedProps.mode ? $662d9978aa5168bc$var$safelyAttachRef(finishedWork, finishedWork.return) : $662d9978aa5168bc$var$safelyDetachRef(finishedWork, finishedWork.return));
            break;
        default:
            $662d9978aa5168bc$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $662d9978aa5168bc$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $662d9978aa5168bc$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $662d9978aa5168bc$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $662d9978aa5168bc$var$hostParent = null, $662d9978aa5168bc$var$hostParentIsContainer = !1;
function $662d9978aa5168bc$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$662d9978aa5168bc$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $662d9978aa5168bc$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($662d9978aa5168bc$var$injectedHook && "function" === typeof $662d9978aa5168bc$var$injectedHook.onCommitFiberUnmount) try {
        $662d9978aa5168bc$var$injectedHook.onCommitFiberUnmount($662d9978aa5168bc$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $662d9978aa5168bc$var$offscreenSubtreeWasHidden || $662d9978aa5168bc$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $662d9978aa5168bc$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $662d9978aa5168bc$var$offscreenSubtreeWasHidden || $662d9978aa5168bc$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $662d9978aa5168bc$var$hostParent, prevHostParentIsContainer = $662d9978aa5168bc$var$hostParentIsContainer;
            $662d9978aa5168bc$var$hostParent = deletedFiber.stateNode;
            $662d9978aa5168bc$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber = deletedFiber.stateNode;
            for(nearestMountedAncestor = deletedFiber.attributes; nearestMountedAncestor.length;)deletedFiber.removeAttributeNode(nearestMountedAncestor[0]);
            $662d9978aa5168bc$var$detachDeletedInstance(deletedFiber);
            $662d9978aa5168bc$var$hostParent = prevHostParent;
            $662d9978aa5168bc$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $662d9978aa5168bc$var$offscreenSubtreeWasHidden || $662d9978aa5168bc$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParentIsContainer = $662d9978aa5168bc$var$hostParent;
            var prevHostParentIsContainer$119 = $662d9978aa5168bc$var$hostParentIsContainer;
            $662d9978aa5168bc$var$hostParent = null;
            $662d9978aa5168bc$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $662d9978aa5168bc$var$hostParent = prevHostParentIsContainer;
            $662d9978aa5168bc$var$hostParentIsContainer = prevHostParentIsContainer$119;
            if (null !== $662d9978aa5168bc$var$hostParent) {
                if ($662d9978aa5168bc$var$hostParentIsContainer) try {
                    finishedRoot = $662d9978aa5168bc$var$hostParent, prevHostParent = deletedFiber.stateNode, 8 === finishedRoot.nodeType ? finishedRoot.parentNode.removeChild(prevHostParent) : finishedRoot.removeChild(prevHostParent);
                } catch (error) {
                    $662d9978aa5168bc$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $662d9978aa5168bc$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $662d9978aa5168bc$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $662d9978aa5168bc$var$hostParent && ($662d9978aa5168bc$var$hostParentIsContainer ? (nearestMountedAncestor = $662d9978aa5168bc$var$hostParent, deletedFiber = deletedFiber.stateNode, 8 === nearestMountedAncestor.nodeType ? $662d9978aa5168bc$var$clearSuspenseBoundary(nearestMountedAncestor.parentNode, deletedFiber) : 1 === nearestMountedAncestor.nodeType && $662d9978aa5168bc$var$clearSuspenseBoundary(nearestMountedAncestor, deletedFiber), $662d9978aa5168bc$var$retryIfBlockedOn(nearestMountedAncestor)) : $662d9978aa5168bc$var$clearSuspenseBoundary($662d9978aa5168bc$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $662d9978aa5168bc$var$hostParent;
            prevHostParentIsContainer = $662d9978aa5168bc$var$hostParentIsContainer;
            $662d9978aa5168bc$var$hostParent = deletedFiber.stateNode.containerInfo;
            $662d9978aa5168bc$var$hostParentIsContainer = !0;
            $662d9978aa5168bc$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $662d9978aa5168bc$var$hostParent = prevHostParent;
            $662d9978aa5168bc$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $662d9978aa5168bc$var$offscreenSubtreeWasHidden || $662d9978aa5168bc$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $662d9978aa5168bc$var$offscreenSubtreeWasHidden || $662d9978aa5168bc$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $662d9978aa5168bc$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $662d9978aa5168bc$var$offscreenSubtreeWasHidden || ($662d9978aa5168bc$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $662d9978aa5168bc$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $662d9978aa5168bc$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $662d9978aa5168bc$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $662d9978aa5168bc$var$offscreenSubtreeWasHidden || $662d9978aa5168bc$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $662d9978aa5168bc$var$offscreenSubtreeWasHidden = (prevHostParent = $662d9978aa5168bc$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $662d9978aa5168bc$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $662d9978aa5168bc$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $662d9978aa5168bc$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $662d9978aa5168bc$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $662d9978aa5168bc$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $662d9978aa5168bc$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $662d9978aa5168bc$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $662d9978aa5168bc$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $662d9978aa5168bc$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($662d9978aa5168bc$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $662d9978aa5168bc$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $662d9978aa5168bc$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        var retry = $662d9978aa5168bc$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
        retryCache.has(wakeable) || (retryCache.add(wakeable), wakeable.then(retry, retry));
    });
}
function $662d9978aa5168bc$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                case 5:
                    $662d9978aa5168bc$var$hostParent = parent.stateNode;
                    $662d9978aa5168bc$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                    $662d9978aa5168bc$var$hostParent = parent.stateNode.containerInfo;
                    $662d9978aa5168bc$var$hostParentIsContainer = !0;
                    break a;
                case 4:
                    $662d9978aa5168bc$var$hostParent = parent.stateNode.containerInfo;
                    $662d9978aa5168bc$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $662d9978aa5168bc$var$hostParent) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(160));
        $662d9978aa5168bc$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $662d9978aa5168bc$var$hostParent = null;
        $662d9978aa5168bc$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13878) for(parentFiber = parentFiber.child; null !== parentFiber;)$662d9978aa5168bc$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $662d9978aa5168bc$var$currentHoistableRoot = null;
function $662d9978aa5168bc$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $662d9978aa5168bc$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $662d9978aa5168bc$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($662d9978aa5168bc$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $662d9978aa5168bc$var$commitHookEffectListMount(3, finishedWork), $662d9978aa5168bc$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $662d9978aa5168bc$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $662d9978aa5168bc$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($662d9978aa5168bc$var$offscreenSubtreeWasHidden || null === current || $662d9978aa5168bc$var$safelyDetachRef(current, current.return));
            flags & 64 && $662d9978aa5168bc$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $662d9978aa5168bc$var$currentHoistableRoot;
            $662d9978aa5168bc$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $662d9978aa5168bc$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($662d9978aa5168bc$var$offscreenSubtreeWasHidden || null === current || $662d9978aa5168bc$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$662d9978aa5168bc$var$internalHoistableMarker] || currentResource[$662d9978aa5168bc$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $662d9978aa5168bc$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$662d9978aa5168bc$var$internalInstanceKey] = finishedWork;
                                        $662d9978aa5168bc$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $662d9978aa5168bc$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $662d9978aa5168bc$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $662d9978aa5168bc$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $662d9978aa5168bc$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($662d9978aa5168bc$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$662d9978aa5168bc$var$internalInstanceKey] = finishedWork;
                                $662d9978aa5168bc$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $662d9978aa5168bc$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $662d9978aa5168bc$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $662d9978aa5168bc$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $662d9978aa5168bc$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $662d9978aa5168bc$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            if (flags & 4 && null === finishedWork.alternate) {
                hoistableRoot = finishedWork.stateNode;
                currentResource = finishedWork.memoizedProps;
                try {
                    for(var node = hoistableRoot.firstChild; node;){
                        var nextNode = node.nextSibling, nodeName = node.nodeName;
                        node[$662d9978aa5168bc$var$internalHoistableMarker] || "HEAD" === nodeName || "BODY" === nodeName || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node.rel.toLowerCase() || hoistableRoot.removeChild(node);
                        node = nextNode;
                    }
                    for(var type = finishedWork.type, attributes = hoistableRoot.attributes; attributes.length;)hoistableRoot.removeAttributeNode(attributes[0]);
                    $662d9978aa5168bc$var$setInitialProperties(hoistableRoot, type, currentResource);
                    hoistableRoot[$662d9978aa5168bc$var$internalInstanceKey] = finishedWork;
                    hoistableRoot[$662d9978aa5168bc$var$internalPropsKey] = currentResource;
                } catch (error) {
                    $662d9978aa5168bc$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
        case 5:
            $662d9978aa5168bc$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $662d9978aa5168bc$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($662d9978aa5168bc$var$offscreenSubtreeWasHidden || null === current || $662d9978aa5168bc$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $662d9978aa5168bc$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $662d9978aa5168bc$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $662d9978aa5168bc$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($662d9978aa5168bc$var$needsFormReset = !0);
            break;
        case 6:
            $662d9978aa5168bc$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $662d9978aa5168bc$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $662d9978aa5168bc$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $662d9978aa5168bc$var$tagCaches = null;
            hoistableRoot = $662d9978aa5168bc$var$currentHoistableRoot;
            $662d9978aa5168bc$var$currentHoistableRoot = $662d9978aa5168bc$var$getHoistableRoot(root.containerInfo);
            $662d9978aa5168bc$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $662d9978aa5168bc$var$currentHoistableRoot = hoistableRoot;
            $662d9978aa5168bc$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $662d9978aa5168bc$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $662d9978aa5168bc$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $662d9978aa5168bc$var$needsFormReset && ($662d9978aa5168bc$var$needsFormReset = !1, $662d9978aa5168bc$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $662d9978aa5168bc$var$currentHoistableRoot;
            $662d9978aa5168bc$var$currentHoistableRoot = $662d9978aa5168bc$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $662d9978aa5168bc$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $662d9978aa5168bc$var$commitReconciliationEffects(finishedWork);
            $662d9978aa5168bc$var$currentHoistableRoot = flags;
            break;
        case 12:
            $662d9978aa5168bc$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $662d9978aa5168bc$var$commitReconciliationEffects(finishedWork);
            break;
        case 13:
            $662d9978aa5168bc$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $662d9978aa5168bc$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($662d9978aa5168bc$var$globalMostRecentFallbackTime = $662d9978aa5168bc$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $662d9978aa5168bc$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            flags & 512 && ($662d9978aa5168bc$var$offscreenSubtreeWasHidden || null === current || $662d9978aa5168bc$var$safelyDetachRef(current, current.return));
            node = null !== finishedWork.memoizedState;
            nextNode = null !== current && null !== current.memoizedState;
            nodeName = $662d9978aa5168bc$var$offscreenSubtreeIsHidden;
            type = $662d9978aa5168bc$var$offscreenSubtreeWasHidden;
            $662d9978aa5168bc$var$offscreenSubtreeIsHidden = nodeName || node;
            $662d9978aa5168bc$var$offscreenSubtreeWasHidden = type || nextNode;
            $662d9978aa5168bc$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $662d9978aa5168bc$var$offscreenSubtreeWasHidden = type;
            $662d9978aa5168bc$var$offscreenSubtreeIsHidden = nodeName;
            $662d9978aa5168bc$var$commitReconciliationEffects(finishedWork);
            root = finishedWork.stateNode;
            root._current = finishedWork;
            root._visibility &= -3;
            root._visibility |= root._pendingVisibility & 2;
            if (flags & 8192 && (root._visibility = node ? root._visibility & -2 : root._visibility | 1, node && (root = $662d9978aa5168bc$var$offscreenSubtreeIsHidden || $662d9978aa5168bc$var$offscreenSubtreeWasHidden, null === current || nextNode || root || $662d9978aa5168bc$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), null === finishedWork.memoizedProps || "manual" !== finishedWork.memoizedProps.mode)) a: for(current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag || 27 === root.tag) {
                    if (null === current) {
                        nextNode = current = root;
                        try {
                            if (hoistableRoot = nextNode.stateNode, node) currentResource = hoistableRoot.style, "function" === typeof currentResource.setProperty ? currentResource.setProperty("display", "none", "important") : currentResource.display = "none";
                            else {
                                maybeNodes = nextNode.stateNode;
                                i = nextNode.memoizedProps.style;
                                var display = void 0 !== i && null !== i && i.hasOwnProperty("display") ? i.display : null;
                                maybeNodes.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $662d9978aa5168bc$var$captureCommitPhaseError(nextNode, nextNode.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        nextNode = root;
                        try {
                            nextNode.stateNode.nodeValue = node ? "" : nextNode.memoizedProps;
                        } catch (error) {
                            $662d9978aa5168bc$var$captureCommitPhaseError(nextNode, nextNode.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $662d9978aa5168bc$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $662d9978aa5168bc$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $662d9978aa5168bc$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $662d9978aa5168bc$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 21:
            break;
        default:
            $662d9978aa5168bc$var$recursivelyTraverseMutationEffects(root, finishedWork), $662d9978aa5168bc$var$commitReconciliationEffects(finishedWork);
    }
}
function $662d9978aa5168bc$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            if (27 !== finishedWork.tag) {
                a: {
                    for(var parent = finishedWork.return; null !== parent;){
                        if ($662d9978aa5168bc$var$isHostParent(parent)) {
                            var JSCompiler_inline_result = parent;
                            break a;
                        }
                        parent = parent.return;
                    }
                    throw Error($662d9978aa5168bc$var$formatProdErrorMessage(160));
                }
                switch(JSCompiler_inline_result.tag){
                    case 27:
                        var parent$jscomp$0 = JSCompiler_inline_result.stateNode, before = $662d9978aa5168bc$var$getHostSibling(finishedWork);
                        $662d9978aa5168bc$var$insertOrAppendPlacementNode(finishedWork, before, parent$jscomp$0);
                        break;
                    case 5:
                        var parent$113 = JSCompiler_inline_result.stateNode;
                        JSCompiler_inline_result.flags & 32 && ($662d9978aa5168bc$var$setTextContent(parent$113, ""), JSCompiler_inline_result.flags &= -33);
                        var before$114 = $662d9978aa5168bc$var$getHostSibling(finishedWork);
                        $662d9978aa5168bc$var$insertOrAppendPlacementNode(finishedWork, before$114, parent$113);
                        break;
                    case 3:
                    case 4:
                        var parent$115 = JSCompiler_inline_result.stateNode.containerInfo, before$116 = $662d9978aa5168bc$var$getHostSibling(finishedWork);
                        $662d9978aa5168bc$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$116, parent$115);
                        break;
                    default:
                        throw Error($662d9978aa5168bc$var$formatProdErrorMessage(161));
                }
            }
        } catch (error) {
            $662d9978aa5168bc$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $662d9978aa5168bc$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $662d9978aa5168bc$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $662d9978aa5168bc$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$662d9978aa5168bc$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $662d9978aa5168bc$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $662d9978aa5168bc$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $662d9978aa5168bc$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $662d9978aa5168bc$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $662d9978aa5168bc$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $662d9978aa5168bc$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 26:
            case 27:
            case 5:
                $662d9978aa5168bc$var$safelyDetachRef(finishedWork, finishedWork.return);
                $662d9978aa5168bc$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                $662d9978aa5168bc$var$safelyDetachRef(finishedWork, finishedWork.return);
                null === finishedWork.memoizedState && $662d9978aa5168bc$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $662d9978aa5168bc$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $662d9978aa5168bc$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $662d9978aa5168bc$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $662d9978aa5168bc$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $662d9978aa5168bc$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $662d9978aa5168bc$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$662d9978aa5168bc$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $662d9978aa5168bc$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $662d9978aa5168bc$var$commitClassCallbacks(finishedWork);
                $662d9978aa5168bc$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 26:
            case 27:
            case 5:
                $662d9978aa5168bc$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $662d9978aa5168bc$var$commitHostMount(finishedWork);
                $662d9978aa5168bc$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $662d9978aa5168bc$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 13:
                $662d9978aa5168bc$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $662d9978aa5168bc$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $662d9978aa5168bc$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $662d9978aa5168bc$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            default:
                $662d9978aa5168bc$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $662d9978aa5168bc$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $662d9978aa5168bc$var$releaseCache(previousCache));
}
function $662d9978aa5168bc$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $662d9978aa5168bc$var$releaseCache(current));
}
function $662d9978aa5168bc$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$662d9978aa5168bc$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $662d9978aa5168bc$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $662d9978aa5168bc$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $662d9978aa5168bc$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 3:
            $662d9978aa5168bc$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $662d9978aa5168bc$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $662d9978aa5168bc$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $662d9978aa5168bc$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $662d9978aa5168bc$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 4 ? $662d9978aa5168bc$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $662d9978aa5168bc$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 4 ? $662d9978aa5168bc$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 4, $662d9978aa5168bc$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256)));
            flags & 2048 && $662d9978aa5168bc$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
            break;
        case 24:
            $662d9978aa5168bc$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $662d9978aa5168bc$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $662d9978aa5168bc$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $662d9978aa5168bc$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 10256);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $662d9978aa5168bc$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $662d9978aa5168bc$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 4 ? $662d9978aa5168bc$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $662d9978aa5168bc$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 4, $662d9978aa5168bc$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $662d9978aa5168bc$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $662d9978aa5168bc$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $662d9978aa5168bc$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $662d9978aa5168bc$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $662d9978aa5168bc$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $662d9978aa5168bc$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $662d9978aa5168bc$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $662d9978aa5168bc$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $662d9978aa5168bc$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $662d9978aa5168bc$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $662d9978aa5168bc$var$suspenseyCommitFlag = 8192;
function $662d9978aa5168bc$var$recursivelyAccumulateSuspenseyCommit(parentFiber) {
    if (parentFiber.subtreeFlags & $662d9978aa5168bc$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$662d9978aa5168bc$var$accumulateSuspenseyCommitOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $662d9978aa5168bc$var$accumulateSuspenseyCommitOnFiber(fiber) {
    switch(fiber.tag){
        case 26:
            $662d9978aa5168bc$var$recursivelyAccumulateSuspenseyCommit(fiber);
            fiber.flags & $662d9978aa5168bc$var$suspenseyCommitFlag && null !== fiber.memoizedState && $662d9978aa5168bc$var$suspendResource($662d9978aa5168bc$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $662d9978aa5168bc$var$recursivelyAccumulateSuspenseyCommit(fiber);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $662d9978aa5168bc$var$currentHoistableRoot;
            $662d9978aa5168bc$var$currentHoistableRoot = $662d9978aa5168bc$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $662d9978aa5168bc$var$recursivelyAccumulateSuspenseyCommit(fiber);
            $662d9978aa5168bc$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $662d9978aa5168bc$var$suspenseyCommitFlag, $662d9978aa5168bc$var$suspenseyCommitFlag = 16777216, $662d9978aa5168bc$var$recursivelyAccumulateSuspenseyCommit(fiber), $662d9978aa5168bc$var$suspenseyCommitFlag = previousHoistableRoot) : $662d9978aa5168bc$var$recursivelyAccumulateSuspenseyCommit(fiber));
            break;
        default:
            $662d9978aa5168bc$var$recursivelyAccumulateSuspenseyCommit(fiber);
    }
}
function $662d9978aa5168bc$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $662d9978aa5168bc$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $662d9978aa5168bc$var$nextEffect = childToDelete;
            $662d9978aa5168bc$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $662d9978aa5168bc$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$662d9978aa5168bc$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $662d9978aa5168bc$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $662d9978aa5168bc$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $662d9978aa5168bc$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $662d9978aa5168bc$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $662d9978aa5168bc$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 4 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -5, $662d9978aa5168bc$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $662d9978aa5168bc$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $662d9978aa5168bc$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $662d9978aa5168bc$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $662d9978aa5168bc$var$nextEffect = childToDelete;
            $662d9978aa5168bc$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $662d9978aa5168bc$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $662d9978aa5168bc$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $662d9978aa5168bc$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 4 && (i._visibility &= -5, $662d9978aa5168bc$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $662d9978aa5168bc$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $662d9978aa5168bc$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $662d9978aa5168bc$var$nextEffect;){
        var fiber = $662d9978aa5168bc$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $662d9978aa5168bc$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $662d9978aa5168bc$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $662d9978aa5168bc$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $662d9978aa5168bc$var$nextEffect;){
            cache = $662d9978aa5168bc$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $662d9978aa5168bc$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $662d9978aa5168bc$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $662d9978aa5168bc$var$nextEffect = sibling;
                break a;
            }
            $662d9978aa5168bc$var$nextEffect = returnFiber;
        }
    }
}
function $662d9978aa5168bc$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $662d9978aa5168bc$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $662d9978aa5168bc$var$FiberNode(tag, pendingProps, key, mode);
}
function $662d9978aa5168bc$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $662d9978aa5168bc$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $662d9978aa5168bc$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 31457280;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $662d9978aa5168bc$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 31457282;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $662d9978aa5168bc$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $662d9978aa5168bc$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $662d9978aa5168bc$var$isHostHoistableType(type, pendingProps, $662d9978aa5168bc$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $662d9978aa5168bc$var$REACT_FRAGMENT_TYPE:
            return $662d9978aa5168bc$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $662d9978aa5168bc$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $662d9978aa5168bc$var$REACT_PROFILER_TYPE:
            return type = $662d9978aa5168bc$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $662d9978aa5168bc$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $662d9978aa5168bc$var$REACT_SUSPENSE_TYPE:
            return type = $662d9978aa5168bc$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $662d9978aa5168bc$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $662d9978aa5168bc$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $662d9978aa5168bc$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $662d9978aa5168bc$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        case $662d9978aa5168bc$var$REACT_OFFSCREEN_TYPE:
            return $662d9978aa5168bc$var$createFiberFromOffscreen(pendingProps, mode, lanes, key);
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $662d9978aa5168bc$var$REACT_PROVIDER_TYPE:
                case $662d9978aa5168bc$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $662d9978aa5168bc$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $662d9978aa5168bc$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $662d9978aa5168bc$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $662d9978aa5168bc$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($662d9978aa5168bc$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $662d9978aa5168bc$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $662d9978aa5168bc$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $662d9978aa5168bc$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $662d9978aa5168bc$var$createFiberFromOffscreen(pendingProps, mode, lanes, key) {
    pendingProps = $662d9978aa5168bc$var$createFiberImplClass(22, pendingProps, key, mode);
    pendingProps.elementType = $662d9978aa5168bc$var$REACT_OFFSCREEN_TYPE;
    pendingProps.lanes = lanes;
    var primaryChildInstance = {
        _visibility: 1,
        _pendingVisibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null,
        _current: null,
        detach: function() {
            var fiber = primaryChildInstance._current;
            if (null === fiber) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(456));
            if (0 === (primaryChildInstance._pendingVisibility & 2)) {
                var root = $662d9978aa5168bc$var$enqueueConcurrentRenderForLane(fiber, 2);
                null !== root && (primaryChildInstance._pendingVisibility |= 2, $662d9978aa5168bc$var$scheduleUpdateOnFiber(root, fiber, 2));
            }
        },
        attach: function() {
            var fiber = primaryChildInstance._current;
            if (null === fiber) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(456));
            if (0 !== (primaryChildInstance._pendingVisibility & 2)) {
                var root = $662d9978aa5168bc$var$enqueueConcurrentRenderForLane(fiber, 2);
                null !== root && (primaryChildInstance._pendingVisibility &= -3, $662d9978aa5168bc$var$scheduleUpdateOnFiber(root, fiber, 2));
            }
        }
    };
    pendingProps.stateNode = primaryChildInstance;
    return pendingProps;
}
function $662d9978aa5168bc$var$createFiberFromText(content, mode, lanes) {
    content = $662d9978aa5168bc$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $662d9978aa5168bc$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $662d9978aa5168bc$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
function $662d9978aa5168bc$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $662d9978aa5168bc$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$662d9978aa5168bc$var$preloadResource(resource)) {
        resource = $662d9978aa5168bc$var$suspenseHandlerStackCursor.current;
        if (null !== resource && (($662d9978aa5168bc$var$workInProgressRootRenderLanes & 4194176) === $662d9978aa5168bc$var$workInProgressRootRenderLanes ? null !== $662d9978aa5168bc$var$shellBoundary : ($662d9978aa5168bc$var$workInProgressRootRenderLanes & 62914560) !== $662d9978aa5168bc$var$workInProgressRootRenderLanes && 0 === ($662d9978aa5168bc$var$workInProgressRootRenderLanes & 536870912) || resource !== $662d9978aa5168bc$var$shellBoundary)) throw $662d9978aa5168bc$var$suspendedThenable = $662d9978aa5168bc$var$noopSuspenseyCommitThenable, $662d9978aa5168bc$var$SuspenseyCommitException;
        workInProgress.flags |= 8192;
    }
}
function $662d9978aa5168bc$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $662d9978aa5168bc$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $662d9978aa5168bc$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $662d9978aa5168bc$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$662d9978aa5168bc$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$131 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$131 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$131 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$131.sibling = null;
    }
}
function $662d9978aa5168bc$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$132 = completedWork.child; null !== child$132;)newChildLanes |= child$132.lanes | child$132.childLanes, subtreeFlags |= child$132.subtreeFlags & 31457280, subtreeFlags |= child$132.flags & 31457280, child$132.return = completedWork, child$132 = child$132.sibling;
    else for(child$132 = completedWork.child; null !== child$132;)newChildLanes |= child$132.lanes | child$132.childLanes, subtreeFlags |= child$132.subtreeFlags, subtreeFlags |= child$132.flags, child$132.return = completedWork, child$132 = child$132.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $662d9978aa5168bc$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $662d9978aa5168bc$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $662d9978aa5168bc$var$bubbleProperties(workInProgress), null;
        case 1:
            return $662d9978aa5168bc$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $662d9978aa5168bc$var$popProvider($662d9978aa5168bc$var$CacheContext);
            $662d9978aa5168bc$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $662d9978aa5168bc$var$popHydrationState(workInProgress) ? $662d9978aa5168bc$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, null !== $662d9978aa5168bc$var$hydrationErrors && ($662d9978aa5168bc$var$queueRecoverableErrors($662d9978aa5168bc$var$hydrationErrors), $662d9978aa5168bc$var$hydrationErrors = null));
            $662d9978aa5168bc$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            return renderLanes = workInProgress.memoizedState, null === current ? ($662d9978aa5168bc$var$markUpdate(workInProgress), null !== renderLanes ? ($662d9978aa5168bc$var$bubbleProperties(workInProgress), $662d9978aa5168bc$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($662d9978aa5168bc$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217)) : renderLanes ? renderLanes !== current.memoizedState ? ($662d9978aa5168bc$var$markUpdate(workInProgress), $662d9978aa5168bc$var$bubbleProperties(workInProgress), $662d9978aa5168bc$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($662d9978aa5168bc$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current.memoizedProps !== newProps && $662d9978aa5168bc$var$markUpdate(workInProgress), $662d9978aa5168bc$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217), null;
        case 27:
            $662d9978aa5168bc$var$popHostContext(workInProgress);
            renderLanes = $662d9978aa5168bc$var$rootInstanceStackCursor.current;
            var type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $662d9978aa5168bc$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(166));
                    $662d9978aa5168bc$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $662d9978aa5168bc$var$contextStackCursor.current;
                $662d9978aa5168bc$var$popHydrationState(workInProgress) ? $662d9978aa5168bc$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $662d9978aa5168bc$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $662d9978aa5168bc$var$markUpdate(workInProgress));
            }
            $662d9978aa5168bc$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $662d9978aa5168bc$var$popHostContext(workInProgress);
            renderLanes = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $662d9978aa5168bc$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(166));
                    $662d9978aa5168bc$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $662d9978aa5168bc$var$contextStackCursor.current;
                if ($662d9978aa5168bc$var$popHydrationState(workInProgress)) $662d9978aa5168bc$var$prepareToHydrateHostInstance(workInProgress, current);
                else {
                    type = $662d9978aa5168bc$var$getOwnerDocumentFromRootContainer($662d9978aa5168bc$var$rootInstanceStackCursor.current);
                    switch(current){
                        case 1:
                            current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                            break;
                        case 2:
                            current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                            break;
                        default:
                            switch(renderLanes){
                                case "svg":
                                    current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                                    break;
                                case "math":
                                    current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                                    break;
                                case "script":
                                    current = type.createElement("div");
                                    current.innerHTML = "<script></script>";
                                    current = current.removeChild(current.firstChild);
                                    break;
                                case "select":
                                    current = "string" === typeof newProps.is ? type.createElement("select", {
                                        is: newProps.is
                                    }) : type.createElement("select");
                                    newProps.multiple ? current.multiple = !0 : newProps.size && (current.size = newProps.size);
                                    break;
                                default:
                                    current = "string" === typeof newProps.is ? type.createElement(renderLanes, {
                                        is: newProps.is
                                    }) : type.createElement(renderLanes);
                            }
                    }
                    current[$662d9978aa5168bc$var$internalInstanceKey] = workInProgress;
                    current[$662d9978aa5168bc$var$internalPropsKey] = newProps;
                    a: for(type = workInProgress.child; null !== type;){
                        if (5 === type.tag || 6 === type.tag) current.appendChild(type.stateNode);
                        else if (4 !== type.tag && 27 !== type.tag && null !== type.child) {
                            type.child.return = type;
                            type = type.child;
                            continue;
                        }
                        if (type === workInProgress) break a;
                        for(; null === type.sibling;){
                            if (null === type.return || type.return === workInProgress) break a;
                            type = type.return;
                        }
                        type.sibling.return = type.return;
                        type = type.sibling;
                    }
                    workInProgress.stateNode = current;
                    a: switch($662d9978aa5168bc$var$setInitialProperties(current, renderLanes, newProps), renderLanes){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            current = !!newProps.autoFocus;
                            break a;
                        case "img":
                            current = !0;
                            break a;
                        default:
                            current = !1;
                    }
                    current && $662d9978aa5168bc$var$markUpdate(workInProgress);
                }
            }
            $662d9978aa5168bc$var$bubbleProperties(workInProgress);
            workInProgress.flags &= -16777217;
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $662d9978aa5168bc$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(166));
                current = $662d9978aa5168bc$var$rootInstanceStackCursor.current;
                if ($662d9978aa5168bc$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $662d9978aa5168bc$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$662d9978aa5168bc$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $662d9978aa5168bc$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $662d9978aa5168bc$var$throwOnHydrationMismatch(workInProgress);
                } else current = $662d9978aa5168bc$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$662d9978aa5168bc$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $662d9978aa5168bc$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $662d9978aa5168bc$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(317));
                        type[$662d9978aa5168bc$var$internalInstanceKey] = workInProgress;
                    } else $662d9978aa5168bc$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $662d9978aa5168bc$var$bubbleProperties(workInProgress);
                    type = !1;
                } else null !== $662d9978aa5168bc$var$hydrationErrors && ($662d9978aa5168bc$var$queueRecoverableErrors($662d9978aa5168bc$var$hydrationErrors), $662d9978aa5168bc$var$hydrationErrors = null), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $662d9978aa5168bc$var$popSuspenseHandler(workInProgress), workInProgress;
                    $662d9978aa5168bc$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $662d9978aa5168bc$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            if (renderLanes) {
                newProps = workInProgress.child;
                type = null;
                null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool);
                var cache$144 = null;
                null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (cache$144 = newProps.memoizedState.cachePool.pool);
                cache$144 !== type && (newProps.flags |= 2048);
            }
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $662d9978aa5168bc$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $662d9978aa5168bc$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $662d9978aa5168bc$var$popHostContainer(), null === current && $662d9978aa5168bc$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $662d9978aa5168bc$var$bubbleProperties(workInProgress), null;
        case 10:
            return $662d9978aa5168bc$var$popProvider(workInProgress.type), $662d9978aa5168bc$var$bubbleProperties(workInProgress), null;
        case 19:
            $662d9978aa5168bc$var$pop($662d9978aa5168bc$var$suspenseStackCursor);
            type = workInProgress.memoizedState;
            if (null === type) return $662d9978aa5168bc$var$bubbleProperties(workInProgress), null;
            newProps = 0 !== (workInProgress.flags & 128);
            cache$144 = type.rendering;
            if (null === cache$144) {
                if (newProps) $662d9978aa5168bc$var$cutOffTailIfNeeded(type, !1);
                else {
                    if (0 !== $662d9978aa5168bc$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        cache$144 = $662d9978aa5168bc$var$findFirstSuspended(current);
                        if (null !== cache$144) {
                            workInProgress.flags |= 128;
                            $662d9978aa5168bc$var$cutOffTailIfNeeded(type, !1);
                            current = cache$144.updateQueue;
                            workInProgress.updateQueue = current;
                            $662d9978aa5168bc$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$662d9978aa5168bc$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $662d9978aa5168bc$var$push($662d9978aa5168bc$var$suspenseStackCursor, $662d9978aa5168bc$var$suspenseStackCursor.current & 1 | 2);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== type.tail && $662d9978aa5168bc$var$now() > $662d9978aa5168bc$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, newProps = !0, $662d9978aa5168bc$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!newProps) {
                    if (current = $662d9978aa5168bc$var$findFirstSuspended(cache$144), null !== current) {
                        if (workInProgress.flags |= 128, newProps = !0, current = current.updateQueue, workInProgress.updateQueue = current, $662d9978aa5168bc$var$scheduleRetryEffect(workInProgress, current), $662d9978aa5168bc$var$cutOffTailIfNeeded(type, !0), null === type.tail && "hidden" === type.tailMode && !cache$144.alternate && !$662d9978aa5168bc$var$isHydrating) return $662d9978aa5168bc$var$bubbleProperties(workInProgress), null;
                    } else 2 * $662d9978aa5168bc$var$now() - type.renderingStartTime > $662d9978aa5168bc$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, newProps = !0, $662d9978aa5168bc$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
                type.isBackwards ? (cache$144.sibling = workInProgress.child, workInProgress.child = cache$144) : (current = type.last, null !== current ? current.sibling = cache$144 : workInProgress.child = cache$144, type.last = cache$144);
            }
            if (null !== type.tail) return workInProgress = type.tail, type.rendering = workInProgress, type.tail = workInProgress.sibling, type.renderingStartTime = $662d9978aa5168bc$var$now(), workInProgress.sibling = null, current = $662d9978aa5168bc$var$suspenseStackCursor.current, $662d9978aa5168bc$var$push($662d9978aa5168bc$var$suspenseStackCursor, newProps ? current & 1 | 2 : current & 1), workInProgress;
            $662d9978aa5168bc$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $662d9978aa5168bc$var$popSuspenseHandler(workInProgress), $662d9978aa5168bc$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($662d9978aa5168bc$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $662d9978aa5168bc$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $662d9978aa5168bc$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $662d9978aa5168bc$var$pop($662d9978aa5168bc$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $662d9978aa5168bc$var$popProvider($662d9978aa5168bc$var$CacheContext), $662d9978aa5168bc$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
    }
    throw Error($662d9978aa5168bc$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $662d9978aa5168bc$var$unwindWork(current, workInProgress) {
    $662d9978aa5168bc$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $662d9978aa5168bc$var$popProvider($662d9978aa5168bc$var$CacheContext), $662d9978aa5168bc$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $662d9978aa5168bc$var$popHostContext(workInProgress), null;
        case 13:
            $662d9978aa5168bc$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(340));
                $662d9978aa5168bc$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $662d9978aa5168bc$var$pop($662d9978aa5168bc$var$suspenseStackCursor), null;
        case 4:
            return $662d9978aa5168bc$var$popHostContainer(), null;
        case 10:
            return $662d9978aa5168bc$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $662d9978aa5168bc$var$popSuspenseHandler(workInProgress), $662d9978aa5168bc$var$popHiddenContext(), null !== current && $662d9978aa5168bc$var$pop($662d9978aa5168bc$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $662d9978aa5168bc$var$popProvider($662d9978aa5168bc$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $662d9978aa5168bc$var$unwindInterruptedWork(current, interruptedWork) {
    $662d9978aa5168bc$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $662d9978aa5168bc$var$popProvider($662d9978aa5168bc$var$CacheContext);
            $662d9978aa5168bc$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $662d9978aa5168bc$var$popHostContext(interruptedWork);
            break;
        case 4:
            $662d9978aa5168bc$var$popHostContainer();
            break;
        case 13:
            $662d9978aa5168bc$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $662d9978aa5168bc$var$pop($662d9978aa5168bc$var$suspenseStackCursor);
            break;
        case 10:
            $662d9978aa5168bc$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $662d9978aa5168bc$var$popSuspenseHandler(interruptedWork);
            $662d9978aa5168bc$var$popHiddenContext();
            null !== current && $662d9978aa5168bc$var$pop($662d9978aa5168bc$var$resumedCache);
            break;
        case 24:
            $662d9978aa5168bc$var$popProvider($662d9978aa5168bc$var$CacheContext);
    }
}
var $662d9978aa5168bc$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $662d9978aa5168bc$var$readContext($662d9978aa5168bc$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    }
}, $662d9978aa5168bc$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $662d9978aa5168bc$var$executionContext = 0, $662d9978aa5168bc$var$workInProgressRoot = null, $662d9978aa5168bc$var$workInProgress = null, $662d9978aa5168bc$var$workInProgressRootRenderLanes = 0, $662d9978aa5168bc$var$workInProgressSuspendedReason = 0, $662d9978aa5168bc$var$workInProgressThrownValue = null, $662d9978aa5168bc$var$workInProgressRootDidSkipSuspendedSiblings = !1, $662d9978aa5168bc$var$workInProgressRootIsPrerendering = !1, $662d9978aa5168bc$var$workInProgressRootDidAttachPingListener = !1, $662d9978aa5168bc$var$entangledRenderLanes = 0, $662d9978aa5168bc$var$workInProgressRootExitStatus = 0, $662d9978aa5168bc$var$workInProgressRootSkippedLanes = 0, $662d9978aa5168bc$var$workInProgressRootInterleavedUpdatedLanes = 0, $662d9978aa5168bc$var$workInProgressRootPingedLanes = 0, $662d9978aa5168bc$var$workInProgressDeferredLane = 0, $662d9978aa5168bc$var$workInProgressSuspendedRetryLanes = 0, $662d9978aa5168bc$var$workInProgressRootConcurrentErrors = null, $662d9978aa5168bc$var$workInProgressRootRecoverableErrors = null, $662d9978aa5168bc$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $662d9978aa5168bc$var$globalMostRecentFallbackTime = 0, $662d9978aa5168bc$var$workInProgressRootRenderTargetTime = Infinity, $662d9978aa5168bc$var$workInProgressTransitions = null, $662d9978aa5168bc$var$legacyErrorBoundariesThatAlreadyFailed = null, $662d9978aa5168bc$var$rootDoesHavePassiveEffects = !1, $662d9978aa5168bc$var$rootWithPendingPassiveEffects = null, $662d9978aa5168bc$var$pendingPassiveEffectsLanes = 0, $662d9978aa5168bc$var$pendingPassiveEffectsRemainingLanes = 0, $662d9978aa5168bc$var$pendingPassiveTransitions = null, $662d9978aa5168bc$var$nestedUpdateCount = 0, $662d9978aa5168bc$var$rootWithNestedUpdates = null;
function $662d9978aa5168bc$var$requestUpdateLane() {
    if (0 !== ($662d9978aa5168bc$var$executionContext & 2) && 0 !== $662d9978aa5168bc$var$workInProgressRootRenderLanes) return $662d9978aa5168bc$var$workInProgressRootRenderLanes & -$662d9978aa5168bc$var$workInProgressRootRenderLanes;
    if (null !== $662d9978aa5168bc$var$ReactSharedInternals.T) {
        var actionScopeLane = $662d9978aa5168bc$var$currentEntangledLane;
        return 0 !== actionScopeLane ? actionScopeLane : $662d9978aa5168bc$var$requestTransitionLane();
    }
    return $662d9978aa5168bc$var$resolveUpdatePriority();
}
function $662d9978aa5168bc$var$requestDeferredLane() {
    0 === $662d9978aa5168bc$var$workInProgressDeferredLane && ($662d9978aa5168bc$var$workInProgressDeferredLane = 0 === ($662d9978aa5168bc$var$workInProgressRootRenderLanes & 536870912) || $662d9978aa5168bc$var$isHydrating ? $662d9978aa5168bc$var$claimNextTransitionLane() : 536870912);
    var suspenseHandler = $662d9978aa5168bc$var$suspenseHandlerStackCursor.current;
    null !== suspenseHandler && (suspenseHandler.flags |= 32);
    return $662d9978aa5168bc$var$workInProgressDeferredLane;
}
function $662d9978aa5168bc$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $662d9978aa5168bc$var$workInProgressRoot && 2 === $662d9978aa5168bc$var$workInProgressSuspendedReason || null !== root.cancelPendingCommit) $662d9978aa5168bc$var$prepareFreshStack(root, 0), $662d9978aa5168bc$var$markRootSuspended(root, $662d9978aa5168bc$var$workInProgressRootRenderLanes, $662d9978aa5168bc$var$workInProgressDeferredLane, !1);
    $662d9978aa5168bc$var$markRootUpdated$1(root, lane);
    if (0 === ($662d9978aa5168bc$var$executionContext & 2) || root !== $662d9978aa5168bc$var$workInProgressRoot) root === $662d9978aa5168bc$var$workInProgressRoot && (0 === ($662d9978aa5168bc$var$executionContext & 2) && ($662d9978aa5168bc$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $662d9978aa5168bc$var$workInProgressRootExitStatus && $662d9978aa5168bc$var$markRootSuspended(root, $662d9978aa5168bc$var$workInProgressRootRenderLanes, $662d9978aa5168bc$var$workInProgressDeferredLane, !1)), $662d9978aa5168bc$var$ensureRootIsScheduled(root);
}
function $662d9978aa5168bc$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($662d9978aa5168bc$var$executionContext & 6)) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 60) && 0 === (lanes & root$jscomp$0.expiredLanes) || $662d9978aa5168bc$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $662d9978aa5168bc$var$renderRootConcurrent(root$jscomp$0, lanes) : $662d9978aa5168bc$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $662d9978aa5168bc$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $662d9978aa5168bc$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else if (6 === exitStatus) $662d9978aa5168bc$var$markRootSuspended(root$jscomp$0, lanes, 0, !$662d9978aa5168bc$var$workInProgressRootDidSkipSuspendedSiblings);
        else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$662d9978aa5168bc$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $662d9978aa5168bc$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $662d9978aa5168bc$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($662d9978aa5168bc$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $662d9978aa5168bc$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($662d9978aa5168bc$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $662d9978aa5168bc$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $662d9978aa5168bc$var$workInProgressRootRecoverableErrors;
                            $662d9978aa5168bc$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && $662d9978aa5168bc$var$queueRecoverableErrors(renderWasConcurrent);
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $662d9978aa5168bc$var$prepareFreshStack(root$jscomp$0, 0);
                $662d9978aa5168bc$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                switch(exitStatus){
                    case 0:
                    case 1:
                        throw Error($662d9978aa5168bc$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194176) === lanes) {
                            $662d9978aa5168bc$var$markRootSuspended(shouldTimeSlice, lanes, $662d9978aa5168bc$var$workInProgressDeferredLane, !$662d9978aa5168bc$var$workInProgressRootDidSkipSuspendedSiblings);
                            break a;
                        }
                        break;
                    case 2:
                        $662d9978aa5168bc$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($662d9978aa5168bc$var$formatProdErrorMessage(329));
                }
                shouldTimeSlice.finishedWork = forceSync;
                shouldTimeSlice.finishedLanes = lanes;
                if ((lanes & 62914560) === lanes && (renderWasConcurrent = $662d9978aa5168bc$var$globalMostRecentFallbackTime + 300 - $662d9978aa5168bc$var$now(), 10 < renderWasConcurrent)) {
                    $662d9978aa5168bc$var$markRootSuspended(shouldTimeSlice, lanes, $662d9978aa5168bc$var$workInProgressDeferredLane, !$662d9978aa5168bc$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $662d9978aa5168bc$var$getNextLanes(shouldTimeSlice, 0)) break a;
                    shouldTimeSlice.timeoutHandle = $662d9978aa5168bc$var$scheduleTimeout($662d9978aa5168bc$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $662d9978aa5168bc$var$workInProgressRootRecoverableErrors, $662d9978aa5168bc$var$workInProgressTransitions, $662d9978aa5168bc$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $662d9978aa5168bc$var$workInProgressDeferredLane, $662d9978aa5168bc$var$workInProgressRootInterleavedUpdatedLanes, $662d9978aa5168bc$var$workInProgressSuspendedRetryLanes, $662d9978aa5168bc$var$workInProgressRootDidSkipSuspendedSiblings, 2, -0, 0), renderWasConcurrent);
                    break a;
                }
                $662d9978aa5168bc$var$commitRootWhenReady(shouldTimeSlice, forceSync, $662d9978aa5168bc$var$workInProgressRootRecoverableErrors, $662d9978aa5168bc$var$workInProgressTransitions, $662d9978aa5168bc$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $662d9978aa5168bc$var$workInProgressDeferredLane, $662d9978aa5168bc$var$workInProgressRootInterleavedUpdatedLanes, $662d9978aa5168bc$var$workInProgressSuspendedRetryLanes, $662d9978aa5168bc$var$workInProgressRootDidSkipSuspendedSiblings, 0, -0, 0);
            }
        }
        break;
    }while (1);
    $662d9978aa5168bc$var$ensureRootIsScheduled(root$jscomp$0);
}
function $662d9978aa5168bc$var$queueRecoverableErrors(errors) {
    null === $662d9978aa5168bc$var$workInProgressRootRecoverableErrors ? $662d9978aa5168bc$var$workInProgressRootRecoverableErrors = errors : $662d9978aa5168bc$var$workInProgressRootRecoverableErrors.push.apply($662d9978aa5168bc$var$workInProgressRootRecoverableErrors, errors);
}
function $662d9978aa5168bc$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    var subtreeFlags = finishedWork.subtreeFlags;
    if (subtreeFlags & 8192 || 16785408 === (subtreeFlags & 16785408)) {
        if ($662d9978aa5168bc$var$suspendedState = {
            stylesheets: null,
            count: 0,
            unsuspend: $662d9978aa5168bc$var$noop
        }, $662d9978aa5168bc$var$accumulateSuspenseyCommitOnFiber(finishedWork), finishedWork = $662d9978aa5168bc$var$waitForCommitToBeReady(), null !== finishedWork) {
            root.cancelPendingCommit = finishedWork($662d9978aa5168bc$var$commitRoot.bind(null, root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, 1, completedRenderStartTime, completedRenderEndTime));
            $662d9978aa5168bc$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $662d9978aa5168bc$var$commitRoot(root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime);
}
function $662d9978aa5168bc$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$662d9978aa5168bc$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $662d9978aa5168bc$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$662d9978aa5168bc$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$662d9978aa5168bc$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $662d9978aa5168bc$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $662d9978aa5168bc$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $662d9978aa5168bc$var$flushSyncWork$1() {
    return 0 === ($662d9978aa5168bc$var$executionContext & 6) ? ($662d9978aa5168bc$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $662d9978aa5168bc$var$resetWorkInProgressStack() {
    if (null !== $662d9978aa5168bc$var$workInProgress) {
        if (0 === $662d9978aa5168bc$var$workInProgressSuspendedReason) var interruptedWork = $662d9978aa5168bc$var$workInProgress.return;
        else interruptedWork = $662d9978aa5168bc$var$workInProgress, $662d9978aa5168bc$var$lastContextDependency = $662d9978aa5168bc$var$currentlyRenderingFiber = null, $662d9978aa5168bc$var$resetHooksOnUnwind(interruptedWork), $662d9978aa5168bc$var$thenableState$1 = null, $662d9978aa5168bc$var$thenableIndexCounter$1 = 0, interruptedWork = $662d9978aa5168bc$var$workInProgress;
        for(; null !== interruptedWork;)$662d9978aa5168bc$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $662d9978aa5168bc$var$workInProgress = null;
    }
}
function $662d9978aa5168bc$var$prepareFreshStack(root, lanes) {
    root.finishedWork = null;
    root.finishedLanes = 0;
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $662d9978aa5168bc$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $662d9978aa5168bc$var$resetWorkInProgressStack();
    $662d9978aa5168bc$var$workInProgressRoot = root;
    $662d9978aa5168bc$var$workInProgress = timeoutHandle = $662d9978aa5168bc$var$createWorkInProgress(root.current, null);
    $662d9978aa5168bc$var$workInProgressRootRenderLanes = lanes;
    $662d9978aa5168bc$var$workInProgressSuspendedReason = 0;
    $662d9978aa5168bc$var$workInProgressThrownValue = null;
    $662d9978aa5168bc$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $662d9978aa5168bc$var$workInProgressRootIsPrerendering = $662d9978aa5168bc$var$checkIfRootIsPrerendering(root, lanes);
    $662d9978aa5168bc$var$workInProgressRootDidAttachPingListener = !1;
    $662d9978aa5168bc$var$workInProgressSuspendedRetryLanes = $662d9978aa5168bc$var$workInProgressDeferredLane = $662d9978aa5168bc$var$workInProgressRootPingedLanes = $662d9978aa5168bc$var$workInProgressRootInterleavedUpdatedLanes = $662d9978aa5168bc$var$workInProgressRootSkippedLanes = $662d9978aa5168bc$var$workInProgressRootExitStatus = 0;
    $662d9978aa5168bc$var$workInProgressRootRecoverableErrors = $662d9978aa5168bc$var$workInProgressRootConcurrentErrors = null;
    $662d9978aa5168bc$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $662d9978aa5168bc$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $662d9978aa5168bc$var$entangledRenderLanes = lanes;
    $662d9978aa5168bc$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $662d9978aa5168bc$var$handleThrow(root, thrownValue) {
    $662d9978aa5168bc$var$currentlyRenderingFiber$1 = null;
    $662d9978aa5168bc$var$ReactSharedInternals.H = $662d9978aa5168bc$var$ContextOnlyDispatcher;
    thrownValue === $662d9978aa5168bc$var$SuspenseException ? (thrownValue = $662d9978aa5168bc$var$getSuspendedThenable(), $662d9978aa5168bc$var$workInProgressSuspendedReason = 3) : thrownValue === $662d9978aa5168bc$var$SuspenseyCommitException ? (thrownValue = $662d9978aa5168bc$var$getSuspendedThenable(), $662d9978aa5168bc$var$workInProgressSuspendedReason = 4) : $662d9978aa5168bc$var$workInProgressSuspendedReason = thrownValue === $662d9978aa5168bc$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $662d9978aa5168bc$var$workInProgressThrownValue = thrownValue;
    null === $662d9978aa5168bc$var$workInProgress && ($662d9978aa5168bc$var$workInProgressRootExitStatus = 1, $662d9978aa5168bc$var$logUncaughtError(root, $662d9978aa5168bc$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $662d9978aa5168bc$var$pushDispatcher() {
    var prevDispatcher = $662d9978aa5168bc$var$ReactSharedInternals.H;
    $662d9978aa5168bc$var$ReactSharedInternals.H = $662d9978aa5168bc$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $662d9978aa5168bc$var$ContextOnlyDispatcher : prevDispatcher;
}
function $662d9978aa5168bc$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $662d9978aa5168bc$var$ReactSharedInternals.A;
    $662d9978aa5168bc$var$ReactSharedInternals.A = $662d9978aa5168bc$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $662d9978aa5168bc$var$renderDidSuspendDelayIfPossible() {
    $662d9978aa5168bc$var$workInProgressRootExitStatus = 4;
    $662d9978aa5168bc$var$workInProgressRootDidSkipSuspendedSiblings || ($662d9978aa5168bc$var$workInProgressRootRenderLanes & 4194176) !== $662d9978aa5168bc$var$workInProgressRootRenderLanes && null !== $662d9978aa5168bc$var$suspenseHandlerStackCursor.current || ($662d9978aa5168bc$var$workInProgressRootIsPrerendering = !0);
    0 === ($662d9978aa5168bc$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($662d9978aa5168bc$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $662d9978aa5168bc$var$workInProgressRoot || $662d9978aa5168bc$var$markRootSuspended($662d9978aa5168bc$var$workInProgressRoot, $662d9978aa5168bc$var$workInProgressRootRenderLanes, $662d9978aa5168bc$var$workInProgressDeferredLane, !1);
}
function $662d9978aa5168bc$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $662d9978aa5168bc$var$executionContext;
    $662d9978aa5168bc$var$executionContext |= 2;
    var prevDispatcher = $662d9978aa5168bc$var$pushDispatcher(), prevAsyncDispatcher = $662d9978aa5168bc$var$pushAsyncDispatcher();
    if ($662d9978aa5168bc$var$workInProgressRoot !== root || $662d9978aa5168bc$var$workInProgressRootRenderLanes !== lanes) $662d9978aa5168bc$var$workInProgressTransitions = null, $662d9978aa5168bc$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $662d9978aa5168bc$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $662d9978aa5168bc$var$workInProgressSuspendedReason && null !== $662d9978aa5168bc$var$workInProgress) {
            var unitOfWork = $662d9978aa5168bc$var$workInProgress, thrownValue = $662d9978aa5168bc$var$workInProgressThrownValue;
            switch($662d9978aa5168bc$var$workInProgressSuspendedReason){
                case 8:
                    $662d9978aa5168bc$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 6:
                    null === $662d9978aa5168bc$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $662d9978aa5168bc$var$workInProgressSuspendedReason;
                    $662d9978aa5168bc$var$workInProgressSuspendedReason = 0;
                    $662d9978aa5168bc$var$workInProgressThrownValue = null;
                    $662d9978aa5168bc$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $662d9978aa5168bc$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $662d9978aa5168bc$var$workInProgressSuspendedReason, $662d9978aa5168bc$var$workInProgressSuspendedReason = 0, $662d9978aa5168bc$var$workInProgressThrownValue = null, $662d9978aa5168bc$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $662d9978aa5168bc$var$workLoopSync();
        exitStatus = $662d9978aa5168bc$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$164) {
        $662d9978aa5168bc$var$handleThrow(root, thrownValue$164);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $662d9978aa5168bc$var$lastContextDependency = $662d9978aa5168bc$var$currentlyRenderingFiber = null;
    $662d9978aa5168bc$var$executionContext = prevExecutionContext;
    $662d9978aa5168bc$var$ReactSharedInternals.H = prevDispatcher;
    $662d9978aa5168bc$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $662d9978aa5168bc$var$workInProgress && ($662d9978aa5168bc$var$workInProgressRoot = null, $662d9978aa5168bc$var$workInProgressRootRenderLanes = 0, $662d9978aa5168bc$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $662d9978aa5168bc$var$workLoopSync() {
    for(; null !== $662d9978aa5168bc$var$workInProgress;)$662d9978aa5168bc$var$performUnitOfWork($662d9978aa5168bc$var$workInProgress);
}
function $662d9978aa5168bc$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $662d9978aa5168bc$var$executionContext;
    $662d9978aa5168bc$var$executionContext |= 2;
    var prevDispatcher = $662d9978aa5168bc$var$pushDispatcher(), prevAsyncDispatcher = $662d9978aa5168bc$var$pushAsyncDispatcher();
    $662d9978aa5168bc$var$workInProgressRoot !== root || $662d9978aa5168bc$var$workInProgressRootRenderLanes !== lanes ? ($662d9978aa5168bc$var$workInProgressTransitions = null, $662d9978aa5168bc$var$workInProgressRootRenderTargetTime = $662d9978aa5168bc$var$now() + 500, $662d9978aa5168bc$var$prepareFreshStack(root, lanes)) : $662d9978aa5168bc$var$workInProgressRootIsPrerendering = $662d9978aa5168bc$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $662d9978aa5168bc$var$workInProgressSuspendedReason && null !== $662d9978aa5168bc$var$workInProgress) {
            lanes = $662d9978aa5168bc$var$workInProgress;
            var thrownValue = $662d9978aa5168bc$var$workInProgressThrownValue;
            b: switch($662d9978aa5168bc$var$workInProgressSuspendedReason){
                case 1:
                    $662d9978aa5168bc$var$workInProgressSuspendedReason = 0;
                    $662d9978aa5168bc$var$workInProgressThrownValue = null;
                    $662d9978aa5168bc$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                    if ($662d9978aa5168bc$var$isThenableResolved(thrownValue)) {
                        $662d9978aa5168bc$var$workInProgressSuspendedReason = 0;
                        $662d9978aa5168bc$var$workInProgressThrownValue = null;
                        $662d9978aa5168bc$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 === $662d9978aa5168bc$var$workInProgressSuspendedReason && $662d9978aa5168bc$var$workInProgressRoot === root && ($662d9978aa5168bc$var$workInProgressSuspendedReason = 7);
                        $662d9978aa5168bc$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $662d9978aa5168bc$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $662d9978aa5168bc$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $662d9978aa5168bc$var$isThenableResolved(thrownValue) ? ($662d9978aa5168bc$var$workInProgressSuspendedReason = 0, $662d9978aa5168bc$var$workInProgressThrownValue = null, $662d9978aa5168bc$var$replaySuspendedUnitOfWork(lanes)) : ($662d9978aa5168bc$var$workInProgressSuspendedReason = 0, $662d9978aa5168bc$var$workInProgressThrownValue = null, $662d9978aa5168bc$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($662d9978aa5168bc$var$workInProgress.tag){
                        case 26:
                            resource = $662d9978aa5168bc$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $662d9978aa5168bc$var$workInProgress;
                            if (resource ? $662d9978aa5168bc$var$preloadResource(resource) : 1) {
                                $662d9978aa5168bc$var$workInProgressSuspendedReason = 0;
                                $662d9978aa5168bc$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $662d9978aa5168bc$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($662d9978aa5168bc$var$workInProgress = returnFiber, $662d9978aa5168bc$var$completeUnitOfWork(returnFiber)) : $662d9978aa5168bc$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $662d9978aa5168bc$var$workInProgressSuspendedReason = 0;
                    $662d9978aa5168bc$var$workInProgressThrownValue = null;
                    $662d9978aa5168bc$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $662d9978aa5168bc$var$workInProgressSuspendedReason = 0;
                    $662d9978aa5168bc$var$workInProgressThrownValue = null;
                    $662d9978aa5168bc$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $662d9978aa5168bc$var$resetWorkInProgressStack();
                    $662d9978aa5168bc$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($662d9978aa5168bc$var$formatProdErrorMessage(462));
            }
        }
        $662d9978aa5168bc$var$workLoopConcurrent();
        break;
    } catch (thrownValue$166) {
        $662d9978aa5168bc$var$handleThrow(root, thrownValue$166);
    }
    while (1);
    $662d9978aa5168bc$var$lastContextDependency = $662d9978aa5168bc$var$currentlyRenderingFiber = null;
    $662d9978aa5168bc$var$ReactSharedInternals.H = prevDispatcher;
    $662d9978aa5168bc$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $662d9978aa5168bc$var$executionContext = prevExecutionContext;
    if (null !== $662d9978aa5168bc$var$workInProgress) return 0;
    $662d9978aa5168bc$var$workInProgressRoot = null;
    $662d9978aa5168bc$var$workInProgressRootRenderLanes = 0;
    $662d9978aa5168bc$var$finishQueueingConcurrentUpdates();
    return $662d9978aa5168bc$var$workInProgressRootExitStatus;
}
function $662d9978aa5168bc$var$workLoopConcurrent() {
    for(; null !== $662d9978aa5168bc$var$workInProgress && !$662d9978aa5168bc$var$shouldYield();)$662d9978aa5168bc$var$performUnitOfWork($662d9978aa5168bc$var$workInProgress);
}
function $662d9978aa5168bc$var$performUnitOfWork(unitOfWork) {
    var next = $662d9978aa5168bc$var$beginWork(unitOfWork.alternate, unitOfWork, $662d9978aa5168bc$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $662d9978aa5168bc$var$completeUnitOfWork(unitOfWork) : $662d9978aa5168bc$var$workInProgress = next;
}
function $662d9978aa5168bc$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $662d9978aa5168bc$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $662d9978aa5168bc$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $662d9978aa5168bc$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $662d9978aa5168bc$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $662d9978aa5168bc$var$resetHooksOnUnwind(next);
        default:
            $662d9978aa5168bc$var$unwindInterruptedWork(current, next), next = $662d9978aa5168bc$var$workInProgress = $662d9978aa5168bc$var$resetWorkInProgress(next, $662d9978aa5168bc$var$entangledRenderLanes), next = $662d9978aa5168bc$var$beginWork(current, next, $662d9978aa5168bc$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $662d9978aa5168bc$var$completeUnitOfWork(unitOfWork) : $662d9978aa5168bc$var$workInProgress = next;
}
function $662d9978aa5168bc$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $662d9978aa5168bc$var$lastContextDependency = $662d9978aa5168bc$var$currentlyRenderingFiber = null;
    $662d9978aa5168bc$var$resetHooksOnUnwind(unitOfWork);
    $662d9978aa5168bc$var$thenableState$1 = null;
    $662d9978aa5168bc$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($662d9978aa5168bc$var$throwException(root, returnFiber, unitOfWork, thrownValue, $662d9978aa5168bc$var$workInProgressRootRenderLanes)) {
            $662d9978aa5168bc$var$workInProgressRootExitStatus = 1;
            $662d9978aa5168bc$var$logUncaughtError(root, $662d9978aa5168bc$var$createCapturedValueAtFiber(thrownValue, root.current));
            $662d9978aa5168bc$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $662d9978aa5168bc$var$workInProgress = returnFiber, error;
        $662d9978aa5168bc$var$workInProgressRootExitStatus = 1;
        $662d9978aa5168bc$var$logUncaughtError(root, $662d9978aa5168bc$var$createCapturedValueAtFiber(thrownValue, root.current));
        $662d9978aa5168bc$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($662d9978aa5168bc$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($662d9978aa5168bc$var$workInProgressRootIsPrerendering || 0 !== ($662d9978aa5168bc$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($662d9978aa5168bc$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $662d9978aa5168bc$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $662d9978aa5168bc$var$unwindUnitOfWork(unitOfWork, root);
    } else $662d9978aa5168bc$var$completeUnitOfWork(unitOfWork);
}
function $662d9978aa5168bc$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $662d9978aa5168bc$var$unwindUnitOfWork(completedWork, $662d9978aa5168bc$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $662d9978aa5168bc$var$completeWork(completedWork.alternate, completedWork, $662d9978aa5168bc$var$entangledRenderLanes);
        if (null !== next) {
            $662d9978aa5168bc$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $662d9978aa5168bc$var$workInProgress = completedWork;
            return;
        }
        $662d9978aa5168bc$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $662d9978aa5168bc$var$workInProgressRootExitStatus && ($662d9978aa5168bc$var$workInProgressRootExitStatus = 5);
}
function $662d9978aa5168bc$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $662d9978aa5168bc$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $662d9978aa5168bc$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $662d9978aa5168bc$var$workInProgress = unitOfWork;
            return;
        }
        $662d9978aa5168bc$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $662d9978aa5168bc$var$workInProgressRootExitStatus = 6;
    $662d9978aa5168bc$var$workInProgress = null;
}
function $662d9978aa5168bc$var$commitRoot(root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    var prevTransition = $662d9978aa5168bc$var$ReactSharedInternals.T, previousUpdateLanePriority = $662d9978aa5168bc$var$ReactDOMSharedInternals.p;
    try {
        $662d9978aa5168bc$var$ReactDOMSharedInternals.p = 2, $662d9978aa5168bc$var$ReactSharedInternals.T = null, $662d9978aa5168bc$var$commitRootImpl(root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, previousUpdateLanePriority, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime);
    } finally{
        $662d9978aa5168bc$var$ReactSharedInternals.T = prevTransition, $662d9978aa5168bc$var$ReactDOMSharedInternals.p = previousUpdateLanePriority;
    }
}
function $662d9978aa5168bc$var$commitRootImpl(root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, renderPriorityLevel, spawnedLane, updatedLanes, suspendedRetryLanes) {
    do $662d9978aa5168bc$var$flushPassiveEffects();
    while (null !== $662d9978aa5168bc$var$rootWithPendingPassiveEffects);
    if (0 !== ($662d9978aa5168bc$var$executionContext & 6)) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(327));
    var finishedWork = root.finishedWork;
    didIncludeRenderPhaseUpdate = root.finishedLanes;
    if (null === finishedWork) return null;
    root.finishedWork = null;
    root.finishedLanes = 0;
    if (finishedWork === root.current) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(177));
    root.callbackNode = null;
    root.callbackPriority = 0;
    root.cancelPendingCommit = null;
    var remainingLanes = finishedWork.lanes | finishedWork.childLanes;
    remainingLanes |= $662d9978aa5168bc$var$concurrentlyUpdatedLanes;
    $662d9978aa5168bc$var$markRootFinished(root, didIncludeRenderPhaseUpdate, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes);
    root === $662d9978aa5168bc$var$workInProgressRoot && ($662d9978aa5168bc$var$workInProgress = $662d9978aa5168bc$var$workInProgressRoot = null, $662d9978aa5168bc$var$workInProgressRootRenderLanes = 0);
    0 === (finishedWork.subtreeFlags & 10256) && 0 === (finishedWork.flags & 10256) || $662d9978aa5168bc$var$rootDoesHavePassiveEffects || ($662d9978aa5168bc$var$rootDoesHavePassiveEffects = !0, $662d9978aa5168bc$var$pendingPassiveEffectsRemainingLanes = remainingLanes, $662d9978aa5168bc$var$pendingPassiveTransitions = transitions, $662d9978aa5168bc$var$scheduleCallback$1($662d9978aa5168bc$var$NormalPriority$1, function() {
        $662d9978aa5168bc$var$flushPassiveEffects(!0);
        return null;
    }));
    transitions = 0 !== (finishedWork.flags & 15990);
    0 !== (finishedWork.subtreeFlags & 15990) || transitions ? (transitions = $662d9978aa5168bc$var$ReactSharedInternals.T, $662d9978aa5168bc$var$ReactSharedInternals.T = null, spawnedLane = $662d9978aa5168bc$var$ReactDOMSharedInternals.p, $662d9978aa5168bc$var$ReactDOMSharedInternals.p = 2, updatedLanes = $662d9978aa5168bc$var$executionContext, $662d9978aa5168bc$var$executionContext |= 4, $662d9978aa5168bc$var$commitBeforeMutationEffects(root, finishedWork), $662d9978aa5168bc$var$commitMutationEffectsOnFiber(finishedWork, root), $662d9978aa5168bc$var$restoreSelection($662d9978aa5168bc$var$selectionInformation, root.containerInfo), $662d9978aa5168bc$var$_enabled = !!$662d9978aa5168bc$var$eventsEnabled, $662d9978aa5168bc$var$selectionInformation = $662d9978aa5168bc$var$eventsEnabled = null, root.current = finishedWork, $662d9978aa5168bc$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork), $662d9978aa5168bc$var$requestPaint(), $662d9978aa5168bc$var$executionContext = updatedLanes, $662d9978aa5168bc$var$ReactDOMSharedInternals.p = spawnedLane, $662d9978aa5168bc$var$ReactSharedInternals.T = transitions) : root.current = finishedWork;
    $662d9978aa5168bc$var$rootDoesHavePassiveEffects ? ($662d9978aa5168bc$var$rootDoesHavePassiveEffects = !1, $662d9978aa5168bc$var$rootWithPendingPassiveEffects = root, $662d9978aa5168bc$var$pendingPassiveEffectsLanes = didIncludeRenderPhaseUpdate) : $662d9978aa5168bc$var$releaseRootPooledCache(root, remainingLanes);
    remainingLanes = root.pendingLanes;
    0 === remainingLanes && ($662d9978aa5168bc$var$legacyErrorBoundariesThatAlreadyFailed = null);
    $662d9978aa5168bc$var$onCommitRoot(finishedWork.stateNode, renderPriorityLevel);
    $662d9978aa5168bc$var$ensureRootIsScheduled(root);
    if (null !== recoverableErrors) for(renderPriorityLevel = root.onRecoverableError, finishedWork = 0; finishedWork < recoverableErrors.length; finishedWork++)remainingLanes = recoverableErrors[finishedWork], renderPriorityLevel(remainingLanes.value, {
        componentStack: remainingLanes.stack
    });
    0 !== ($662d9978aa5168bc$var$pendingPassiveEffectsLanes & 3) && $662d9978aa5168bc$var$flushPassiveEffects();
    remainingLanes = root.pendingLanes;
    0 !== (didIncludeRenderPhaseUpdate & 4194218) && 0 !== (remainingLanes & 42) ? root === $662d9978aa5168bc$var$rootWithNestedUpdates ? $662d9978aa5168bc$var$nestedUpdateCount++ : ($662d9978aa5168bc$var$nestedUpdateCount = 0, $662d9978aa5168bc$var$rootWithNestedUpdates = root) : $662d9978aa5168bc$var$nestedUpdateCount = 0;
    $662d9978aa5168bc$var$flushSyncWorkAcrossRoots_impl(0, !1);
    return null;
}
function $662d9978aa5168bc$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $662d9978aa5168bc$var$releaseCache(remainingLanes)));
}
function $662d9978aa5168bc$var$flushPassiveEffects() {
    if (null !== $662d9978aa5168bc$var$rootWithPendingPassiveEffects) {
        var root$170 = $662d9978aa5168bc$var$rootWithPendingPassiveEffects, remainingLanes = $662d9978aa5168bc$var$pendingPassiveEffectsRemainingLanes;
        $662d9978aa5168bc$var$pendingPassiveEffectsRemainingLanes = 0;
        var renderPriority = $662d9978aa5168bc$var$lanesToEventPriority($662d9978aa5168bc$var$pendingPassiveEffectsLanes), prevTransition = $662d9978aa5168bc$var$ReactSharedInternals.T, previousPriority = $662d9978aa5168bc$var$ReactDOMSharedInternals.p;
        try {
            $662d9978aa5168bc$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
            $662d9978aa5168bc$var$ReactSharedInternals.T = null;
            if (null === $662d9978aa5168bc$var$rootWithPendingPassiveEffects) var JSCompiler_inline_result = !1;
            else {
                renderPriority = $662d9978aa5168bc$var$pendingPassiveTransitions;
                $662d9978aa5168bc$var$pendingPassiveTransitions = null;
                var root = $662d9978aa5168bc$var$rootWithPendingPassiveEffects, lanes = $662d9978aa5168bc$var$pendingPassiveEffectsLanes;
                $662d9978aa5168bc$var$rootWithPendingPassiveEffects = null;
                $662d9978aa5168bc$var$pendingPassiveEffectsLanes = 0;
                if (0 !== ($662d9978aa5168bc$var$executionContext & 6)) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(331));
                var prevExecutionContext = $662d9978aa5168bc$var$executionContext;
                $662d9978aa5168bc$var$executionContext |= 4;
                $662d9978aa5168bc$var$commitPassiveUnmountOnFiber(root.current);
                $662d9978aa5168bc$var$commitPassiveMountOnFiber(root, root.current, lanes, renderPriority);
                $662d9978aa5168bc$var$executionContext = prevExecutionContext;
                $662d9978aa5168bc$var$flushSyncWorkAcrossRoots_impl(0, !1);
                if ($662d9978aa5168bc$var$injectedHook && "function" === typeof $662d9978aa5168bc$var$injectedHook.onPostCommitFiberRoot) try {
                    $662d9978aa5168bc$var$injectedHook.onPostCommitFiberRoot($662d9978aa5168bc$var$rendererID, root);
                } catch (err) {}
                JSCompiler_inline_result = !0;
            }
            return JSCompiler_inline_result;
        } finally{
            $662d9978aa5168bc$var$ReactDOMSharedInternals.p = previousPriority, $662d9978aa5168bc$var$ReactSharedInternals.T = prevTransition, $662d9978aa5168bc$var$releaseRootPooledCache(root$170, remainingLanes);
        }
    }
    return !1;
}
function $662d9978aa5168bc$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $662d9978aa5168bc$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $662d9978aa5168bc$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $662d9978aa5168bc$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($662d9978aa5168bc$var$markRootUpdated$1(rootFiber, 2), $662d9978aa5168bc$var$ensureRootIsScheduled(rootFiber));
}
function $662d9978aa5168bc$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $662d9978aa5168bc$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $662d9978aa5168bc$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $662d9978aa5168bc$var$legacyErrorBoundariesThatAlreadyFailed || !$662d9978aa5168bc$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $662d9978aa5168bc$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $662d9978aa5168bc$var$createClassErrorUpdate(2);
                instance = $662d9978aa5168bc$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($662d9978aa5168bc$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $662d9978aa5168bc$var$markRootUpdated$1(instance, 2), $662d9978aa5168bc$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $662d9978aa5168bc$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $662d9978aa5168bc$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($662d9978aa5168bc$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $662d9978aa5168bc$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $662d9978aa5168bc$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $662d9978aa5168bc$var$workInProgressRoot === root && ($662d9978aa5168bc$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $662d9978aa5168bc$var$workInProgressRootExitStatus || 3 === $662d9978aa5168bc$var$workInProgressRootExitStatus && ($662d9978aa5168bc$var$workInProgressRootRenderLanes & 62914560) === $662d9978aa5168bc$var$workInProgressRootRenderLanes && 300 > $662d9978aa5168bc$var$now() - $662d9978aa5168bc$var$globalMostRecentFallbackTime ? 0 === ($662d9978aa5168bc$var$executionContext & 2) && $662d9978aa5168bc$var$prepareFreshStack(root, 0) : $662d9978aa5168bc$var$workInProgressRootPingedLanes |= pingedLanes, $662d9978aa5168bc$var$workInProgressSuspendedRetryLanes === $662d9978aa5168bc$var$workInProgressRootRenderLanes && ($662d9978aa5168bc$var$workInProgressSuspendedRetryLanes = 0));
    $662d9978aa5168bc$var$ensureRootIsScheduled(root);
}
function $662d9978aa5168bc$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $662d9978aa5168bc$var$claimNextRetryLane());
    boundaryFiber = $662d9978aa5168bc$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($662d9978aa5168bc$var$markRootUpdated$1(boundaryFiber, retryLane), $662d9978aa5168bc$var$ensureRootIsScheduled(boundaryFiber));
}
function $662d9978aa5168bc$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $662d9978aa5168bc$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $662d9978aa5168bc$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($662d9978aa5168bc$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $662d9978aa5168bc$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $662d9978aa5168bc$var$scheduleCallback$1(priorityLevel, callback) {
    return $662d9978aa5168bc$var$scheduleCallback$3(priorityLevel, callback);
}
var $662d9978aa5168bc$var$firstScheduledRoot = null, $662d9978aa5168bc$var$lastScheduledRoot = null, $662d9978aa5168bc$var$didScheduleMicrotask = !1, $662d9978aa5168bc$var$mightHavePendingSyncWork = !1, $662d9978aa5168bc$var$isFlushingWork = !1, $662d9978aa5168bc$var$currentEventTransitionLane = 0;
function $662d9978aa5168bc$var$ensureRootIsScheduled(root) {
    root !== $662d9978aa5168bc$var$lastScheduledRoot && null === root.next && (null === $662d9978aa5168bc$var$lastScheduledRoot ? $662d9978aa5168bc$var$firstScheduledRoot = $662d9978aa5168bc$var$lastScheduledRoot = root : $662d9978aa5168bc$var$lastScheduledRoot = $662d9978aa5168bc$var$lastScheduledRoot.next = root);
    $662d9978aa5168bc$var$mightHavePendingSyncWork = !0;
    $662d9978aa5168bc$var$didScheduleMicrotask || ($662d9978aa5168bc$var$didScheduleMicrotask = !0, $662d9978aa5168bc$var$scheduleImmediateTask($662d9978aa5168bc$var$processRootScheduleInMicrotask));
}
function $662d9978aa5168bc$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$662d9978aa5168bc$var$isFlushingWork && $662d9978aa5168bc$var$mightHavePendingSyncWork) {
        $662d9978aa5168bc$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$172 = $662d9978aa5168bc$var$firstScheduledRoot; null !== root$172;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$172.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$172.suspendedLanes, pingedLanes = root$172.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $662d9978aa5168bc$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326677 ? JSCompiler_inline_result & 201326677 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $662d9978aa5168bc$var$performSyncWorkOnRoot(root$172, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $662d9978aa5168bc$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $662d9978aa5168bc$var$getNextLanes(root$172, root$172 === $662d9978aa5168bc$var$workInProgressRoot ? JSCompiler_inline_result : 0), 0 === (JSCompiler_inline_result & 3) || $662d9978aa5168bc$var$checkIfRootIsPrerendering(root$172, JSCompiler_inline_result) || (didPerformSomeWork = !0, $662d9978aa5168bc$var$performSyncWorkOnRoot(root$172, JSCompiler_inline_result));
                }
                root$172 = root$172.next;
            }
        }while (didPerformSomeWork);
        $662d9978aa5168bc$var$isFlushingWork = !1;
    }
}
function $662d9978aa5168bc$var$processRootScheduleInMicrotask() {
    $662d9978aa5168bc$var$mightHavePendingSyncWork = $662d9978aa5168bc$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $662d9978aa5168bc$var$currentEventTransitionLane && ($662d9978aa5168bc$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $662d9978aa5168bc$var$currentEventTransitionLane), $662d9978aa5168bc$var$currentEventTransitionLane = 0);
    for(var currentTime = $662d9978aa5168bc$var$now(), prev = null, root = $662d9978aa5168bc$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $662d9978aa5168bc$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $662d9978aa5168bc$var$firstScheduledRoot = next : prev.next = next, null === next && ($662d9978aa5168bc$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $662d9978aa5168bc$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    $662d9978aa5168bc$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
}
function $662d9978aa5168bc$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $662d9978aa5168bc$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $662d9978aa5168bc$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $662d9978aa5168bc$var$workInProgressRoot;
    suspendedLanes = $662d9978aa5168bc$var$workInProgressRootRenderLanes;
    suspendedLanes = $662d9978aa5168bc$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && 2 === $662d9978aa5168bc$var$workInProgressSuspendedReason || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $662d9978aa5168bc$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $662d9978aa5168bc$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $662d9978aa5168bc$var$cancelCallback$1(pingedLanes);
        switch($662d9978aa5168bc$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $662d9978aa5168bc$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $662d9978aa5168bc$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $662d9978aa5168bc$var$IdlePriority;
                break;
            default:
                suspendedLanes = $662d9978aa5168bc$var$NormalPriority$1;
        }
        pingedLanes = $662d9978aa5168bc$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $662d9978aa5168bc$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $662d9978aa5168bc$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $662d9978aa5168bc$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    var originalCallbackNode = root.callbackNode;
    if ($662d9978aa5168bc$var$flushPassiveEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $662d9978aa5168bc$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $662d9978aa5168bc$var$getNextLanes(root, root === $662d9978aa5168bc$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $662d9978aa5168bc$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $662d9978aa5168bc$var$scheduleTaskForRootDuringMicrotask(root, $662d9978aa5168bc$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $662d9978aa5168bc$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $662d9978aa5168bc$var$performSyncWorkOnRoot(root, lanes) {
    if ($662d9978aa5168bc$var$flushPassiveEffects()) return null;
    $662d9978aa5168bc$var$performWorkOnRoot(root, lanes, !0);
}
function $662d9978aa5168bc$var$scheduleImmediateTask(cb) {
    $662d9978aa5168bc$var$scheduleMicrotask(function() {
        0 !== ($662d9978aa5168bc$var$executionContext & 6) ? $662d9978aa5168bc$var$scheduleCallback$3($662d9978aa5168bc$var$ImmediatePriority, cb) : cb();
    });
}
function $662d9978aa5168bc$var$requestTransitionLane() {
    0 === $662d9978aa5168bc$var$currentEventTransitionLane && ($662d9978aa5168bc$var$currentEventTransitionLane = $662d9978aa5168bc$var$claimNextTransitionLane());
    return $662d9978aa5168bc$var$currentEventTransitionLane;
}
function $662d9978aa5168bc$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $662d9978aa5168bc$var$sanitizeURL("" + actionProp);
}
function $662d9978aa5168bc$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $662d9978aa5168bc$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $662d9978aa5168bc$var$coerceFormActionProp((nativeEventTarget[$662d9978aa5168bc$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$662d9978aa5168bc$var$internalPropsKey] || null) ? $662d9978aa5168bc$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $662d9978aa5168bc$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $662d9978aa5168bc$var$currentEventTransitionLane) {
                                var formData = submitter ? $662d9978aa5168bc$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $662d9978aa5168bc$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $662d9978aa5168bc$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $662d9978aa5168bc$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $662d9978aa5168bc$var$i$jscomp$inline_1439 = 0; $662d9978aa5168bc$var$i$jscomp$inline_1439 < $662d9978aa5168bc$var$simpleEventPluginEvents.length; $662d9978aa5168bc$var$i$jscomp$inline_1439++){
    var $662d9978aa5168bc$var$eventName$jscomp$inline_1440 = $662d9978aa5168bc$var$simpleEventPluginEvents[$662d9978aa5168bc$var$i$jscomp$inline_1439], $662d9978aa5168bc$var$domEventName$jscomp$inline_1441 = $662d9978aa5168bc$var$eventName$jscomp$inline_1440.toLowerCase(), $662d9978aa5168bc$var$capitalizedEvent$jscomp$inline_1442 = $662d9978aa5168bc$var$eventName$jscomp$inline_1440[0].toUpperCase() + $662d9978aa5168bc$var$eventName$jscomp$inline_1440.slice(1);
    $662d9978aa5168bc$var$registerSimpleEvent($662d9978aa5168bc$var$domEventName$jscomp$inline_1441, "on" + $662d9978aa5168bc$var$capitalizedEvent$jscomp$inline_1442);
}
$662d9978aa5168bc$var$registerSimpleEvent($662d9978aa5168bc$var$ANIMATION_END, "onAnimationEnd");
$662d9978aa5168bc$var$registerSimpleEvent($662d9978aa5168bc$var$ANIMATION_ITERATION, "onAnimationIteration");
$662d9978aa5168bc$var$registerSimpleEvent($662d9978aa5168bc$var$ANIMATION_START, "onAnimationStart");
$662d9978aa5168bc$var$registerSimpleEvent("dblclick", "onDoubleClick");
$662d9978aa5168bc$var$registerSimpleEvent("focusin", "onFocus");
$662d9978aa5168bc$var$registerSimpleEvent("focusout", "onBlur");
$662d9978aa5168bc$var$registerSimpleEvent($662d9978aa5168bc$var$TRANSITION_RUN, "onTransitionRun");
$662d9978aa5168bc$var$registerSimpleEvent($662d9978aa5168bc$var$TRANSITION_START, "onTransitionStart");
$662d9978aa5168bc$var$registerSimpleEvent($662d9978aa5168bc$var$TRANSITION_CANCEL, "onTransitionCancel");
$662d9978aa5168bc$var$registerSimpleEvent($662d9978aa5168bc$var$TRANSITION_END, "onTransitionEnd");
$662d9978aa5168bc$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$662d9978aa5168bc$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$662d9978aa5168bc$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$662d9978aa5168bc$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$662d9978aa5168bc$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$662d9978aa5168bc$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$662d9978aa5168bc$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$662d9978aa5168bc$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$662d9978aa5168bc$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$662d9978aa5168bc$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $662d9978aa5168bc$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $662d9978aa5168bc$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($662d9978aa5168bc$var$mediaEventTypes));
function $662d9978aa5168bc$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $662d9978aa5168bc$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $662d9978aa5168bc$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $662d9978aa5168bc$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$662d9978aa5168bc$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$662d9978aa5168bc$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($662d9978aa5168bc$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $662d9978aa5168bc$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $662d9978aa5168bc$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $662d9978aa5168bc$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $662d9978aa5168bc$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$662d9978aa5168bc$var$listeningMarker]) {
        rootContainerElement[$662d9978aa5168bc$var$listeningMarker] = !0;
        $662d9978aa5168bc$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($662d9978aa5168bc$var$nonDelegatedEvents.has(domEventName) || $662d9978aa5168bc$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $662d9978aa5168bc$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$662d9978aa5168bc$var$listeningMarker] || (ownerDocument[$662d9978aa5168bc$var$listeningMarker] = !0, $662d9978aa5168bc$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $662d9978aa5168bc$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($662d9978aa5168bc$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $662d9978aa5168bc$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $662d9978aa5168bc$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $662d9978aa5168bc$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$662d9978aa5168bc$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $662d9978aa5168bc$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer || 8 === container.nodeType && container.parentNode === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if (3 === grandTag || 4 === grandTag) {
                    if (grandTag = nodeTag.stateNode.containerInfo, grandTag === targetContainer || 8 === grandTag.nodeType && grandTag.parentNode === targetContainer) return;
                }
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $662d9978aa5168bc$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $662d9978aa5168bc$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $662d9978aa5168bc$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $662d9978aa5168bc$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $662d9978aa5168bc$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $662d9978aa5168bc$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $662d9978aa5168bc$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $662d9978aa5168bc$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $662d9978aa5168bc$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $662d9978aa5168bc$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $662d9978aa5168bc$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $662d9978aa5168bc$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $662d9978aa5168bc$var$SyntheticTouchEvent;
                        break;
                    case $662d9978aa5168bc$var$ANIMATION_END:
                    case $662d9978aa5168bc$var$ANIMATION_ITERATION:
                    case $662d9978aa5168bc$var$ANIMATION_START:
                        SyntheticEventCtor = $662d9978aa5168bc$var$SyntheticAnimationEvent;
                        break;
                    case $662d9978aa5168bc$var$TRANSITION_END:
                        SyntheticEventCtor = $662d9978aa5168bc$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $662d9978aa5168bc$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $662d9978aa5168bc$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $662d9978aa5168bc$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $662d9978aa5168bc$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $662d9978aa5168bc$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $662d9978aa5168bc$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($662d9978aa5168bc$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $662d9978aa5168bc$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($662d9978aa5168bc$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$662d9978aa5168bc$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $662d9978aa5168bc$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $662d9978aa5168bc$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $662d9978aa5168bc$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $662d9978aa5168bc$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $662d9978aa5168bc$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $662d9978aa5168bc$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $662d9978aa5168bc$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = SyntheticEventCtor;
                            reactEventName = reactEventType;
                            instance = 0;
                            for(lastHostComponent = inCapturePhase; lastHostComponent; lastHostComponent = $662d9978aa5168bc$var$getParent(lastHostComponent))instance++;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = $662d9978aa5168bc$var$getParent(_instance))lastHostComponent++;
                            for(; 0 < instance - lastHostComponent;)inCapturePhase = $662d9978aa5168bc$var$getParent(inCapturePhase), instance--;
                            for(; 0 < lastHostComponent - instance;)reactEventName = $662d9978aa5168bc$var$getParent(reactEventName), lastHostComponent--;
                            for(; instance--;){
                                if (inCapturePhase === reactEventName || null !== reactEventName && inCapturePhase === reactEventName.alternate) break b;
                                inCapturePhase = $662d9978aa5168bc$var$getParent(inCapturePhase);
                                reactEventName = $662d9978aa5168bc$var$getParent(reactEventName);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $662d9978aa5168bc$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $662d9978aa5168bc$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $662d9978aa5168bc$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $662d9978aa5168bc$var$getTargetInstForChangeEvent;
                else if ($662d9978aa5168bc$var$isTextInputElement(reactName)) {
                    if ($662d9978aa5168bc$var$isInputEventSupported) getTargetInstFunc = $662d9978aa5168bc$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $662d9978aa5168bc$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $662d9978aa5168bc$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $662d9978aa5168bc$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $662d9978aa5168bc$var$getTargetInstForChangeEvent) : getTargetInstFunc = $662d9978aa5168bc$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $662d9978aa5168bc$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $662d9978aa5168bc$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $662d9978aa5168bc$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($662d9978aa5168bc$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $662d9978aa5168bc$var$activeElement = handleEventFunc, $662d9978aa5168bc$var$activeElementInst = targetInst, $662d9978aa5168bc$var$lastSelection = null;
                    break;
                case "focusout":
                    $662d9978aa5168bc$var$lastSelection = $662d9978aa5168bc$var$activeElementInst = $662d9978aa5168bc$var$activeElement = null;
                    break;
                case "mousedown":
                    $662d9978aa5168bc$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $662d9978aa5168bc$var$mouseDown = !1;
                    $662d9978aa5168bc$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($662d9978aa5168bc$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $662d9978aa5168bc$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($662d9978aa5168bc$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $662d9978aa5168bc$var$isComposing ? $662d9978aa5168bc$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($662d9978aa5168bc$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($662d9978aa5168bc$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $662d9978aa5168bc$var$isComposing && (fallbackData = $662d9978aa5168bc$var$getData()) : ($662d9978aa5168bc$var$root = nativeEventTarget, $662d9978aa5168bc$var$startText = "value" in $662d9978aa5168bc$var$root ? $662d9978aa5168bc$var$root.value : $662d9978aa5168bc$var$root.textContent, $662d9978aa5168bc$var$isComposing = !0)), handleEventFunc = $662d9978aa5168bc$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $662d9978aa5168bc$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $662d9978aa5168bc$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $662d9978aa5168bc$var$canUseTextInputEvent ? $662d9978aa5168bc$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $662d9978aa5168bc$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $662d9978aa5168bc$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $662d9978aa5168bc$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $662d9978aa5168bc$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $662d9978aa5168bc$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $662d9978aa5168bc$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $662d9978aa5168bc$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $662d9978aa5168bc$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($662d9978aa5168bc$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $662d9978aa5168bc$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($662d9978aa5168bc$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        targetFiber = targetFiber.return;
    }
    return listeners;
}
function $662d9978aa5168bc$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $662d9978aa5168bc$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $662d9978aa5168bc$var$getListener(target, registrationName), null != stateNode && listeners.unshift($662d9978aa5168bc$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $662d9978aa5168bc$var$getListener(target, registrationName), null != stateNode && listeners.push($662d9978aa5168bc$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $662d9978aa5168bc$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $662d9978aa5168bc$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $662d9978aa5168bc$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($662d9978aa5168bc$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($662d9978aa5168bc$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $662d9978aa5168bc$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $662d9978aa5168bc$var$normalizeMarkupForTextOrAttribute(clientText);
    return $662d9978aa5168bc$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $662d9978aa5168bc$var$noop$1() {}
function $662d9978aa5168bc$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $662d9978aa5168bc$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $662d9978aa5168bc$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $662d9978aa5168bc$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $662d9978aa5168bc$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $662d9978aa5168bc$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $662d9978aa5168bc$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $662d9978aa5168bc$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $662d9978aa5168bc$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $662d9978aa5168bc$var$setProp(domElement, tag, "name", props.name, props, null), $662d9978aa5168bc$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $662d9978aa5168bc$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $662d9978aa5168bc$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($662d9978aa5168bc$var$setProp(domElement, tag, "encType", props.encType, props, null), $662d9978aa5168bc$var$setProp(domElement, tag, "method", props.method, props, null), $662d9978aa5168bc$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $662d9978aa5168bc$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $662d9978aa5168bc$var$noop$1);
            break;
        case "onScroll":
            null != value && $662d9978aa5168bc$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $662d9978aa5168bc$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $662d9978aa5168bc$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $662d9978aa5168bc$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $662d9978aa5168bc$var$listenToNonDelegatedEvent("toggle", domElement);
            $662d9978aa5168bc$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $662d9978aa5168bc$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $662d9978aa5168bc$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $662d9978aa5168bc$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $662d9978aa5168bc$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $662d9978aa5168bc$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $662d9978aa5168bc$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $662d9978aa5168bc$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $662d9978aa5168bc$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $662d9978aa5168bc$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $662d9978aa5168bc$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $662d9978aa5168bc$var$aliases.get(key) || key, $662d9978aa5168bc$var$setValueForAttribute(domElement, key, value);
    }
}
function $662d9978aa5168bc$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $662d9978aa5168bc$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $662d9978aa5168bc$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $662d9978aa5168bc$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $662d9978aa5168bc$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $662d9978aa5168bc$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $662d9978aa5168bc$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$662d9978aa5168bc$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$662d9978aa5168bc$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $662d9978aa5168bc$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $662d9978aa5168bc$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $662d9978aa5168bc$var$listenToNonDelegatedEvent("error", domElement);
            $662d9978aa5168bc$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($662d9978aa5168bc$var$formatProdErrorMessage(137, tag));
                    default:
                        $662d9978aa5168bc$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $662d9978aa5168bc$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $662d9978aa5168bc$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $662d9978aa5168bc$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$186 = props[hasSrc];
                if (null != propValue$186) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$186;
                        break;
                    case "type":
                        propValue = propValue$186;
                        break;
                    case "checked":
                        checked = propValue$186;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$186;
                        break;
                    case "value":
                        propKey = propValue$186;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$186;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$186) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $662d9978aa5168bc$var$setProp(domElement, tag, hasSrc, propValue$186, props, null);
                }
            }
            $662d9978aa5168bc$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            $662d9978aa5168bc$var$track(domElement);
            return;
        case "select":
            $662d9978aa5168bc$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $662d9978aa5168bc$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $662d9978aa5168bc$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $662d9978aa5168bc$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $662d9978aa5168bc$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(91));
                    break;
                default:
                    $662d9978aa5168bc$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $662d9978aa5168bc$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            $662d9978aa5168bc$var$track(domElement);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $662d9978aa5168bc$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $662d9978aa5168bc$var$listenToNonDelegatedEvent("cancel", domElement);
            $662d9978aa5168bc$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $662d9978aa5168bc$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $662d9978aa5168bc$var$mediaEventTypes.length; hasSrc++)$662d9978aa5168bc$var$listenToNonDelegatedEvent($662d9978aa5168bc$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $662d9978aa5168bc$var$listenToNonDelegatedEvent("error", domElement);
            $662d9978aa5168bc$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $662d9978aa5168bc$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $662d9978aa5168bc$var$listenToNonDelegatedEvent("error", domElement), $662d9978aa5168bc$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($662d9978aa5168bc$var$formatProdErrorMessage(137, tag));
                default:
                    $662d9978aa5168bc$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($662d9978aa5168bc$var$isCustomElement(tag)) {
                for(propValue$186 in props)props.hasOwnProperty(propValue$186) && (hasSrc = props[propValue$186], void 0 !== hasSrc && $662d9978aa5168bc$var$setPropOnCustomElement(domElement, tag, propValue$186, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $662d9978aa5168bc$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $662d9978aa5168bc$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $662d9978aa5168bc$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$203 in nextProps){
                var propKey = nextProps[propKey$203];
                lastProp = lastProps[propKey$203];
                if (nextProps.hasOwnProperty(propKey$203) && (null != propKey || null != lastProp)) switch(propKey$203){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $662d9978aa5168bc$var$setProp(domElement, tag, propKey$203, propKey, nextProps, lastProp);
                }
            }
            $662d9978aa5168bc$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$203 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $662d9978aa5168bc$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$203 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $662d9978aa5168bc$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$203 ? $662d9978aa5168bc$var$updateOptions(domElement, !!lastProps, propKey$203, !1) : !!nextProps !== !!lastProps && (null != tag ? $662d9978aa5168bc$var$updateOptions(domElement, !!lastProps, tag, !0) : $662d9978aa5168bc$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$203 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $662d9978aa5168bc$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$203 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $662d9978aa5168bc$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $662d9978aa5168bc$var$updateTextarea(domElement, propKey$203, propKey);
            return;
        case "option":
            for(var propKey$219 in lastProps)if (propKey$203 = lastProps[propKey$219], lastProps.hasOwnProperty(propKey$219) && null != propKey$203 && !nextProps.hasOwnProperty(propKey$219)) switch(propKey$219){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $662d9978aa5168bc$var$setProp(domElement, tag, propKey$219, null, nextProps, propKey$203);
            }
            for(lastDefaultValue in nextProps)if (propKey$203 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$203 !== propKey && (null != propKey$203 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$203 && "function" !== typeof propKey$203 && "symbol" !== typeof propKey$203;
                    break;
                default:
                    $662d9978aa5168bc$var$setProp(domElement, tag, lastDefaultValue, propKey$203, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$224 in lastProps)propKey$203 = lastProps[propKey$224], lastProps.hasOwnProperty(propKey$224) && null != propKey$203 && !nextProps.hasOwnProperty(propKey$224) && $662d9978aa5168bc$var$setProp(domElement, tag, propKey$224, null, nextProps, propKey$203);
            for(checked in nextProps)if (propKey$203 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$203 !== propKey && (null != propKey$203 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$203) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $662d9978aa5168bc$var$setProp(domElement, tag, checked, propKey$203, nextProps, propKey);
            }
            return;
        default:
            if ($662d9978aa5168bc$var$isCustomElement(tag)) {
                for(var propKey$229 in lastProps)propKey$203 = lastProps[propKey$229], lastProps.hasOwnProperty(propKey$229) && void 0 !== propKey$203 && !nextProps.hasOwnProperty(propKey$229) && $662d9978aa5168bc$var$setPropOnCustomElement(domElement, tag, propKey$229, void 0, nextProps, propKey$203);
                for(defaultChecked in nextProps)propKey$203 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$203 === propKey || void 0 === propKey$203 && void 0 === propKey || $662d9978aa5168bc$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$203, nextProps, propKey);
                return;
            }
    }
    for(var propKey$234 in lastProps)propKey$203 = lastProps[propKey$234], lastProps.hasOwnProperty(propKey$234) && null != propKey$203 && !nextProps.hasOwnProperty(propKey$234) && $662d9978aa5168bc$var$setProp(domElement, tag, propKey$234, null, nextProps, propKey$203);
    for(lastProp in nextProps)propKey$203 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$203 === propKey || null == propKey$203 && null == propKey || $662d9978aa5168bc$var$setProp(domElement, tag, lastProp, propKey$203, nextProps, propKey);
}
var $662d9978aa5168bc$var$eventsEnabled = null, $662d9978aa5168bc$var$selectionInformation = null;
function $662d9978aa5168bc$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $662d9978aa5168bc$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $662d9978aa5168bc$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $662d9978aa5168bc$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $662d9978aa5168bc$var$currentPopstateTransitionEvent = null;
function $662d9978aa5168bc$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $662d9978aa5168bc$var$currentPopstateTransitionEvent) return !1;
        $662d9978aa5168bc$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $662d9978aa5168bc$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $662d9978aa5168bc$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $662d9978aa5168bc$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $662d9978aa5168bc$var$localPromise = "function" === typeof Promise ? Promise : void 0, $662d9978aa5168bc$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $662d9978aa5168bc$var$localPromise ? function(callback) {
    return $662d9978aa5168bc$var$localPromise.resolve(null).then(callback).catch($662d9978aa5168bc$var$handleErrorInNextTick);
} : $662d9978aa5168bc$var$scheduleTimeout;
function $662d9978aa5168bc$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $662d9978aa5168bc$var$clearSuspenseBoundary(parentInstance, suspenseInstance) {
    var node = suspenseInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $662d9978aa5168bc$var$retryIfBlockedOn(suspenseInstance);
                    return;
                }
                depth--;
            } else "$" !== node && "$?" !== node && "$!" !== node || depth++;
        }
        node = nextNode;
    }while (node);
    $662d9978aa5168bc$var$retryIfBlockedOn(suspenseInstance);
}
function $662d9978aa5168bc$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $662d9978aa5168bc$var$clearContainerSparingly(node);
                $662d9978aa5168bc$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $662d9978aa5168bc$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$662d9978aa5168bc$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $662d9978aa5168bc$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $662d9978aa5168bc$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $662d9978aa5168bc$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $662d9978aa5168bc$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType) return null;
        }
    }
    return node;
}
function $662d9978aa5168bc$var$getParentSuspenseInstance(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" === data && depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $662d9978aa5168bc$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $662d9978aa5168bc$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($662d9978aa5168bc$var$formatProdErrorMessage(451));
    }
}
var $662d9978aa5168bc$var$preloadPropsMap = new Map(), $662d9978aa5168bc$var$preconnectsSet = new Set();
function $662d9978aa5168bc$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : container.ownerDocument;
}
var $662d9978aa5168bc$var$previousDispatcher = $662d9978aa5168bc$var$ReactDOMSharedInternals.d;
$662d9978aa5168bc$var$ReactDOMSharedInternals.d = {
    f: $662d9978aa5168bc$var$flushSyncWork,
    r: $662d9978aa5168bc$var$requestFormReset,
    D: $662d9978aa5168bc$var$prefetchDNS,
    C: $662d9978aa5168bc$var$preconnect,
    L: $662d9978aa5168bc$var$preload,
    m: $662d9978aa5168bc$var$preloadModule,
    X: $662d9978aa5168bc$var$preinitScript,
    S: $662d9978aa5168bc$var$preinitStyle,
    M: $662d9978aa5168bc$var$preinitModuleScript
};
function $662d9978aa5168bc$var$flushSyncWork() {
    var previousWasRendering = $662d9978aa5168bc$var$previousDispatcher.f(), wasRendering = $662d9978aa5168bc$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $662d9978aa5168bc$var$requestFormReset(form) {
    var formInst = $662d9978aa5168bc$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $662d9978aa5168bc$var$requestFormReset$1(formInst) : $662d9978aa5168bc$var$previousDispatcher.r(form);
}
var $662d9978aa5168bc$var$globalDocument = "undefined" === typeof document ? null : document;
function $662d9978aa5168bc$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $662d9978aa5168bc$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $662d9978aa5168bc$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $662d9978aa5168bc$var$preconnectsSet.has(limitedEscapedHref) || ($662d9978aa5168bc$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $662d9978aa5168bc$var$setInitialProperties(href, "link", rel), $662d9978aa5168bc$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $662d9978aa5168bc$var$prefetchDNS(href) {
    $662d9978aa5168bc$var$previousDispatcher.D(href);
    $662d9978aa5168bc$var$preconnectAs("dns-prefetch", href, null);
}
function $662d9978aa5168bc$var$preconnect(href, crossOrigin) {
    $662d9978aa5168bc$var$previousDispatcher.C(href, crossOrigin);
    $662d9978aa5168bc$var$preconnectAs("preconnect", href, crossOrigin);
}
function $662d9978aa5168bc$var$preload(href, as, options) {
    $662d9978aa5168bc$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $662d9978aa5168bc$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $662d9978aa5168bc$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $662d9978aa5168bc$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $662d9978aa5168bc$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $662d9978aa5168bc$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $662d9978aa5168bc$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $662d9978aa5168bc$var$getStyleKey(href);
                break;
            case "script":
                key = $662d9978aa5168bc$var$getScriptKey(href);
        }
        $662d9978aa5168bc$var$preloadPropsMap.has(key) || (href = $662d9978aa5168bc$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $662d9978aa5168bc$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($662d9978aa5168bc$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($662d9978aa5168bc$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $662d9978aa5168bc$var$setInitialProperties(as, "link", href), $662d9978aa5168bc$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $662d9978aa5168bc$var$preloadModule(href, options) {
    $662d9978aa5168bc$var$previousDispatcher.m(href, options);
    var ownerDocument = $662d9978aa5168bc$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $662d9978aa5168bc$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $662d9978aa5168bc$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $662d9978aa5168bc$var$getScriptKey(href);
        }
        if (!$662d9978aa5168bc$var$preloadPropsMap.has(key) && (href = $662d9978aa5168bc$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $662d9978aa5168bc$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($662d9978aa5168bc$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $662d9978aa5168bc$var$setInitialProperties(as, "link", href);
            $662d9978aa5168bc$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $662d9978aa5168bc$var$preinitStyle(href, precedence, options) {
    $662d9978aa5168bc$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $662d9978aa5168bc$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $662d9978aa5168bc$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $662d9978aa5168bc$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($662d9978aa5168bc$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $662d9978aa5168bc$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $662d9978aa5168bc$var$preloadPropsMap.get(key)) && $662d9978aa5168bc$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $662d9978aa5168bc$var$markNodeAsHoistable(link);
                $662d9978aa5168bc$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $662d9978aa5168bc$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $662d9978aa5168bc$var$preinitScript(src, options) {
    $662d9978aa5168bc$var$previousDispatcher.X(src, options);
    var ownerDocument = $662d9978aa5168bc$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $662d9978aa5168bc$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $662d9978aa5168bc$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($662d9978aa5168bc$var$getScriptSelectorFromKey(key)), resource || (src = $662d9978aa5168bc$var$assign({
            src: src,
            async: !0
        }, options), (options = $662d9978aa5168bc$var$preloadPropsMap.get(key)) && $662d9978aa5168bc$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $662d9978aa5168bc$var$markNodeAsHoistable(resource), $662d9978aa5168bc$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $662d9978aa5168bc$var$preinitModuleScript(src, options) {
    $662d9978aa5168bc$var$previousDispatcher.M(src, options);
    var ownerDocument = $662d9978aa5168bc$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $662d9978aa5168bc$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $662d9978aa5168bc$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($662d9978aa5168bc$var$getScriptSelectorFromKey(key)), resource || (src = $662d9978aa5168bc$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $662d9978aa5168bc$var$preloadPropsMap.get(key)) && $662d9978aa5168bc$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $662d9978aa5168bc$var$markNodeAsHoistable(resource), $662d9978aa5168bc$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $662d9978aa5168bc$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $662d9978aa5168bc$var$rootInstanceStackCursor.current) ? $662d9978aa5168bc$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $662d9978aa5168bc$var$getStyleKey(pendingProps.href), pendingProps = $662d9978aa5168bc$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $662d9978aa5168bc$var$getStyleKey(pendingProps.href);
                var styles$242 = $662d9978aa5168bc$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$243 = styles$242.get(type);
                resource$243 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$243 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$242.set(type, resource$243), (styles$242 = JSCompiler_inline_result.querySelector($662d9978aa5168bc$var$getStylesheetSelectorFromKey(type))) && !styles$242._p && (resource$243.instance = styles$242, resource$243.state.loading = 5), $662d9978aa5168bc$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $662d9978aa5168bc$var$preloadPropsMap.set(type, pendingProps), styles$242 || $662d9978aa5168bc$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$243.state)));
                if (currentProps && null === currentResource) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(528, ""));
                return resource$243;
            }
            if (currentProps && null !== currentResource) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $662d9978aa5168bc$var$getScriptKey(pendingProps), pendingProps = $662d9978aa5168bc$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($662d9978aa5168bc$var$formatProdErrorMessage(444, type));
    }
}
function $662d9978aa5168bc$var$getStyleKey(href) {
    return 'href="' + $662d9978aa5168bc$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $662d9978aa5168bc$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $662d9978aa5168bc$var$stylesheetPropsFromRawProps(rawProps) {
    return $662d9978aa5168bc$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $662d9978aa5168bc$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $662d9978aa5168bc$var$setInitialProperties(key, "link", preloadProps), $662d9978aa5168bc$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $662d9978aa5168bc$var$getScriptKey(src) {
    return '[src="' + $662d9978aa5168bc$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $662d9978aa5168bc$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $662d9978aa5168bc$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $662d9978aa5168bc$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $662d9978aa5168bc$var$markNodeAsHoistable(instance), instance;
            var styleProps = $662d9978aa5168bc$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $662d9978aa5168bc$var$markNodeAsHoistable(instance);
            $662d9978aa5168bc$var$setInitialProperties(instance, "style", styleProps);
            $662d9978aa5168bc$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $662d9978aa5168bc$var$getStyleKey(props.href);
            var instance$248 = hoistableRoot.querySelector($662d9978aa5168bc$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$248) return resource.state.loading |= 4, resource.instance = instance$248, $662d9978aa5168bc$var$markNodeAsHoistable(instance$248), instance$248;
            instance = $662d9978aa5168bc$var$stylesheetPropsFromRawProps(props);
            (styleProps = $662d9978aa5168bc$var$preloadPropsMap.get(styleProps)) && $662d9978aa5168bc$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$248 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $662d9978aa5168bc$var$markNodeAsHoistable(instance$248);
            var linkInstance = instance$248;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $662d9978aa5168bc$var$setInitialProperties(instance$248, "link", instance);
            resource.state.loading |= 4;
            $662d9978aa5168bc$var$insertStylesheet(instance$248, props.precedence, hoistableRoot);
            return resource.instance = instance$248;
        case "script":
            instance$248 = $662d9978aa5168bc$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($662d9978aa5168bc$var$getScriptSelectorFromKey(instance$248))) return resource.instance = styleProps, $662d9978aa5168bc$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $662d9978aa5168bc$var$preloadPropsMap.get(instance$248)) instance = $662d9978aa5168bc$var$assign({}, props), $662d9978aa5168bc$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $662d9978aa5168bc$var$markNodeAsHoistable(styleProps);
            $662d9978aa5168bc$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($662d9978aa5168bc$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $662d9978aa5168bc$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $662d9978aa5168bc$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $662d9978aa5168bc$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $662d9978aa5168bc$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $662d9978aa5168bc$var$tagCaches = null;
function $662d9978aa5168bc$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $662d9978aa5168bc$var$tagCaches) {
        var cache = new Map();
        var caches = $662d9978aa5168bc$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $662d9978aa5168bc$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$662d9978aa5168bc$var$internalHoistableMarker] || node[$662d9978aa5168bc$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $662d9978aa5168bc$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $662d9978aa5168bc$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $662d9978aa5168bc$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
var $662d9978aa5168bc$var$suspendedState = null;
function $662d9978aa5168bc$var$noop() {}
function $662d9978aa5168bc$var$suspendResource(hoistableRoot, resource, props) {
    if (null === $662d9978aa5168bc$var$suspendedState) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(475));
    var state = $662d9978aa5168bc$var$suspendedState;
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $662d9978aa5168bc$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($662d9978aa5168bc$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $662d9978aa5168bc$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $662d9978aa5168bc$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $662d9978aa5168bc$var$stylesheetPropsFromRawProps(props);
            (key = $662d9978aa5168bc$var$preloadPropsMap.get(key)) && $662d9978aa5168bc$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $662d9978aa5168bc$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $662d9978aa5168bc$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $662d9978aa5168bc$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
function $662d9978aa5168bc$var$waitForCommitToBeReady() {
    if (null === $662d9978aa5168bc$var$suspendedState) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(475));
    var state = $662d9978aa5168bc$var$suspendedState;
    state.stylesheets && 0 === state.count && $662d9978aa5168bc$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $662d9978aa5168bc$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
        };
    } : null;
}
function $662d9978aa5168bc$var$onUnsuspend() {
    this.count--;
    if (0 === this.count) {
        if (this.stylesheets) $662d9978aa5168bc$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $662d9978aa5168bc$var$precedencesByRoot = null;
function $662d9978aa5168bc$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $662d9978aa5168bc$var$precedencesByRoot = new Map(), resources.forEach($662d9978aa5168bc$var$insertStylesheetIntoRoot, state), $662d9978aa5168bc$var$precedencesByRoot = null, $662d9978aa5168bc$var$onUnsuspend.call(state));
}
function $662d9978aa5168bc$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $662d9978aa5168bc$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $662d9978aa5168bc$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $662d9978aa5168bc$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $662d9978aa5168bc$var$HostTransitionContext = {
    $$typeof: $662d9978aa5168bc$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $662d9978aa5168bc$var$sharedNotPendingObject,
    _currentValue2: $662d9978aa5168bc$var$sharedNotPendingObject,
    _threadCount: 0
};
function $662d9978aa5168bc$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $662d9978aa5168bc$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.finishedLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $662d9978aa5168bc$var$createLaneMap(0);
    this.hiddenUpdates = $662d9978aa5168bc$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $662d9978aa5168bc$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState) {
    containerInfo = new $662d9978aa5168bc$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $662d9978aa5168bc$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $662d9978aa5168bc$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $662d9978aa5168bc$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $662d9978aa5168bc$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $662d9978aa5168bc$var$emptyContextObject;
    parentComponent = $662d9978aa5168bc$var$emptyContextObject;
    return parentComponent;
}
function $662d9978aa5168bc$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $662d9978aa5168bc$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $662d9978aa5168bc$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $662d9978aa5168bc$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($662d9978aa5168bc$var$scheduleUpdateOnFiber(element, rootFiber, lane), $662d9978aa5168bc$var$entangleTransitions(element, rootFiber, lane));
}
function $662d9978aa5168bc$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $662d9978aa5168bc$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $662d9978aa5168bc$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $662d9978aa5168bc$var$markRetryLaneImpl(fiber, retryLane);
}
function $662d9978aa5168bc$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag) {
        var root = $662d9978aa5168bc$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $662d9978aa5168bc$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $662d9978aa5168bc$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
var $662d9978aa5168bc$var$_enabled = !0;
function $662d9978aa5168bc$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $662d9978aa5168bc$var$ReactSharedInternals.T;
    $662d9978aa5168bc$var$ReactSharedInternals.T = null;
    var previousPriority = $662d9978aa5168bc$var$ReactDOMSharedInternals.p;
    try {
        $662d9978aa5168bc$var$ReactDOMSharedInternals.p = 2, $662d9978aa5168bc$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $662d9978aa5168bc$var$ReactDOMSharedInternals.p = previousPriority, $662d9978aa5168bc$var$ReactSharedInternals.T = prevTransition;
    }
}
function $662d9978aa5168bc$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $662d9978aa5168bc$var$ReactSharedInternals.T;
    $662d9978aa5168bc$var$ReactSharedInternals.T = null;
    var previousPriority = $662d9978aa5168bc$var$ReactDOMSharedInternals.p;
    try {
        $662d9978aa5168bc$var$ReactDOMSharedInternals.p = 8, $662d9978aa5168bc$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $662d9978aa5168bc$var$ReactDOMSharedInternals.p = previousPriority, $662d9978aa5168bc$var$ReactSharedInternals.T = prevTransition;
    }
}
function $662d9978aa5168bc$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($662d9978aa5168bc$var$_enabled) {
        var blockedOn = $662d9978aa5168bc$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $662d9978aa5168bc$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $662d9978aa5168bc$var$return_targetInst, targetContainer), $662d9978aa5168bc$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($662d9978aa5168bc$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($662d9978aa5168bc$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $662d9978aa5168bc$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $662d9978aa5168bc$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $662d9978aa5168bc$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $662d9978aa5168bc$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $662d9978aa5168bc$var$ensureRootIsScheduled(fiber);
                                0 === ($662d9978aa5168bc$var$executionContext & 6) && ($662d9978aa5168bc$var$workInProgressRootRenderTargetTime = $662d9978aa5168bc$var$now() + 500, $662d9978aa5168bc$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 13:
                        root = $662d9978aa5168bc$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $662d9978aa5168bc$var$scheduleUpdateOnFiber(root, fiber, 2), $662d9978aa5168bc$var$flushSyncWork$1(), $662d9978aa5168bc$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $662d9978aa5168bc$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $662d9978aa5168bc$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $662d9978aa5168bc$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $662d9978aa5168bc$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $662d9978aa5168bc$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $662d9978aa5168bc$var$getEventTarget(nativeEvent);
    return $662d9978aa5168bc$var$findInstanceBlockingTarget(nativeEvent);
}
var $662d9978aa5168bc$var$return_targetInst = null;
function $662d9978aa5168bc$var$findInstanceBlockingTarget(targetNode) {
    $662d9978aa5168bc$var$return_targetInst = null;
    targetNode = $662d9978aa5168bc$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $662d9978aa5168bc$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $662d9978aa5168bc$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $662d9978aa5168bc$var$return_targetInst = targetNode;
    return null;
}
function $662d9978aa5168bc$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($662d9978aa5168bc$var$getCurrentPriorityLevel()){
                case $662d9978aa5168bc$var$ImmediatePriority:
                    return 2;
                case $662d9978aa5168bc$var$UserBlockingPriority:
                    return 8;
                case $662d9978aa5168bc$var$NormalPriority$1:
                case $662d9978aa5168bc$var$LowPriority:
                    return 32;
                case $662d9978aa5168bc$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $662d9978aa5168bc$var$hasScheduledReplayAttempt = !1, $662d9978aa5168bc$var$queuedFocus = null, $662d9978aa5168bc$var$queuedDrag = null, $662d9978aa5168bc$var$queuedMouse = null, $662d9978aa5168bc$var$queuedPointers = new Map(), $662d9978aa5168bc$var$queuedPointerCaptures = new Map(), $662d9978aa5168bc$var$queuedExplicitHydrationTargets = [], $662d9978aa5168bc$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $662d9978aa5168bc$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $662d9978aa5168bc$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $662d9978aa5168bc$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $662d9978aa5168bc$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $662d9978aa5168bc$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $662d9978aa5168bc$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $662d9978aa5168bc$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $662d9978aa5168bc$var$getInstanceFromNode(blockedOn), null !== blockedOn && $662d9978aa5168bc$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $662d9978aa5168bc$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $662d9978aa5168bc$var$queuedFocus = $662d9978aa5168bc$var$accumulateOrCreateContinuousQueuedReplayableEvent($662d9978aa5168bc$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $662d9978aa5168bc$var$queuedDrag = $662d9978aa5168bc$var$accumulateOrCreateContinuousQueuedReplayableEvent($662d9978aa5168bc$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $662d9978aa5168bc$var$queuedMouse = $662d9978aa5168bc$var$accumulateOrCreateContinuousQueuedReplayableEvent($662d9978aa5168bc$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $662d9978aa5168bc$var$queuedPointers.set(pointerId, $662d9978aa5168bc$var$accumulateOrCreateContinuousQueuedReplayableEvent($662d9978aa5168bc$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $662d9978aa5168bc$var$queuedPointerCaptures.set(pointerId, $662d9978aa5168bc$var$accumulateOrCreateContinuousQueuedReplayableEvent($662d9978aa5168bc$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $662d9978aa5168bc$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $662d9978aa5168bc$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $662d9978aa5168bc$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $662d9978aa5168bc$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $662d9978aa5168bc$var$runWithPriority(queuedTarget.priority, function() {
                        if (13 === nearestMounted.tag) {
                            var lane = $662d9978aa5168bc$var$requestUpdateLane(), root = $662d9978aa5168bc$var$enqueueConcurrentRenderForLane(nearestMounted, lane);
                            null !== root && $662d9978aa5168bc$var$scheduleUpdateOnFiber(root, nearestMounted, lane);
                            $662d9978aa5168bc$var$markRetryLaneIfNotHydrated(nearestMounted, lane);
                        }
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $662d9978aa5168bc$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $662d9978aa5168bc$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $662d9978aa5168bc$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $662d9978aa5168bc$var$currentReplayingEvent = null;
        } else return targetContainers = $662d9978aa5168bc$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $662d9978aa5168bc$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $662d9978aa5168bc$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $662d9978aa5168bc$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $662d9978aa5168bc$var$replayUnblockedEvents() {
    $662d9978aa5168bc$var$hasScheduledReplayAttempt = !1;
    null !== $662d9978aa5168bc$var$queuedFocus && $662d9978aa5168bc$var$attemptReplayContinuousQueuedEvent($662d9978aa5168bc$var$queuedFocus) && ($662d9978aa5168bc$var$queuedFocus = null);
    null !== $662d9978aa5168bc$var$queuedDrag && $662d9978aa5168bc$var$attemptReplayContinuousQueuedEvent($662d9978aa5168bc$var$queuedDrag) && ($662d9978aa5168bc$var$queuedDrag = null);
    null !== $662d9978aa5168bc$var$queuedMouse && $662d9978aa5168bc$var$attemptReplayContinuousQueuedEvent($662d9978aa5168bc$var$queuedMouse) && ($662d9978aa5168bc$var$queuedMouse = null);
    $662d9978aa5168bc$var$queuedPointers.forEach($662d9978aa5168bc$var$attemptReplayContinuousQueuedEventInMap);
    $662d9978aa5168bc$var$queuedPointerCaptures.forEach($662d9978aa5168bc$var$attemptReplayContinuousQueuedEventInMap);
}
function $662d9978aa5168bc$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $662d9978aa5168bc$var$hasScheduledReplayAttempt || ($662d9978aa5168bc$var$hasScheduledReplayAttempt = !0, $ibqfJ.unstable_scheduleCallback($ibqfJ.unstable_NormalPriority, $662d9978aa5168bc$var$replayUnblockedEvents)));
}
var $662d9978aa5168bc$var$lastScheduledReplayQueue = null;
function $662d9978aa5168bc$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $662d9978aa5168bc$var$lastScheduledReplayQueue !== formReplayingQueue && ($662d9978aa5168bc$var$lastScheduledReplayQueue = formReplayingQueue, $ibqfJ.unstable_scheduleCallback($ibqfJ.unstable_NormalPriority, function() {
        $662d9978aa5168bc$var$lastScheduledReplayQueue === formReplayingQueue && ($662d9978aa5168bc$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $662d9978aa5168bc$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $662d9978aa5168bc$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $662d9978aa5168bc$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $662d9978aa5168bc$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $662d9978aa5168bc$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $662d9978aa5168bc$var$queuedFocus && $662d9978aa5168bc$var$scheduleCallbackIfUnblocked($662d9978aa5168bc$var$queuedFocus, unblocked);
    null !== $662d9978aa5168bc$var$queuedDrag && $662d9978aa5168bc$var$scheduleCallbackIfUnblocked($662d9978aa5168bc$var$queuedDrag, unblocked);
    null !== $662d9978aa5168bc$var$queuedMouse && $662d9978aa5168bc$var$scheduleCallbackIfUnblocked($662d9978aa5168bc$var$queuedMouse, unblocked);
    $662d9978aa5168bc$var$queuedPointers.forEach(unblock);
    $662d9978aa5168bc$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $662d9978aa5168bc$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $662d9978aa5168bc$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $662d9978aa5168bc$var$queuedExplicitHydrationTargets.length && (i = $662d9978aa5168bc$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$662d9978aa5168bc$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $662d9978aa5168bc$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$662d9978aa5168bc$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $662d9978aa5168bc$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$662d9978aa5168bc$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $662d9978aa5168bc$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $662d9978aa5168bc$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $662d9978aa5168bc$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$662d9978aa5168bc$var$ReactDOMHydrationRoot.prototype.render = $662d9978aa5168bc$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(409));
    var current = root.current, lane = $662d9978aa5168bc$var$requestUpdateLane();
    $662d9978aa5168bc$var$updateContainerImpl(current, lane, children, root, null, null);
};
$662d9978aa5168bc$var$ReactDOMHydrationRoot.prototype.unmount = $662d9978aa5168bc$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        0 === root.tag && $662d9978aa5168bc$var$flushPassiveEffects();
        $662d9978aa5168bc$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $662d9978aa5168bc$var$flushSyncWork$1();
        container[$662d9978aa5168bc$var$internalContainerInstanceKey] = null;
    }
};
function $662d9978aa5168bc$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$662d9978aa5168bc$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $662d9978aa5168bc$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $662d9978aa5168bc$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $662d9978aa5168bc$var$queuedExplicitHydrationTargets[i].priority; i++);
        $662d9978aa5168bc$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $662d9978aa5168bc$var$attemptExplicitHydrationTarget(target);
    }
};
var $662d9978aa5168bc$var$isomorphicReactPackageVersion$jscomp$inline_1686 = $exYeM.version;
if ("19.0.0" !== $662d9978aa5168bc$var$isomorphicReactPackageVersion$jscomp$inline_1686) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(527, $662d9978aa5168bc$var$isomorphicReactPackageVersion$jscomp$inline_1686, "19.0.0"));
$662d9978aa5168bc$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($662d9978aa5168bc$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $662d9978aa5168bc$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $662d9978aa5168bc$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $662d9978aa5168bc$var$internals$jscomp$inline_2165 = {
    bundleType: 0,
    version: "19.0.0",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $662d9978aa5168bc$var$ReactSharedInternals,
    findFiberByHostInstance: $662d9978aa5168bc$var$getClosestInstanceFromNode,
    reconcilerVersion: "19.0.0"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $662d9978aa5168bc$var$hook$jscomp$inline_2166 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$662d9978aa5168bc$var$hook$jscomp$inline_2166.isDisabled && $662d9978aa5168bc$var$hook$jscomp$inline_2166.supportsFiber) try {
        $662d9978aa5168bc$var$rendererID = $662d9978aa5168bc$var$hook$jscomp$inline_2166.inject($662d9978aa5168bc$var$internals$jscomp$inline_2165), $662d9978aa5168bc$var$injectedHook = $662d9978aa5168bc$var$hook$jscomp$inline_2166;
    } catch (err) {}
}
$662d9978aa5168bc$export$882461b6382ed46c = function(container, options) {
    if (!$662d9978aa5168bc$var$isValidContainer(container)) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $662d9978aa5168bc$var$defaultOnUncaughtError, onCaughtError = $662d9978aa5168bc$var$defaultOnCaughtError, onRecoverableError = $662d9978aa5168bc$var$defaultOnRecoverableError, transitionCallbacks = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks));
    options = $662d9978aa5168bc$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, null);
    container[$662d9978aa5168bc$var$internalContainerInstanceKey] = options.current;
    $662d9978aa5168bc$var$listenToAllSupportedEvents(8 === container.nodeType ? container.parentNode : container);
    return new $662d9978aa5168bc$var$ReactDOMRoot(options);
};
$662d9978aa5168bc$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$662d9978aa5168bc$var$isValidContainer(container)) throw Error($662d9978aa5168bc$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $662d9978aa5168bc$var$defaultOnUncaughtError, onCaughtError = $662d9978aa5168bc$var$defaultOnCaughtError, onRecoverableError = $662d9978aa5168bc$var$defaultOnRecoverableError, transitionCallbacks = null, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $662d9978aa5168bc$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState);
    initialChildren.context = $662d9978aa5168bc$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $662d9978aa5168bc$var$requestUpdateLane();
    identifierPrefix = $662d9978aa5168bc$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $662d9978aa5168bc$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    initialChildren.current.lanes = isStrictMode;
    $662d9978aa5168bc$var$markRootUpdated$1(initialChildren, isStrictMode);
    $662d9978aa5168bc$var$ensureRootIsScheduled(initialChildren);
    container[$662d9978aa5168bc$var$internalContainerInstanceKey] = initialChildren.current;
    $662d9978aa5168bc$var$listenToAllSupportedEvents(container);
    return new $662d9978aa5168bc$var$ReactDOMHydrationRoot(initialChildren);
};
$662d9978aa5168bc$export$83d89fbfd8236492 = "19.0.0";

});
parcelRegister("ibqfJ", function(module, exports) {
"use strict";

module.exports = (parcelRequire("8GlMf"));

});
parcelRegister("8GlMf", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $65232378122dc16b$export$c4744153514ff05d; }, function (v) { return $65232378122dc16b$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $65232378122dc16b$export$3e506c1ccc9cc1a7; }, function (v) { return $65232378122dc16b$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $65232378122dc16b$export$e26fe2ed2fa76875; }, function (v) { return $65232378122dc16b$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $65232378122dc16b$export$502329bbf4b505b1; }, function (v) { return $65232378122dc16b$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $65232378122dc16b$export$6e3807111c4874c4; }, function (v) { return $65232378122dc16b$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $65232378122dc16b$export$c27134553091fb3a; }, function (v) { return $65232378122dc16b$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $65232378122dc16b$export$33ee1acdc04fd2a2; }, function (v) { return $65232378122dc16b$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $65232378122dc16b$export$b00a404bbd5edef2; }, function (v) { return $65232378122dc16b$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $65232378122dc16b$export$8352ce38b91d0c62; }, function (v) { return $65232378122dc16b$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $65232378122dc16b$export$d66a1c1c77bd778b; }, function (v) { return $65232378122dc16b$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $65232378122dc16b$export$d3dfb8e4810cb555; }, function (v) { return $65232378122dc16b$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $65232378122dc16b$export$839f9183b0465a69; }, function (v) { return $65232378122dc16b$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $65232378122dc16b$export$72fdf0e06517287b; }, function (v) { return $65232378122dc16b$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $65232378122dc16b$export$4b844e58a3e414b4; }, function (v) { return $65232378122dc16b$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $65232378122dc16b$export$816d2913ae6b83b1; }, function (v) { return $65232378122dc16b$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $65232378122dc16b$export$61bcfe829111a1d0; }, function (v) { return $65232378122dc16b$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $65232378122dc16b$export$7ee8c9beb337bc3f; }, function (v) { return $65232378122dc16b$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $65232378122dc16b$export$b5836b71941fa3ed; }, function (v) { return $65232378122dc16b$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $65232378122dc16b$export$cf845f2c119da08a; }, function (v) { return $65232378122dc16b$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $65232378122dc16b$export$c4744153514ff05d;
var $65232378122dc16b$export$3e506c1ccc9cc1a7;
var $65232378122dc16b$export$e26fe2ed2fa76875;
var $65232378122dc16b$export$502329bbf4b505b1;
var $65232378122dc16b$export$6e3807111c4874c4;
var $65232378122dc16b$export$c27134553091fb3a;
var $65232378122dc16b$export$33ee1acdc04fd2a2;
var $65232378122dc16b$export$b00a404bbd5edef2;
var $65232378122dc16b$export$8352ce38b91d0c62;
var $65232378122dc16b$export$d66a1c1c77bd778b;
var $65232378122dc16b$export$d3dfb8e4810cb555;
var $65232378122dc16b$export$839f9183b0465a69;
var $65232378122dc16b$export$72fdf0e06517287b;
var $65232378122dc16b$export$4b844e58a3e414b4;
var $65232378122dc16b$export$816d2913ae6b83b1;
var $65232378122dc16b$export$61bcfe829111a1d0;
var $65232378122dc16b$export$7ee8c9beb337bc3f;
var $65232378122dc16b$export$b5836b71941fa3ed;
var $65232378122dc16b$export$cf845f2c119da08a;
"use strict";
function $65232378122dc16b$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $65232378122dc16b$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $65232378122dc16b$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $65232378122dc16b$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $65232378122dc16b$var$compare(left, last)) rightIndex < length && 0 > $65232378122dc16b$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $65232378122dc16b$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $65232378122dc16b$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$65232378122dc16b$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $65232378122dc16b$var$localPerformance = performance;
    $65232378122dc16b$export$c4744153514ff05d = function() {
        return $65232378122dc16b$var$localPerformance.now();
    };
} else {
    var $65232378122dc16b$var$localDate = Date, $65232378122dc16b$var$initialTime = $65232378122dc16b$var$localDate.now();
    $65232378122dc16b$export$c4744153514ff05d = function() {
        return $65232378122dc16b$var$localDate.now() - $65232378122dc16b$var$initialTime;
    };
}
var $65232378122dc16b$var$taskQueue = [], $65232378122dc16b$var$timerQueue = [], $65232378122dc16b$var$taskIdCounter = 1, $65232378122dc16b$var$currentTask = null, $65232378122dc16b$var$currentPriorityLevel = 3, $65232378122dc16b$var$isPerformingWork = !1, $65232378122dc16b$var$isHostCallbackScheduled = !1, $65232378122dc16b$var$isHostTimeoutScheduled = !1, $65232378122dc16b$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $65232378122dc16b$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $65232378122dc16b$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $65232378122dc16b$var$advanceTimers(currentTime) {
    for(var timer = $65232378122dc16b$var$peek($65232378122dc16b$var$timerQueue); null !== timer;){
        if (null === timer.callback) $65232378122dc16b$var$pop($65232378122dc16b$var$timerQueue);
        else if (timer.startTime <= currentTime) $65232378122dc16b$var$pop($65232378122dc16b$var$timerQueue), timer.sortIndex = timer.expirationTime, $65232378122dc16b$var$push($65232378122dc16b$var$taskQueue, timer);
        else break;
        timer = $65232378122dc16b$var$peek($65232378122dc16b$var$timerQueue);
    }
}
function $65232378122dc16b$var$handleTimeout(currentTime) {
    $65232378122dc16b$var$isHostTimeoutScheduled = !1;
    $65232378122dc16b$var$advanceTimers(currentTime);
    if (!$65232378122dc16b$var$isHostCallbackScheduled) {
        if (null !== $65232378122dc16b$var$peek($65232378122dc16b$var$taskQueue)) $65232378122dc16b$var$isHostCallbackScheduled = !0, $65232378122dc16b$var$requestHostCallback();
        else {
            var firstTimer = $65232378122dc16b$var$peek($65232378122dc16b$var$timerQueue);
            null !== firstTimer && $65232378122dc16b$var$requestHostTimeout($65232378122dc16b$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $65232378122dc16b$var$isMessageLoopRunning = !1, $65232378122dc16b$var$taskTimeoutID = -1, $65232378122dc16b$var$frameInterval = 5, $65232378122dc16b$var$startTime = -1;
function $65232378122dc16b$var$shouldYieldToHost() {
    return $65232378122dc16b$export$c4744153514ff05d() - $65232378122dc16b$var$startTime < $65232378122dc16b$var$frameInterval ? !1 : !0;
}
function $65232378122dc16b$var$performWorkUntilDeadline() {
    if ($65232378122dc16b$var$isMessageLoopRunning) {
        var currentTime = $65232378122dc16b$export$c4744153514ff05d();
        $65232378122dc16b$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $65232378122dc16b$var$isHostCallbackScheduled = !1;
                $65232378122dc16b$var$isHostTimeoutScheduled && ($65232378122dc16b$var$isHostTimeoutScheduled = !1, $65232378122dc16b$var$localClearTimeout($65232378122dc16b$var$taskTimeoutID), $65232378122dc16b$var$taskTimeoutID = -1);
                $65232378122dc16b$var$isPerformingWork = !0;
                var previousPriorityLevel = $65232378122dc16b$var$currentPriorityLevel;
                try {
                    b: {
                        $65232378122dc16b$var$advanceTimers(currentTime);
                        for($65232378122dc16b$var$currentTask = $65232378122dc16b$var$peek($65232378122dc16b$var$taskQueue); null !== $65232378122dc16b$var$currentTask && !($65232378122dc16b$var$currentTask.expirationTime > currentTime && $65232378122dc16b$var$shouldYieldToHost());){
                            var callback = $65232378122dc16b$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $65232378122dc16b$var$currentTask.callback = null;
                                $65232378122dc16b$var$currentPriorityLevel = $65232378122dc16b$var$currentTask.priorityLevel;
                                var continuationCallback = callback($65232378122dc16b$var$currentTask.expirationTime <= currentTime);
                                currentTime = $65232378122dc16b$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $65232378122dc16b$var$currentTask.callback = continuationCallback;
                                    $65232378122dc16b$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $65232378122dc16b$var$currentTask === $65232378122dc16b$var$peek($65232378122dc16b$var$taskQueue) && $65232378122dc16b$var$pop($65232378122dc16b$var$taskQueue);
                                $65232378122dc16b$var$advanceTimers(currentTime);
                            } else $65232378122dc16b$var$pop($65232378122dc16b$var$taskQueue);
                            $65232378122dc16b$var$currentTask = $65232378122dc16b$var$peek($65232378122dc16b$var$taskQueue);
                        }
                        if (null !== $65232378122dc16b$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $65232378122dc16b$var$peek($65232378122dc16b$var$timerQueue);
                            null !== firstTimer && $65232378122dc16b$var$requestHostTimeout($65232378122dc16b$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $65232378122dc16b$var$currentTask = null, $65232378122dc16b$var$currentPriorityLevel = previousPriorityLevel, $65232378122dc16b$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $65232378122dc16b$var$schedulePerformWorkUntilDeadline() : $65232378122dc16b$var$isMessageLoopRunning = !1;
        }
    }
}
var $65232378122dc16b$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $65232378122dc16b$var$localSetImmediate) $65232378122dc16b$var$schedulePerformWorkUntilDeadline = function() {
    $65232378122dc16b$var$localSetImmediate($65232378122dc16b$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $65232378122dc16b$var$channel = new MessageChannel(), $65232378122dc16b$var$port = $65232378122dc16b$var$channel.port2;
    $65232378122dc16b$var$channel.port1.onmessage = $65232378122dc16b$var$performWorkUntilDeadline;
    $65232378122dc16b$var$schedulePerformWorkUntilDeadline = function() {
        $65232378122dc16b$var$port.postMessage(null);
    };
} else $65232378122dc16b$var$schedulePerformWorkUntilDeadline = function() {
    $65232378122dc16b$var$localSetTimeout($65232378122dc16b$var$performWorkUntilDeadline, 0);
};
function $65232378122dc16b$var$requestHostCallback() {
    $65232378122dc16b$var$isMessageLoopRunning || ($65232378122dc16b$var$isMessageLoopRunning = !0, $65232378122dc16b$var$schedulePerformWorkUntilDeadline());
}
function $65232378122dc16b$var$requestHostTimeout(callback, ms) {
    $65232378122dc16b$var$taskTimeoutID = $65232378122dc16b$var$localSetTimeout(function() {
        callback($65232378122dc16b$export$c4744153514ff05d());
    }, ms);
}
$65232378122dc16b$export$3e506c1ccc9cc1a7 = 5;
$65232378122dc16b$export$e26fe2ed2fa76875 = 1;
$65232378122dc16b$export$502329bbf4b505b1 = 4;
$65232378122dc16b$export$6e3807111c4874c4 = 3;
$65232378122dc16b$export$c27134553091fb3a = null;
$65232378122dc16b$export$33ee1acdc04fd2a2 = 2;
$65232378122dc16b$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$65232378122dc16b$export$8352ce38b91d0c62 = function() {
    $65232378122dc16b$var$isHostCallbackScheduled || $65232378122dc16b$var$isPerformingWork || ($65232378122dc16b$var$isHostCallbackScheduled = !0, $65232378122dc16b$var$requestHostCallback());
};
$65232378122dc16b$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $65232378122dc16b$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$65232378122dc16b$export$d3dfb8e4810cb555 = function() {
    return $65232378122dc16b$var$currentPriorityLevel;
};
$65232378122dc16b$export$839f9183b0465a69 = function() {
    return $65232378122dc16b$var$peek($65232378122dc16b$var$taskQueue);
};
$65232378122dc16b$export$72fdf0e06517287b = function(eventHandler) {
    switch($65232378122dc16b$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $65232378122dc16b$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $65232378122dc16b$var$currentPriorityLevel;
    $65232378122dc16b$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $65232378122dc16b$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$65232378122dc16b$export$4b844e58a3e414b4 = function() {};
$65232378122dc16b$export$816d2913ae6b83b1 = function() {};
$65232378122dc16b$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $65232378122dc16b$var$currentPriorityLevel;
    $65232378122dc16b$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $65232378122dc16b$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$65232378122dc16b$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $65232378122dc16b$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $65232378122dc16b$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $65232378122dc16b$var$push($65232378122dc16b$var$timerQueue, priorityLevel), null === $65232378122dc16b$var$peek($65232378122dc16b$var$taskQueue) && priorityLevel === $65232378122dc16b$var$peek($65232378122dc16b$var$timerQueue) && ($65232378122dc16b$var$isHostTimeoutScheduled ? ($65232378122dc16b$var$localClearTimeout($65232378122dc16b$var$taskTimeoutID), $65232378122dc16b$var$taskTimeoutID = -1) : $65232378122dc16b$var$isHostTimeoutScheduled = !0, $65232378122dc16b$var$requestHostTimeout($65232378122dc16b$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $65232378122dc16b$var$push($65232378122dc16b$var$taskQueue, priorityLevel), $65232378122dc16b$var$isHostCallbackScheduled || $65232378122dc16b$var$isPerformingWork || ($65232378122dc16b$var$isHostCallbackScheduled = !0, $65232378122dc16b$var$requestHostCallback()));
    return priorityLevel;
};
$65232378122dc16b$export$b5836b71941fa3ed = $65232378122dc16b$var$shouldYieldToHost;
$65232378122dc16b$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $65232378122dc16b$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $65232378122dc16b$var$currentPriorityLevel;
        $65232378122dc16b$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $65232378122dc16b$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("exYeM", function(module, exports) {
"use strict";

module.exports = (parcelRequire("gfHYB"));

});

parcelRegister("d2lNW", function(module, exports) {
"use strict";
function $97dc602bd7e23afa$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($97dc602bd7e23afa$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$97dc602bd7e23afa$var$checkDCE();

module.exports = (parcelRequire("cONs6"));

});
parcelRegister("cONs6", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $955083c1bd0bad05$export$69ce8ef3fe5cead0; }, function (v) { return $955083c1bd0bad05$export$69ce8ef3fe5cead0 = v; });
$parcel$export(module.exports, "createPortal", function () { return $955083c1bd0bad05$export$d39a5bbd09211389; }, function (v) { return $955083c1bd0bad05$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "flushSync", function () { return $955083c1bd0bad05$export$cd75ccfd720a3cd4; }, function (v) { return $955083c1bd0bad05$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "preconnect", function () { return $955083c1bd0bad05$export$a0816fa17a9e79be; }, function (v) { return $955083c1bd0bad05$export$a0816fa17a9e79be = v; });
$parcel$export(module.exports, "prefetchDNS", function () { return $955083c1bd0bad05$export$7292efcadded39f3; }, function (v) { return $955083c1bd0bad05$export$7292efcadded39f3 = v; });
$parcel$export(module.exports, "preinit", function () { return $955083c1bd0bad05$export$da407abadb9b8f86; }, function (v) { return $955083c1bd0bad05$export$da407abadb9b8f86 = v; });
$parcel$export(module.exports, "preinitModule", function () { return $955083c1bd0bad05$export$314cfea32580671c; }, function (v) { return $955083c1bd0bad05$export$314cfea32580671c = v; });
$parcel$export(module.exports, "preload", function () { return $955083c1bd0bad05$export$513ccb98c53b8039; }, function (v) { return $955083c1bd0bad05$export$513ccb98c53b8039 = v; });
$parcel$export(module.exports, "preloadModule", function () { return $955083c1bd0bad05$export$dbca993bc2d264a; }, function (v) { return $955083c1bd0bad05$export$dbca993bc2d264a = v; });
$parcel$export(module.exports, "requestFormReset", function () { return $955083c1bd0bad05$export$4797a8006f0655d0; }, function (v) { return $955083c1bd0bad05$export$4797a8006f0655d0 = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $955083c1bd0bad05$export$c78a37762a8d58e1; }, function (v) { return $955083c1bd0bad05$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "useFormState", function () { return $955083c1bd0bad05$export$606f11b2eb45ecc6; }, function (v) { return $955083c1bd0bad05$export$606f11b2eb45ecc6 = v; });
$parcel$export(module.exports, "useFormStatus", function () { return $955083c1bd0bad05$export$f7e8a0bf92324b1e; }, function (v) { return $955083c1bd0bad05$export$f7e8a0bf92324b1e = v; });
$parcel$export(module.exports, "version", function () { return $955083c1bd0bad05$export$83d89fbfd8236492; }, function (v) { return $955083c1bd0bad05$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $955083c1bd0bad05$export$69ce8ef3fe5cead0;
var $955083c1bd0bad05$export$d39a5bbd09211389;
var $955083c1bd0bad05$export$cd75ccfd720a3cd4;
var $955083c1bd0bad05$export$a0816fa17a9e79be;
var $955083c1bd0bad05$export$7292efcadded39f3;
var $955083c1bd0bad05$export$da407abadb9b8f86;
var $955083c1bd0bad05$export$314cfea32580671c;
var $955083c1bd0bad05$export$513ccb98c53b8039;
var $955083c1bd0bad05$export$dbca993bc2d264a;
var $955083c1bd0bad05$export$4797a8006f0655d0;
var $955083c1bd0bad05$export$c78a37762a8d58e1;
var $955083c1bd0bad05$export$606f11b2eb45ecc6;
var $955083c1bd0bad05$export$f7e8a0bf92324b1e;
var $955083c1bd0bad05$export$83d89fbfd8236492;
"use strict";

var $exYeM = parcelRequire("exYeM");
function $955083c1bd0bad05$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $955083c1bd0bad05$var$noop() {}
var $955083c1bd0bad05$var$Internals = {
    d: {
        f: $955083c1bd0bad05$var$noop,
        r: function() {
            throw Error($955083c1bd0bad05$var$formatProdErrorMessage(522));
        },
        D: $955083c1bd0bad05$var$noop,
        C: $955083c1bd0bad05$var$noop,
        L: $955083c1bd0bad05$var$noop,
        m: $955083c1bd0bad05$var$noop,
        X: $955083c1bd0bad05$var$noop,
        S: $955083c1bd0bad05$var$noop,
        M: $955083c1bd0bad05$var$noop
    },
    p: 0,
    findDOMNode: null
}, $955083c1bd0bad05$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $955083c1bd0bad05$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $955083c1bd0bad05$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $955083c1bd0bad05$var$ReactSharedInternals = $exYeM.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $955083c1bd0bad05$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$955083c1bd0bad05$export$69ce8ef3fe5cead0 = $955083c1bd0bad05$var$Internals;
$955083c1bd0bad05$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($955083c1bd0bad05$var$formatProdErrorMessage(299));
    return $955083c1bd0bad05$var$createPortal$1(children, container, null, key);
};
$955083c1bd0bad05$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $955083c1bd0bad05$var$ReactSharedInternals.T, previousUpdatePriority = $955083c1bd0bad05$var$Internals.p;
    try {
        if ($955083c1bd0bad05$var$ReactSharedInternals.T = null, $955083c1bd0bad05$var$Internals.p = 2, fn) return fn();
    } finally{
        $955083c1bd0bad05$var$ReactSharedInternals.T = previousTransition, $955083c1bd0bad05$var$Internals.p = previousUpdatePriority, $955083c1bd0bad05$var$Internals.d.f();
    }
};
$955083c1bd0bad05$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $955083c1bd0bad05$var$Internals.d.C(href, options));
};
$955083c1bd0bad05$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $955083c1bd0bad05$var$Internals.d.D(href);
};
$955083c1bd0bad05$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $955083c1bd0bad05$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $955083c1bd0bad05$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $955083c1bd0bad05$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$955083c1bd0bad05$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $955083c1bd0bad05$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $955083c1bd0bad05$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $955083c1bd0bad05$var$Internals.d.M(href);
    }
};
$955083c1bd0bad05$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $955083c1bd0bad05$var$getCrossOriginStringAs(as, options.crossOrigin);
        $955083c1bd0bad05$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$955083c1bd0bad05$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $955083c1bd0bad05$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $955083c1bd0bad05$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $955083c1bd0bad05$var$Internals.d.m(href);
    }
};
$955083c1bd0bad05$export$4797a8006f0655d0 = function(form) {
    $955083c1bd0bad05$var$Internals.d.r(form);
};
$955083c1bd0bad05$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$955083c1bd0bad05$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $955083c1bd0bad05$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$955083c1bd0bad05$export$f7e8a0bf92324b1e = function() {
    return $955083c1bd0bad05$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$955083c1bd0bad05$export$83d89fbfd8236492 = "19.0.0";

});



var $7ead0b1397a835ed$exports = {};
"use strict";

$7ead0b1397a835ed$exports = (parcelRequire("1tTUb"));


parcelRequire("exYeM");
var $7bd215913159ea08$exports = {};
"use strict";
function $7bd215913159ea08$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($7bd215913159ea08$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$7bd215913159ea08$var$checkDCE();

$7bd215913159ea08$exports = (parcelRequire("8LThT"));




var $exYeM = parcelRequire("exYeM");


var $exYeM = parcelRequire("exYeM");
const $f6745ab07405201d$export$4812e460280c6ef2 = (arr)=>{
    return arr[Math.floor(Math.random() * arr.length)];
};
const $f6745ab07405201d$export$d02631cccf789723 = (start, end, step = 1)=>{
    let output = [];
    if (typeof end === "undefined") {
        end = start;
        start = 0;
    }
    for(let i = start; i < end; i += step)output.push(i);
    return output;
};




var $exYeM = parcelRequire("exYeM");

parcelRequire("exYeM");
var $a3cfc94d50127174$exports = {};

$a3cfc94d50127174$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "bug.6faf8eea.svg";


var $7773ebb06c4dbedf$exports = {};

$7773ebb06c4dbedf$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "dark.8bc30bce.svg";


var $3d3df57ec91ae8dc$exports = {};

$3d3df57ec91ae8dc$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "dragon.d4af5e08.svg";


var $0a923f1a0120332f$exports = {};

$0a923f1a0120332f$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "electric.bd428d9b.svg";


var $50f196883a9cfed6$exports = {};

$50f196883a9cfed6$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "fairy.299d8f1d.svg";


var $728866df7d541d2d$exports = {};

$728866df7d541d2d$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "fighting.9c02ca4c.svg";


var $d704177f450bef31$exports = {};

$d704177f450bef31$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "fire.489dbe6e.svg";


var $ea75850ee78b1b63$exports = {};

$ea75850ee78b1b63$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "flying.fcdef7c2.svg";


var $2fcb4e897fef4d16$exports = {};

$2fcb4e897fef4d16$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "ghost.6958c727.svg";


var $28a1e5944bcb777a$exports = {};

$28a1e5944bcb777a$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "grass.e9c9f6fe.svg";


var $ac67ca82c2f6144c$exports = {};

$ac67ca82c2f6144c$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "ground.59f160ef.svg";


var $9174ed45a2c44095$exports = {};

$9174ed45a2c44095$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "ice.c039ae21.svg";


var $8f92214ef438844e$exports = {};

$8f92214ef438844e$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "normal.e46214df.svg";


var $3b4b70d7fa344c54$exports = {};

$3b4b70d7fa344c54$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "poison.2bc9058f.svg";


var $c30078397018fe44$exports = {};

$c30078397018fe44$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "psychic.ac39bc34.svg";


var $0ccb112bfbc35d77$exports = {};

$0ccb112bfbc35d77$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "rock.62035363.svg";


var $94ee052636ff3e37$exports = {};

$94ee052636ff3e37$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "steel.00b8f038.svg";


var $28d8c1171c898bc8$exports = {};

$28d8c1171c898bc8$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "water.5709d703.svg";


// Type icon mapping
const $af43f6d3681ca32e$var$typeIcons = {
    bug: (0, (/*@__PURE__*/$parcel$interopDefault($a3cfc94d50127174$exports))),
    dark: (0, (/*@__PURE__*/$parcel$interopDefault($7773ebb06c4dbedf$exports))),
    dragon: (0, (/*@__PURE__*/$parcel$interopDefault($3d3df57ec91ae8dc$exports))),
    electric: (0, (/*@__PURE__*/$parcel$interopDefault($0a923f1a0120332f$exports))),
    fairy: (0, (/*@__PURE__*/$parcel$interopDefault($50f196883a9cfed6$exports))),
    fighting: (0, (/*@__PURE__*/$parcel$interopDefault($728866df7d541d2d$exports))),
    fire: (0, (/*@__PURE__*/$parcel$interopDefault($d704177f450bef31$exports))),
    flying: (0, (/*@__PURE__*/$parcel$interopDefault($ea75850ee78b1b63$exports))),
    ghost: (0, (/*@__PURE__*/$parcel$interopDefault($2fcb4e897fef4d16$exports))),
    grass: (0, (/*@__PURE__*/$parcel$interopDefault($28a1e5944bcb777a$exports))),
    ground: (0, (/*@__PURE__*/$parcel$interopDefault($ac67ca82c2f6144c$exports))),
    ice: (0, (/*@__PURE__*/$parcel$interopDefault($9174ed45a2c44095$exports))),
    normal: (0, (/*@__PURE__*/$parcel$interopDefault($8f92214ef438844e$exports))),
    poison: (0, (/*@__PURE__*/$parcel$interopDefault($3b4b70d7fa344c54$exports))),
    psychic: (0, (/*@__PURE__*/$parcel$interopDefault($c30078397018fe44$exports))),
    rock: (0, (/*@__PURE__*/$parcel$interopDefault($0ccb112bfbc35d77$exports))),
    steel: (0, (/*@__PURE__*/$parcel$interopDefault($94ee052636ff3e37$exports))),
    water: (0, (/*@__PURE__*/$parcel$interopDefault($28d8c1171c898bc8$exports)))
};
// Type color mapping (matching existing CSS type badge colors)
const $af43f6d3681ca32e$var$typeColors = {
    bug: {
        bg: "#9FB93C",
        text: "#000000"
    },
    dark: {
        bg: "#3A2F6B",
        text: "#FFFFFF"
    },
    dragon: {
        bg: "#D6AF3F",
        text: "#000000"
    },
    electric: {
        bg: "#F6D64A",
        text: "#000000"
    },
    fairy: {
        bg: "#F0A8C0",
        text: "#000000"
    },
    fighting: {
        bg: "#4A3F3F",
        text: "#FFFFFF"
    },
    fire: {
        bg: "#F0802A",
        text: "#000000"
    },
    flying: {
        bg: "#7DB6D6",
        text: "#000000"
    },
    ghost: {
        bg: "#7A64A8",
        text: "#FFFFFF"
    },
    grass: {
        bg: "#6FC24A",
        text: "#000000"
    },
    ground: {
        bg: "#B0813A",
        text: "#FFFFFF"
    },
    ice: {
        bg: "#6BC7C7",
        text: "#000000"
    },
    normal: {
        bg: "#9A9AA0",
        text: "#000000"
    },
    poison: {
        bg: "#9B4AA3",
        text: "#FFFFFF"
    },
    psychic: {
        bg: "#453075",
        text: "#FFFFFF"
    },
    rock: {
        bg: "#6B5555",
        text: "#FFFFFF"
    },
    steel: {
        bg: "#C4C6DD",
        text: "#000000"
    },
    water: {
        bg: "#2B63C6",
        text: "#FFFFFF"
    }
};
/**
 * TypeBadge Component
 * @param {string} type - The Pokemon type name
 * @param {string} variant - 'full' (icon + text), 'mini' (icon only), 'circular' (small circular icon)
 * @param {string} size - 'small', 'medium', 'large' (for different icon sizes)
 */ function $af43f6d3681ca32e$var$TypeBadge({ type: type, variant: variant = "full", size: size = "medium" }) {
    const typeInfo = $af43f6d3681ca32e$var$typeColors[type.toLowerCase()];
    const icon = $af43f6d3681ca32e$var$typeIcons[type.toLowerCase()];
    if (!typeInfo || !icon) {
        console.warn(`Unknown type: ${type}`);
        return null;
    }
    const iconSizes = {
        small: "12px",
        medium: "16px",
        large: "20px"
    };
    const iconSize = iconSizes[size];
    if (variant === "circular") return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
        className: "type-badge-circular",
        style: {
            backgroundColor: typeInfo.bg,
            width: iconSize === "12px" ? "18px" : iconSize === "16px" ? "24px" : "30px",
            height: iconSize === "12px" ? "18px" : iconSize === "16px" ? "24px" : "30px",
            borderRadius: "50%",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "2px"
        },
        title: type.charAt(0).toUpperCase() + type.slice(1),
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("img", {
            src: icon,
            alt: type,
            style: {
                width: iconSize,
                height: iconSize,
                filter: typeInfo.text === "#000000" ? "brightness(0) saturate(100%) invert(0%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(0%) contrast(100%)" : "brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(100%) contrast(100%)"
            }
        })
    });
    if (variant === "mini") return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("span", {
        className: "type-badge-mini",
        style: {
            backgroundColor: typeInfo.bg,
            color: typeInfo.text,
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "4px",
            borderRadius: "6px",
            minWidth: iconSize === "12px" ? "20px" : iconSize === "16px" ? "26px" : "32px",
            height: iconSize === "12px" ? "20px" : iconSize === "16px" ? "26px" : "32px"
        },
        title: type.charAt(0).toUpperCase() + type.slice(1),
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("img", {
            src: icon,
            alt: type,
            style: {
                width: iconSize,
                height: iconSize,
                filter: typeInfo.text === "#000000" ? "brightness(0) saturate(100%) invert(0%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(0%) contrast(100%)" : "brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(100%) contrast(100%)"
            }
        })
    });
    // Full variant - icon + text
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("span", {
        className: "type-badge-full",
        style: {
            backgroundColor: typeInfo.bg,
            color: typeInfo.text,
            display: "inline-flex",
            alignItems: "center",
            gap: "4px",
            padding: "4px 8px",
            borderRadius: "8px",
            fontSize: "12px",
            fontWeight: "600",
            textTransform: "capitalize"
        },
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("img", {
                src: icon,
                alt: type,
                style: {
                    width: iconSize,
                    height: iconSize,
                    filter: typeInfo.text === "#000000" ? "brightness(0) saturate(100%) invert(0%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(0%) contrast(100%)" : "brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(100%) contrast(100%)"
                }
            }),
            type
        ]
    });
}
var $af43f6d3681ca32e$export$2e2bcd8739ae039 = $af43f6d3681ca32e$var$TypeBadge;




var $3039ba0e25b90224$exports = {};

$3039ba0e25b90224$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "pokeball.c2056cd9.svg";


var $b9132c93e7ea9065$exports = {};

$b9132c93e7ea9065$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "arrow-up.ea242b2e.svg";


// Sound Manager for Squirtle Wordle
var $42f11d58e5b1c21e$exports = {};

$42f11d58e5b1c21e$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "button-hover.14a2f169.mp3";


var $8a4b222be881f557$exports = {};

$8a4b222be881f557$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "button-click.eea41c69.mp3";


var $faba89b17a6ebea9$exports = {};

$faba89b17a6ebea9$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "button-click-2.8e976cea.mp3";


var $2efe094e448d2feb$exports = {};

$2efe094e448d2feb$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "button-click-3.01fc2c2f.mp3";


var $3c90364279c7ef16$exports = {};

$3c90364279c7ef16$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "click.2e9bd1e0.mp3";


var $3c29689430aa2e8a$exports = {};

$3c29689430aa2e8a$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "click2.cf3bd378.mp3";


var $f6c9cb32b163b047$exports = {};

$f6c9cb32b163b047$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "input-hover.0d6597e2.mp3";


var $bee39022b52dd7ba$exports = {};

$bee39022b52dd7ba$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "input-click.38b544f7.mp3";


var $ff19f1bddcb37564$exports = {};

$ff19f1bddcb37564$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "bubble-hover.0aa30f47.mp3";


var $42ebb7f3a87b4cae$exports = {};

$42ebb7f3a87b4cae$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "grid-click.da1ab500.mp3";


var $2ae944015e941279$exports = {};

$2ae944015e941279$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "slider-on.c41da418.mp3";


var $00d55ee2ae3276f4$exports = {};

$00d55ee2ae3276f4$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "slider-off.b29caee4.mp3";


var $2b6b47f0e8c92474$exports = {};

$2b6b47f0e8c92474$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "guess-success.3fd245a2.mp3";


var $cab38a4859b1dbb2$exports = {};

$cab38a4859b1dbb2$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "guess-wrong.6ac24946.mp3";


var $1cdc3d9ce7200da4$exports = {};

$1cdc3d9ce7200da4$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "guess-lost.1ec76cfe.mp3";


var $d342f8e4fda0a2e8$exports = {};

$d342f8e4fda0a2e8$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "caught-a-pokemon.89f79be1.mp3";


var $a1a7aa87a66ad568$exports = {};

$a1a7aa87a66ad568$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "pokemon-runaway.5e95afcc.mp3";


var $0c2cd5c5872dc1e7$exports = {};

$0c2cd5c5872dc1e7$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "pokedex-open-after-catch.ea87b5da.mp3";


var $a4a16d44a809789d$exports = {};

$a4a16d44a809789d$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "victory-beat.15cdfa6a.mp3";


var $ada81d753fe6678f$exports = {};

$ada81d753fe6678f$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "gameboy-sound.89da7408.mp3";


class $581e9cf8be9ecc17$var$SoundManager {
    constructor(){
        this.sounds = {
            buttonHover: new Audio((0, (/*@__PURE__*/$parcel$interopDefault($42f11d58e5b1c21e$exports)))),
            buttonClick: new Audio((0, (/*@__PURE__*/$parcel$interopDefault($8a4b222be881f557$exports)))),
            buttonClick2: new Audio((0, (/*@__PURE__*/$parcel$interopDefault($faba89b17a6ebea9$exports)))),
            buttonClick3: new Audio((0, (/*@__PURE__*/$parcel$interopDefault($2efe094e448d2feb$exports)))),
            click: new Audio((0, (/*@__PURE__*/$parcel$interopDefault($3c90364279c7ef16$exports)))),
            click2: new Audio((0, (/*@__PURE__*/$parcel$interopDefault($3c29689430aa2e8a$exports)))),
            inputHover: new Audio((0, (/*@__PURE__*/$parcel$interopDefault($f6c9cb32b163b047$exports)))),
            inputClick: new Audio((0, (/*@__PURE__*/$parcel$interopDefault($bee39022b52dd7ba$exports)))),
            bubbleHover: new Audio((0, (/*@__PURE__*/$parcel$interopDefault($ff19f1bddcb37564$exports)))),
            gridClick: new Audio((0, (/*@__PURE__*/$parcel$interopDefault($42ebb7f3a87b4cae$exports)))),
            sliderOn: new Audio((0, (/*@__PURE__*/$parcel$interopDefault($2ae944015e941279$exports)))),
            sliderOff: new Audio((0, (/*@__PURE__*/$parcel$interopDefault($00d55ee2ae3276f4$exports)))),
            guessSuccess: new Audio((0, (/*@__PURE__*/$parcel$interopDefault($2b6b47f0e8c92474$exports)))),
            guessWrong: new Audio((0, (/*@__PURE__*/$parcel$interopDefault($cab38a4859b1dbb2$exports)))),
            guessLost: new Audio((0, (/*@__PURE__*/$parcel$interopDefault($1cdc3d9ce7200da4$exports)))),
            caughtAPokemon: new Audio((0, (/*@__PURE__*/$parcel$interopDefault($d342f8e4fda0a2e8$exports)))),
            pokemonRunaway: new Audio((0, (/*@__PURE__*/$parcel$interopDefault($a1a7aa87a66ad568$exports)))),
            pokedexOpenAfterCatch: new Audio((0, (/*@__PURE__*/$parcel$interopDefault($0c2cd5c5872dc1e7$exports)))),
            victoryBeat: new Audio((0, (/*@__PURE__*/$parcel$interopDefault($a4a16d44a809789d$exports)))),
            gameboySound: new Audio((0, (/*@__PURE__*/$parcel$interopDefault($ada81d753fe6678f$exports))))
        };
        // Set volumes for better balance
        this.sounds.buttonHover.volume = 1;
        this.sounds.buttonClick.volume = 0.25;
        this.sounds.buttonClick2.volume = 0.4;
        this.sounds.buttonClick3.volume = 0.4;
        this.sounds.click.volume = 0.1;
        this.sounds.click2.volume = 0.4;
        this.sounds.inputHover.volume = 0.3;
        this.sounds.inputClick.volume = 0.35;
        this.sounds.bubbleHover.volume = 0.3;
        this.sounds.gridClick.volume = 0.3;
        this.sounds.sliderOn.volume = 0.4;
        this.sounds.sliderOff.volume = 0.4;
        this.sounds.guessSuccess.volume = 0.7;
        this.sounds.guessWrong.volume = 1;
        this.sounds.guessLost.volume = 0.25;
        this.sounds.caughtAPokemon.volume = 0.8;
        this.sounds.pokemonRunaway.volume = 0.7;
        this.sounds.pokedexOpenAfterCatch.volume = 0.6;
        this.sounds.victoryBeat.volume = 0.7;
        this.sounds.gameboySound.volume = 0.2;
        // Loop victory beat
        this.sounds.victoryBeat.loop = true;
        this.isMuted = this.loadMutedState();
        this.classicSoundsEnabled = true;
        this.currentBgMusic = null;
    }
    loadMutedState() {
        try {
            const stored = localStorage.getItem("sound-muted");
            return stored === "true";
        } catch  {
            return false;
        }
    }
    saveMutedState() {
        try {
            localStorage.setItem("sound-muted", this.isMuted.toString());
        } catch  {
        // Ignore localStorage errors
        }
    }
    toggleMute() {
        this.isMuted = !this.isMuted;
        this.saveMutedState();
        // Stop any currently playing background music if muting
        if (this.isMuted && this.currentBgMusic) this.stopBackgroundMusic();
        return this.isMuted;
    }
    setClassicSounds(enabled) {
        this.classicSoundsEnabled = enabled;
    }
    play(soundName, options = {}) {
        if (this.isMuted) return;
        const sound = this.sounds[soundName];
        if (!sound) return;
        // Stop and reset the sound
        sound.currentTime = 0;
        // Play the sound
        const playPromise = sound.play();
        // Handle play promise (some browsers require user interaction first)
        if (playPromise !== undefined) playPromise.catch((error)=>{
            // Auto-play was prevented, which is normal on first load
            console.log("Sound play prevented:", error);
        });
        return playPromise;
    }
    playSequence(soundNames, delay = 500) {
        if (this.isMuted) return;
        soundNames.forEach((soundName, index)=>{
            setTimeout(()=>{
                this.play(soundName);
            }, index * delay);
        });
    }
    playBackgroundMusic(soundName) {
        if (this.isMuted) return;
        // Stop any current background music
        this.stopBackgroundMusic();
        this.currentBgMusic = soundName;
        const sound = this.sounds[soundName];
        if (sound) {
            sound.currentTime = 0;
            const playPromise = sound.play();
            if (playPromise !== undefined) playPromise.catch((error)=>{
                console.log("Background music play prevented:", error);
            });
        }
    }
    stopBackgroundMusic() {
        if (this.currentBgMusic) {
            const sound = this.sounds[this.currentBgMusic];
            if (sound) {
                sound.pause();
                sound.currentTime = 0;
            }
            this.currentBgMusic = null;
        }
    }
    stop(soundName) {
        const sound = this.sounds[soundName];
        if (sound) {
            sound.pause();
            sound.currentTime = 0;
        }
    }
    // Convenience methods for specific game events
    playButtonHover() {
        this.play("buttonHover");
    }
    playButtonClick() {
        this.play("buttonClick");
    }
    playModalDismiss() {
        this.play("buttonClick2");
    }
    playFilterHover() {
        this.play("click");
    }
    playFilterClick() {
        this.play("click2");
    }
    playInputHover() {
        this.play("inputHover");
    }
    playInputClick() {
        this.play("inputClick");
    }
    playButtonClick3() {
        this.play("buttonClick3");
    }
    playSliderOn() {
        this.play("sliderOn");
    }
    playSliderOff() {
        this.play("sliderOff");
    }
    playBubbleHover() {
        this.play("bubbleHover");
    }
    playGridClick() {
        this.play("gridClick");
    }
    playCorrectGuess() {
        this.play("guessSuccess");
    }
    playWrongGuess() {
        this.play("guessWrong");
    }
    playGameLost() {
        this.play("guessLost");
    }
    playPokemonCaught() {
        // Only play if classic sounds are enabled
        if (this.classicSoundsEnabled) // Play after a short delay to let guess-success finish
        setTimeout(()=>{
            this.playPokemonCaughtSound();
        }, 800);
    }
    playPokemonRunaway() {
        // Play during the Pokemon shaking/fading animation (2.5s after game over)
        setTimeout(()=>{
            this.play("pokemonRunaway");
        }, 2500);
    }
    playPokemonCaughtSound() {
        // Direct sound play for when pokemon is caught, used within timeouts
        if (this.classicSoundsEnabled) this.play("caughtAPokemon");
    }
    playPokedexOpenSound() {
        // Direct sound play for when pokedex opens, used within timeouts
        if (this.classicSoundsEnabled && !this.currentBgMusic) this.play("pokedexOpenAfterCatch");
        else this.playGridClick(); // Fallback sound if pokedex open sound is not played
    }
    playPokedexOpen() {
        // Legacy method - kept for compatibility but should not set its own timeout
        // Use playPokedexOpenSound() directly in timeout callbacks instead
        if (this.classicSoundsEnabled && !this.currentBgMusic) this.play("pokedexOpenAfterCatch");
    }
    playVictoryBeat() {
        this.playBackgroundMusic("victoryBeat");
    }
    stopVictoryBeat() {
        if (this.currentBgMusic === "victoryBeat") this.stopBackgroundMusic();
    }
    playGameboySound() {
        this.play("gameboySound");
    }
}
// Create singleton instance
const $581e9cf8be9ecc17$var$soundManager = new $581e9cf8be9ecc17$var$SoundManager();
var $581e9cf8be9ecc17$export$2e2bcd8739ae039 = $581e9cf8be9ecc17$var$soundManager;


function $8a386e8a1b7f1e08$var$GuessInput({ onGuess: onGuess, gameIsOver: gameIsOver, answerLength: answerLength, pokemonTypes: pokemonTypes, isLoadingHint: isLoadingHint }) {
    const [pendingGuess, setPendingGuess] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState("");
    function handleSubmit(event) {
        event.preventDefault();
        // Only require at least one letter, allow partial guesses
        if (pendingGuess.length === 0) return; // Don't submit empty guesses
        console.log("Guess:", pendingGuess);
        setPendingGuess("");
        onGuess(pendingGuess);
    }
    function handleInputChange(e) {
        const value = e.target.value.toLocaleUpperCase().trim().slice(0, answerLength);
        setPendingGuess(value);
    }
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("form", {
        className: "guess-input-wrapper",
        onSubmit: handleSubmit,
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("label", {
                htmlFor: "guess-input",
                children: "Guess the Pok\xe9mon:"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                className: "guess-input-container",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("input", {
                        id: "guess-input",
                        type: "text",
                        value: pendingGuess,
                        autoComplete: "off",
                        autoFocus: true,
                        onChange: handleInputChange,
                        onFocus: ()=>(0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playInputClick(),
                        onMouseEnter: ()=>(0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playInputHover(),
                        pattern: `[A-Za-z]{1,${answerLength}}`,
                        disabled: gameIsOver
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("button", {
                        type: "submit",
                        className: "guess-submit-button",
                        disabled: pendingGuess.length === 0 || gameIsOver,
                        onClick: ()=>(0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playButtonClick3(),
                        onMouseEnter: ()=>(0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playBubbleHover(),
                        title: "Submit guess (or press Enter)",
                        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($b9132c93e7ea9065$exports))),
                            alt: "Submit",
                            style: {
                                width: "20px",
                                height: "20px",
                                filter: "brightness(0) invert(1)"
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                className: "type-hint",
                children: [
                    "Guess the ",
                    answerLength,
                    "-letter",
                    isLoadingHint ? /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                        className: "mini-pokeball-loader",
                        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($3039ba0e25b90224$exports))),
                            alt: "Loading...",
                            className: "mini-pokeball-icon"
                        })
                    }) : pokemonTypes && pokemonTypes.length > 0 ? /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                        className: "type-badges inline",
                        children: pokemonTypes.map((typeInfo, index)=>/*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $af43f6d3681ca32e$export$2e2bcd8739ae039), {
                                type: typeInfo.name,
                                variant: "full",
                                size: "medium"
                            }, index))
                    }) : /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("span", {
                        className: "type-badge unknown",
                        children: "unknown type"
                    }),
                    "Pok\xe9mon"
                ]
            })
        ]
    });
}
var $8a386e8a1b7f1e08$export$2e2bcd8739ae039 = $8a386e8a1b7f1e08$var$GuessInput;



parcelRequire("exYeM");
const $826109a56306c1ec$export$5c6373d26cb292a9 = 6;




function $0911cd882bc2cf2e$var$GuessDisplay({ guesses: guesses, answerLength: answerLength }) {
    function getDescForLetterStatus(status) {
        switch(status){
            case "correct":
                return "Nailed it.";
            case "misplaced":
                return "Right letter, wrong spot.";
            case "incorrect":
                return "Not in the word.";
            default:
                return "";
        }
    }
    // Use the actual answer length if provided, otherwise default to 5
    const wordLength = answerLength || 5;
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
        className: "guess-results",
        children: (0, $f6745ab07405201d$export$d02631cccf789723)(0, (0, $826109a56306c1ec$export$5c6373d26cb292a9)).map((index)=>{
            const guess = guesses[index];
            return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("p", {
                className: "guess",
                children: (0, $f6745ab07405201d$export$d02631cccf789723)(0, wordLength).map((i)=>{
                    const letter = guess?.letters[i];
                    const helpText = letter ? getDescForLetterStatus(letter.status) : "";
                    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("span", {
                        title: helpText,
                        className: `cell ${letter?.status}`,
                        onMouseEnter: ()=>(0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playButtonHover(),
                        children: letter?.letter || ""
                    }, i);
                })
            }, index);
        })
    });
}
var $0911cd882bc2cf2e$export$2e2bcd8739ae039 = $0911cd882bc2cf2e$var$GuessDisplay;




var $exYeM = parcelRequire("exYeM");
var $a31fa635851c5725$exports = {};

$a31fa635851c5725$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "refresh.e075aec8.svg";



var $7b7f4dfe5a1966b6$exports = {};

$7b7f4dfe5a1966b6$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "pokeball-open.ac59824d.svg";



function $c247978c49877e21$var$GameResult({ answer: answer, gameIsWon: gameIsWon, guessCount: guessCount, reset: reset, pokemonId: pokemonId, pokemonName: pokemonName, isNewDiscovery: isNewDiscovery, onOpenPokedex: onOpenPokedex, onClose: onClose, catchCount: catchCount }, ref) {
    const [animationKey, setAnimationKey] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(0);
    const [pokemonCry, setPokemonCry] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(null);
    const [isLoadingCry, setIsLoadingCry] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(false);
    const playAgainButtonRef = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useRef(null);
    // Expose focus method via ref so parent can restore focus when Pokedex closes
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useImperativeHandle(ref, ()=>({
            focus: ()=>{
                playAgainButtonRef.current?.focus();
            }
        }));
    // Auto-focus play again button when result is shown
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(()=>{
        playAgainButtonRef.current?.focus();
    }, []);
    // Handle Enter key press to play again
    const handleKeyPress = (e)=>{
        if (e.key === "Enter" && playAgainButtonRef.current === document.activeElement) {
            e.preventDefault();
            (0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playButtonClick3();
            reset();
        }
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(()=>{
        window.addEventListener("keydown", handleKeyPress);
        return ()=>{
            window.removeEventListener("keydown", handleKeyPress);
        };
    }, [
        reset
    ]);
    const handlePokeballClick = ()=>{
        (0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playButtonClick3();
        setAnimationKey((prev)=>prev + 1);
    };
    // Function to fetch and cache Pokemon cry
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(()=>{
        if (pokemonId) fetchPokemonCry(pokemonId);
        else {
            // Clean up audio when no Pokemon ID
            if (pokemonCry) {
                pokemonCry.pause();
                pokemonCry.src = "";
                pokemonCry.load();
            }
            setPokemonCry(null);
            setIsLoadingCry(false);
        }
        // Cleanup function
        return ()=>{
            if (pokemonCry) {
                pokemonCry.pause();
                pokemonCry.src = "";
                pokemonCry.load();
            }
        };
    }, [
        pokemonId
    ]);
    const fetchPokemonCry = async (id)=>{
        if (isLoadingCry) return; // Don't fetch if already loading
        // Clean up previous audio
        if (pokemonCry) {
            pokemonCry.pause();
            pokemonCry.src = "";
            pokemonCry.load();
        }
        setIsLoadingCry(true);
        setPokemonCry(null);
        try {
            const cryUrl = `https://raw.githubusercontent.com/PokeAPI/cries/main/cries/pokemon/latest/${id}.ogg`;
            const audio = new Audio();
            audio.crossOrigin = "anonymous";
            audio.preload = "auto";
            audio.volume = 0.2; // Set Pokemon cry volume to 50%
            // Wait for audio to be ready
            await new Promise((resolve, reject)=>{
                const timeout = setTimeout(()=>{
                    reject(new Error("Audio load timeout"));
                }, 5000);
                const cleanup = ()=>{
                    clearTimeout(timeout);
                    audio.removeEventListener("canplaythrough", onLoad);
                    audio.removeEventListener("loadeddata", onLoad);
                    audio.removeEventListener("error", onError);
                };
                const onLoad = ()=>{
                    cleanup();
                    resolve();
                };
                const onError = (e)=>{
                    cleanup();
                    reject(new Error(`Audio load failed: ${e.type}`));
                };
                audio.addEventListener("canplaythrough", onLoad, {
                    once: true
                });
                audio.addEventListener("loadeddata", onLoad, {
                    once: true
                });
                audio.addEventListener("error", onError, {
                    once: true
                });
                // Set source after event listeners are attached
                audio.src = cryUrl;
            });
            setPokemonCry(audio);
        } catch (error) {
            console.warn(`Failed to load Pokemon cry for ID ${id}:`, error);
            setPokemonCry(null);
        } finally{
            setIsLoadingCry(false);
        }
    };
    const handlePokemonImageClick = ()=>{
        if (pokemonCry && !isLoadingCry) {
            // Reset audio to beginning and play
            pokemonCry.currentTime = 0;
            pokemonCry.play().catch((error)=>{
                console.warn("Failed to play Pokemon cry:", error);
            });
        }
    };
    const getPokemonImageTitle = ()=>{
        if (isLoadingCry) return "Loading Pok\xe9mon cry...";
        if (pokemonCry) return "Click to hear this Pok\xe9mon's cry!";
        return "Pok\xe9mon cry unavailable";
    };
    if (gameIsWon) return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
        className: "happy banner",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("button", {
                className: "close-banner-button",
                onClick: ()=>{
                    (0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playModalDismiss();
                    onClose();
                },
                onMouseEnter: ()=>(0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playBubbleHover(),
                children: "\xd7"
            }),
            pokemonId && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("img", {
                src: `https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/dream-world/${pokemonId}.svg`,
                alt: answer,
                className: `pokemon-result-image ${pokemonCry && !isLoadingCry ? "clickable-pokemon" : ""}`,
                onClick: handlePokemonImageClick,
                title: getPokemonImageTitle(),
                style: {
                    cursor: pokemonCry && !isLoadingCry ? "pointer" : "default"
                }
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                className: "caught-message-container",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                        className: "pokeball-wrapper success",
                        title: "Click to play pokeball animation again",
                        onClick: handlePokeballClick,
                        onMouseEnter: ()=>(0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playBubbleHover(),
                        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                            className: "pokeball-animation-container",
                            children: [
                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($3039ba0e25b90224$exports))),
                                    alt: "Pokeball",
                                    className: "pokeball-catch-animation"
                                }),
                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                    className: "pokeball-catch-circle"
                                }),
                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("svg", {
                                    className: "pokeball-checkmark",
                                    width: "8",
                                    height: "8",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "white",
                                    strokeWidth: "4",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("polyline", {
                                        points: "20,6 9,17 4,12"
                                    })
                                })
                            ]
                        }, `success-${animationKey}`)
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("p", {
                        className: "caught-pokemon-message",
                        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("strong", {
                            children: [
                                "You caught a ",
                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("span", {
                                    className: "results-pokemon-name",
                                    children: pokemonName || answer
                                }),
                                " in ",
                                guessCount,
                                " guess",
                                guessCount !== 1 ? "es" : "",
                                "!"
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("p", {
                className: "pokedex-link-message",
                children: [
                    catchCount > 1 && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("span", {
                        children: [
                            "You've caught ",
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("span", {
                                className: "results-pokemon-name",
                                children: pokemonName || answer
                            }),
                            " ",
                            catchCount,
                            " times."
                        ]
                    }),
                    " ",
                    isNewDiscovery ? "It's been added to your" : "View it in your",
                    " ",
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("button", {
                        className: "pokedex-link",
                        onClick: ()=>{
                            (0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playGridClick();
                            onOpenPokedex && onOpenPokedex(pokemonId);
                        },
                        onMouseEnter: ()=>(0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playBubbleHover(),
                        type: "button",
                        children: "pok\xe9dex"
                    }),
                    "."
                ]
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("button", {
                className: "play-again-button",
                ref: playAgainButtonRef,
                onClick: reset,
                onMouseEnter: ()=>(0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playBubbleHover(),
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($a31fa635851c5725$exports))),
                        alt: "Refresh",
                        style: {
                            width: "16px",
                            height: "16px",
                            marginRight: "8px"
                        }
                    }),
                    "Play again"
                ]
            })
        ]
    });
    else return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
        className: "sad banner",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("button", {
                className: "close-banner-button",
                onClick: ()=>{
                    (0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playModalDismiss();
                    onClose();
                },
                onMouseEnter: ()=>(0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playBubbleHover(),
                children: "\xd7"
            }),
            pokemonId && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("img", {
                src: `https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/dream-world/${pokemonId}.svg`,
                alt: answer,
                className: `pokemon-result-image sad-pokemon-image ${pokemonCry && !isLoadingCry ? "clickable-pokemon" : ""}`,
                onClick: handlePokemonImageClick,
                title: getPokemonImageTitle(),
                style: {
                    cursor: pokemonCry && !isLoadingCry ? "pointer" : "default"
                }
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                className: "failed-message-container",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                        className: "pokeball-wrapper failure",
                        title: "Click to play pokeball animation again",
                        onClick: handlePokeballClick,
                        onMouseEnter: ()=>(0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playBubbleHover(),
                        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                            className: "pokeball-animation-container",
                            children: [
                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($3039ba0e25b90224$exports))),
                                    alt: "Pokeball",
                                    className: "pokeball-fail-animation"
                                }),
                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($7b7f4dfe5a1966b6$exports))),
                                    alt: "Open Pokeball",
                                    className: "pokeball-open-animation"
                                }),
                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                    className: "pokeball-explosion-ring"
                                })
                            ]
                        }, `fail-${animationKey}`)
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("p", {
                        children: [
                            "Sorry, the correct answer is ",
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("strong", {
                                children: answer
                            }),
                            "."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("button", {
                className: "play-again-button",
                ref: playAgainButtonRef,
                onClick: reset,
                onMouseEnter: ()=>(0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playBubbleHover(),
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($a31fa635851c5725$exports))),
                        alt: "Refresh",
                        style: {
                            width: "16px",
                            height: "16px",
                            marginRight: "8px"
                        }
                    }),
                    "Play again"
                ]
            })
        ]
    });
}
var $c247978c49877e21$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).forwardRef($c247978c49877e21$var$GameResult);


/**
 * Thanks to Github user dylano for supplying a more-accurate
 * solving algorithm!
 */ function $79752a1afa028072$export$6e90f449c7e09a62(guess, answer) {
    // This constant is a placeholder that indicates we've successfully
    // dealt with this character (it's correct, or misplaced).
    const SOLVED_CHAR = "\u2713";
    if (!guess) return null;
    const guessChars = guess.toUpperCase().split("");
    const answerChars = answer.split("");
    const result = [];
    // Step 1: Look for correct letters.
    for(let i = 0; i < guessChars.length; i++)if (guessChars[i] === answerChars[i]) {
        result[i] = {
            letter: guessChars[i],
            status: "correct"
        };
        answerChars[i] = SOLVED_CHAR;
        guessChars[i] = SOLVED_CHAR;
    }
    // Step 2: look for misplaced letters. If it's not misplaced,
    // it must be incorrect.
    for(let i = 0; i < guessChars.length; i++){
        if (guessChars[i] === SOLVED_CHAR) continue;
        let status = "incorrect";
        const misplacedIndex = answerChars.findIndex((char)=>char === guessChars[i]);
        if (misplacedIndex >= 0) {
            status = "misplaced";
            answerChars[misplacedIndex] = SOLVED_CHAR;
        }
        result[i] = {
            letter: guessChars[i],
            status: status
        };
    }
    return result;
}





// Cache for Pokemon data
let $b60d5ef55411eecc$var$cachedPokemon = null;
async function $b60d5ef55411eecc$var$fetchPokemonList() {
    if ($b60d5ef55411eecc$var$cachedPokemon) return $b60d5ef55411eecc$var$cachedPokemon;
    // Check localStorage cache first
    const CACHE_KEY = "pokemon-list-cache";
    const CACHE_DURATION = 86400000; // 24 hours in milliseconds
    try {
        const cachedData = localStorage.getItem(CACHE_KEY);
        if (cachedData) {
            const { data: data, timestamp: timestamp } = JSON.parse(cachedData);
            const now = Date.now();
            // Check if cache is still valid (less than 24 hours old)
            if (now - timestamp < CACHE_DURATION) {
                // Check if the cached data has the expected structure with types
                if (data && data.length > 0 && data[0].types) {
                    $b60d5ef55411eecc$var$cachedPokemon = data;
                    return data;
                } else {
                    // Old cache format detected, clear it
                    console.log("Old cache format detected, clearing cache for compatibility...");
                    localStorage.removeItem(CACHE_KEY);
                    // Also clear the old types cache to start fresh
                    localStorage.removeItem("pokemon-types-cache");
                }
            }
        }
    } catch (error) {
        console.warn("Failed to read from localStorage cache:", error);
        // Clear potentially corrupted cache
        localStorage.removeItem(CACHE_KEY);
        localStorage.removeItem("pokemon-types-cache");
    }
    // Cache is empty or expired, fetch from API
    try {
        const response = await fetch("https://pokeapi.co/api/v2/pokemon-species?limit=151");
        const data = await response.json();
        // Extract basic Pokemon data
        const pokemonBasicData = data.results.map((pokemon, index)=>({
                name: pokemon.name.toUpperCase().replace("-", ""),
                originalName: pokemon.name,
                id: index + 1 // Pokemon IDs are 1-indexed
            }));
        // Try to get existing types from the old cache
        const oldTypesCache = localStorage.getItem("pokemon-types-cache");
        let existingTypes = {};
        if (oldTypesCache) try {
            const { data: typesData } = JSON.parse(oldTypesCache);
            existingTypes = typesData || {};
        } catch (error) {
            console.warn("Failed to parse existing types cache:", error);
        }
        // Fetch types for Pokemon that don't have cached types
        const pokemonData = await Promise.all(pokemonBasicData.map(async (pokemon)=>{
            let types = existingTypes[pokemon.id];
            if (!types) // Fetch types for this Pokemon
            try {
                const typeResponse = await fetch(`https://pokeapi.co/api/v2/pokemon/${pokemon.id}`);
                const typeData = await typeResponse.json();
                types = typeData.types.map((typeInfo)=>({
                        name: typeInfo.type.name,
                        slot: typeInfo.slot
                    }));
                // Add a small delay to avoid overwhelming the API
                await new Promise((resolve)=>setTimeout(resolve, 50));
            } catch (error) {
                console.warn(`Failed to fetch types for ${pokemon.name}:`, error);
                types = [
                    {
                        name: "normal",
                        slot: 1
                    }
                ]; // fallback
            }
            return {
                ...pokemon,
                types: types
            };
        }));
        // Cache the complete data with timestamp
        try {
            const cacheData = {
                data: pokemonData,
                timestamp: Date.now()
            };
            localStorage.setItem(CACHE_KEY, JSON.stringify(cacheData));
            // Also update the types cache with the new data
            const typesCache = {
                data: pokemonData.reduce((acc, pokemon)=>{
                    acc[pokemon.id] = pokemon.types;
                    return acc;
                }, {}),
                timestamp: Date.now()
            };
            localStorage.setItem("pokemon-types-cache", JSON.stringify(typesCache));
        } catch (error) {
            console.warn("Failed to save to localStorage cache:", error);
        }
        $b60d5ef55411eecc$var$cachedPokemon = pokemonData;
        return pokemonData;
    } catch (error) {
        console.error("Failed to fetch Pokemon:", error);
        // Fallback to some hardcoded Pokemon names
        $b60d5ef55411eecc$var$cachedPokemon = [
            {
                name: "PIKACHU",
                originalName: "pikachu",
                id: 25,
                types: [
                    {
                        name: "electric",
                        slot: 1
                    }
                ]
            },
            {
                name: "CHARIZARD",
                originalName: "charizard",
                id: 6,
                types: [
                    {
                        name: "fire",
                        slot: 1
                    },
                    {
                        name: "flying",
                        slot: 2
                    }
                ]
            },
            {
                name: "BLASTOISE",
                originalName: "blastoise",
                id: 9,
                types: [
                    {
                        name: "water",
                        slot: 1
                    }
                ]
            },
            {
                name: "VENUSAUR",
                originalName: "venusaur",
                id: 3,
                types: [
                    {
                        name: "grass",
                        slot: 1
                    },
                    {
                        name: "poison",
                        slot: 2
                    }
                ]
            }
        ];
        return $b60d5ef55411eecc$var$cachedPokemon;
    }
}
async function $b60d5ef55411eecc$var$fetchPokemonTypes(pokemonId, originalName) {
    const CACHE_KEY = "pokemon-types-cache";
    const CACHE_DURATION = 86400000; // 24 hours
    try {
        // Check if we already have cached types for this Pokemon
        const cachedTypes = localStorage.getItem(CACHE_KEY);
        if (cachedTypes) {
            const { data: data, timestamp: timestamp } = JSON.parse(cachedTypes);
            const now = Date.now();
            if (now - timestamp < CACHE_DURATION && data[pokemonId]) return data[pokemonId];
        }
        // Fetch types from API
        const response = await fetch(`https://pokeapi.co/api/v2/pokemon/${pokemonId}`);
        const data = await response.json();
        const types = data.types.map((typeInfo)=>({
                name: typeInfo.type.name,
                slot: typeInfo.slot
            }));
        // Update cache
        try {
            const existingCache = JSON.parse(localStorage.getItem(CACHE_KEY) || "{}");
            const cacheData = {
                data: {
                    ...existingCache.data,
                    [pokemonId]: types
                },
                timestamp: Date.now()
            };
            localStorage.setItem(CACHE_KEY, JSON.stringify(cacheData));
        } catch (error) {
            console.warn("Failed to save types to cache:", error);
        }
        return types;
    } catch (error) {
        console.error(`Failed to fetch types for ${originalName}:`, error);
        return [
            {
                name: "normal",
                slot: 1
            }
        ]; // fallback
    }
}
async function $b60d5ef55411eecc$var$fetchPokemonDescription(originalName) {
    try {
        const response = await fetch(`https://pokeapi.co/api/v2/pokemon-species/${originalName}/`);
        const data = await response.json();
        // Get the first English flavor text entry
        if (data.flavor_text_entries && data.flavor_text_entries.length > 0) {
            const englishEntry = data.flavor_text_entries.find((entry)=>entry.language.name === "en");
            if (englishEntry) // Clean up the text (remove form feeds and newlines, normalize spacing)
            return englishEntry.flavor_text.replace(/\f/g, " ").replace(/\n/g, " ").replace(/\s+/g, " ").trim();
        }
        return "A mysterious Pokemon.";
    } catch (error) {
        console.error("Failed to fetch Pokemon description:", error);
        return "A mysterious Pokemon.";
    }
}
// Helper function to get all unique types from the Pokemon list
function $b60d5ef55411eecc$export$cd75e89a26d85a6e(pokemonList) {
    const typesSet = new Set();
    pokemonList.forEach((pokemon)=>{
        if (pokemon.types) pokemon.types.forEach((typeInfo)=>{
            typesSet.add(typeInfo.name);
        });
    });
    return Array.from(typesSet).sort();
}
const $b60d5ef55411eecc$var$Game = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).forwardRef(function Game({ onPokemonDiscovered: onPokemonDiscovered, onPokemonListLoaded: onPokemonListLoaded, onOpenPokedex: onOpenPokedex, gameResultRef: gameResultRef, settings: settings }, ref) {
    const [pokemonList, setPokemonList] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState([]);
    const [answer, setAnswer] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState("");
    const [currentPokemon, setCurrentPokemon] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(null);
    const [pokemonTypes, setPokemonTypes] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState([]);
    const [pokemonDescription, setPokemonDescription] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState("");
    const [guesses, setGuesses] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState([]);
    const [gameIsOver, setGameIsOver] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(false);
    const [gameIsWon, setGameIsWon] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(false);
    const [isLoading, setIsLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(true);
    const [isLoadingHint, setIsLoadingHint] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(false);
    const [isNewDiscovery, setIsNewDiscovery] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(false);
    const [catchCount, setCatchCount] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(0);
    const [showBanner, setShowBanner] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(true);
    const [consecutiveRepeats, setConsecutiveRepeats] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(0);
    const pokedexTimeoutRef = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useRef(null);
    // Function to select a new Pokemon and get its description
    async function selectNewPokemon(pokemonList) {
        const discoveredPokemon = JSON.parse(localStorage.getItem("discovered-pokemon") || "[]");
        let selectedPokemon;
        // SPECIAL CASE: Force Pikachu (#25) as the first Pokemon for new players
        if (discoveredPokemon.length === 0) {
            selectedPokemon = pokemonList.find((pokemon)=>pokemon.id === 25); // Pikachu
            if (!selectedPokemon) // Fallback if Pikachu not found in list
            selectedPokemon = (0, $f6745ab07405201d$export$4812e460280c6ef2)(pokemonList);
        } else if (settings?.noRepeatPokemon) {
            const uncaughtPokemon = pokemonList.filter((pokemon)=>!discoveredPokemon.includes(pokemon.id));
            if (uncaughtPokemon.length > 0) selectedPokemon = (0, $f6745ab07405201d$export$4812e460280c6ef2)(uncaughtPokemon);
            else // If all Pokemon are caught and no repeat is on, just pick randomly
            selectedPokemon = (0, $f6745ab07405201d$export$4812e460280c6ef2)(pokemonList);
        } else if (consecutiveRepeats >= 3) {
            const uncaughtPokemon = pokemonList.filter((pokemon)=>!discoveredPokemon.includes(pokemon.id));
            if (uncaughtPokemon.length > 0) selectedPokemon = (0, $f6745ab07405201d$export$4812e460280c6ef2)(uncaughtPokemon);
            else // Fallback if all Pokemon are caught
            selectedPokemon = (0, $f6745ab07405201d$export$4812e460280c6ef2)(pokemonList);
        } else selectedPokemon = (0, $f6745ab07405201d$export$4812e460280c6ef2)(pokemonList);
        setCurrentPokemon(selectedPokemon);
        setAnswer(selectedPokemon.name);
        // Check if this Pokemon was previously caught
        const isPreviouslyCaught = discoveredPokemon.includes(selectedPokemon.id);
        // Update consecutive repeat counter (only when no-repeat is disabled)
        if (!settings?.noRepeatPokemon) {
            if (isPreviouslyCaught) setConsecutiveRepeats((prev)=>prev + 1);
            else setConsecutiveRepeats(0); // Reset counter when we get a new Pokemon
        } else setConsecutiveRepeats(0); // Always reset when no-repeat is enabled
        // Load current catch count for this Pokemon
        const catchCounts = JSON.parse(localStorage.getItem("pokemon-catch-counts") || "{}");
        let currentCount = catchCounts[selectedPokemon.id] || 0;
        // If Pokemon has been discovered but no count exists, default to 1
        if (currentCount === 0 && isPreviouslyCaught) currentCount = 1;
        setCatchCount(currentCount);
        // Fetch the description
        const description = await $b60d5ef55411eecc$var$fetchPokemonDescription(selectedPokemon.originalName);
        setPokemonDescription(description);
        // Fetch types for the selected Pokemon
        setIsLoadingHint(true);
        const types = await $b60d5ef55411eecc$var$fetchPokemonTypes(selectedPokemon.id, selectedPokemon.originalName);
        setPokemonTypes(types);
        setIsLoadingHint(false);
    }
    // Load Pokemon data on component mount
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(()=>{
        async function loadPokemon() {
            setIsLoading(true);
            const pokemon = await $b60d5ef55411eecc$var$fetchPokemonList();
            setPokemonList(pokemon);
            if (onPokemonListLoaded) onPokemonListLoaded(pokemon);
            await selectNewPokemon(pokemon);
            setIsLoading(false);
        }
        loadPokemon();
    }, []); // Empty dependency array to only run on mount
    // Update sound manager when settings change
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(()=>{
        if (settings) (0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).setClassicSounds(settings.classicSounds);
    }, [
        settings?.classicSounds
    ]);
    console.info("answer:", answer);
    // Expose handleNewGuess to parent component
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useImperativeHandle(ref, ()=>({
            submitGuess: (guess)=>{
                if (!gameIsOver) handleNewGuess(guess.toUpperCase());
            },
            isGameActive: !gameIsOver
        }));
    function handleNewGuess(newGuess) {
        const letters = (0, $79752a1afa028072$export$6e90f449c7e09a62)(newGuess, answer);
        const newGuesses = [
            ...guesses,
            {
                id: crypto.randomUUID(),
                word: newGuess,
                letters: letters
            }
        ];
        setGuesses(newGuesses);
        if (newGuess === answer) {
            (0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playCorrectGuess();
            setGameIsOver(true);
            setGameIsWon(true);
            if (currentPokemon) {
                // Check if this was a single guess (first try)
                const wasSingleGuess = newGuesses.length === 1;
                // Get current catch counts
                const catchCounts = JSON.parse(localStorage.getItem("pokemon-catch-counts") || "{}");
                const currentCount = catchCounts[currentPokemon.id] || 0;
                const newCount = currentCount + 1;
                // Update catch count
                catchCounts[currentPokemon.id] = newCount;
                localStorage.setItem("pokemon-catch-counts", JSON.stringify(catchCounts));
                setCatchCount(newCount);
                // Play pokemon caught sound
                (0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playPokemonCaught();
                // Check if this is a new discovery
                const discoveredPokemon = JSON.parse(localStorage.getItem("discovered-pokemon") || "[]");
                const wasAlreadyDiscovered = discoveredPokemon.includes(currentPokemon.id);
                setIsNewDiscovery(!wasAlreadyDiscovered);
                if (onPokemonDiscovered) onPokemonDiscovered(currentPokemon.id, wasSingleGuess);
                // Auto-open Pokedex for new discoveries after 3 seconds (if setting is enabled)
                if (!wasAlreadyDiscovered && onOpenPokedex && settings?.autoOpenPokedex) pokedexTimeoutRef.current = setTimeout(()=>{
                    onOpenPokedex(currentPokemon.id);
                    // Only play sound when pokedex actually opens automatically
                    (0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playPokedexOpenSound();
                }, 3000); // Wait 3 seconds to let user read the success message
            }
        } else if (newGuesses.length >= 6) {
            (0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playGameLost();
            (0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playPokemonRunaway();
            setGameIsOver(true);
        } else (0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playWrongGuess();
    }
    function resetGame() {
        (0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playButtonClick();
        // Cancel pending Pokedex auto-open
        if (pokedexTimeoutRef.current) {
            clearTimeout(pokedexTimeoutRef.current);
            pokedexTimeoutRef.current = null;
        }
        if (pokemonList.length > 0) {
            selectNewPokemon(pokemonList);
            setGuesses([]);
            setGameIsOver(false);
            setGameIsWon(false);
            setIsNewDiscovery(false);
            setCatchCount(0);
            setShowBanner(true);
            setConsecutiveRepeats(0); // Reset consecutive repeat counter
        }
    }
    function closeBanner() {
        // Cancel pending Pokedex auto-open when banner is dismissed
        if (pokedexTimeoutRef.current) {
            clearTimeout(pokedexTimeoutRef.current);
            pokedexTimeoutRef.current = null;
        }
        setShowBanner(false);
    }
    if (isLoading) return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
        className: "pokeball-loader",
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($3039ba0e25b90224$exports))),
            alt: "Loading...",
            className: "pokeball-icon"
        })
    });
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $7ead0b1397a835ed$exports.Fragment), {
        children: [
            pokemonDescription && !settings?.hideHints && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                className: "pokemon-hint",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("strong", {
                        children: "Hint:"
                    }),
                    " ",
                    pokemonDescription
                ]
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $0911cd882bc2cf2e$export$2e2bcd8739ae039), {
                guesses: guesses,
                answerLength: answer.length
            }),
            gameIsOver && showBanner && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $c247978c49877e21$export$2e2bcd8739ae039), {
                ref: gameResultRef,
                answer: answer,
                gameIsWon: gameIsWon,
                guessCount: guesses.length,
                reset: resetGame,
                onClose: closeBanner,
                pokemonId: currentPokemon?.id,
                pokemonName: currentPokemon?.originalName,
                isNewDiscovery: isNewDiscovery,
                onOpenPokedex: onOpenPokedex,
                catchCount: catchCount
            }),
            gameIsOver ? /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                className: "play-again-container",
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("button", {
                    className: "primary-button",
                    onClick: resetGame,
                    onMouseEnter: ()=>(0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playBubbleHover(),
                    children: [
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($a31fa635851c5725$exports))),
                            alt: "Refresh",
                            width: "16",
                            height: "16"
                        }),
                        "Play Again"
                    ]
                })
            }) : /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $8a386e8a1b7f1e08$export$2e2bcd8739ae039), {
                onGuess: handleNewGuess,
                gameIsOver: gameIsOver,
                answerLength: answer.length,
                pokemonTypes: pokemonTypes,
                isLoadingHint: isLoadingHint
            })
        ]
    });
});
var $b60d5ef55411eecc$export$2e2bcd8739ae039 = $b60d5ef55411eecc$var$Game;






var $exYeM = parcelRequire("exYeM");
var $01d561f4096516ea$exports = {};

$01d561f4096516ea$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "squirtle.4e7ed10d.png";


var $85426c462a45faf7$exports = {};

$85426c462a45faf7$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "trainer-scene.60272a68.png";




var $e2060fc363c9de60$exports = {};

$e2060fc363c9de60$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "elip.7f2a179d.svg";


var $acfd74b1b78aba4b$exports = {};

$acfd74b1b78aba4b$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "info.ea2676ac.svg";


var $ffad1067c3552705$exports = {};

$ffad1067c3552705$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "cog.e66e805e.svg";


var $3c2e7a25617d6f35$exports = {};

$3c2e7a25617d6f35$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "external-link.703a97ab.svg";


var $dbc67147a1487b0d$exports = {};

$dbc67147a1487b0d$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "volume-on.05b0e7db.svg";


var $ea763808cdbc8a03$exports = {};

$ea763808cdbc8a03$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "volume-mute.066deb5c.svg";



function $ce2bbf7743ae7f98$var$Header({ onReset: onReset, onOpenPokedex: onOpenPokedex, discoveredCount: discoveredCount, totalCount: totalCount, isMaster: isMaster, isLegend: isLegend, trophyIcon: trophyIcon }) {
    const [showMoreDropdown, setShowMoreDropdown] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(false);
    const [showAboutModal, setShowAboutModal] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(false);
    const [showCreditsScreen, setShowCreditsScreen] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(false);
    const [showSettingsModal, setShowSettingsModal] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(false);
    const [showConfirmModal, setShowConfirmModal] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(false);
    const [isMuted, setIsMuted] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState((0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).isMuted);
    const [settings, setSettings] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(()=>{
        try {
            const stored = localStorage.getItem("squirtle-wordle-settings");
            return stored ? JSON.parse(stored) : {
                hideHints: false,
                noRepeatPokemon: false,
                classicSounds: true,
                autoOpenPokedex: true
            };
        } catch  {
            return {
                hideHints: false,
                noRepeatPokemon: false,
                classicSounds: true,
                autoOpenPokedex: true
            };
        }
    });
    const handlePokedexClick = (event)=>{
        event.preventDefault();
        (0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playButtonClick();
        if (onOpenPokedex) onOpenPokedex();
    };
    const handleResetClick = (event)=>{
        event.preventDefault();
        (0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playButtonClick();
        if (onReset) onReset();
    };
    const handleMoreClick = (event)=>{
        event.preventDefault();
        event.stopPropagation();
        (0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playButtonClick();
        setShowMoreDropdown(!showMoreDropdown);
    };
    const handleVolumeClick = (event)=>{
        event.preventDefault();
        const newMutedState = (0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).toggleMute();
        setIsMuted(newMutedState);
        // Play click sound if we just unmuted
        if (!newMutedState) (0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playButtonClick();
    };
    const handleAboutClick = ()=>{
        (0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playButtonClick();
        (0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playGameboySound();
        setShowMoreDropdown(false);
        setShowAboutModal(true);
    };
    const handleSettingsClick = ()=>{
        (0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playButtonClick();
        setShowMoreDropdown(false);
        setShowSettingsModal(true);
    };
    const handleSettingToggle = (key)=>{
        const newValue = !settings[key];
        // Play appropriate slider sound based on whether turning on or off
        if (newValue) (0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playSliderOn();
        else (0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playSliderOff();
        const newSettings = {
            ...settings,
            [key]: newValue
        };
        setSettings(newSettings);
        localStorage.setItem("squirtle-wordle-settings", JSON.stringify(newSettings));
        // Dispatch custom event to notify other components
        window.dispatchEvent(new CustomEvent("settingsChanged", {
            detail: newSettings
        }));
    };
    const handleClearData = ()=>{
        (0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playButtonClick();
        setShowSettingsModal(false);
        setShowConfirmModal(true);
    };
    const handleConfirmClear = ()=>{
        (0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playButtonClick();
        localStorage.removeItem("discovered-pokemon");
        localStorage.removeItem("single-guess-pokemon");
        localStorage.removeItem("pokemon-catch-counts");
        // Keep settings: localStorage.removeItem('squirtle-wordle-settings');
        setShowConfirmModal(false);
        window.location.reload();
    };
    // Close dropdown when clicking outside
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(()=>{
        const handleClickOutside = (event)=>{
            if (!event.target.closest(".more-menu-container")) setShowMoreDropdown(false);
        };
        if (showMoreDropdown) {
            document.addEventListener("click", handleClickOutside);
            return ()=>document.removeEventListener("click", handleClickOutside);
        }
    }, [
        showMoreDropdown
    ]);
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("header", {
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                className: "side"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("h1", {
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($01d561f4096516ea$exports))),
                        alt: "Squirtle"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("span", {
                        className: "app-name",
                        children: "Squirtle Wordle"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                        className: "header-buttons",
                        children: [
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                className: "pokemon-count",
                                title: isLegend ? "Pokemon Legend. Guessed all 151 with 1 guess." : `You've caught ${discoveredCount} out of ${totalCount} Pok\xe9mon`,
                                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("span", {
                                    className: isMaster ? "header-trophy" : "",
                                    style: isLegend ? {
                                        background: "linear-gradient(135deg, #fbbf24, #f59e0b)",
                                        color: "white"
                                    } : {},
                                    children: [
                                        discoveredCount,
                                        "/",
                                        totalCount,
                                        isMaster && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("img", {
                                            src: trophyIcon,
                                            alt: "Pok\xe9mon Master",
                                            className: "trophy-icon"
                                        })
                                    ]
                                })
                            }),
                            onOpenPokedex && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("button", {
                                type: "button",
                                className: "pokedex-button",
                                onClick: handlePokedexClick,
                                onMouseEnter: ()=>(0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playButtonHover(),
                                children: [
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($3039ba0e25b90224$exports))),
                                        alt: "Open Pok\xe9dex"
                                    }),
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                        className: "tooltip",
                                        children: "Open Pok\xe9dex"
                                    })
                                ]
                            }),
                            onReset && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("button", {
                                type: "button",
                                className: "reset-button",
                                onClick: handleResetClick,
                                onMouseEnter: ()=>(0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playButtonHover(),
                                children: [
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($a31fa635851c5725$exports))),
                                        alt: "Reset game"
                                    }),
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                        className: "tooltip",
                                        children: "Guess a different Pokemon"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("button", {
                                type: "button",
                                className: "volume-button",
                                onClick: handleVolumeClick,
                                onMouseEnter: ()=>(0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playButtonHover(),
                                children: [
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("img", {
                                        src: isMuted ? (0, (/*@__PURE__*/$parcel$interopDefault($ea763808cdbc8a03$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($dbc67147a1487b0d$exports))),
                                        alt: isMuted ? "Unmute sounds" : "Mute sounds"
                                    }),
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                        className: "tooltip",
                                        children: isMuted ? "Unmute sounds" : "Mute sounds"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                                className: "more-menu-container",
                                children: [
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("button", {
                                        type: "button",
                                        className: "more-button",
                                        onClick: handleMoreClick,
                                        onMouseEnter: ()=>(0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playButtonHover(),
                                        children: [
                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("img", {
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($e2060fc363c9de60$exports))),
                                                alt: "More options"
                                            }),
                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                                className: "tooltip",
                                                children: "More..."
                                            })
                                        ]
                                    }),
                                    showMoreDropdown && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                                        className: "more-dropdown",
                                        children: [
                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("button", {
                                                onClick: handleAboutClick,
                                                onMouseEnter: ()=>(0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playButtonHover(),
                                                children: [
                                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("img", {
                                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($acfd74b1b78aba4b$exports))),
                                                        alt: ""
                                                    }),
                                                    "About"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("button", {
                                                onClick: handleSettingsClick,
                                                onMouseEnter: ()=>(0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playButtonHover(),
                                                children: [
                                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("img", {
                                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($ffad1067c3552705$exports))),
                                                        alt: ""
                                                    }),
                                                    "Settings"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                className: "side"
            }),
            showAboutModal && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                className: "modal-overlay",
                onClick: ()=>{
                    (0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playButtonClick();
                    setShowAboutModal(false);
                    setShowCreditsScreen(false);
                },
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                    className: "modal-content about-modal",
                    onClick: (e)=>e.stopPropagation(),
                    children: !showCreditsScreen ? /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $7ead0b1397a835ed$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("h2", {
                                children: "About Squirtle Wordle"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($85426c462a45faf7$exports))),
                                alt: "Pokemon Trainer Scene",
                                className: "about-image"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                                className: "about-text",
                                children: [
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("p", {
                                        children: [
                                            'A Pok\xe9mon guessing game based on Wordle. Inspired by a project from the course "',
                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("a", {
                                                href: "https://www.joyofreact.com/",
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                children: "Joy of React"
                                            }),
                                            '".'
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("p", {
                                        children: "Catch as many Pokemon as you can, and even better, try to get them in one guess. Use your Pok\xe9dex to track progress."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("button", {
                                className: "primary-button modal-button",
                                onClick: ()=>{
                                    (0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playModalDismiss();
                                    setShowAboutModal(false);
                                    setShowCreditsScreen(false);
                                },
                                onMouseEnter: ()=>(0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playBubbleHover(),
                                children: "Done"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                                className: "about-footer",
                                children: [
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                                        className: "built-by-line",
                                        children: [
                                            "Created by ",
                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("a", {
                                                href: "https://coryfugate.com",
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                children: "Cory Fugate"
                                            }),
                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("img", {
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($3c2e7a25617d6f35$exports))),
                                                alt: "",
                                                className: "about-footer-icon"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                        className: "credits-line",
                                        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("button", {
                                            className: "credits-link",
                                            onClick: ()=>{
                                                (0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playFilterClick();
                                                setShowCreditsScreen(true);
                                            },
                                            children: [
                                                "Sound Credits",
                                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("span", {
                                                    className: "chevron",
                                                    children: "\u203A"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $7ead0b1397a835ed$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("button", {
                                className: "credits-back-button",
                                onClick: ()=>{
                                    (0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playFilterClick();
                                    setShowCreditsScreen(false);
                                },
                                children: "\u2039 Back"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("h2", {
                                children: "Sound Credits"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                                className: "credits-content",
                                children: [
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                        className: "credits-intro",
                                        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("p", {
                                            children: "Special thanks to these talented creators from Pixabay.com for their amazing sound effects:"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                        className: "credits-list",
                                        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("ul", {
                                            children: [
                                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("li", {
                                                    children: "skyscraper_seven"
                                                }),
                                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("li", {
                                                    children: "Universfield"
                                                }),
                                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("li", {
                                                    children: "FREESOUND-COMMUNITY"
                                                }),
                                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("li", {
                                                    children: "Viacheslav Starostin"
                                                }),
                                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("li", {
                                                    children: "Poradovskyi"
                                                }),
                                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("li", {
                                                    children: "CFL_TurningPages"
                                                }),
                                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("li", {
                                                    children: "Feora, Lucas Cooper"
                                                }),
                                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("li", {
                                                    children: "Alphix"
                                                }),
                                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("li", {
                                                    children: "SoundReality"
                                                }),
                                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("li", {
                                                    children: "Flora phonic"
                                                }),
                                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("li", {
                                                    children: "R0T0R"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                className: "credits-buttons",
                                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("button", {
                                    className: "primary-button modal-button",
                                    onClick: ()=>{
                                        (0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playModalDismiss();
                                        setShowAboutModal(false);
                                        setShowCreditsScreen(false);
                                    },
                                    onMouseEnter: ()=>(0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playBubbleHover(),
                                    children: "Done"
                                })
                            })
                        ]
                    })
                })
            }),
            showSettingsModal && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                className: "modal-overlay",
                onClick: ()=>{
                    (0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playModalDismiss();
                    setShowSettingsModal(false);
                },
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                    className: "modal-content settings-modal",
                    onClick: (e)=>e.stopPropagation(),
                    children: [
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("h2", {
                            children: [
                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($ffad1067c3552705$exports))),
                                    alt: "",
                                    style: {
                                        width: "24px",
                                        height: "24px",
                                        marginRight: "8px",
                                        verticalAlign: "middle"
                                    }
                                }),
                                "Settings"
                            ]
                        }),
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                            className: "settings-list",
                            children: [
                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                                    className: "setting-item",
                                    children: [
                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                                            className: "setting-label-container",
                                            children: [
                                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                                    className: "setting-label",
                                                    children: "Hide Hints"
                                                }),
                                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                                    className: "setting-description",
                                                    children: "Hard mode. If turned on, pok\xe9mon description hints won't be given."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("label", {
                                            className: "toggle-switch",
                                            children: [
                                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("input", {
                                                    type: "checkbox",
                                                    checked: settings.hideHints,
                                                    onChange: ()=>handleSettingToggle("hideHints")
                                                }),
                                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("span", {
                                                    className: "slider"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                                    className: "setting-item",
                                    children: [
                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                                            className: "setting-label-container",
                                            children: [
                                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                                    className: "setting-label",
                                                    children: "No Repeat Pok\xe9mon"
                                                }),
                                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                                    className: "setting-description",
                                                    children: "If turned on, you'll only guess Pok\xe9mon you haven't caught yet."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("label", {
                                            className: "toggle-switch",
                                            children: [
                                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("input", {
                                                    type: "checkbox",
                                                    checked: settings.noRepeatPokemon,
                                                    onChange: ()=>handleSettingToggle("noRepeatPokemon")
                                                }),
                                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("span", {
                                                    className: "slider"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                                    className: "setting-item",
                                    children: [
                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                                            className: "setting-label-container",
                                            children: [
                                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                                    className: "setting-label",
                                                    children: "Classic Sounds"
                                                }),
                                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                                    className: "setting-description",
                                                    children: "Play old school pok\xe9mon sounds"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("label", {
                                            className: "toggle-switch",
                                            children: [
                                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("input", {
                                                    type: "checkbox",
                                                    checked: settings.classicSounds,
                                                    onChange: ()=>handleSettingToggle("classicSounds")
                                                }),
                                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("span", {
                                                    className: "slider"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                                    className: "setting-item",
                                    children: [
                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                                            className: "setting-label-container",
                                            children: [
                                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                                    className: "setting-label",
                                                    children: "Auto Open Pokedex"
                                                }),
                                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                                    className: "setting-description",
                                                    children: "Automatically opens the pokedex when a new pokemon is caught"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("label", {
                                            className: "toggle-switch",
                                            children: [
                                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("input", {
                                                    type: "checkbox",
                                                    checked: settings.autoOpenPokedex,
                                                    onChange: ()=>handleSettingToggle("autoOpenPokedex")
                                                }),
                                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("span", {
                                                    className: "slider"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                            className: "settings-danger-zone",
                            children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                                className: "danger-zone-item",
                                children: [
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                                        className: "setting-label-container",
                                        children: [
                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                                className: "setting-label",
                                                children: "Clear All Data"
                                            }),
                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                                className: "setting-description",
                                                children: "Remove all Pok\xe9mon progress and statistics."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("button", {
                                        className: "danger-button",
                                        onClick: handleClearData,
                                        onMouseEnter: ()=>(0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playButtonHover(),
                                        children: "Clear data"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("button", {
                            className: "modal-button primary-button",
                            onClick: ()=>{
                                (0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playModalDismiss();
                                setShowSettingsModal(false);
                            },
                            onMouseEnter: ()=>(0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playBubbleHover(),
                            children: "Done"
                        })
                    ]
                })
            }),
            showConfirmModal && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                className: "modal-overlay",
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                    className: "modal-content confirm-modal",
                    children: [
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("h2", {
                            children: "Clear All Data"
                        }),
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("p", {
                            children: "Are you sure you want to delete all progress? This cannot be undone."
                        }),
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                            className: "modal-buttons",
                            children: [
                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("button", {
                                    className: "cancel-button",
                                    onClick: ()=>{
                                        (0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playModalDismiss();
                                        setShowConfirmModal(false);
                                    },
                                    onMouseEnter: ()=>(0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playButtonHover(),
                                    children: "Cancel"
                                }),
                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("button", {
                                    className: "delete-button",
                                    onClick: handleConfirmClear,
                                    onMouseEnter: ()=>(0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playButtonHover(),
                                    children: "Delete"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
var $ce2bbf7743ae7f98$export$2e2bcd8739ae039 = $ce2bbf7743ae7f98$var$Header;






var $exYeM = parcelRequire("exYeM");



var $37c59b8338c91365$exports = {};

$37c59b8338c91365$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "search.5f4ae9e4.svg";


var $5397e018e8dbecb0$exports = {};

$5397e018e8dbecb0$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "share.25d67bb6.svg";



function $bed1218db9113960$var$Pokedex({ isOpen: isOpen, onClose: onClose, pokemonList: pokemonList, discoveredPokemon: discoveredPokemon, singleGuessPokemon: singleGuessPokemon, highlightPokemonId: highlightPokemonId, isMaster: isMaster, trophyIcon: trophyIcon, onSubmitGuess: onSubmitGuess }) {
    const [searchTerm, setSearchTerm] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState("");
    const [pokemonDescriptions, setPokemonDescriptions] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState({});
    const [pokemonTypes, setPokemonTypes] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState({});
    const [selectedPokemon, setSelectedPokemon] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(null);
    const [activeFilter, setActiveFilter] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState("all");
    const [typeFilter, setTypeFilter] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState("all");
    const [hasAutoScrolled, setHasAutoScrolled] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(false);
    // Handle closing pokedex with sound cleanup
    const handleClose = ()=>{
        (0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).stop("pokedexOpenAfterCatch");
        (0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playModalDismiss();
        onClose();
    };
    const [sortBy, setSortBy] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState("pokemon id");
    const [showSortDropdown, setShowSortDropdown] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(false);
    const [showTypeDropdown, setShowTypeDropdown] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(false);
    const [catchCounts, setCatchCounts] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState({});
    const [showScrollButton, setShowScrollButton] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(false);
    const [hoveredShareButton, setHoveredShareButton] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(null);
    const [pokemonCry, setPokemonCry] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(null);
    const [isLoadingCry, setIsLoadingCry] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(false);
    const [isMobile, setIsMobile] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(false);
    const [lastTapTime, setLastTapTime] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(0);
    const [lastTappedPokemon, setLastTappedPokemon] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(null);
    const searchInputRef = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useRef();
    const sortDropdownRef = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useRef();
    const typeDropdownRef = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useRef();
    // Mobile detection
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(()=>{
        const checkMobile = ()=>{
            setIsMobile(window.innerWidth <= 768);
        };
        checkMobile();
        window.addEventListener("resize", checkMobile);
        return ()=>window.removeEventListener("resize", checkMobile);
    }, []);
    // Auto-focus search input on desktop when Pokedex opens
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(()=>{
        if (isOpen && !isMobile && searchInputRef.current) setTimeout(()=>{
            searchInputRef.current.focus();
        }, 300); // Wait for drawer animation
    }, [
        isOpen,
        isMobile
    ]);
    // Close dropdowns when clicking outside
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(()=>{
        const handleClickOutside = (event)=>{
            if (sortDropdownRef.current && !sortDropdownRef.current.contains(event.target)) setShowSortDropdown(false);
            if (typeDropdownRef.current && !typeDropdownRef.current.contains(event.target)) setShowTypeDropdown(false);
        };
        if (isOpen) document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        isOpen
    ]);
    // Scroll to top when search/filter/sort changes
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(()=>{
        if (isOpen) scrollToTop();
    }, [
        searchTerm,
        activeFilter,
        typeFilter,
        sortBy,
        isOpen
    ]);
    // Function to fetch and cache Pokemon types
    const fetchTypes = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useCallback(async (pokemon)=>{
        if (pokemonTypes[pokemon.id]) return;
        const CACHE_KEY = "pokemon-types-cache";
        const CACHE_DURATION = 86400000; // 24 hours
        try {
            // Check if we already have cached types for this Pokemon
            const cachedTypes = localStorage.getItem(CACHE_KEY);
            if (cachedTypes) {
                const { data: data, timestamp: timestamp } = JSON.parse(cachedTypes);
                const now = Date.now();
                if (now - timestamp < CACHE_DURATION && data[pokemon.id]) {
                    setPokemonTypes((prev)=>({
                            ...prev,
                            [pokemon.id]: data[pokemon.id]
                        }));
                    return;
                }
            }
            // Fetch types from API
            const response = await fetch(`https://pokeapi.co/api/v2/pokemon/${pokemon.id}`);
            const pokemonData = await response.json();
            const types = pokemonData.types.map((typeInfo)=>({
                    name: typeInfo.type.name,
                    slot: typeInfo.slot
                }));
            // Update cache
            try {
                const existingCache = JSON.parse(localStorage.getItem(CACHE_KEY) || "{}");
                const cacheData = {
                    data: {
                        ...existingCache.data,
                        [pokemon.id]: types
                    },
                    timestamp: Date.now()
                };
                localStorage.setItem(CACHE_KEY, JSON.stringify(cacheData));
            } catch (error) {
                console.warn("Failed to save types to cache:", error);
            }
            setPokemonTypes((prev)=>({
                    ...prev,
                    [pokemon.id]: types
                }));
        } catch (error) {
            console.error(`Failed to fetch types for ${pokemon.name}:`, error);
        }
    }, [
        pokemonTypes
    ]);
    // Function to fetch and cache Pokemon descriptions
    const fetchDescription = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useCallback(async (pokemon)=>{
        if (pokemonDescriptions[pokemon.id]) return;
        try {
            const response = await fetch(`https://pokeapi.co/api/v2/pokemon-species/${pokemon.originalName}/`);
            const data = await response.json();
            const englishEntry = data.flavor_text_entries?.find((entry)=>entry.language.name === "en");
            const description = englishEntry ? englishEntry.flavor_text.replace(/\f/g, " ").replace(/\n/g, " ").replace(/\s+/g, " ").trim() : "A mysterious Pokemon.";
            setPokemonDescriptions((prev)=>({
                    ...prev,
                    [pokemon.id]: description
                }));
        } catch (error) {
            console.error("Failed to fetch description:", error);
        }
    }, [
        pokemonDescriptions
    ]);
    // Load catch counts from localStorage
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(()=>{
        const counts = JSON.parse(localStorage.getItem("pokemon-catch-counts") || "{}");
        setCatchCounts(counts);
    }, [
        isOpen
    ]);
    // Handle scroll events to show/hide scroll-to-top button
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(()=>{
        const pokedexContent = document.querySelector(".pokedex-content");
        if (!pokedexContent || !isOpen) return;
        const handleScroll = ()=>{
            const scrollTop = pokedexContent.scrollTop;
            setShowScrollButton(scrollTop > 200);
        };
        pokedexContent.addEventListener("scroll", handleScroll);
        // Initial check
        handleScroll();
        return ()=>{
            pokedexContent.removeEventListener("scroll", handleScroll);
        };
    }, [
        isOpen
    ]);
    // Scroll to highlighted Pokemon when Pokedx opens (only once)
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(()=>{
        if (isOpen && highlightPokemonId && !hasAutoScrolled) {
            // Clear filters and search to ensure highlighted pokemon is visible
            setSearchTerm("");
            setActiveFilter("all");
            setTypeFilter("all");
            const highlightedPokemon = pokemonList.find((p)=>p.id === highlightPokemonId);
            if (highlightedPokemon) {
                setSelectedPokemon(highlightedPokemon);
                fetchDescription(highlightedPokemon);
                fetchTypes(highlightedPokemon);
            }
            const timer = setTimeout(()=>{
                const element = document.getElementById(`pokemon-${highlightPokemonId}`);
                if (element) element.scrollIntoView({
                    behavior: "smooth",
                    block: "center"
                });
                setHasAutoScrolled(true);
            }, 300); // Wait for drawer animation to complete
            return ()=>clearTimeout(timer);
        }
    }, [
        isOpen,
        highlightPokemonId,
        pokemonList,
        fetchDescription,
        fetchTypes,
        hasAutoScrolled
    ]);
    // Reset auto-scroll flag when Pokedex closes
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(()=>{
        if (!isOpen) setHasAutoScrolled(false);
    }, [
        isOpen
    ]);
    // Load Pokemon cry when selectedPokemon changes
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(()=>{
        if (selectedPokemon && discoveredPokemon.includes(selectedPokemon.id)) fetchPokemonCry(selectedPokemon.id);
        else {
            // Clean up audio when no Pokemon is selected or Pokemon is undiscovered
            if (pokemonCry) {
                pokemonCry.pause();
                pokemonCry.src = "";
                pokemonCry.load();
            }
            setPokemonCry(null);
            setIsLoadingCry(false);
        }
        // Cleanup function
        return ()=>{
            if (pokemonCry) {
                pokemonCry.pause();
                pokemonCry.src = "";
                pokemonCry.load();
            }
        };
    }, [
        selectedPokemon,
        discoveredPokemon
    ]);
    const fetchPokemonCry = async (pokemonId)=>{
        if (isLoadingCry) return; // Don't fetch if already loading
        // Clean up previous audio
        if (pokemonCry) {
            pokemonCry.pause();
            pokemonCry.src = "";
            pokemonCry.load();
        }
        setIsLoadingCry(true);
        setPokemonCry(null);
        try {
            const cryUrl = `https://raw.githubusercontent.com/PokeAPI/cries/main/cries/pokemon/latest/${pokemonId}.ogg`;
            const audio = new Audio();
            audio.crossOrigin = "anonymous";
            audio.preload = "auto";
            audio.volume = 0.20;
            // Wait for audio to be ready
            await new Promise((resolve, reject)=>{
                const timeout = setTimeout(()=>{
                    reject(new Error("Audio load timeout"));
                }, 5000);
                const cleanup = ()=>{
                    clearTimeout(timeout);
                    audio.removeEventListener("canplaythrough", onLoad);
                    audio.removeEventListener("loadeddata", onLoad);
                    audio.removeEventListener("error", onError);
                };
                const onLoad = ()=>{
                    cleanup();
                    resolve();
                };
                const onError = (e)=>{
                    cleanup();
                    reject(new Error(`Audio load failed: ${e.type}`));
                };
                audio.addEventListener("canplaythrough", onLoad, {
                    once: true
                });
                audio.addEventListener("loadeddata", onLoad, {
                    once: true
                });
                audio.addEventListener("error", onError, {
                    once: true
                });
                // Set source after event listeners are attached
                audio.src = cryUrl;
            });
            setPokemonCry(audio);
        } catch (error) {
            console.warn(`Failed to load Pokemon cry for ID ${pokemonId}:`, error);
            setPokemonCry(null);
        } finally{
            setIsLoadingCry(false);
        }
    };
    const handlePokemonImageClick = ()=>{
        if (pokemonCry && !isLoadingCry) {
            // Reset audio to beginning and play
            pokemonCry.currentTime = 0;
            pokemonCry.play().catch((error)=>{
                console.warn("Failed to play Pokemon cry:", error);
            });
        }
    // Click is always responsive, even if audio isn't ready
    };
    const getPokemonImageTitle = ()=>{
        if (!selectedPokemon || !discoveredPokemon.includes(selectedPokemon.id)) return selectedPokemon ? selectedPokemon.name : "";
        if (isLoadingCry) return `Click to hear ${selectedPokemon.name}'s cry (loading...)`;
        if (pokemonCry) return `Click to hear ${selectedPokemon.name}'s cry!`;
        return `Click to hear ${selectedPokemon.name}'s cry (unavailable)`;
    };
    // Function to highlight matching tokens in pokemon names
    const highlightSearchTerms = (name, searchTerms)=>{
        if (!searchTerms || searchTerms.length === 0) return name;
        // Create a list of all matches with their positions
        const matches = [];
        searchTerms.forEach((token)=>{
            if (token.length === 0) return;
            const regex = new RegExp(token.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "gi");
            let match;
            while((match = regex.exec(name)) !== null)matches.push({
                start: match.index,
                end: match.index + match[0].length,
                text: match[0]
            });
        });
        // Sort matches by start position
        matches.sort((a, b)=>a.start - b.start);
        // Merge overlapping matches
        const mergedMatches = [];
        for (const match of matches)if (mergedMatches.length === 0) mergedMatches.push(match);
        else {
            const last = mergedMatches[mergedMatches.length - 1];
            if (match.start <= last.end) {
                // Overlapping or adjacent - merge them
                last.end = Math.max(last.end, match.end);
                last.text = name.substring(last.start, last.end);
            } else mergedMatches.push(match);
        }
        // Build highlighted string from end to beginning to preserve indices
        let result = name;
        for(let i = mergedMatches.length - 1; i >= 0; i--){
            const match = mergedMatches[i];
            const before = result.substring(0, match.start);
            const highlighted = `<span class="search-highlight-no-spacing">${match.text}</span>`;
            const after = result.substring(match.end);
            result = before + highlighted + after;
        }
        return result;
    };
    // Parse search term into tokens
    const searchTokens = searchTerm.trim().toLowerCase().split(/\s+/).filter((token)=>token.length > 0);
    const filteredPokemon = pokemonList.filter((pokemon)=>{
        // Multi-token search: pokemon name must contain ALL tokens
        const nameMatch = searchTokens.length === 0 || searchTokens.every((token)=>pokemon.name.toLowerCase().includes(token));
        const idMatch = searchTerm === "" || pokemon.id.toString().includes(searchTerm);
        const matchesSearch = nameMatch || idMatch;
        const isDiscovered = discoveredPokemon.includes(pokemon.id);
        const matchesFilter = activeFilter === "all" || activeFilter === "caught" && isDiscovered || activeFilter === "uncaught" && !isDiscovered;
        // Type filtering
        const matchesType = typeFilter === "all" || pokemon.types && pokemon.types.some((type)=>type.name === typeFilter);
        return matchesSearch && matchesFilter && matchesType;
    }).sort((a, b)=>{
        if (sortBy === "pokemon id") return a.id - b.id;
        else if (sortBy === "times caught") {
            const aCount = catchCounts[a.id] || 0;
            const bCount = catchCounts[b.id] || 0;
            return bCount - aCount; // Descending order (most caught first)
        }
        return 0;
    });
    // Get all unique types for the filter dropdown
    const allTypes = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useMemo(()=>{
        return (0, $b60d5ef55411eecc$export$cd75e89a26d85a6e)(pokemonList);
    }, [
        pokemonList
    ]);
    const CheckIcon = ()=>/*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("svg", {
            width: "16",
            height: "16",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "#10B981",
            strokeWidth: "3",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            className: "check-icon",
            children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("polyline", {
                points: "20,6 9,17 4,12"
            })
        });
    const handleOverlayClick = (e)=>{
        if (e.target === e.currentTarget) handleClose();
    };
    // Handle pokemon card clicks with double-tap detection for mobile
    const handlePokemonClick = (pokemon)=>{
        const currentTime = Date.now();
        const isDoubleTap = isMobile && onSubmitGuess && lastTappedPokemon === pokemon.id && currentTime - lastTapTime < 300; // 300ms double-tap threshold
        if (isDoubleTap) {
            // Double tap on mobile - submit as guess
            (0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playButtonClick();
            onSubmitGuess(pokemon.name);
            handleClose(); // Close Pokedex after submitting guess
        } else {
            // Single tap - normal behavior (show pokemon details)
            (0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playGridClick();
            setSelectedPokemon(pokemon);
            if (discoveredPokemon.includes(pokemon.id)) {
                fetchDescription(pokemon);
                fetchTypes(pokemon);
            }
            // Update last tap tracking
            setLastTapTime(currentTime);
            setLastTappedPokemon(pokemon.id);
        }
    };
    const scrollToTop = ()=>{
        const pokedexContent = document.querySelector(".pokedex-content");
        if (pokedexContent) pokedexContent.scrollTo({
            top: 0
        });
    };
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
        className: `pokedex-overlay ${isOpen ? "open" : ""}`,
        onClick: handleOverlayClick,
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
            className: "pokedex-drawer",
            children: [
                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                    className: "pokedex-header",
                    children: [
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("button", {
                            className: "close-button",
                            onClick: handleClose,
                            onMouseEnter: ()=>(0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playBubbleHover(),
                            children: "\xd7"
                        }),
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("h2", {
                            className: "pokedex-title",
                            children: [
                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($3039ba0e25b90224$exports))),
                                    alt: "Open Pok\xe9dex"
                                }),
                                "Pok\xe9dex"
                            ]
                        }),
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                            className: "progress-container",
                            children: [
                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                    className: "progress-text",
                                    children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("strong", {
                                        children: "Caught:"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                    className: "progress-bar",
                                    children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                        className: "progress-fill",
                                        style: {
                                            width: `${discoveredPokemon.length / 151 * 100}%`
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                    className: "progress-text",
                                    children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("span", {
                                        className: isMaster ? "header-trophy" : "",
                                        children: [
                                            discoveredPokemon.length,
                                            "/151 (",
                                            Math.round(discoveredPokemon.length / 151 * 100),
                                            "%)",
                                            isMaster && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("img", {
                                                src: trophyIcon,
                                                alt: "Pok\xe9mon Master",
                                                className: "trophy-icon pokedex-trophy"
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                            className: "search-sort-row",
                            children: [
                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                                    className: "search-container",
                                    children: [
                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($37c59b8338c91365$exports))),
                                            alt: "Search",
                                            className: "search-icon"
                                        }),
                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("input", {
                                            ref: searchInputRef,
                                            type: "text",
                                            placeholder: "Search pok\xe9mon...",
                                            value: searchTerm,
                                            onChange: (e)=>setSearchTerm(e.target.value),
                                            onFocus: ()=>(0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playInputClick(),
                                            onMouseEnter: ()=>(0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playInputHover(),
                                            className: "pokedex-search",
                                            title: "Tip: You can search for multiple distinct letters by separating with spaces. For example: 'B S R' will find 'Bulbasaur'"
                                        }),
                                        searchTerm && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("button", {
                                            className: "clear-search-button",
                                            onClick: ()=>setSearchTerm(""),
                                            "aria-label": "Clear search",
                                            children: "\xd7"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                                    className: "sort-filter-container",
                                    children: [
                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                                            className: "type-filter-container",
                                            ref: typeDropdownRef,
                                            children: [
                                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("button", {
                                                    className: `type-filter-button ${isMobile ? "mobile" : ""}`,
                                                    onClick: ()=>{
                                                        (0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playFilterClick();
                                                        setShowTypeDropdown(!showTypeDropdown);
                                                    },
                                                    onMouseEnter: ()=>(0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playFilterHover(),
                                                    children: isMobile ? /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $7ead0b1397a835ed$exports.Fragment), {
                                                        children: [
                                                            typeFilter === "all" ? /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("svg", {
                                                                width: "16",
                                                                height: "16",
                                                                viewBox: "0 0 24 24",
                                                                fill: "currentColor",
                                                                stroke: "none",
                                                                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                                                                    d: "M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
                                                                })
                                                            }) : /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $af43f6d3681ca32e$export$2e2bcd8739ae039), {
                                                                type: typeFilter,
                                                                variant: "circular",
                                                                size: "small"
                                                            }),
                                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("svg", {
                                                                width: "12",
                                                                height: "12",
                                                                viewBox: "0 0 24 24",
                                                                fill: "none",
                                                                stroke: "currentColor",
                                                                strokeWidth: "2",
                                                                className: "type-filter-caret",
                                                                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("polyline", {
                                                                    points: "6,9 12,15 18,9"
                                                                })
                                                            })
                                                        ]
                                                    }) : /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $7ead0b1397a835ed$exports.Fragment), {
                                                        children: [
                                                            typeFilter === "all" ? /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $7ead0b1397a835ed$exports.Fragment), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("svg", {
                                                                        width: "16",
                                                                        height: "16",
                                                                        viewBox: "0 0 24 24",
                                                                        fill: "currentColor",
                                                                        stroke: "none",
                                                                        style: {
                                                                            color: "#fbbf24"
                                                                        },
                                                                        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                                                                            d: "M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("span", {
                                                                        children: "All Types"
                                                                    })
                                                                ]
                                                            }) : /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $af43f6d3681ca32e$export$2e2bcd8739ae039), {
                                                                type: typeFilter,
                                                                variant: "mini",
                                                                size: "small"
                                                            }),
                                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("svg", {
                                                                width: "12",
                                                                height: "12",
                                                                viewBox: "0 0 24 24",
                                                                fill: "none",
                                                                stroke: "currentColor",
                                                                strokeWidth: "2",
                                                                className: "type-filter-caret",
                                                                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("polyline", {
                                                                    points: "6,9 12,15 18,9"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                }),
                                                showTypeDropdown && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                                                    className: "type-filter-dropdown",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("button", {
                                                            onClick: ()=>{
                                                                (0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playFilterClick();
                                                                setTypeFilter("all");
                                                                setShowTypeDropdown(false);
                                                            },
                                                            onMouseEnter: ()=>(0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playFilterHover(),
                                                            className: typeFilter === "all" ? "active" : "",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("svg", {
                                                                    width: "16",
                                                                    height: "16",
                                                                    viewBox: "0 0 24 24",
                                                                    fill: "currentColor",
                                                                    stroke: "none",
                                                                    style: {
                                                                        color: "#fbbf24"
                                                                    },
                                                                    children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                                                                        d: "M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("span", {
                                                                    children: "All Types"
                                                                })
                                                            ]
                                                        }),
                                                        allTypes.map((type)=>/*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("button", {
                                                                onClick: ()=>{
                                                                    (0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playFilterClick();
                                                                    setTypeFilter(type);
                                                                    setShowTypeDropdown(false);
                                                                },
                                                                onMouseEnter: ()=>(0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playFilterHover(),
                                                                className: typeFilter === type ? "active" : "",
                                                                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $af43f6d3681ca32e$export$2e2bcd8739ae039), {
                                                                    type: type,
                                                                    variant: "full",
                                                                    size: "small"
                                                                })
                                                            }, type))
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                                            className: "sort-container",
                                            ref: sortDropdownRef,
                                            children: [
                                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("button", {
                                                    className: `sort-button ${isMobile ? "mobile" : ""}`,
                                                    onClick: ()=>{
                                                        (0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playFilterClick();
                                                        setShowSortDropdown(!showSortDropdown);
                                                    },
                                                    onMouseEnter: ()=>(0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playFilterHover(),
                                                    children: isMobile ? /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $7ead0b1397a835ed$exports.Fragment), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("svg", {
                                                                width: "16",
                                                                height: "16",
                                                                viewBox: "0 0 24 24",
                                                                fill: "none",
                                                                stroke: "currentColor",
                                                                strokeWidth: "2",
                                                                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                                                                    d: "M3 6h18M7 12h10m-7 6h4"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("svg", {
                                                                width: "12",
                                                                height: "12",
                                                                viewBox: "0 0 24 24",
                                                                fill: "none",
                                                                stroke: "currentColor",
                                                                strokeWidth: "2",
                                                                className: "sort-caret",
                                                                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("polyline", {
                                                                    points: "6,9 12,15 18,9"
                                                                })
                                                            })
                                                        ]
                                                    }) : /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $7ead0b1397a835ed$exports.Fragment), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("svg", {
                                                                width: "16",
                                                                height: "16",
                                                                viewBox: "0 0 24 24",
                                                                fill: "none",
                                                                stroke: "currentColor",
                                                                strokeWidth: "2",
                                                                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("path", {
                                                                    d: "M3 6h18M7 12h10m-7 6h4"
                                                                })
                                                            }),
                                                            sortBy === "pokemon id" ? "Id" : "# Caught",
                                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("svg", {
                                                                width: "12",
                                                                height: "12",
                                                                viewBox: "0 0 24 24",
                                                                fill: "none",
                                                                stroke: "currentColor",
                                                                strokeWidth: "2",
                                                                className: "sort-caret",
                                                                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("polyline", {
                                                                    points: "6,9 12,15 18,9"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                }),
                                                showSortDropdown && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                                                    className: "sort-dropdown",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("button", {
                                                            onClick: ()=>{
                                                                (0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playFilterClick();
                                                                setSortBy("pokemon id");
                                                                setShowSortDropdown(false);
                                                            },
                                                            onMouseEnter: ()=>(0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playFilterHover(),
                                                            className: sortBy === "pokemon id" ? "active" : "",
                                                            children: "Pokemon ID"
                                                        }),
                                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("button", {
                                                            onClick: ()=>{
                                                                (0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playFilterClick();
                                                                setSortBy("times caught");
                                                                setShowSortDropdown(false);
                                                            },
                                                            onMouseEnter: ()=>(0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playFilterHover(),
                                                            className: sortBy === "times caught" ? "active" : "",
                                                            children: "Times Caught"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                            className: "filter-tabs",
                            children: [
                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("button", {
                                    className: `filter-tab ${activeFilter === "all" ? "active" : ""}`,
                                    onClick: ()=>{
                                        (0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playFilterClick();
                                        setActiveFilter("all");
                                    },
                                    onMouseEnter: ()=>(0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playFilterHover(),
                                    children: [
                                        "All (",
                                        pokemonList.length,
                                        ")"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("button", {
                                    className: `filter-tab ${activeFilter === "caught" ? "active" : ""}`,
                                    onClick: ()=>{
                                        (0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playFilterClick();
                                        setActiveFilter("caught");
                                    },
                                    onMouseEnter: ()=>(0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playFilterHover(),
                                    children: [
                                        "Caught (",
                                        discoveredPokemon.length,
                                        ")"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("button", {
                                    className: `filter-tab ${activeFilter === "uncaught" ? "active" : ""}`,
                                    onClick: ()=>{
                                        (0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playFilterClick();
                                        setActiveFilter("uncaught");
                                    },
                                    onMouseEnter: ()=>(0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playFilterHover(),
                                    children: [
                                        "Uncaught (",
                                        pokemonList.length - discoveredPokemon.length,
                                        ")"
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                    className: "pokedex-content",
                    children: [
                        (searchTerm || typeFilter !== "all") && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                            className: "search-results-counter",
                            children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("em", {
                                children: [
                                    filteredPokemon.length,
                                    " Pok\xe9mon ",
                                    searchTerm ? "matching search" : "found"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                            className: "pokemon-grid",
                            children: filteredPokemon.length > 0 ? filteredPokemon.map((pokemon)=>{
                                const isDiscovered = discoveredPokemon.includes(pokemon.id);
                                const isHighlighted = highlightPokemonId === pokemon.id;
                                return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                                    id: `pokemon-${pokemon.id}`,
                                    className: `pokemon-card ${isDiscovered ? "discovered" : "undiscovered"} ${isHighlighted ? "highlighted" : ""}`,
                                    onClick: ()=>handlePokemonClick(pokemon),
                                    onMouseEnter: ()=>(0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playButtonHover(),
                                    style: {
                                        cursor: "pointer"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("img", {
                                            src: `https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/${pokemon.id}.png`,
                                            alt: pokemon.name,
                                            className: "pokemon-image",
                                            onError: (e)=>{
                                                e.target.src = `https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/${pokemon.id}.png`;
                                            }
                                        }),
                                        isDiscovered && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                            className: "discovery-badge",
                                            title: "You've caught this Pok\xe9mon"
                                        }),
                                        isDiscovered && singleGuessPokemon && singleGuessPokemon.includes(pokemon.id) && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                            className: "single-guess-badge",
                                            title: "Caught in a single guess",
                                            children: "\u2605"
                                        }),
                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                                            className: "pokemon-number",
                                            children: [
                                                "#",
                                                pokemon.id.toString().padStart(3, "0")
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                                            className: "pokemon-name-container",
                                            children: [
                                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                                    className: "pokemon-name",
                                                    dangerouslySetInnerHTML: {
                                                        __html: highlightSearchTerms(pokemon.name, searchTokens)
                                                    }
                                                }),
                                                onSubmitGuess && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                                                    className: "pokemon-share-container",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("button", {
                                                            className: "pokemon-share-button",
                                                            onClick: (e)=>{
                                                                e.stopPropagation();
                                                                (0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playButtonClick();
                                                                onSubmitGuess(pokemon.name);
                                                                handleClose(); // Close Pokedex after submitting guess
                                                            },
                                                            onMouseEnter: ()=>{
                                                                (0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playBubbleHover();
                                                                setHoveredShareButton(pokemon.id);
                                                            },
                                                            onMouseLeave: ()=>setHoveredShareButton(null),
                                                            children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("img", {
                                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($5397e018e8dbecb0$exports))),
                                                                alt: "Submit guess",
                                                                className: "share-icon"
                                                            })
                                                        }),
                                                        hoveredShareButton === pokemon.id && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                                                            className: "share-tooltip",
                                                            children: [
                                                                "Submit ",
                                                                pokemon.name,
                                                                " as your guess"
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                                            className: "pokemon-card-bottom",
                                            children: [
                                                pokemon.types && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                                    className: "pokemon-type-icons",
                                                    children: pokemon.types.map((type, index)=>/*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $af43f6d3681ca32e$export$2e2bcd8739ae039), {
                                                            type: type.name,
                                                            variant: "circular",
                                                            size: "small"
                                                        }, index))
                                                }),
                                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                                                    className: "pokemon-catch-count",
                                                    style: {
                                                        opacity: isDiscovered && catchCounts[pokemon.id] ? 1 : 0
                                                    },
                                                    title: isDiscovered && catchCounts[pokemon.id] ? `You've caught ${catchCounts[pokemon.id]} ${pokemon.name}` : "",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("img", {
                                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($3039ba0e25b90224$exports))),
                                                            alt: "Pokeball",
                                                            className: "catch-count-icon"
                                                        }),
                                                        catchCounts[pokemon.id] || 0
                                                    ]
                                                })
                                            ]
                                        }),
                                        "                                "
                                    ]
                                }, pokemon.id);
                            }) : /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                                className: "pokedex-empty-state",
                                children: [
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($3039ba0e25b90224$exports))),
                                        alt: "Pokeball",
                                        className: "empty-state-icon"
                                    }),
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                                        className: "empty-state-message",
                                        children: [
                                            activeFilter === "caught" && "No pokemon caught, yet.",
                                            activeFilter === "uncaught" && "Caught 'em all!",
                                            activeFilter === "all" && "No pokemon found."
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("button", {
                            className: `scroll-to-top-button ${showScrollButton ? "visible" : ""}`,
                            onClick: scrollToTop,
                            "aria-label": "Scroll to top",
                            children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("svg", {
                                width: "16",
                                height: "16",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                strokeWidth: "2",
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("polyline", {
                                    points: "18,15 12,9 6,15"
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                    className: "pokemon-description-panel",
                    children: [
                        selectedPokemon ? /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                            className: "description-content",
                            children: [
                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                                    className: "description-image-container",
                                    children: [
                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("img", {
                                            src: `https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/${selectedPokemon.id}.png`,
                                            alt: selectedPokemon.name,
                                            className: `description-pokemon-image ${discoveredPokemon.includes(selectedPokemon.id) ? "discovered clickable-pokemon" : "undiscovered"}`,
                                            onClick: discoveredPokemon.includes(selectedPokemon.id) ? handlePokemonImageClick : undefined,
                                            title: getPokemonImageTitle(),
                                            onError: (e)=>{
                                                e.target.src = `https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/${selectedPokemon.id}.png`;
                                            }
                                        }),
                                        discoveredPokemon.includes(selectedPokemon.id) && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                            className: "description-discovery-badge"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                    className: "description-info",
                                    children: discoveredPokemon.includes(selectedPokemon.id) ? /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $7ead0b1397a835ed$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                                                className: "description-header",
                                                children: [
                                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("strong", {
                                                        children: [
                                                            "#",
                                                            selectedPokemon.id.toString().padStart(3, "0"),
                                                            " ",
                                                            selectedPokemon.name
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                                                        className: "desc-header-detail",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                                                className: "type-badges",
                                                                children: pokemonTypes[selectedPokemon.id]?.map((typeInfo, index)=>/*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $af43f6d3681ca32e$export$2e2bcd8739ae039), {
                                                                        type: typeInfo.name,
                                                                        variant: "full",
                                                                        size: "medium"
                                                                    }, index))
                                                            }),
                                                            catchCounts[selectedPokemon.id] && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                                                                className: "description-catch-count",
                                                                title: `You've caught ${catchCounts[selectedPokemon.id]} ${selectedPokemon.name}`,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("img", {
                                                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($3039ba0e25b90224$exports))),
                                                                        alt: "Pokeball",
                                                                        className: "description-catch-icon"
                                                                    }),
                                                                    catchCounts[selectedPokemon.id]
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                                className: "description-text",
                                                children: pokemonDescriptions[selectedPokemon.id] || "Loading description..."
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $7ead0b1397a835ed$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                                className: "description-header",
                                                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("strong", {
                                                    children: [
                                                        "#",
                                                        selectedPokemon.id.toString().padStart(3, "0"),
                                                        " ???"
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                                className: "description-text undiscovered-text",
                                                children: "Catch this Pok\xe9mon to learn more"
                                            })
                                        ]
                                    })
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                            className: "description-content",
                            children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                className: "description-placeholder",
                                children: "Click a Pok\xe9mon to learn more"
                            })
                        }),
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("button", {
                            className: "pokedex-close-button",
                            onClick: handleClose,
                            onMouseEnter: ()=>(0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playBubbleHover(),
                            children: "Close Pok\xe9dex"
                        })
                    ]
                })
            ]
        })
    });
}
var $bed1218db9113960$export$2e2bcd8739ae039 = $bed1218db9113960$var$Pokedex;






var $exYeM = parcelRequire("exYeM");
var $994ddcb807969d92$exports = {};

$994ddcb807969d92$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "pokemon-master.6b47ce1a.png";


var $78a7b344deb00b85$exports = {};

$78a7b344deb00b85$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "pokemon-progress.f5a323ba.png";


var $eecd464176c7f13d$exports = {};

$eecd464176c7f13d$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "trophy-star.7f38dfc2.svg";


var $6edca0338b17e9b7$exports = {};

$6edca0338b17e9b7$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "trophy.3203088e.svg";



function $fb8114cc29bf120e$var$Celebrations({ showMasterCelebration: showMasterCelebration, showProgressCelebration: showProgressCelebration, showLegendCelebration: showLegendCelebration, showFirstPokemonCelebration: showFirstPokemonCelebration, progressCount: progressCount, onDismissMaster: onDismissMaster, onDismissProgress: onDismissProgress, onDismissLegend: onDismissLegend, onDismissFirstPokemon: onDismissFirstPokemon, onHoorayClick: onHoorayClick, onLegendHoorayClick: onLegendHoorayClick, meetPikaImage: meetPikaImage }) {
    const [confettiKey, setConfettiKey] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(0);
    const [hoorayFireworks, setHoorayFireworks] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(false);
    const [isFadingOut, setIsFadingOut] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(false);
    // Create confetti animation
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(()=>{
        if (showMasterCelebration || showProgressCelebration || showLegendCelebration || showFirstPokemonCelebration) {
            setConfettiKey((prev)=>prev + 1);
            setIsFadingOut(false);
            // Play victory beat for progress, master, and legend celebrations
            if (showProgressCelebration || showMasterCelebration || showLegendCelebration) (0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playVictoryBeat();
        }
    }, [
        showMasterCelebration,
        showProgressCelebration,
        showLegendCelebration,
        showFirstPokemonCelebration
    ]);
    const handleHoorayClick = ()=>{
        (0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playModalDismiss();
        // Trigger more fireworks immediately
        setHoorayFireworks(true);
        setConfettiKey((prev)=>prev + 1);
        // Start fade out animation
        setIsFadingOut(true);
        // Stop victory music and reset fireworks and dismiss after fade completes
        setTimeout(()=>{
            (0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).stopVictoryBeat();
            setHoorayFireworks(false);
            onHoorayClick();
        }, 2000);
    };
    const handleLegendHoorayClick = ()=>{
        (0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playModalDismiss();
        // Trigger more fireworks immediately
        setHoorayFireworks(true);
        setConfettiKey((prev)=>prev + 1);
        // Start fade out animation
        setIsFadingOut(true);
        // Stop victory music and reset fireworks and dismiss after fade completes
        setTimeout(()=>{
            (0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).stopVictoryBeat();
            setHoorayFireworks(false);
            onLegendHoorayClick();
        }, 2000);
    };
    const handleProgressDismiss = ()=>{
        (0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playModalDismiss();
        (0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).stopVictoryBeat();
        // Start fade out animation
        setIsFadingOut(true);
        // Dismiss after fade completes
        setTimeout(()=>{
            onDismissProgress();
        }, 800);
    };
    const handleFirstPokemonDismiss = ()=>{
        (0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playModalDismiss();
        // Start fade out animation
        setIsFadingOut(true);
        // Dismiss after fade completes
        setTimeout(()=>{
            onDismissFirstPokemon();
        }, 800);
    };
    if (showFirstPokemonCelebration) return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
        className: `celebration-overlay first-pokemon-celebration ${isFadingOut ? "fade-out" : ""}`,
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                className: "confetti-container",
                children: [
                    ...Array(30)
                ].map((_, i)=>/*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                        className: "confetti-piece",
                        style: {
                            left: `${Math.random() * 100}%`,
                            animationDelay: `${Math.random() * 2}s`,
                            backgroundColor: [
                                "#FFD700",
                                "#FF6B9D",
                                "#4ECDC4",
                                "#45B7D1",
                                "#FFA07A"
                            ][Math.floor(Math.random() * 5)]
                        }
                    }, i))
            }, `first-${confettiKey}`),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                className: "celebration-content first-pokemon-content",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("h2", {
                        className: "celebration-title first-pokemon-title",
                        children: "Welcome!"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("img", {
                        src: meetPikaImage,
                        alt: "Meet Pikachu",
                        className: "celebration-image first-pokemon-image",
                        style: {
                            maxWidth: "500px",
                            width: "100%"
                        }
                    }, "first-pokemon-celebration-image"),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("p", {
                        className: "celebration-message first-pokemon-message",
                        children: [
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("strong", {
                                children: "Congratulations on your first Pok\xe9mon!"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("br", {}),
                            "You caught Pikachu! You're on your way to becoming a Pok\xe9mon master."
                        ]
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("button", {
                        className: "celebration-button first-pokemon-button",
                        onClick: handleFirstPokemonDismiss,
                        onMouseEnter: ()=>(0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playBubbleHover(),
                        children: "Let's catch 'em all!"
                    })
                ]
            })
        ]
    });
    if (showLegendCelebration) return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
        className: `celebration-overlay legend-celebration ${isFadingOut ? "fade-out" : ""}`,
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                className: "confetti-container",
                children: [
                    [
                        ...Array(100)
                    ].map((_, i)=>/*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                            className: "confetti-piece",
                            style: {
                                left: `${Math.random() * 100}%`,
                                animationDelay: `${Math.random() * 3}s`,
                                backgroundColor: [
                                    "#FFD700",
                                    "#FFA500",
                                    "#FF6347",
                                    "#FF69B4",
                                    "#00CED1"
                                ][Math.floor(Math.random() * 5)]
                            }
                        }, i)),
                    hoorayFireworks && [
                        ...Array(200)
                    ].map((_, i)=>/*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                            className: "confetti-piece hooray-confetti",
                            style: {
                                left: `${Math.random() * 100}%`,
                                animationDelay: `${Math.random() * 0.3}s`,
                                backgroundColor: [
                                    "#FFD700",
                                    "#FFA500",
                                    "#FF6347",
                                    "#32CD32",
                                    "#FF1493"
                                ][Math.floor(Math.random() * 5)]
                            }
                        }, `hooray-${i}`))
                ]
            }, `legend-${confettiKey}`),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                className: "celebration-content legend-content",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("h1", {
                        className: "celebration-title legend-title",
                        children: "LEGEND."
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                        className: "celebration-progress-container",
                        children: [
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                className: "celebration-progress-bar",
                                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                    className: "celebration-progress-fill legend-progress-fill",
                                    style: {
                                        width: "100%"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                                className: "celebration-progress-text",
                                children: [
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("span", {
                                        children: "151/151 Single Guesses"
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($eecd464176c7f13d$exports))),
                                        alt: "Trophy Star",
                                        style: {
                                            width: "20px",
                                            height: "20px",
                                            marginLeft: "4px",
                                            filter: "drop-shadow(0 1px 2px rgba(0,0,0,0.3))"
                                        }
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($994ddcb807969d92$exports))),
                        alt: "Pokemon Legend",
                        className: "celebration-image legend-image",
                        style: {
                            filter: "sepia(1) saturate(2) hue-rotate(40deg)"
                        }
                    }, "legend-celebration-image"),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("p", {
                        className: "celebration-message legend-message",
                        children: [
                            "You've caught every pokemon with 1 guess. Incredible! ",
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("br", {}),
                            "There are few Pokemon masters, even fewer ",
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("strong", {
                                children: "legends"
                            }),
                            "."
                        ]
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("button", {
                        className: "celebration-button legend-button",
                        onClick: handleLegendHoorayClick,
                        onMouseEnter: ()=>(0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playBubbleHover(),
                        children: "Legendary!"
                    })
                ]
            })
        ]
    });
    if (showMasterCelebration) return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
        className: `celebration-overlay master-celebration ${isFadingOut ? "fade-out" : ""}`,
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                className: "confetti-container",
                children: [
                    [
                        ...Array(50)
                    ].map((_, i)=>/*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                            className: "confetti-piece",
                            style: {
                                left: `${Math.random() * 100}%`,
                                animationDelay: `${Math.random() * 3}s`,
                                backgroundColor: [
                                    "#FF6B9D",
                                    "#4ECDC4",
                                    "#45B7D1",
                                    "#FFA07A",
                                    "#98D8C8"
                                ][Math.floor(Math.random() * 5)]
                            }
                        }, i)),
                    hoorayFireworks && [
                        ...Array(100)
                    ].map((_, i)=>/*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                            className: "confetti-piece hooray-confetti",
                            style: {
                                left: `${Math.random() * 100}%`,
                                animationDelay: `${Math.random() * 0.5}s`,
                                backgroundColor: [
                                    "#FFD700",
                                    "#FF69B4",
                                    "#00CED1",
                                    "#FF4500",
                                    "#32CD32"
                                ][Math.floor(Math.random() * 5)]
                            }
                        }, `hooray-${i}`))
                ]
            }, `master-${confettiKey}`),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                className: "celebration-content master-content",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("h1", {
                        className: "celebration-title",
                        children: "You've caught 'em all!"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                        className: "celebration-progress-container",
                        children: [
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                className: "celebration-progress-bar",
                                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                    className: "celebration-progress-fill master-progress-fill",
                                    style: {
                                        width: "100%"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                                className: "celebration-progress-text",
                                children: [
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("span", {
                                        children: "151/151 (100%)"
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($6edca0338b17e9b7$exports))),
                                        alt: "Trophy",
                                        style: {
                                            width: "20px",
                                            height: "20px",
                                            marginLeft: "4px",
                                            filter: "sepia(1) saturate(3) hue-rotate(40deg) brightness(1.2)"
                                        }
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($994ddcb807969d92$exports))),
                        alt: "Pokemon Master",
                        className: "celebration-image master-image"
                    }, "master-celebration-image"),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("p", {
                        className: "celebration-message master-message",
                        children: [
                            "151, baby! Amazing. ",
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("br", {}),
                            " You have officially earned the rank of ",
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("strong", {
                                children: "Pok\xe9mon Master"
                            }),
                            "."
                        ]
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("button", {
                        className: "celebration-button hooray-button",
                        onClick: handleHoorayClick,
                        onMouseEnter: ()=>(0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playBubbleHover(),
                        children: "Hooray!"
                    })
                ]
            })
        ]
    });
    if (showProgressCelebration) return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
        className: `celebration-overlay progress-celebration ${isFadingOut ? "fade-out" : ""}`,
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                className: "confetti-container",
                children: [
                    ...Array(20)
                ].map((_, i)=>/*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                        className: "confetti-piece",
                        style: {
                            left: `${Math.random() * 100}%`,
                            animationDelay: `${Math.random() * 2}s`,
                            backgroundColor: [
                                "#FF6B9D",
                                "#4ECDC4",
                                "#45B7D1",
                                "#FFA07A",
                                "#98D8C8"
                            ][Math.floor(Math.random() * 5)]
                        }
                    }, i))
            }, `progress-${confettiKey}`),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                className: "celebration-content progress-content",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("h2", {
                        className: "celebration-title progress-title",
                        children: [
                            "You've caught ",
                            progressCount,
                            "!"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                        className: "celebration-progress-container",
                        children: [
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                className: "celebration-progress-bar",
                                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                    className: "celebration-progress-fill",
                                    style: {
                                        "--target-width": `${progressCount / 151 * 100}%`,
                                        width: `${progressCount / 151 * 100}%`
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                                className: "celebration-progress-text",
                                children: [
                                    progressCount,
                                    "/151 (",
                                    Math.round(progressCount / 151 * 100),
                                    "%)"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("p", {
                        className: "celebration-message progress-message",
                        children: "Congrats on catching so many Pok\xe9mon. Keep it going!"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($78a7b344deb00b85$exports))),
                        alt: "Pokemon Progress",
                        className: "celebration-image progress-image"
                    }, "progress-celebration-image"),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("button", {
                        className: "celebration-button progress-button",
                        onClick: handleProgressDismiss,
                        onMouseEnter: ()=>(0, $581e9cf8be9ecc17$export$2e2bcd8739ae039).playBubbleHover(),
                        children: "Let's go!"
                    })
                ]
            })
        ]
    });
    return null;
}
var $fb8114cc29bf120e$export$2e2bcd8739ae039 = $fb8114cc29bf120e$var$Celebrations;






var $f1ee11da3bd60ac0$exports = {};

$f1ee11da3bd60ac0$exports = (parcelRequire("aNJCr")).getBundleURL("EVgbq") + "meet-pika.c1168535.png";


// Helper functions for localStorage management
const $adee9df12d2c2787$var$getDiscoveredPokemon = ()=>{
    try {
        const stored = localStorage.getItem("discovered-pokemon");
        return stored ? JSON.parse(stored) : [];
    } catch (error) {
        console.warn("Failed to read discovered Pokemon from localStorage:", error);
        return [];
    }
};
const $adee9df12d2c2787$var$saveDiscoveredPokemon = (discoveredList)=>{
    try {
        localStorage.setItem("discovered-pokemon", JSON.stringify(discoveredList));
    } catch (error) {
        console.warn("Failed to save discovered Pokemon to localStorage:", error);
    }
};
// Helper functions for single-guess catches
const $adee9df12d2c2787$var$getSingleGuessPokemon = ()=>{
    try {
        const stored = localStorage.getItem("single-guess-pokemon");
        return stored ? JSON.parse(stored) : [];
    } catch (error) {
        console.warn("Failed to read single-guess Pokemon from localStorage:", error);
        return [];
    }
};
const $adee9df12d2c2787$var$saveSingleGuessPokemon = (singleGuessList)=>{
    try {
        localStorage.setItem("single-guess-pokemon", JSON.stringify(singleGuessList));
    } catch (error) {
        console.warn("Failed to save single-guess Pokemon to localStorage:", error);
    }
};
function $adee9df12d2c2787$var$App() {
    const [gameKey, setGameKey] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(0);
    const [isPokedexOpen, setIsPokedexOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(false);
    const [highlightPokemonId, setHighlightPokemonId] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(null);
    const [pokemonList, setPokemonList] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState([]);
    const [discoveredPokemon, setDiscoveredPokemon] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState($adee9df12d2c2787$var$getDiscoveredPokemon());
    const [singleGuessPokemon, setSingleGuessPokemon] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState($adee9df12d2c2787$var$getSingleGuessPokemon());
    const [showMasterCelebration, setShowMasterCelebration] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(false);
    const [showProgressCelebration, setShowProgressCelebration] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(false);
    const [showLegendCelebration, setShowLegendCelebration] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(false);
    const [showFirstPokemonCelebration, setShowFirstPokemonCelebration] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(false);
    const [progressCount, setProgressCount] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(0);
    const [isMaster, setIsMaster] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(false);
    const [isLegend, setIsLegend] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(false);
    const [settings, setSettings] = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useState(()=>{
        try {
            const stored = localStorage.getItem("squirtle-wordle-settings");
            return stored ? JSON.parse(stored) : {
                hideHints: false,
                noRepeatPokemon: false,
                classicSounds: true,
                autoOpenPokedex: true
            };
        } catch  {
            return {
                hideHints: false,
                noRepeatPokemon: false,
                classicSounds: true,
                autoOpenPokedex: true
            };
        }
    });
    const gameRef = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useRef();
    const gameResultRef = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useRef();
    function handleReset() {
        setGameKey((prevKey)=>prevKey + 1);
    }
    function handleOpenPokedex(pokemonIdToHighlight = null) {
        setHighlightPokemonId(pokemonIdToHighlight);
        setIsPokedexOpen(true);
    }
    function handleClosePokedex() {
        setIsPokedexOpen(false);
        setHighlightPokemonId(null);
        // Restore focus to play again button when Pokedex closes
        gameResultRef.current?.focus();
    }
    function handlePokemonDiscovered(pokemonId, wasSingleGuess = false) {
        if (!discoveredPokemon.includes(pokemonId)) {
            const newDiscovered = [
                ...discoveredPokemon,
                pokemonId
            ];
            const newCount = newDiscovered.length;
            setDiscoveredPokemon(newDiscovered);
            $adee9df12d2c2787$var$saveDiscoveredPokemon(newDiscovered);
            // Check for legend celebration (all 151 caught with single guesses) - delay to let pokeball animation finish
            if (wasSingleGuess && !singleGuessPokemon.includes(pokemonId)) {
                const newSingleGuess = [
                    ...singleGuessPokemon,
                    pokemonId
                ];
                setSingleGuessPokemon(newSingleGuess);
                $adee9df12d2c2787$var$saveSingleGuessPokemon(newSingleGuess);
                // Check if user has become a legend (all 151 with single guesses)
                if (newSingleGuess.length === 151) {
                    setTimeout(()=>{
                        setIsLegend(true);
                        setShowLegendCelebration(true);
                    }, 1500);
                    return; // Exit early to show legend celebration instead of master
                }
            }
            // Special case: First Pokemon celebration
            if (newCount === 1) setTimeout(()=>{
                setShowFirstPokemonCelebration(true);
            }, 1500);
            else if (newCount === 151) setTimeout(()=>{
                setIsMaster(true);
                setShowMasterCelebration(true);
            }, 1500);
            else if (newCount % 10 === 0 && newCount >= 10) setTimeout(()=>{
                setProgressCount(newCount);
                setShowProgressCelebration(true);
            }, 1500);
        }
    }
    function handlePokemonListLoaded(list) {
        setPokemonList(list);
    }
    function handleDismissMaster() {
        setShowMasterCelebration(false);
    }
    function handleDismissProgress() {
        setShowProgressCelebration(false);
    }
    function handleDismissLegend() {
        setShowLegendCelebration(false);
    }
    function handleDismissFirstPokemon() {
        setShowFirstPokemonCelebration(false);
    }
    function handleLegendHoorayClick() {
        setShowLegendCelebration(false);
    }
    function handleSubmitGuess(pokemonName) {
        if (gameRef.current && gameRef.current.isGameActive) gameRef.current.submitGuess(pokemonName);
    }
    function handleHoorayClick() {
        setShowMasterCelebration(false);
    }
    // Check if user is already a master or legend on load
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(()=>{
        setIsMaster(discoveredPokemon.length === 151);
        setIsLegend(singleGuessPokemon.length === 151);
    }, [
        discoveredPokemon.length,
        singleGuessPokemon.length
    ]);
    // Listen for settings changes from localStorage
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(()=>{
        const handleStorageChange = ()=>{
            try {
                const stored = localStorage.getItem("squirtle-wordle-settings");
                if (stored) setSettings(JSON.parse(stored));
            } catch  {
            // Keep current settings on parse error
            }
        };
        // Listen for custom settings change events
        const handleSettingsChange = ()=>{
            handleStorageChange();
        };
        // Poll for localStorage changes (in case same-tab changes aren't triggering events)
        const pollInterval = setInterval(handleStorageChange, 1000);
        window.addEventListener("storage", handleStorageChange);
        window.addEventListener("settingsChanged", handleSettingsChange);
        return ()=>{
            window.removeEventListener("storage", handleStorageChange);
            window.removeEventListener("settingsChanged", handleSettingsChange);
            clearInterval(pollInterval);
        };
    }, []);
    // Add event listeners for test functions
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useEffect(()=>{
        const handleTestMaster = ()=>{
            setShowMasterCelebration(true);
        };
        const handleTestLegend = ()=>{
            setShowLegendCelebration(true);
        };
        const handleTestProgress = (event)=>{
            const count = event.detail?.count || 50;
            setProgressCount(count);
            setShowProgressCelebration(true);
        };
        window.addEventListener("testMasterCelebration", handleTestMaster);
        window.addEventListener("testLegendCelebration", handleTestLegend);
        window.addEventListener("testProgressCelebration", handleTestProgress);
        // Add test function to window for legend celebration
        window.testLegendCelebration = ()=>{
            setShowLegendCelebration(true);
        };
        return ()=>{
            window.removeEventListener("testMasterCelebration", handleTestMaster);
            window.removeEventListener("testLegendCelebration", handleTestLegend);
            window.removeEventListener("testProgressCelebration", handleTestProgress);
            delete window.testLegendCelebration;
        };
    }, []);
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
        className: "wrapper",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $ce2bbf7743ae7f98$export$2e2bcd8739ae039), {
                onReset: handleReset,
                onOpenPokedex: handleOpenPokedex,
                discoveredCount: discoveredPokemon.length,
                totalCount: pokemonList.length,
                isMaster: isMaster,
                isLegend: isLegend,
                trophyIcon: isLegend ? (0, (/*@__PURE__*/$parcel$interopDefault($eecd464176c7f13d$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($6edca0338b17e9b7$exports)))
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                className: "game-wrapper",
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $b60d5ef55411eecc$export$2e2bcd8739ae039), {
                    ref: gameRef,
                    gameResultRef: gameResultRef,
                    onPokemonDiscovered: handlePokemonDiscovered,
                    onPokemonListLoaded: handlePokemonListLoaded,
                    onOpenPokedex: handleOpenPokedex,
                    settings: settings
                }, gameKey)
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $bed1218db9113960$export$2e2bcd8739ae039), {
                isOpen: isPokedexOpen,
                onClose: handleClosePokedex,
                pokemonList: pokemonList,
                discoveredPokemon: discoveredPokemon,
                singleGuessPokemon: singleGuessPokemon,
                highlightPokemonId: highlightPokemonId,
                isMaster: isMaster,
                trophyIcon: (0, (/*@__PURE__*/$parcel$interopDefault($6edca0338b17e9b7$exports))),
                onSubmitGuess: handleSubmitGuess
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $fb8114cc29bf120e$export$2e2bcd8739ae039), {
                showMasterCelebration: showMasterCelebration,
                showProgressCelebration: showProgressCelebration,
                showLegendCelebration: showLegendCelebration,
                showFirstPokemonCelebration: showFirstPokemonCelebration,
                progressCount: progressCount,
                onDismissMaster: handleDismissMaster,
                onDismissProgress: handleDismissProgress,
                onDismissLegend: handleDismissLegend,
                onDismissFirstPokemon: handleDismissFirstPokemon,
                onHoorayClick: handleHoorayClick,
                onLegendHoorayClick: handleLegendHoorayClick,
                meetPikaImage: (0, (/*@__PURE__*/$parcel$interopDefault($f1ee11da3bd60ac0$exports)))
            })
        ]
    });
}
var $adee9df12d2c2787$export$2e2bcd8739ae039 = $adee9df12d2c2787$var$App;






const $b8f9b7833fa37166$var$root = (0, $7bd215913159ea08$exports.createRoot)(document.querySelector("#root"));
$b8f9b7833fa37166$var$root.render(/*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $adee9df12d2c2787$export$2e2bcd8739ae039), {}));

})();
//# sourceMappingURL=index.814194a7.js.map
